import { c as Mm, a as H, f as km, i as Xs } from "./index-ihl6KO3Y.js";
import { b as GP } from "./index-ihl6KO3Y.js";
import { jsx as b, Fragment as Ce, jsxs as $ } from "react/jsx-runtime";
import { c as ee } from "react/compiler-runtime";
import * as x from "react";
import B, { useState as le, useEffect as fe, useRef as pe, useMemo as It, useLayoutEffect as ji, createContext as lt, useContext as ar, useCallback as Ne, useId as nn, isValidElement as _m, useReducer as Dm, Fragment as oo, createElement as Bo, PureComponent as Rm, startTransition as Am } from "react";
import * as lr from "react-dom";
import Fm, { flushSync as Lm } from "react-dom";
import { ChevronDown as zr, Loader2 as Gi, X as Wn, MoreHorizontal as Wm, ChevronRight as qi, ChevronLeft as El, Square as $m, CheckSquare as Vm, CalendarDays as Bm, SquareX as zm, Check as Pl, ChevronUp as Hm, MapPin as Ym, SquareArrowOutUpRight as Km, ChevronsUpDown as Nl, Minus as Um, Plus as jm, Circle as Gm, CheckCircle as qm, EyeOff as Xm, Eye as Zm } from "lucide-react";
function Jm(t, e) {
  const n = x.createContext(e), r = (i) => {
    const { children: a, ...s } = i, l = x.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ b(n.Provider, { value: l, children: a });
  };
  r.displayName = t + "Provider";
  function o(i) {
    const a = x.useContext(n);
    if (a) return a;
    if (e !== void 0) return e;
    throw new Error(`\`${i}\` must be used within \`${t}\``);
  }
  return [r, o];
}
function Ye(t, e = []) {
  let n = [];
  function r(i, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const c = (u) => {
      var g;
      const { scope: m, children: h, ...v } = u, f = ((g = m == null ? void 0 : m[t]) == null ? void 0 : g[l]) || s, p = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ b(f.Provider, { value: p, children: h });
    };
    c.displayName = i + "Provider";
    function d(u, m) {
      var f;
      const h = ((f = m == null ? void 0 : m[t]) == null ? void 0 : f[l]) || s, v = x.useContext(h);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return [c, d];
  }
  const o = () => {
    const i = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || i;
      return x.useMemo(
        () => ({ [`__scope${t}`]: { ...s, [t]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = t, [r, Qm(o, ...e)];
}
function Qm(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const r = t.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const u = l(i)[`__scope${c}`];
        return { ...s, ...u };
      }, {});
      return x.useMemo(() => ({ [`__scope${e.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function Zs(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function Ol(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((o) => {
      const i = Zs(o, e);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Zs(t[o], null);
        }
      };
  };
}
function ae(...t) {
  return x.useCallback(Ol(...t), t);
}
// @__NO_SIDE_EFFECTS__
function Mn(t) {
  const e = /* @__PURE__ */ eh(t), n = x.forwardRef((r, o) => {
    const { children: i, ...a } = r, s = x.Children.toArray(i), l = s.find(nh);
    if (l) {
      const c = l.props.children, d = s.map((u) => u === l ? x.Children.count(c) > 1 ? x.Children.only(null) : x.isValidElement(c) ? c.props.children : null : u);
      return /* @__PURE__ */ b(e, { ...a, ref: o, children: x.isValidElement(c) ? x.cloneElement(c, void 0, d) : null });
    }
    return /* @__PURE__ */ b(e, { ...a, ref: o, children: i });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function eh(t) {
  const e = x.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (x.isValidElement(o)) {
      const a = oh(o), s = rh(i, o.props);
      return o.type !== x.Fragment && (s.ref = r ? Ol(r, a) : a), x.cloneElement(o, s);
    }
    return x.Children.count(o) > 1 ? x.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var Tl = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function th(t) {
  const e = ({ children: n }) => /* @__PURE__ */ b(Ce, { children: n });
  return e.displayName = `${t}.Slottable`, e.__radixId = Tl, e;
}
function nh(t) {
  return x.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === Tl;
}
function rh(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], i = e[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      const l = i(...s);
      return o(...s), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function oh(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
function cr(t) {
  const e = t + "CollectionProvider", [n, r] = Ye(e), [o, i] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (f) => {
    const { scope: p, children: g } = f, y = B.useRef(null), w = B.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ b(o, { scope: p, itemMap: w, collectionRef: y, children: g });
  };
  a.displayName = e;
  const s = t + "CollectionSlot", l = /* @__PURE__ */ Mn(s), c = B.forwardRef(
    (f, p) => {
      const { scope: g, children: y } = f, w = i(s, g), C = ae(p, w.collectionRef);
      return /* @__PURE__ */ b(l, { ref: C, children: y });
    }
  );
  c.displayName = s;
  const d = t + "CollectionItemSlot", u = "data-radix-collection-item", m = /* @__PURE__ */ Mn(d), h = B.forwardRef(
    (f, p) => {
      const { scope: g, children: y, ...w } = f, C = B.useRef(null), S = ae(p, C), P = i(d, g);
      return B.useEffect(() => (P.itemMap.set(C, { ref: C, ...w }), () => void P.itemMap.delete(C))), /* @__PURE__ */ b(m, { [u]: "", ref: S, children: y });
    }
  );
  h.displayName = d;
  function v(f) {
    const p = i(t + "CollectionConsumer", f);
    return B.useCallback(() => {
      const y = p.collectionRef.current;
      if (!y) return [];
      const w = Array.from(y.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (P, E) => w.indexOf(P.ref.current) - w.indexOf(E.ref.current)
      );
    }, [p.collectionRef, p.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: h },
    v,
    r
  ];
}
function U(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (t == null || t(o), n === !1 || !o.defaultPrevented)
      return e == null ? void 0 : e(o);
  };
}
var De = globalThis != null && globalThis.document ? x.useLayoutEffect : () => {
}, ih = x[" useInsertionEffect ".trim().toString()] || De;
function je({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, a] = sh({
    defaultProp: e,
    onChange: n
  }), s = t !== void 0, l = s ? t : o;
  {
    const d = x.useRef(t !== void 0);
    x.useEffect(() => {
      const u = d.current;
      u !== s && console.warn(
        `${r} is changing from ${u ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = s;
    }, [s, r]);
  }
  const c = x.useCallback(
    (d) => {
      var u;
      if (s) {
        const m = ah(d) ? d(t) : d;
        m !== t && ((u = a.current) == null || u.call(a, m));
      } else
        i(d);
    },
    [s, t, i, a]
  );
  return [l, c];
}
function sh({
  defaultProp: t,
  onChange: e
}) {
  const [n, r] = x.useState(t), o = x.useRef(n), i = x.useRef(e);
  return ih(() => {
    i.current = e;
  }, [e]), x.useEffect(() => {
    var a;
    o.current !== n && ((a = i.current) == null || a.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
function ah(t) {
  return typeof t == "function";
}
var lh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], q = lh.reduce((t, e) => {
  const n = /* @__PURE__ */ Mn(`Primitive.${e}`), r = x.forwardRef((o, i) => {
    const { asChild: a, ...s } = o, l = a ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function Il(t, e) {
  t && lr.flushSync(() => t.dispatchEvent(e));
}
function ch(t, e) {
  return x.useReducer((n, r) => e[n][r] ?? n, t);
}
var tt = (t) => {
  const { present: e, children: n } = t, r = uh(e), o = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), i = ae(r.ref, dh(o));
  return typeof n == "function" || r.isPresent ? x.cloneElement(o, { ref: i }) : null;
};
tt.displayName = "Presence";
function uh(t) {
  const [e, n] = x.useState(), r = x.useRef(null), o = x.useRef(t), i = x.useRef("none"), a = t ? "mounted" : "unmounted", [s, l] = ch(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const c = Pr(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), De(() => {
    const c = r.current, d = o.current;
    if (d !== t) {
      const m = i.current, h = Pr(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(d && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = t;
    }
  }, [t, l]), De(() => {
    if (e) {
      let c;
      const d = e.ownerDocument.defaultView ?? window, u = (h) => {
        const f = Pr(r.current).includes(h.animationName);
        if (h.target === e && f && (l("ANIMATION_END"), !o.current)) {
          const p = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = d.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = p);
          });
        }
      }, m = (h) => {
        h.target === e && (i.current = Pr(r.current));
      };
      return e.addEventListener("animationstart", m), e.addEventListener("animationcancel", u), e.addEventListener("animationend", u), () => {
        d.clearTimeout(c), e.removeEventListener("animationstart", m), e.removeEventListener("animationcancel", u), e.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Pr(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function dh(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var fh = x[" useId ".trim().toString()] || (() => {
}), mh = 0;
function st(t) {
  const [e, n] = x.useState(fh());
  return De(() => {
    n((r) => r ?? String(mh++));
  }, [t]), e ? `radix-${e}` : "";
}
var io = "Collapsible", [hh, Ml] = Ye(io), [ph, Xi] = hh(io), kl = x.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: a,
      ...s
    } = t, [l, c] = je({
      prop: r,
      defaultProp: o ?? !1,
      onChange: a,
      caller: io
    });
    return /* @__PURE__ */ b(
      ph,
      {
        scope: n,
        disabled: i,
        contentId: st(),
        open: l,
        onOpenToggle: x.useCallback(() => c((d) => !d), [c]),
        children: /* @__PURE__ */ b(
          q.div,
          {
            "data-state": Ji(l),
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: e
          }
        )
      }
    );
  }
);
kl.displayName = io;
var _l = "CollapsibleTrigger", Dl = x.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: n, ...r } = t, o = Xi(_l, n);
    return /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": Ji(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: e,
        onClick: U(t.onClick, o.onOpenToggle)
      }
    );
  }
);
Dl.displayName = _l;
var Zi = "CollapsibleContent", Rl = x.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, o = Xi(Zi, t.__scopeCollapsible);
    return /* @__PURE__ */ b(tt, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ b(vh, { ...r, ref: e, present: i }) });
  }
);
Rl.displayName = Zi;
var vh = x.forwardRef((t, e) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = t, a = Xi(Zi, n), [s, l] = x.useState(r), c = x.useRef(null), d = ae(e, c), u = x.useRef(0), m = u.current, h = x.useRef(0), v = h.current, f = a.open || s, p = x.useRef(f), g = x.useRef(void 0);
  return x.useEffect(() => {
    const y = requestAnimationFrame(() => p.current = !1);
    return () => cancelAnimationFrame(y);
  }, []), De(() => {
    const y = c.current;
    if (y) {
      g.current = g.current || {
        transitionDuration: y.style.transitionDuration,
        animationName: y.style.animationName
      }, y.style.transitionDuration = "0s", y.style.animationName = "none";
      const w = y.getBoundingClientRect();
      u.current = w.height, h.current = w.width, p.current || (y.style.transitionDuration = g.current.transitionDuration, y.style.animationName = g.current.animationName), l(r);
    }
  }, [a.open, r]), /* @__PURE__ */ b(
    q.div,
    {
      "data-state": Ji(a.open),
      "data-disabled": a.disabled ? "" : void 0,
      id: a.contentId,
      hidden: !f,
      ...i,
      ref: d,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": v ? `${v}px` : void 0,
        ...t.style
      },
      children: f && o
    }
  );
});
function Ji(t) {
  return t ? "open" : "closed";
}
var gh = kl, bh = Dl, yh = Rl, wh = x.createContext(void 0);
function $n(t) {
  const e = x.useContext(wh);
  return t || e || "ltr";
}
var bt = "Accordion", xh = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Qi, Sh, Ch] = cr(bt), [so, aP] = Ye(bt, [
  Ch,
  Ml
]), es = Ml(), Al = B.forwardRef(
  (t, e) => {
    const { type: n, ...r } = t, o = r, i = r;
    return /* @__PURE__ */ b(Qi.Provider, { scope: t.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ b(Oh, { ...i, ref: e }) : /* @__PURE__ */ b(Nh, { ...o, ref: e }) });
  }
);
Al.displayName = bt;
var [Fl, Eh] = so(bt), [Ll, Ph] = so(
  bt,
  { collapsible: !1 }
), Nh = B.forwardRef(
  (t, e) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...a
    } = t, [s, l] = je({
      prop: n,
      defaultProp: r ?? "",
      onChange: o,
      caller: bt
    });
    return /* @__PURE__ */ b(
      Fl,
      {
        scope: t.__scopeAccordion,
        value: B.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: l,
        onItemClose: B.useCallback(() => i && l(""), [i, l]),
        children: /* @__PURE__ */ b(Ll, { scope: t.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ b(Wl, { ...a, ref: e }) })
      }
    );
  }
), Oh = B.forwardRef((t, e) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = t, [a, s] = je({
    prop: n,
    defaultProp: r ?? [],
    onChange: o,
    caller: bt
  }), l = B.useCallback(
    (d) => s((u = []) => [...u, d]),
    [s]
  ), c = B.useCallback(
    (d) => s((u = []) => u.filter((m) => m !== d)),
    [s]
  );
  return /* @__PURE__ */ b(
    Fl,
    {
      scope: t.__scopeAccordion,
      value: a,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ b(Ll, { scope: t.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ b(Wl, { ...i, ref: e }) })
    }
  );
}), [Th, ao] = so(bt), Wl = B.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: i = "vertical", ...a } = t, s = B.useRef(null), l = ae(s, e), c = Sh(n), u = $n(o) === "ltr", m = U(t.onKeyDown, (h) => {
      var N;
      if (!xh.includes(h.key)) return;
      const v = h.target, f = c().filter((T) => {
        var k;
        return !((k = T.ref.current) != null && k.disabled);
      }), p = f.findIndex((T) => T.ref.current === v), g = f.length;
      if (p === -1) return;
      h.preventDefault();
      let y = p;
      const w = 0, C = g - 1, S = () => {
        y = p + 1, y > C && (y = w);
      }, P = () => {
        y = p - 1, y < w && (y = C);
      };
      switch (h.key) {
        case "Home":
          y = w;
          break;
        case "End":
          y = C;
          break;
        case "ArrowRight":
          i === "horizontal" && (u ? S() : P());
          break;
        case "ArrowDown":
          i === "vertical" && S();
          break;
        case "ArrowLeft":
          i === "horizontal" && (u ? P() : S());
          break;
        case "ArrowUp":
          i === "vertical" && P();
          break;
      }
      const E = y % g;
      (N = f[E].ref.current) == null || N.focus();
    });
    return /* @__PURE__ */ b(
      Th,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ b(Qi.Slot, { scope: n, children: /* @__PURE__ */ b(
          q.div,
          {
            ...a,
            "data-orientation": i,
            ref: l,
            onKeyDown: r ? void 0 : m
          }
        ) })
      }
    );
  }
), Hr = "AccordionItem", [Ih, ts] = so(Hr), $l = B.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, value: r, ...o } = t, i = ao(Hr, n), a = Eh(Hr, n), s = es(n), l = st(), c = r && a.value.includes(r) || !1, d = i.disabled || t.disabled;
    return /* @__PURE__ */ b(
      Ih,
      {
        scope: n,
        open: c,
        disabled: d,
        triggerId: l,
        children: /* @__PURE__ */ b(
          gh,
          {
            "data-orientation": i.orientation,
            "data-state": Kl(c),
            ...s,
            ...o,
            ref: e,
            disabled: d,
            open: c,
            onOpenChange: (u) => {
              u ? a.onItemOpen(r) : a.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
$l.displayName = Hr;
var Vl = "AccordionHeader", Bl = B.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, o = ao(bt, n), i = ts(Vl, n);
    return /* @__PURE__ */ b(
      q.h3,
      {
        "data-orientation": o.orientation,
        "data-state": Kl(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
Bl.displayName = Vl;
var vi = "AccordionTrigger", zl = B.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, o = ao(bt, n), i = ts(vi, n), a = Ph(vi, n), s = es(n);
    return /* @__PURE__ */ b(Qi.ItemSlot, { scope: n, children: /* @__PURE__ */ b(
      bh,
      {
        "aria-disabled": i.open && !a.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...s,
        ...r,
        ref: e
      }
    ) });
  }
);
zl.displayName = vi;
var Hl = "AccordionContent", Yl = B.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, o = ao(bt, n), i = ts(Hl, n), a = es(n);
    return /* @__PURE__ */ b(
      yh,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...a,
        ...r,
        ref: e,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...t.style
        }
      }
    );
  }
);
Yl.displayName = Hl;
function Kl(t) {
  return t ? "open" : "closed";
}
var Mh = Al, kh = $l, _h = Bl, Dh = zl, Rh = Yl;
const Js = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, Qs = Mm, Yt = (t, e) => (n) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null) return Qs(t, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = e, a = Object.keys(o).map((c) => {
    const d = n == null ? void 0 : n[c], u = i == null ? void 0 : i[c];
    if (d === null) return null;
    const m = Js(d) || Js(u);
    return o[c][m];
  }), s = n && Object.entries(n).reduce((c, d) => {
    let [u, m] = d;
    return m === void 0 || (c[u] = m), c;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, d) => {
    let { class: u, className: m, ...h } = d;
    return Object.entries(h).every((v) => {
      let [f, p] = v;
      return Array.isArray(p) ? p.includes({
        ...i,
        ...s
      }[f]) : {
        ...i,
        ...s
      }[f] === p;
    }) ? [
      ...c,
      u,
      m
    ] : c;
  }, []);
  return Qs(t, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Ah = {
  step: {
    "-2": "text-xs",
    "-1": "text-sm",
    0: "text-base",
    1: "text-lg",
    2: "text-xl",
    3: "text-2xl",
    4: "text-3xl",
    5: "text-4xl"
  },
  weight: {
    normal: "font-normal",
    semibold: "font-semibold",
    bold: "font-bold"
  },
  autoSpacing: {
    true: "first:mt-0 last:mb-0"
  }
}, Fh = Yt("text-main", {
  variants: {
    ...Ah
  },
  compoundVariants: [{
    step: "-2",
    autoSpacing: !0,
    className: "my-3xs"
  }, {
    step: "-2",
    weight: "normal",
    className: "font-normal"
  }, {
    step: "-2",
    weight: "semibold",
    className: "font-semibold"
  }, {
    step: "-2",
    weight: "bold",
    className: "font-bold"
  }, {
    step: "-1",
    autoSpacing: !0,
    className: "my-2xs mb-sm"
  }, {
    step: "-1",
    weight: "normal",
    className: "font-normal"
  }, {
    step: "-1",
    weight: "semibold",
    className: "font-semibold"
  }, {
    step: "-1",
    weight: "bold",
    className: "font-bold"
  }, {
    step: "0",
    autoSpacing: !0,
    className: "my-xs mb-sm"
  }, {
    step: "0",
    weight: "normal",
    className: "font-normal"
  }, {
    step: "0",
    weight: "semibold",
    className: "font-semibold"
  }, {
    step: "0",
    weight: "bold",
    className: "font-bold"
  }, {
    step: "1",
    autoSpacing: !0,
    className: "mb-sm mt-md"
  }, {
    step: "1",
    weight: "normal",
    className: "font-normal"
  }, {
    step: "1",
    weight: "semibold",
    className: "font-semibold"
  }, {
    step: "1",
    weight: "bold",
    className: "font-bold"
  }, {
    step: "2",
    autoSpacing: !0,
    className: "mb-sm mt-md"
  }, {
    step: "2",
    weight: "normal",
    className: "font-bold"
  }, {
    step: "2",
    weight: "semibold",
    className: "font-bold"
  }, {
    step: "2",
    weight: "bold",
    className: "font-black"
  }, {
    step: "3",
    autoSpacing: !0,
    className: "mb-sm mt-lg"
  }, {
    step: "3",
    weight: "normal",
    className: "font-bold"
  }, {
    step: "3",
    weight: "semibold",
    className: "font-bold"
  }, {
    step: "3",
    weight: "bold",
    className: "font-black"
  }, {
    step: "4",
    autoSpacing: !0,
    className: "mb-sm mt-xl"
  }, {
    step: "4",
    weight: "normal",
    className: "font-bold"
  }, {
    step: "4",
    weight: "semibold",
    className: "font-bold"
  }, {
    step: "4",
    weight: "bold",
    className: "font-black"
  }, {
    step: "5",
    autoSpacing: !0,
    className: "mb-lg mt-xl"
  }, {
    step: "5",
    weight: "normal",
    className: "font-bold"
  }, {
    step: "5",
    weight: "semibold",
    className: "font-bold"
  }, {
    step: "5",
    weight: "bold",
    className: "font-black"
  }],
  defaultVariants: {
    step: "0",
    weight: "normal",
    autoSpacing: !1
  }
}), Lh = {
  5: "span",
  4: "span",
  3: "span",
  2: "span",
  1: "span",
  0: "p",
  "-1": "span",
  "-2": "span"
};
function ve(t) {
  const e = ee(18);
  let n, r, o, i, a, s, l;
  e[0] !== t ? ({
    as: n,
    step: s,
    weight: l,
    autoSpacing: r,
    children: o,
    className: i,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s, e[7] = l) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6], l = e[7]);
  const c = s === void 0 ? "0" : s, d = n || Lh[c];
  let u;
  e[8] !== r || e[9] !== i || e[10] !== c || e[11] !== l ? (u = H(Fh({
    step: c,
    weight: l,
    autoSpacing: r,
    className: i
  })), e[8] = r, e[9] = i, e[10] = c, e[11] = l, e[12] = u) : u = e[12];
  let m;
  return e[13] !== d || e[14] !== o || e[15] !== a || e[16] !== u ? (m = /* @__PURE__ */ b(d, { className: u, ...a, children: o }), e[13] = d, e[14] = o, e[15] = a, e[16] = u, e[17] = m) : m = e[17], m;
}
function Ul(t) {
  return `accordion-item-${t}`;
}
function lP(t) {
  const e = ee(7), {
    items: n
  } = t, r = n.findIndex($h);
  let o;
  e[0] !== r ? (o = r >= 0 ? Ul(r) : void 0, e[0] = r, e[1] = o) : o = e[1];
  const i = o;
  let a;
  e[2] !== n ? (a = n.map(Wh), e[2] = n, e[3] = a) : a = e[3];
  let s;
  return e[4] !== i || e[5] !== a ? (s = /* @__PURE__ */ b(Mh, { type: "single", collapsible: !0, defaultValue: i, className: "gap-y-md flex w-full flex-col", children: a }), e[4] = i, e[5] = a, e[6] = s) : s = e[6], s;
}
function Wh(t, e) {
  const n = Ul(e);
  return /* @__PURE__ */ $(kh, { value: n, className: "w-full", children: [
    /* @__PURE__ */ b(_h, { className: "w-full", children: /* @__PURE__ */ $(Dh, { className: "group gap-x-sm flex w-full items-center justify-between", children: [
      /* @__PURE__ */ b(ve, { weight: "bold", className: "text-left", children: t.trigger }),
      /* @__PURE__ */ b(zr, { className: "text-grayscale group-hover:text-main group-radix-state-open:rotate-180 transition-all duration-200 ease-out" })
    ] }) }),
    /* @__PURE__ */ b(Rh, { className: "AccordionContent mt-sm", children: t.content })
  ] }, n);
}
function $h(t) {
  return t.isOpenByDefault;
}
function jl(t) {
  return t.disabled ? (delete t.href, delete t.to, delete t.onClick, delete t.target, (t.as === "a" || t != null && t.to) && (t.as = "span")) : (t.as === "a" || t != null && t.to) && t.shouldOpenNewTab ? (t.rel = "noopener noreferrer", t.target = "_blank") : t.as === "button" && !t.type && (t.type = "button"), delete t.shouldOpenNewTab, t;
}
const Vh = {
  intent: {
    primary: "",
    secondary: "",
    positive: "",
    negative: "",
    white: ""
  },
  shape: {
    solid: "rounded-md shadow-sm hover:shadow-lg focus-visible:shadow-lg active:shadow-inner disabled:shadow-none disabled:bg-grayscale-xx-light disabled:text-grayscale",
    soft: "rounded-full active:shadow-inner",
    outline: "rounded-md shadow-none hover:shadow-lg focus-visible:shadow-lg active:shadow-none",
    link: "hover:underline focus-visible:underline active:no-underline"
  },
  size: {
    small: "text-sm px-xs py-2xs",
    medium: "text-base px-sm py-xs",
    large: "text-lg px-md py-sm"
  },
  hasIcon: {
    true: ""
  }
}, Bh = Yt("gap-2xs inline-flex items-center justify-center font-semibold outline-offset-2 transition-all duration-200 ease-out active:duration-150 disabled:pointer-events-none disabled:select-none", {
  variants: {
    ...Vh
  },
  compoundVariants: [
    // Solid shapes
    {
      shape: "solid",
      intent: "primary",
      className: "bg-primary hover:bg-primary-light focus-visible:bg-primary-light active:bg-primary-light text-white"
    },
    {
      shape: "solid",
      intent: "secondary",
      className: "bg-secondary hover:bg-secondary-light focus-visible:bg-secondary-light active:bg-secondary-light text-white"
    },
    {
      shape: "solid",
      intent: "positive",
      className: "bg-positive text-positive-x-dark hover:bg-positive-light focus-visible:bg-positive-light active:bg-positive-light"
    },
    {
      shape: "solid",
      intent: "negative",
      className: "bg-negative hover:bg-negative-light focus-visible:bg-negative-light active:bg-negative-light text-white"
    },
    {
      shape: "solid",
      intent: "white",
      className: "text-main bg-white hover:bg-white focus-visible:bg-white active:bg-white"
    },
    // Soft shapes
    {
      shape: "soft",
      intent: "primary",
      className: "bg-primary-xx-light text-primary hover:bg-primary-x-light focus-visible:bg-primary-x-light active:bg-primary-xx-light"
    },
    {
      shape: "soft",
      intent: "secondary",
      className: "bg-secondary-xx-light text-secondary-dark hover:bg-secondary-x-light focus-visible:bg-secondary-x-light active:bg-secondary-xx-light"
    },
    {
      shape: "soft",
      intent: "positive",
      className: "bg-positive-xx-light text-positive-x-dark hover:bg-positive-x-light focus-visible:bg-positive-x-light active:bg-positive-xx-light"
    },
    {
      shape: "soft",
      intent: "negative",
      className: "bg-negative-xx-light text-negative-dark hover:bg-negative-x-light focus-visible:bg-negative-x-light active:bg-negative-xx-light"
    },
    {
      shape: "soft",
      intent: "white",
      className: "text-main hover:bg-grayscale-x-light focus-visible:bg-grayscale-x-light bg-white active:bg-white"
    },
    // Outline shapes
    {
      shape: "outline",
      intent: "primary",
      className: "border-primary text-primary hover:bg-primary focus-visible:bg-primary active:text-primary border hover:text-white focus-visible:text-white active:bg-white"
    },
    {
      shape: "outline",
      intent: "secondary",
      className: "border-secondary text-secondary hover:bg-secondary focus-visible:bg-secondary active:text-secondary border hover:text-white focus-visible:text-white active:bg-white"
    },
    {
      shape: "outline",
      intent: "positive",
      className: "border-positive-dark text-positive-dark hover:bg-positive-dark focus-visible:bg-positive-dark border hover:text-white focus-visible:text-white active:bg-white"
    },
    {
      shape: "outline",
      intent: "negative",
      className: "border-negative-dark text-negative-dark hover:bg-negative-dark border hover:text-white focus-visible:text-white active:bg-white"
    },
    // Link shapes
    {
      shape: "link",
      intent: "primary",
      className: "text-primary hover:text-primary-light focus-visible:text-primary-light active:text-primary-light"
    },
    {
      shape: "link",
      intent: "positive",
      className: "text-positive-dark hover:text-positive focus-visible:text-positive active:text-positive"
    },
    {
      shape: "link",
      intent: "secondary",
      className: "text-secondary hover:text-secondary-light focus-visible:text-secondary-light active:text-secondary-light"
    },
    {
      shape: "link",
      intent: "negative",
      className: "text-negative-dark hover:text-negative focus-visible:text-negative active:text-negative"
    },
    {
      shape: "link",
      intent: "white",
      className: "hover:text-primary-light focus-visible:text-primary active:text-primary text-white"
    },
    // Icon
    {
      hasIcon: !0,
      className: "!p-2xs disabled:bg-grayscale-x-light disabled:text-grayscale-dark rounded-full disabled:border-none"
    },
    {
      hasIcon: !0,
      shape: "solid",
      intent: "primary",
      className: "bg-primary-light hover:bg-primary focus-visible:bg-primary"
    },
    {
      hasIcon: !0,
      shape: "solid",
      intent: "secondary",
      className: "hover:bg-secondary-dark focus-visible:bg-secondary-dark active:bg-secondary"
    },
    {
      hasIcon: !0,
      shape: "solid",
      intent: "positive",
      className: "hover:bg-positive-dark focus-visible:bg-positive-dark active:bg-positive text-white"
    },
    {
      hasIcon: !0,
      shape: "solid",
      intent: "negative",
      className: "hover:bg-negative-dark focus-visible:bg-negative-dark active:bg-negative"
    },
    {
      hasIcon: !0,
      shape: "soft",
      intent: "primary",
      className: "text-primary-light"
    },
    {
      hasIcon: !0,
      shape: "soft",
      intent: "secondary",
      className: "text-secondary hover:bg-secondary-x-light focus-visible:bg-secondary-x-light"
    },
    {
      hasIcon: !0,
      shape: "soft",
      intent: "positive",
      className: "text-positive-dark"
    },
    {
      hasIcon: !0,
      shape: "outline",
      intent: "primary",
      className: "border-primary-light text-primary-light hover:bg-primary-light focus-visible:bg-primary-light active:text-primary-light"
    },
    {
      hasIcon: !0,
      shape: "outline",
      intent: "positive",
      className: "hover:border-positive hover:bg-positive focus-visible:border-positive focus-visible:bg-positive active:border-positive-dark active:text-positive-dark"
    },
    {
      hasIcon: !0,
      shape: "outline",
      intent: "negative",
      className: "hover:border-negative hover:bg-negative focus-visible:border-negative focus-visible:bg-negative active:text-negative-dark"
    },
    {
      hasIcon: !0,
      shape: "link",
      className: "text-grayscale-dark hover:text-grayscale focus-visible:text-grayscale active:text-grayscale-dark disabled:text-grayscale-light disabled:bg-transparent"
    }
  ],
  defaultVariants: {
    intent: "primary",
    shape: "solid",
    size: "medium"
  }
});
function $t(t) {
  const e = ee(44);
  let n, r, o, i, a, s, l, c, d, u, m, h, v;
  e[0] !== t ? ({
    as: i,
    className: s,
    intent: d,
    shape: h,
    size: v,
    fullWidth: c,
    isLoading: u,
    error: l,
    children: a,
    Icon: n,
    PrefixIcon: r,
    SuffixIcon: o,
    ...m
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s, e[7] = l, e[8] = c, e[9] = d, e[10] = u, e[11] = m, e[12] = h, e[13] = v) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6], l = e[7], c = e[8], d = e[9], u = e[10], m = e[11], h = e[12], v = e[13]);
  const f = v === void 0 ? "medium" : v, {
    as: p,
    ...g
  } = jl({
    as: i || "button",
    ...m
  }), {
    disabled: y
  } = g, w = p, C = f === "medium" || f === "small" ? "size-sm" : "size-md";
  let S;
  e[14] !== n || e[15] !== r || e[16] !== o || e[17] !== a || e[18] !== C || e[19] !== f ? (S = n ? /* @__PURE__ */ b(n, { className: H(f === "small" && "size-sm", f === "medium" && "size-md", f === "large" && "size-lg") }) : /* @__PURE__ */ $(Ce, { children: [
    r ? /* @__PURE__ */ b(r, { className: C }) : null,
    a,
    o ? /* @__PURE__ */ b(o, { className: C }) : null
  ] }), e[14] = n, e[15] = r, e[16] = o, e[17] = a, e[18] = C, e[19] = f, e[20] = S) : S = e[20];
  const P = S, [E, N] = le(l);
  let T;
  e[21] !== l || e[22] !== N ? (T = () => {
    N(l);
  }, e[21] = l, e[22] = N, e[23] = T) : T = e[23];
  let k;
  e[24] !== l ? (k = [l], e[24] = l, e[25] = k) : k = e[25], fe(T, k);
  const D = H(Bh({
    intent: d,
    shape: h,
    size: f,
    hasIcon: !!n,
    className: s
  }), c && "w-full", (u || y) && "pointer-events-none cursor-default select-none", y && "bg-grayscale-xx-light text-grayscale shadow-none", E && "animate-shake");
  let F;
  e[26] !== N ? (F = () => N(!1), e[26] = N, e[27] = F) : F = e[27];
  const O = n && a;
  let _;
  e[28] !== u ? (_ = u ? /* @__PURE__ */ b(Gi, { className: "absolute animate-spin", "aria-hidden": !0 }) : null, e[28] = u, e[29] = _) : _ = e[29];
  const L = u && "opacity-0";
  let I;
  e[30] !== L ? (I = H("gap-2xs inline-flex items-center justify-center", L), e[30] = L, e[31] = I) : I = e[31];
  let R;
  e[32] !== P || e[33] !== I ? (R = /* @__PURE__ */ b("span", { className: I, children: P }), e[32] = P, e[33] = I, e[34] = R) : R = e[34];
  let A;
  return e[35] !== w || e[36] !== u || e[37] !== g || e[38] !== R || e[39] !== D || e[40] !== F || e[41] !== O || e[42] !== _ ? (A = /* @__PURE__ */ $(w, { className: D, onAnimationEnd: F, "aria-label": O, "aria-busy": u, ...g, children: [
    _,
    R
  ] }), e[35] = w, e[36] = u, e[37] = g, e[38] = R, e[39] = D, e[40] = F, e[41] = O, e[42] = _, e[43] = A) : A = e[43], A;
}
function cP(t) {
  const e = ee(11), {
    children: n,
    dismissable: r,
    onDismiss: o,
    className: i
  } = t, a = r === void 0 ? !1 : r, [s, l] = le(!0);
  if (!s)
    return null;
  let c;
  e[0] !== o ? (c = () => {
    l(!1), o == null || o();
  }, e[0] = o, e[1] = c) : c = e[1];
  const d = c;
  let u;
  e[2] !== i ? (u = H("border-grayscale-x-light px-sm py-sm bottom-sm relative sticky flex items-center justify-center rounded-md border bg-white shadow-lg", i), e[2] = i, e[3] = u) : u = e[3];
  let m;
  e[4] !== a || e[5] !== d ? (m = a && /* @__PURE__ */ b($t, { Icon: Wn, shape: "link", className: "right-sm absolute top-1/2 -translate-y-1/2", onClick: d }), e[4] = a, e[5] = d, e[6] = m) : m = e[6];
  let h;
  return e[7] !== n || e[8] !== u || e[9] !== m ? (h = /* @__PURE__ */ $("div", { className: u, children: [
    n,
    m
  ] }), e[7] = n, e[8] = u, e[9] = m, e[10] = h) : h = e[10], h;
}
function ea(t, e) {
  let n;
  return (...r) => {
    window.clearTimeout(n), n = window.setTimeout(() => t(...r), e);
  };
}
function zh({ debounce: t, scroll: e, polyfill: n, offsetSize: r } = { debounce: 0, scroll: !1, offsetSize: !1 }) {
  const o = n || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!o) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [i, a] = le({ left: 0, top: 0, width: 0, height: 0, bottom: 0, right: 0, x: 0, y: 0 }), s = pe({ element: null, scrollContainers: null, resizeObserver: null, lastBounds: i, orientationHandler: null }), l = t ? typeof t == "number" ? t : t.scroll : null, c = t ? typeof t == "number" ? t : t.resize : null, d = pe(!1);
  fe(() => (d.current = !0, () => void (d.current = !1)));
  const [u, m, h] = It(() => {
    const g = () => {
      if (!s.current.element) return;
      const { left: y, top: w, width: C, height: S, bottom: P, right: E, x: N, y: T } = s.current.element.getBoundingClientRect(), k = { left: y, top: w, width: C, height: S, bottom: P, right: E, x: N, y: T };
      s.current.element instanceof HTMLElement && r && (k.height = s.current.element.offsetHeight, k.width = s.current.element.offsetWidth), Object.freeze(k), d.current && !Uh(s.current.lastBounds, k) && a(s.current.lastBounds = k);
    };
    return [g, c ? ea(g, c) : g, l ? ea(g, l) : g];
  }, [a, r, l, c]);
  function v() {
    s.current.scrollContainers && (s.current.scrollContainers.forEach((g) => g.removeEventListener("scroll", h, !0)), s.current.scrollContainers = null), s.current.resizeObserver && (s.current.resizeObserver.disconnect(), s.current.resizeObserver = null), s.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", s.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", s.current.orientationHandler));
  }
  function f() {
    s.current.element && (s.current.resizeObserver = new o(h), s.current.resizeObserver.observe(s.current.element), e && s.current.scrollContainers && s.current.scrollContainers.forEach((g) => g.addEventListener("scroll", h, { capture: !0, passive: !0 })), s.current.orientationHandler = () => {
      h();
    }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", s.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", s.current.orientationHandler));
  }
  const p = (g) => {
    !g || g === s.current.element || (v(), s.current.element = g, s.current.scrollContainers = Gl(g), f());
  };
  return Yh(h, !!e), Hh(m), fe(() => {
    v(), f();
  }, [e, h, m]), fe(() => v, []), [p, i, u];
}
function Hh(t) {
  fe(() => {
    const e = t;
    return window.addEventListener("resize", e), () => void window.removeEventListener("resize", e);
  }, [t]);
}
function Yh(t, e) {
  fe(() => {
    if (e) {
      const n = t;
      return window.addEventListener("scroll", n, { capture: !0, passive: !0 }), () => void window.removeEventListener("scroll", n, !0);
    }
  }, [t, e]);
}
function Gl(t) {
  const e = [];
  if (!t || t === document.body) return e;
  const { overflow: n, overflowX: r, overflowY: o } = window.getComputedStyle(t);
  return [n, r, o].some((i) => i === "auto" || i === "scroll") && e.push(t), [...e, ...Gl(t.parentElement)];
}
const Kh = ["x", "y", "top", "bottom", "left", "right", "width", "height"], Uh = (t, e) => Kh.every((n) => t[n] === e[n]);
function at(t) {
  const e = x.useRef(t);
  return x.useEffect(() => {
    e.current = t;
  }), x.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function jh(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = at(t);
  x.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var Gh = "DismissableLayer", gi = "dismissableLayer.update", qh = "dismissableLayer.pointerDownOutside", Xh = "dismissableLayer.focusOutside", ta, ql = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Vn = x.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = t, c = x.useContext(ql), [d, u] = x.useState(null), m = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = x.useState({}), v = ae(e, (E) => u(E)), f = Array.from(c.layers), [p] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), g = f.indexOf(p), y = d ? f.indexOf(d) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, C = y >= g, S = Jh((E) => {
      const N = E.target, T = [...c.branches].some((k) => k.contains(N));
      !C || T || (o == null || o(E), a == null || a(E), E.defaultPrevented || s == null || s());
    }, m), P = Qh((E) => {
      const N = E.target;
      [...c.branches].some((k) => k.contains(N)) || (i == null || i(E), a == null || a(E), E.defaultPrevented || s == null || s());
    }, m);
    return jh((E) => {
      y === c.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && s && (E.preventDefault(), s()));
    }, m), x.useEffect(() => {
      if (d)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (ta = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), na(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = ta);
        };
    }, [d, m, n, c]), x.useEffect(() => () => {
      d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), na());
    }, [d, c]), x.useEffect(() => {
      const E = () => h({});
      return document.addEventListener(gi, E), () => document.removeEventListener(gi, E);
    }, []), /* @__PURE__ */ b(
      q.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: w ? C ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: U(t.onFocusCapture, P.onFocusCapture),
        onBlurCapture: U(t.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: U(
          t.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
Vn.displayName = Gh;
var Zh = "DismissableLayerBranch", Xl = x.forwardRef((t, e) => {
  const n = x.useContext(ql), r = x.useRef(null), o = ae(e, r);
  return x.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ b(q.div, { ...t, ref: o });
});
Xl.displayName = Zh;
function Jh(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = at(t), r = x.useRef(!1), o = x.useRef(() => {
  });
  return x.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Zl(
            qh,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", o.current), o.current = l, e.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", i), e.removeEventListener("click", o.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Qh(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = at(t), r = x.useRef(!1);
  return x.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Zl(Xh, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", o), () => e.removeEventListener("focusin", o);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function na() {
  const t = new CustomEvent(gi);
  document.dispatchEvent(t);
}
function Zl(t, e, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && o.addEventListener(t, e, { once: !0 }), r ? Il(o, i) : o.dispatchEvent(i);
}
var ep = Vn, tp = Xl, zo = 0;
function ns() {
  x.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? ra()), document.body.insertAdjacentElement("beforeend", t[1] ?? ra()), zo++, () => {
      zo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), zo--;
    };
  }, []);
}
function ra() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var Ho = "focusScope.autoFocusOnMount", Yo = "focusScope.autoFocusOnUnmount", oa = { bubbles: !1, cancelable: !0 }, np = "FocusScope", lo = x.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = t, [s, l] = x.useState(null), c = at(o), d = at(i), u = x.useRef(null), m = ae(e, (f) => l(f)), h = x.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  x.useEffect(() => {
    if (r) {
      let f = function(w) {
        if (h.paused || !s) return;
        const C = w.target;
        s.contains(C) ? u.current = C : Xt(u.current, { select: !0 });
      }, p = function(w) {
        if (h.paused || !s) return;
        const C = w.relatedTarget;
        C !== null && (s.contains(C) || Xt(u.current, { select: !0 }));
      }, g = function(w) {
        if (document.activeElement === document.body)
          for (const S of w)
            S.removedNodes.length > 0 && Xt(s);
      };
      document.addEventListener("focusin", f), document.addEventListener("focusout", p);
      const y = new MutationObserver(g);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", p), y.disconnect();
      };
    }
  }, [r, s, h.paused]), x.useEffect(() => {
    if (s) {
      sa.add(h);
      const f = document.activeElement;
      if (!s.contains(f)) {
        const g = new CustomEvent(Ho, oa);
        s.addEventListener(Ho, c), s.dispatchEvent(g), g.defaultPrevented || (rp(lp(Jl(s)), { select: !0 }), document.activeElement === f && Xt(s));
      }
      return () => {
        s.removeEventListener(Ho, c), setTimeout(() => {
          const g = new CustomEvent(Yo, oa);
          s.addEventListener(Yo, d), s.dispatchEvent(g), g.defaultPrevented || Xt(f ?? document.body, { select: !0 }), s.removeEventListener(Yo, d), sa.remove(h);
        }, 0);
      };
    }
  }, [s, c, d, h]);
  const v = x.useCallback(
    (f) => {
      if (!n && !r || h.paused) return;
      const p = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, g = document.activeElement;
      if (p && g) {
        const y = f.currentTarget, [w, C] = op(y);
        w && C ? !f.shiftKey && g === C ? (f.preventDefault(), n && Xt(w, { select: !0 })) : f.shiftKey && g === w && (f.preventDefault(), n && Xt(C, { select: !0 })) : g === y && f.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ b(q.div, { tabIndex: -1, ...a, ref: m, onKeyDown: v });
});
lo.displayName = np;
function rp(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Xt(r, { select: e }), document.activeElement !== n) return;
}
function op(t) {
  const e = Jl(t), n = ia(e, t), r = ia(e.reverse(), t);
  return [n, r];
}
function Jl(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function ia(t, e) {
  for (const n of t)
    if (!ip(n, { upTo: e })) return n;
}
function ip(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function sp(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Xt(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && sp(t) && e && t.select();
  }
}
var sa = ap();
function ap() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = aa(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = aa(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function aa(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function lp(t) {
  return t.filter((e) => e.tagName !== "A");
}
const cp = ["top", "right", "bottom", "left"], en = Math.min, Ze = Math.max, Yr = Math.round, Nr = Math.floor, Mt = (t) => ({
  x: t,
  y: t
}), up = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, dp = {
  start: "end",
  end: "start"
};
function bi(t, e, n) {
  return Ze(t, en(e, n));
}
function Bt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function zt(t) {
  return t.split("-")[0];
}
function Bn(t) {
  return t.split("-")[1];
}
function rs(t) {
  return t === "x" ? "y" : "x";
}
function os(t) {
  return t === "y" ? "height" : "width";
}
function Vt(t) {
  return ["top", "bottom"].includes(zt(t)) ? "y" : "x";
}
function is(t) {
  return rs(Vt(t));
}
function fp(t, e, n) {
  n === void 0 && (n = !1);
  const r = Bn(t), o = is(t), i = os(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (a = Kr(a)), [a, Kr(a)];
}
function mp(t) {
  const e = Kr(t);
  return [yi(t), e, yi(e)];
}
function yi(t) {
  return t.replace(/start|end/g, (e) => dp[e]);
}
function hp(t, e, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? o : r : e ? r : o;
    case "left":
    case "right":
      return e ? i : a;
    default:
      return [];
  }
}
function pp(t, e, n, r) {
  const o = Bn(t);
  let i = hp(zt(t), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), e && (i = i.concat(i.map(yi)))), i;
}
function Kr(t) {
  return t.replace(/left|right|bottom|top/g, (e) => up[e]);
}
function vp(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Ql(t) {
  return typeof t != "number" ? vp(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Ur(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: o
  } = t;
  return {
    width: r,
    height: o,
    top: n,
    left: e,
    right: e + r,
    bottom: n + o,
    x: e,
    y: n
  };
}
function la(t, e, n) {
  let {
    reference: r,
    floating: o
  } = t;
  const i = Vt(e), a = is(e), s = os(a), l = zt(e), c = i === "y", d = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, m = r[s] / 2 - o[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Bn(e)) {
    case "start":
      h[a] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      h[a] += m * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const gp = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let c = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: o
  }), {
    x: d,
    y: u
  } = la(c, r, l), m = r, h = {}, v = 0;
  for (let f = 0; f < s.length; f++) {
    const {
      name: p,
      fn: g
    } = s[f], {
      x: y,
      y: w,
      data: C,
      reset: S
    } = await g({
      x: d,
      y: u,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = y ?? d, u = w ?? u, h = {
      ...h,
      [p]: {
        ...h[p],
        ...C
      }
    }, S && v <= 50 && (v++, typeof S == "object" && (S.placement && (m = S.placement), S.rects && (c = S.rects === !0 ? await a.getElementRects({
      reference: t,
      floating: e,
      strategy: o
    }) : S.rects), {
      x: d,
      y: u
    } = la(c, m, l)), f = -1);
  }
  return {
    x: d,
    y: u,
    placement: m,
    strategy: o,
    middlewareData: h
  };
};
async function nr(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = Bt(e, t), v = Ql(h), p = s[m ? u === "floating" ? "reference" : "floating" : u], g = Ur(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(p))) == null || n ? p : p.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), y = u === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), C = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ur(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: w,
    strategy: l
  }) : y);
  return {
    top: (g.top - S.top + v.top) / C.y,
    bottom: (S.bottom - g.bottom + v.bottom) / C.y,
    left: (g.left - S.left + v.left) / C.x,
    right: (S.right - g.right + v.right) / C.x
  };
}
const bp = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = e, {
      element: c,
      padding: d = 0
    } = Bt(t, e) || {};
    if (c == null)
      return {};
    const u = Ql(d), m = {
      x: n,
      y: r
    }, h = is(o), v = os(h), f = await a.getDimensions(c), p = h === "y", g = p ? "top" : "left", y = p ? "bottom" : "right", w = p ? "clientHeight" : "clientWidth", C = i.reference[v] + i.reference[h] - m[h] - i.floating[v], S = m[h] - i.reference[h], P = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let E = P ? P[w] : 0;
    (!E || !await (a.isElement == null ? void 0 : a.isElement(P))) && (E = s.floating[w] || i.floating[v]);
    const N = C / 2 - S / 2, T = E / 2 - f[v] / 2 - 1, k = en(u[g], T), D = en(u[y], T), F = k, O = E - f[v] - D, _ = E / 2 - f[v] / 2 + N, L = bi(F, _, O), I = !l.arrow && Bn(o) != null && _ !== L && i.reference[v] / 2 - (_ < F ? k : D) - f[v] / 2 < 0, R = I ? _ < F ? _ - F : _ - O : 0;
    return {
      [h]: m[h] + R,
      data: {
        [h]: L,
        centerOffset: _ - L - R,
        ...I && {
          alignmentOffset: R
        }
      },
      reset: I
    };
  }
}), yp = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = e, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: f = !0,
        ...p
      } = Bt(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = zt(o), y = Vt(s), w = zt(s) === s, C = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = m || (w || !f ? [Kr(s)] : mp(s)), P = v !== "none";
      !m && P && S.push(...pp(s, f, v, C));
      const E = [s, ...S], N = await nr(e, p), T = [];
      let k = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && T.push(N[g]), u) {
        const L = fp(o, a, C);
        T.push(N[L[0]], N[L[1]]);
      }
      if (k = [...k, {
        placement: o,
        overflows: T
      }], !T.every((L) => L <= 0)) {
        var D, F;
        const L = (((D = i.flip) == null ? void 0 : D.index) || 0) + 1, I = E[L];
        if (I) {
          var O;
          const A = u === "alignment" ? y !== Vt(I) : !1, M = ((O = k[0]) == null ? void 0 : O.overflows[0]) > 0;
          if (!A || M)
            return {
              data: {
                index: L,
                overflows: k
              },
              reset: {
                placement: I
              }
            };
        }
        let R = (F = k.filter((A) => A.overflows[0] <= 0).sort((A, M) => A.overflows[1] - M.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!R)
          switch (h) {
            case "bestFit": {
              var _;
              const A = (_ = k.filter((M) => {
                if (P) {
                  const W = Vt(M.placement);
                  return W === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  W === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((W) => W > 0).reduce((W, z) => W + z, 0)]).sort((M, W) => M[1] - W[1])[0]) == null ? void 0 : _[0];
              A && (R = A);
              break;
            }
            case "initialPlacement":
              R = s;
              break;
          }
        if (o !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
};
function ca(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function ua(t) {
  return cp.some((e) => t[e] >= 0);
}
const wp = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...o
      } = Bt(t, e);
      switch (r) {
        case "referenceHidden": {
          const i = await nr(e, {
            ...o,
            elementContext: "reference"
          }), a = ca(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: ua(a)
            }
          };
        }
        case "escaped": {
          const i = await nr(e, {
            ...o,
            altBoundary: !0
          }), a = ca(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: ua(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function xp(t, e) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = t, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = zt(n), s = Bn(n), l = Vt(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, d = i && l ? -1 : 1, u = Bt(e, t);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: v
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof v == "number" && (h = s === "end" ? v * -1 : v), l ? {
    x: h * d,
    y: m * c
  } : {
    x: m * c,
    y: h * d
  };
}
const Sp = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = e, l = await xp(e, t);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, Cp = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: o
      } = e, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (p) => {
            let {
              x: g,
              y
            } = p;
            return {
              x: g,
              y
            };
          }
        },
        ...l
      } = Bt(t, e), c = {
        x: n,
        y: r
      }, d = await nr(e, l), u = Vt(zt(o)), m = rs(u);
      let h = c[m], v = c[u];
      if (i) {
        const p = m === "y" ? "top" : "left", g = m === "y" ? "bottom" : "right", y = h + d[p], w = h - d[g];
        h = bi(y, h, w);
      }
      if (a) {
        const p = u === "y" ? "top" : "left", g = u === "y" ? "bottom" : "right", y = v + d[p], w = v - d[g];
        v = bi(y, v, w);
      }
      const f = s.fn({
        ...e,
        [m]: h,
        [u]: v
      });
      return {
        ...f,
        data: {
          x: f.x - n,
          y: f.y - r,
          enabled: {
            [m]: i,
            [u]: a
          }
        }
      };
    }
  };
}, Ep = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = e, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Bt(t, e), d = {
        x: n,
        y: r
      }, u = Vt(o), m = rs(u);
      let h = d[m], v = d[u];
      const f = Bt(s, e), p = typeof f == "number" ? {
        mainAxis: f,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...f
      };
      if (l) {
        const w = m === "y" ? "height" : "width", C = i.reference[m] - i.floating[w] + p.mainAxis, S = i.reference[m] + i.reference[w] - p.mainAxis;
        h < C ? h = C : h > S && (h = S);
      }
      if (c) {
        var g, y;
        const w = m === "y" ? "width" : "height", C = ["top", "left"].includes(zt(o)), S = i.reference[u] - i.floating[w] + (C && ((g = a.offset) == null ? void 0 : g[u]) || 0) + (C ? 0 : p.crossAxis), P = i.reference[u] + i.reference[w] + (C ? 0 : ((y = a.offset) == null ? void 0 : y[u]) || 0) - (C ? p.crossAxis : 0);
        v < S ? v = S : v > P && (v = P);
      }
      return {
        [m]: h,
        [u]: v
      };
    }
  };
}, Pp = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: s
      } = e, {
        apply: l = () => {
        },
        ...c
      } = Bt(t, e), d = await nr(e, c), u = zt(o), m = Bn(o), h = Vt(o) === "y", {
        width: v,
        height: f
      } = i.floating;
      let p, g;
      u === "top" || u === "bottom" ? (p = u, g = m === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = u, p = m === "end" ? "top" : "bottom");
      const y = f - d.top - d.bottom, w = v - d.left - d.right, C = en(f - d[p], y), S = en(v - d[g], w), P = !e.middlewareData.shift;
      let E = C, N = S;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (N = w), (r = e.middlewareData.shift) != null && r.enabled.y && (E = y), P && !m) {
        const k = Ze(d.left, 0), D = Ze(d.right, 0), F = Ze(d.top, 0), O = Ze(d.bottom, 0);
        h ? N = v - 2 * (k !== 0 || D !== 0 ? k + D : Ze(d.left, d.right)) : E = f - 2 * (F !== 0 || O !== 0 ? F + O : Ze(d.top, d.bottom));
      }
      await l({
        ...e,
        availableWidth: N,
        availableHeight: E
      });
      const T = await a.getDimensions(s.floating);
      return v !== T.width || f !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function co() {
  return typeof window < "u";
}
function zn(t) {
  return ec(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function et(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Dt(t) {
  var e;
  return (e = (ec(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function ec(t) {
  return co() ? t instanceof Node || t instanceof et(t).Node : !1;
}
function vt(t) {
  return co() ? t instanceof Element || t instanceof et(t).Element : !1;
}
function kt(t) {
  return co() ? t instanceof HTMLElement || t instanceof et(t).HTMLElement : !1;
}
function da(t) {
  return !co() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof et(t).ShadowRoot;
}
function ur(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: o
  } = gt(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(o);
}
function Np(t) {
  return ["table", "td", "th"].includes(zn(t));
}
function uo(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function ss(t) {
  const e = as(), n = vt(t) ? gt(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Op(t) {
  let e = tn(t);
  for (; kt(e) && !kn(e); ) {
    if (ss(e))
      return e;
    if (uo(e))
      return null;
    e = tn(e);
  }
  return null;
}
function as() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function kn(t) {
  return ["html", "body", "#document"].includes(zn(t));
}
function gt(t) {
  return et(t).getComputedStyle(t);
}
function fo(t) {
  return vt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function tn(t) {
  if (zn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    da(t) && t.host || // Fallback.
    Dt(t)
  );
  return da(e) ? e.host : e;
}
function tc(t) {
  const e = tn(t);
  return kn(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : kt(e) && ur(e) ? e : tc(e);
}
function rr(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const o = tc(t), i = o === ((r = t.ownerDocument) == null ? void 0 : r.body), a = et(o);
  if (i) {
    const s = wi(a);
    return e.concat(a, a.visualViewport || [], ur(o) ? o : [], s && n ? rr(s) : []);
  }
  return e.concat(o, rr(o, [], n));
}
function wi(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function nc(t) {
  const e = gt(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const o = kt(t), i = o ? t.offsetWidth : n, a = o ? t.offsetHeight : r, s = Yr(n) !== i || Yr(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function ls(t) {
  return vt(t) ? t : t.contextElement;
}
function On(t) {
  const e = ls(t);
  if (!kt(e))
    return Mt(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = nc(e);
  let a = (i ? Yr(n.width) : n.width) / r, s = (i ? Yr(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const Tp = /* @__PURE__ */ Mt(0);
function rc(t) {
  const e = et(t);
  return !as() || !e.visualViewport ? Tp : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Ip(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== et(t) ? !1 : e;
}
function cn(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), i = ls(t);
  let a = Mt(1);
  e && (r ? vt(r) && (a = On(r)) : a = On(t));
  const s = Ip(i, n, r) ? rc(i) : Mt(0);
  let l = (o.left + s.x) / a.x, c = (o.top + s.y) / a.y, d = o.width / a.x, u = o.height / a.y;
  if (i) {
    const m = et(i), h = r && vt(r) ? et(r) : r;
    let v = m, f = wi(v);
    for (; f && r && h !== v; ) {
      const p = On(f), g = f.getBoundingClientRect(), y = gt(f), w = g.left + (f.clientLeft + parseFloat(y.paddingLeft)) * p.x, C = g.top + (f.clientTop + parseFloat(y.paddingTop)) * p.y;
      l *= p.x, c *= p.y, d *= p.x, u *= p.y, l += w, c += C, v = et(f), f = wi(v);
    }
  }
  return Ur({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function cs(t, e) {
  const n = fo(t).scrollLeft;
  return e ? e.left + n : cn(Dt(t)).left + n;
}
function oc(t, e, n) {
  n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), o = r.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    cs(t, r)
  )), i = r.top + e.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Mp(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: o
  } = t;
  const i = o === "fixed", a = Dt(r), s = e ? uo(e.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Mt(1);
  const d = Mt(0), u = kt(r);
  if ((u || !u && !i) && ((zn(r) !== "body" || ur(a)) && (l = fo(r)), kt(r))) {
    const h = cn(r);
    c = On(r), d.x = h.x + r.clientLeft, d.y = h.y + r.clientTop;
  }
  const m = a && !u && !i ? oc(a, l, !0) : Mt(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x + m.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y + m.y
  };
}
function kp(t) {
  return Array.from(t.getClientRects());
}
function _p(t) {
  const e = Dt(t), n = fo(t), r = t.ownerDocument.body, o = Ze(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), i = Ze(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + cs(t);
  const s = -n.scrollTop;
  return gt(r).direction === "rtl" && (a += Ze(e.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function Dp(t, e) {
  const n = et(t), r = Dt(t), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = as();
    (!c || c && e === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function Rp(t, e) {
  const n = cn(t, !0, e === "fixed"), r = n.top + t.clientTop, o = n.left + t.clientLeft, i = kt(t) ? On(t) : Mt(1), a = t.clientWidth * i.x, s = t.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function fa(t, e, n) {
  let r;
  if (e === "viewport")
    r = Dp(t, n);
  else if (e === "document")
    r = _p(Dt(t));
  else if (vt(e))
    r = Rp(e, n);
  else {
    const o = rc(t);
    r = {
      x: e.x - o.x,
      y: e.y - o.y,
      width: e.width,
      height: e.height
    };
  }
  return Ur(r);
}
function ic(t, e) {
  const n = tn(t);
  return n === e || !vt(n) || kn(n) ? !1 : gt(n).position === "fixed" || ic(n, e);
}
function Ap(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = rr(t, [], !1).filter((s) => vt(s) && zn(s) !== "body"), o = null;
  const i = gt(t).position === "fixed";
  let a = i ? tn(t) : t;
  for (; vt(a) && !kn(a); ) {
    const s = gt(a), l = ss(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ur(a) && !l && ic(t, a)) ? r = r.filter((d) => d !== a) : o = s, a = tn(a);
  }
  return e.set(t, r), r;
}
function Fp(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = t;
  const a = [...n === "clippingAncestors" ? uo(e) ? [] : Ap(e, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, d) => {
    const u = fa(e, d, o);
    return c.top = Ze(u.top, c.top), c.right = en(u.right, c.right), c.bottom = en(u.bottom, c.bottom), c.left = Ze(u.left, c.left), c;
  }, fa(e, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Lp(t) {
  const {
    width: e,
    height: n
  } = nc(t);
  return {
    width: e,
    height: n
  };
}
function Wp(t, e, n) {
  const r = kt(e), o = Dt(e), i = n === "fixed", a = cn(t, !0, i, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Mt(0);
  function c() {
    l.x = cs(o);
  }
  if (r || !r && !i)
    if ((zn(e) !== "body" || ur(o)) && (s = fo(e)), r) {
      const h = cn(e, !0, i, e);
      l.x = h.x + e.clientLeft, l.y = h.y + e.clientTop;
    } else o && c();
  i && !r && o && c();
  const d = o && !r && !i ? oc(o, s) : Mt(0), u = a.left + s.scrollLeft - l.x - d.x, m = a.top + s.scrollTop - l.y - d.y;
  return {
    x: u,
    y: m,
    width: a.width,
    height: a.height
  };
}
function Ko(t) {
  return gt(t).position === "static";
}
function ma(t, e) {
  if (!kt(t) || gt(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return Dt(t) === n && (n = n.ownerDocument.body), n;
}
function sc(t, e) {
  const n = et(t);
  if (uo(t))
    return n;
  if (!kt(t)) {
    let o = tn(t);
    for (; o && !kn(o); ) {
      if (vt(o) && !Ko(o))
        return o;
      o = tn(o);
    }
    return n;
  }
  let r = ma(t, e);
  for (; r && Np(r) && Ko(r); )
    r = ma(r, e);
  return r && kn(r) && Ko(r) && !ss(r) ? n : r || Op(t) || n;
}
const $p = async function(t) {
  const e = this.getOffsetParent || sc, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: Wp(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Vp(t) {
  return gt(t).direction === "rtl";
}
const Bp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Mp,
  getDocumentElement: Dt,
  getClippingRect: Fp,
  getOffsetParent: sc,
  getElementRects: $p,
  getClientRects: kp,
  getDimensions: Lp,
  getScale: On,
  isElement: vt,
  isRTL: Vp
};
function ac(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function zp(t, e) {
  let n = null, r;
  const o = Dt(t);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = t.getBoundingClientRect(), {
      left: d,
      top: u,
      width: m,
      height: h
    } = c;
    if (s || e(), !m || !h)
      return;
    const v = Nr(u), f = Nr(o.clientWidth - (d + m)), p = Nr(o.clientHeight - (u + h)), g = Nr(d), w = {
      rootMargin: -v + "px " + -f + "px " + -p + "px " + -g + "px",
      threshold: Ze(0, en(1, l)) || 1
    };
    let C = !0;
    function S(P) {
      const E = P[0].intersectionRatio;
      if (E !== l) {
        if (!C)
          return a();
        E ? a(!1, E) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !ac(c, t.getBoundingClientRect()) && a(), C = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, w);
    }
    n.observe(t);
  }
  return a(!0), i;
}
function Hp(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = ls(t), d = o || i ? [...c ? rr(c) : [], ...rr(e)] : [];
  d.forEach((g) => {
    o && g.addEventListener("scroll", n, {
      passive: !0
    }), i && g.addEventListener("resize", n);
  });
  const u = c && s ? zp(c, n) : null;
  let m = -1, h = null;
  a && (h = new ResizeObserver((g) => {
    let [y] = g;
    y && y.target === c && h && (h.unobserve(e), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(e);
    })), n();
  }), c && !l && h.observe(c), h.observe(e));
  let v, f = l ? cn(t) : null;
  l && p();
  function p() {
    const g = cn(t);
    f && !ac(f, g) && n(), f = g, v = requestAnimationFrame(p);
  }
  return n(), () => {
    var g;
    d.forEach((y) => {
      o && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), u == null || u(), (g = h) == null || g.disconnect(), h = null, l && cancelAnimationFrame(v);
  };
}
const Yp = Sp, Kp = Cp, Up = yp, jp = Pp, Gp = wp, ha = bp, qp = Ep, Xp = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Bp,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return gp(t, e, {
    ...o,
    platform: i
  });
};
var Ar = typeof document < "u" ? ji : fe;
function jr(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, o;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (r = n; r-- !== 0; )
        if (!jr(t[r], e[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(t), n = o.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && t.$$typeof) && !jr(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function lc(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function pa(t, e) {
  const n = lc(t);
  return Math.round(e * n) / n;
}
function Uo(t) {
  const e = x.useRef(t);
  return Ar(() => {
    e.current = t;
  }), e;
}
function Zp(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = t, [d, u] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [m, h] = x.useState(r);
  jr(m, r) || h(r);
  const [v, f] = x.useState(null), [p, g] = x.useState(null), y = x.useCallback((A) => {
    A !== P.current && (P.current = A, f(A));
  }, []), w = x.useCallback((A) => {
    A !== E.current && (E.current = A, g(A));
  }, []), C = i || v, S = a || p, P = x.useRef(null), E = x.useRef(null), N = x.useRef(d), T = l != null, k = Uo(l), D = Uo(o), F = Uo(c), O = x.useCallback(() => {
    if (!P.current || !E.current)
      return;
    const A = {
      placement: e,
      strategy: n,
      middleware: m
    };
    D.current && (A.platform = D.current), Xp(P.current, E.current, A).then((M) => {
      const W = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      _.current && !jr(N.current, W) && (N.current = W, lr.flushSync(() => {
        u(W);
      }));
    });
  }, [m, e, n, D, F]);
  Ar(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, u((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [c]);
  const _ = x.useRef(!1);
  Ar(() => (_.current = !0, () => {
    _.current = !1;
  }), []), Ar(() => {
    if (C && (P.current = C), S && (E.current = S), C && S) {
      if (k.current)
        return k.current(C, S, O);
      O();
    }
  }, [C, S, O, k, T]);
  const L = x.useMemo(() => ({
    reference: P,
    floating: E,
    setReference: y,
    setFloating: w
  }), [y, w]), I = x.useMemo(() => ({
    reference: C,
    floating: S
  }), [C, S]), R = x.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return A;
    const M = pa(I.floating, d.x), W = pa(I.floating, d.y);
    return s ? {
      ...A,
      transform: "translate(" + M + "px, " + W + "px)",
      ...lc(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: W
    };
  }, [n, s, I.floating, d.x, d.y]);
  return x.useMemo(() => ({
    ...d,
    update: O,
    refs: L,
    elements: I,
    floatingStyles: R
  }), [d, O, L, I, R]);
}
const Jp = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? ha({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? ha({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Qp = (t, e) => ({
  ...Yp(t),
  options: [t, e]
}), ev = (t, e) => ({
  ...Kp(t),
  options: [t, e]
}), tv = (t, e) => ({
  ...qp(t),
  options: [t, e]
}), nv = (t, e) => ({
  ...Up(t),
  options: [t, e]
}), rv = (t, e) => ({
  ...jp(t),
  options: [t, e]
}), ov = (t, e) => ({
  ...Gp(t),
  options: [t, e]
}), iv = (t, e) => ({
  ...Jp(t),
  options: [t, e]
});
var sv = "Arrow", cc = x.forwardRef((t, e) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = t;
  return /* @__PURE__ */ b(
    q.svg,
    {
      ...i,
      ref: e,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ b("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
cc.displayName = sv;
var av = cc;
function dr(t) {
  const [e, n] = x.useState(void 0);
  return De(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = t.offsetWidth, s = t.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(t, { box: "border-box" }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
var us = "Popper", [uc, Hn] = Ye(us), [lv, dc] = uc(us), fc = (t) => {
  const { __scopePopper: e, children: n } = t, [r, o] = x.useState(null);
  return /* @__PURE__ */ b(lv, { scope: e, anchor: r, onAnchorChange: o, children: n });
};
fc.displayName = us;
var mc = "PopperAnchor", hc = x.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: r, ...o } = t, i = dc(mc, n), a = x.useRef(null), s = ae(e, a);
    return x.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ b(q.div, { ...o, ref: s });
  }
);
hc.displayName = mc;
var ds = "PopperContent", [cv, uv] = uc(ds), pc = x.forwardRef(
  (t, e) => {
    var Y, Z, ie, te, ne, re;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: d = 0,
      sticky: u = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...f
    } = t, p = dc(ds, n), [g, y] = x.useState(null), w = ae(e, (xe) => y(xe)), [C, S] = x.useState(null), P = dr(C), E = (P == null ? void 0 : P.width) ?? 0, N = (P == null ? void 0 : P.height) ?? 0, T = r + (i !== "center" ? "-" + i : ""), k = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, D = Array.isArray(c) ? c : [c], F = D.length > 0, O = {
      padding: k,
      boundary: D.filter(fv),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: _, floatingStyles: L, placement: I, isPositioned: R, middlewareData: A } = Zp({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...xe) => Hp(...xe, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: p.anchor
      },
      middleware: [
        Qp({ mainAxis: o + N, alignmentAxis: a }),
        l && ev({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? tv() : void 0,
          ...O
        }),
        l && nv({ ...O }),
        rv({
          ...O,
          apply: ({ elements: xe, rects: Ee, availableWidth: Ke, availableHeight: Ae }) => {
            const { width: Ge, height: nt } = Ee.reference, Ve = xe.floating.style;
            Ve.setProperty("--radix-popper-available-width", `${Ke}px`), Ve.setProperty("--radix-popper-available-height", `${Ae}px`), Ve.setProperty("--radix-popper-anchor-width", `${Ge}px`), Ve.setProperty("--radix-popper-anchor-height", `${nt}px`);
          }
        }),
        C && iv({ element: C, padding: s }),
        mv({ arrowWidth: E, arrowHeight: N }),
        m && ov({ strategy: "referenceHidden", ...O })
      ]
    }), [M, W] = bc(I), z = at(v);
    De(() => {
      R && (z == null || z());
    }, [R, z]);
    const K = (Y = A.arrow) == null ? void 0 : Y.x, j = (Z = A.arrow) == null ? void 0 : Z.y, G = ((ie = A.arrow) == null ? void 0 : ie.centerOffset) !== 0, [J, oe] = x.useState();
    return De(() => {
      g && oe(window.getComputedStyle(g).zIndex);
    }, [g]), /* @__PURE__ */ b(
      "div",
      {
        ref: _.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...L,
          transform: R ? L.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: J,
          "--radix-popper-transform-origin": [
            (te = A.transformOrigin) == null ? void 0 : te.x,
            (ne = A.transformOrigin) == null ? void 0 : ne.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((re = A.hide) == null ? void 0 : re.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ b(
          cv,
          {
            scope: n,
            placedSide: M,
            onArrowChange: S,
            arrowX: K,
            arrowY: j,
            shouldHideArrow: G,
            children: /* @__PURE__ */ b(
              q.div,
              {
                "data-side": M,
                "data-align": W,
                ...f,
                ref: w,
                style: {
                  ...f.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: R ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
pc.displayName = ds;
var vc = "PopperArrow", dv = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, gc = x.forwardRef(function(e, n) {
  const { __scopePopper: r, ...o } = e, i = uv(vc, r), a = dv[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ b(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ b(
          av,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
gc.displayName = vc;
function fv(t) {
  return t !== null;
}
var mv = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var p, g, y;
    const { placement: n, rects: r, middlewareData: o } = e, a = ((p = o.arrow) == null ? void 0 : p.centerOffset) !== 0, s = a ? 0 : t.arrowWidth, l = a ? 0 : t.arrowHeight, [c, d] = bc(n), u = { start: "0%", center: "50%", end: "100%" }[d], m = (((g = o.arrow) == null ? void 0 : g.x) ?? 0) + s / 2, h = (((y = o.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let v = "", f = "";
    return c === "bottom" ? (v = a ? u : `${m}px`, f = `${-l}px`) : c === "top" ? (v = a ? u : `${m}px`, f = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, f = a ? u : `${h}px`) : c === "left" && (v = `${r.floating.width + l}px`, f = a ? u : `${h}px`), { data: { x: v, y: f } };
  }
});
function bc(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var fs = fc, mo = hc, ms = pc, hs = gc, hv = "Portal", Yn = x.forwardRef((t, e) => {
  var s;
  const { container: n, ...r } = t, [o, i] = x.useState(!1);
  De(() => i(!0), []);
  const a = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Fm.createPortal(/* @__PURE__ */ b(q.div, { ...r, ref: e }), a) : null;
});
Yn.displayName = hv;
var pv = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, wn = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), Tr = {}, jo = 0, yc = function(t) {
  return t && (t.host || yc(t.parentNode));
}, vv = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = yc(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, gv = function(t, e, n, r) {
  var o = vv(e, Array.isArray(t) ? t : [t]);
  Tr[n] || (Tr[n] = /* @__PURE__ */ new WeakMap());
  var i = Tr[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(u) {
    !u || s.has(u) || (s.add(u), c(u.parentNode));
  };
  o.forEach(c);
  var d = function(u) {
    !u || l.has(u) || Array.prototype.forEach.call(u.children, function(m) {
      if (s.has(m))
        d(m);
      else
        try {
          var h = m.getAttribute(r), v = h !== null && h !== "false", f = (wn.get(m) || 0) + 1, p = (i.get(m) || 0) + 1;
          wn.set(m, f), i.set(m, p), a.push(m), f === 1 && v && Or.set(m, !0), p === 1 && m.setAttribute(n, "true"), v || m.setAttribute(r, "true");
        } catch (g) {
          console.error("aria-hidden: cannot operate on ", m, g);
        }
    });
  };
  return d(e), s.clear(), jo++, function() {
    a.forEach(function(u) {
      var m = wn.get(u) - 1, h = i.get(u) - 1;
      wn.set(u, m), i.set(u, h), m || (Or.has(u) || u.removeAttribute(r), Or.delete(u)), h || u.removeAttribute(n);
    }), jo--, jo || (wn = /* @__PURE__ */ new WeakMap(), wn = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), Tr = {});
  };
}, ps = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), o = pv(t);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), gv(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Pt = function() {
  return Pt = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, Pt.apply(this, arguments);
};
function wc(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function bv(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, o = e.length, i; r < o; r++)
    (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var Fr = "right-scroll-bar-position", Lr = "width-before-scroll-bar", yv = "with-scroll-bars-hidden", wv = "--removed-body-scroll-bar-size";
function Go(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function xv(t, e) {
  var n = le(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var Sv = typeof window < "u" ? x.useLayoutEffect : x.useEffect, va = /* @__PURE__ */ new WeakMap();
function Cv(t, e) {
  var n = xv(null, function(r) {
    return t.forEach(function(o) {
      return Go(o, r);
    });
  });
  return Sv(function() {
    var r = va.get(n);
    if (r) {
      var o = new Set(r), i = new Set(t), a = n.current;
      o.forEach(function(s) {
        i.has(s) || Go(s, null);
      }), i.forEach(function(s) {
        o.has(s) || Go(s, a);
      });
    }
    va.set(n, t);
  }, [t]), n;
}
function Ev(t) {
  return t;
}
function Pv(t, e) {
  e === void 0 && (e = Ev);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(i) {
      var a = e(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var l = function() {
        var d = a;
        a = [], d.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(d) {
          a.push(d), c();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return o;
}
function Nv(t) {
  t === void 0 && (t = {});
  var e = Pv(null);
  return e.options = Pt({ async: !0, ssr: !1 }, t), e;
}
var xc = function(t) {
  var e = t.sideCar, n = wc(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return x.createElement(r, Pt({}, n));
};
xc.isSideCarExport = !0;
function Ov(t, e) {
  return t.useMedium(e), xc;
}
var Sc = Nv(), qo = function() {
}, ho = x.forwardRef(function(t, e) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: qo,
    onWheelCapture: qo,
    onTouchMoveCapture: qo
  }), o = r[0], i = r[1], a = t.forwardProps, s = t.children, l = t.className, c = t.removeScrollBar, d = t.enabled, u = t.shards, m = t.sideCar, h = t.noRelative, v = t.noIsolation, f = t.inert, p = t.allowPinchZoom, g = t.as, y = g === void 0 ? "div" : g, w = t.gapMode, C = wc(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = m, P = Cv([n, e]), E = Pt(Pt({}, C), o);
  return x.createElement(
    x.Fragment,
    null,
    d && x.createElement(S, { sideCar: Sc, removeScrollBar: c, shards: u, noRelative: h, noIsolation: v, inert: f, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: w }),
    a ? x.cloneElement(x.Children.only(s), Pt(Pt({}, E), { ref: P })) : x.createElement(y, Pt({}, E, { className: l, ref: P }), s)
  );
});
ho.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ho.classNames = {
  fullWidth: Lr,
  zeroRight: Fr
};
var Tv = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Iv() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = Tv();
  return e && t.setAttribute("nonce", e), t;
}
function Mv(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function kv(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var _v = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = Iv()) && (Mv(e, n), kv(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, Dv = function() {
  var t = _v();
  return function(e, n) {
    x.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, Cc = function() {
  var t = Dv(), e = function(n) {
    var r = n.styles, o = n.dynamic;
    return t(r, o), null;
  };
  return e;
}, Rv = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Xo = function(t) {
  return parseInt(t || "", 10) || 0;
}, Av = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], o = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Xo(n), Xo(r), Xo(o)];
}, Fv = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return Rv;
  var e = Av(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, Lv = Cc(), Tn = "data-scroll-locked", Wv = function(t, e, n, r) {
  var o = t.left, i = t.top, a = t.right, s = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(yv, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Tn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Fr, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Lr, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Fr, " .").concat(Fr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Lr, " .").concat(Lr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Tn, `] {
    `).concat(wv, ": ").concat(s, `px;
  }
`);
}, ga = function() {
  var t = parseInt(document.body.getAttribute(Tn) || "0", 10);
  return isFinite(t) ? t : 0;
}, $v = function() {
  x.useEffect(function() {
    return document.body.setAttribute(Tn, (ga() + 1).toString()), function() {
      var t = ga() - 1;
      t <= 0 ? document.body.removeAttribute(Tn) : document.body.setAttribute(Tn, t.toString());
    };
  }, []);
}, Vv = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, o = r === void 0 ? "margin" : r;
  $v();
  var i = x.useMemo(function() {
    return Fv(o);
  }, [o]);
  return x.createElement(Lv, { styles: Wv(i, !e, o, n ? "" : "!important") });
}, xi = !1;
if (typeof window < "u")
  try {
    var Ir = Object.defineProperty({}, "passive", {
      get: function() {
        return xi = !0, !0;
      }
    });
    window.addEventListener("test", Ir, Ir), window.removeEventListener("test", Ir, Ir);
  } catch {
    xi = !1;
  }
var xn = xi ? { passive: !1 } : !1, Bv = function(t) {
  return t.tagName === "TEXTAREA";
}, Ec = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Bv(t) && n[e] === "visible")
  );
}, zv = function(t) {
  return Ec(t, "overflowY");
}, Hv = function(t) {
  return Ec(t, "overflowX");
}, ba = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Pc(t, r);
    if (o) {
      var i = Nc(t, r), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Yv = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, Kv = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, Pc = function(t, e) {
  return t === "v" ? zv(e) : Hv(e);
}, Nc = function(t, e) {
  return t === "v" ? Yv(e) : Kv(e);
}, Uv = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, jv = function(t, e, n, r, o) {
  var i = Uv(t, window.getComputedStyle(e).direction), a = i * r, s = n.target, l = e.contains(s), c = !1, d = a > 0, u = 0, m = 0;
  do {
    var h = Nc(t, s), v = h[0], f = h[1], p = h[2], g = f - p - i * v;
    (v || g) && Pc(t, s) && (u += g, m += v), s = s.parentNode.host || s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (e.contains(s) || e === s)
  );
  return (d && Math.abs(u) < 1 || !d && Math.abs(m) < 1) && (c = !0), c;
}, Mr = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, ya = function(t) {
  return [t.deltaX, t.deltaY];
}, wa = function(t) {
  return t && "current" in t ? t.current : t;
}, Gv = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, qv = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, Xv = 0, Sn = [];
function Zv(t) {
  var e = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), o = x.useState(Xv++)[0], i = x.useState(Cc)[0], a = x.useRef(t);
  x.useEffect(function() {
    a.current = t;
  }, [t]), x.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var f = bv([t.lockRef.current], (t.shards || []).map(wa), !0).filter(Boolean);
      return f.forEach(function(p) {
        return p.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), f.forEach(function(p) {
          return p.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = x.useCallback(function(f, p) {
    if ("touches" in f && f.touches.length === 2 || f.type === "wheel" && f.ctrlKey)
      return !a.current.allowPinchZoom;
    var g = Mr(f), y = n.current, w = "deltaX" in f ? f.deltaX : y[0] - g[0], C = "deltaY" in f ? f.deltaY : y[1] - g[1], S, P = f.target, E = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in f && E === "h" && P.type === "range")
      return !1;
    var N = ba(E, P);
    if (!N)
      return !0;
    if (N ? S = E : (S = E === "v" ? "h" : "v", N = ba(E, P)), !N)
      return !1;
    if (!r.current && "changedTouches" in f && (w || C) && (r.current = S), !S)
      return !0;
    var T = r.current || S;
    return jv(T, p, f, T === "h" ? w : C);
  }, []), l = x.useCallback(function(f) {
    var p = f;
    if (!(!Sn.length || Sn[Sn.length - 1] !== i)) {
      var g = "deltaY" in p ? ya(p) : Mr(p), y = e.current.filter(function(S) {
        return S.name === p.type && (S.target === p.target || p.target === S.shadowParent) && Gv(S.delta, g);
      })[0];
      if (y && y.should) {
        p.cancelable && p.preventDefault();
        return;
      }
      if (!y) {
        var w = (a.current.shards || []).map(wa).filter(Boolean).filter(function(S) {
          return S.contains(p.target);
        }), C = w.length > 0 ? s(p, w[0]) : !a.current.noIsolation;
        C && p.cancelable && p.preventDefault();
      }
    }
  }, []), c = x.useCallback(function(f, p, g, y) {
    var w = { name: f, delta: p, target: g, should: y, shadowParent: Jv(g) };
    e.current.push(w), setTimeout(function() {
      e.current = e.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), d = x.useCallback(function(f) {
    n.current = Mr(f), r.current = void 0;
  }, []), u = x.useCallback(function(f) {
    c(f.type, ya(f), f.target, s(f, t.lockRef.current));
  }, []), m = x.useCallback(function(f) {
    c(f.type, Mr(f), f.target, s(f, t.lockRef.current));
  }, []);
  x.useEffect(function() {
    return Sn.push(i), t.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, xn), document.addEventListener("touchmove", l, xn), document.addEventListener("touchstart", d, xn), function() {
      Sn = Sn.filter(function(f) {
        return f !== i;
      }), document.removeEventListener("wheel", l, xn), document.removeEventListener("touchmove", l, xn), document.removeEventListener("touchstart", d, xn);
    };
  }, []);
  var h = t.removeScrollBar, v = t.inert;
  return x.createElement(
    x.Fragment,
    null,
    v ? x.createElement(i, { styles: qv(o) }) : null,
    h ? x.createElement(Vv, { noRelative: t.noRelative, gapMode: t.gapMode }) : null
  );
}
function Jv(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const Qv = Ov(Sc, Zv);
var po = x.forwardRef(function(t, e) {
  return x.createElement(ho, Pt({}, t, { ref: e, sideCar: Qv }));
});
po.classNames = ho.classNames;
var vo = "Popover", [Oc, uP] = Ye(vo, [
  Hn
]), fr = Hn(), [eg, rn] = Oc(vo), Tc = (t) => {
  const {
    __scopePopover: e,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !1
  } = t, s = fr(e), l = x.useRef(null), [c, d] = x.useState(!1), [u, m] = je({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: vo
  });
  return /* @__PURE__ */ b(fs, { ...s, children: /* @__PURE__ */ b(
    eg,
    {
      scope: e,
      contentId: st(),
      triggerRef: l,
      open: u,
      onOpenChange: m,
      onOpenToggle: x.useCallback(() => m((h) => !h), [m]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: x.useCallback(() => d(!0), []),
      onCustomAnchorRemove: x.useCallback(() => d(!1), []),
      modal: a,
      children: n
    }
  ) });
};
Tc.displayName = vo;
var Ic = "PopoverAnchor", Mc = x.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, o = rn(Ic, n), i = fr(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = o;
    return x.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ b(mo, { ...i, ...r, ref: e });
  }
);
Mc.displayName = Ic;
var kc = "PopoverTrigger", _c = x.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, o = rn(kc, n), i = fr(n), a = ae(e, o.triggerRef), s = /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": $c(o.open),
        ...r,
        ref: a,
        onClick: U(t.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ b(mo, { asChild: !0, ...i, children: s });
  }
);
_c.displayName = kc;
var vs = "PopoverPortal", [tg, ng] = Oc(vs, {
  forceMount: void 0
}), Dc = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: o } = t, i = rn(vs, e);
  return /* @__PURE__ */ b(tg, { scope: e, forceMount: n, children: /* @__PURE__ */ b(tt, { present: n || i.open, children: /* @__PURE__ */ b(Yn, { asChild: !0, container: o, children: r }) }) });
};
Dc.displayName = vs;
var _n = "PopoverContent", Rc = x.forwardRef(
  (t, e) => {
    const n = ng(_n, t.__scopePopover), { forceMount: r = n.forceMount, ...o } = t, i = rn(_n, t.__scopePopover);
    return /* @__PURE__ */ b(tt, { present: r || i.open, children: i.modal ? /* @__PURE__ */ b(og, { ...o, ref: e }) : /* @__PURE__ */ b(ig, { ...o, ref: e }) });
  }
);
Rc.displayName = _n;
var rg = /* @__PURE__ */ Mn("PopoverContent.RemoveScroll"), og = x.forwardRef(
  (t, e) => {
    const n = rn(_n, t.__scopePopover), r = x.useRef(null), o = ae(e, r), i = x.useRef(!1);
    return x.useEffect(() => {
      const a = r.current;
      if (a) return ps(a);
    }, []), /* @__PURE__ */ b(po, { as: rg, allowPinchZoom: !0, children: /* @__PURE__ */ b(
      Ac,
      {
        ...t,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: U(t.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), i.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: U(
          t.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            i.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: U(
          t.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), ig = x.forwardRef(
  (t, e) => {
    const n = rn(_n, t.__scopePopover), r = x.useRef(!1), o = x.useRef(!1);
    return /* @__PURE__ */ b(
      Ac,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, s;
          (a = t.onCloseAutoFocus) == null || a.call(t, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Ac = x.forwardRef(
  (t, e) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: d,
      ...u
    } = t, m = rn(_n, n), h = fr(n);
    return ns(), /* @__PURE__ */ b(
      lo,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ b(
          Vn,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: d,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ b(
              ms,
              {
                "data-state": $c(m.open),
                role: "dialog",
                id: m.contentId,
                ...h,
                ...u,
                ref: e,
                style: {
                  ...u.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Fc = "PopoverClose", Lc = x.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, o = rn(Fc, n);
    return /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: U(t.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Lc.displayName = Fc;
var sg = "PopoverArrow", Wc = x.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, o = fr(n);
    return /* @__PURE__ */ b(hs, { ...o, ...r, ref: e });
  }
);
Wc.displayName = sg;
function $c(t) {
  return t ? "open" : "closed";
}
var Vc = Tc, Bc = Mc, zc = _c, ag = Dc, Hc = Rc, go = Lc, xa = Wc;
const gs = (t) => {
  const e = ee(43);
  let n, r, o, i, a, s, l, c, d, u, m, h, v, f;
  e[0] !== t ? ({
    trigger: f,
    children: n,
    className: r,
    align: d,
    sideOffset: u,
    isOpen: i,
    setIsOpen: c,
    modal: a,
    hasCloseButton: o,
    hasArrow: m,
    title: v,
    portalContainer: s,
    zIndex: h,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s, e[7] = l, e[8] = c, e[9] = d, e[10] = u, e[11] = m, e[12] = h, e[13] = v, e[14] = f) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6], l = e[7], c = e[8], d = e[9], u = e[10], m = e[11], h = e[12], v = e[13], f = e[14]);
  const p = d === void 0 ? "center" : d, g = u === void 0 ? 4 : u, y = m === void 0 ? !0 : m, w = h === void 0 ? "z-50" : h, C = v || o;
  let S;
  e[15] !== f ? (S = /* @__PURE__ */ b(zc, { asChild: !0, children: f }), e[15] = f, e[16] = S) : S = e[16];
  let P;
  e[17] !== r || e[18] !== w ? (P = H("border-grayscale-x-light p-md rounded-lg border bg-white shadow-lg outline-hidden", ["radix-state-open:animate-in", "radix-state-closed:animate-out", "radix-state-closed:fade-out-0", "radix-state-open:fade-in-0", "radix-state-closed:zoom-out-95", "radix-state-open:zoom-in-95", "radix-side-bottom:slide-in-from-top-[1rem]", "radix-side-left:slide-in-from-right-[1rem]", "radix-side-right:slide-in-from-left-[1rem]", "radix-side-top:slide-in-from-bottom-[1rem]"], w, r), e[17] = r, e[18] = w, e[19] = P) : P = e[19];
  let E;
  e[20] !== o || e[21] !== C || e[22] !== v ? (E = C ? /* @__PURE__ */ $("div", { className: H("mb-md flex items-center", v ? "justify-between" : "justify-end"), children: [
    v ? /* @__PURE__ */ b(ve, { step: "1", weight: "bold", children: v }) : null,
    o ? /* @__PURE__ */ b(go, { children: /* @__PURE__ */ b(Wn, { className: "h-md text-grayscale hover:text-grayscale-dark w-md transition-colors" }) }) : null
  ] }) : null, e[20] = o, e[21] = C, e[22] = v, e[23] = E) : E = e[23];
  let N;
  e[24] !== y ? (N = y ? /* @__PURE__ */ $(Ce, { children: [
    /* @__PURE__ */ b(xa, { className: "h-2xs fill-grayscale-x-light relative top-[-1px] w-sm" }),
    /* @__PURE__ */ b(xa, { className: "h-2xs relative top-[-2.5px] w-sm fill-white" })
  ] }) : null, e[24] = y, e[25] = N) : N = e[25];
  let T;
  e[26] !== p || e[27] !== n || e[28] !== l || e[29] !== g || e[30] !== P || e[31] !== E || e[32] !== N ? (T = /* @__PURE__ */ $(Hc, { align: p, sideOffset: g, arrowPadding: 16, className: P, ...l, children: [
    E,
    n,
    N
  ] }), e[26] = p, e[27] = n, e[28] = l, e[29] = g, e[30] = P, e[31] = E, e[32] = N, e[33] = T) : T = e[33];
  let k;
  e[34] !== s || e[35] !== T ? (k = /* @__PURE__ */ b(ag, { container: s, children: T }), e[34] = s, e[35] = T, e[36] = k) : k = e[36];
  let D;
  return e[37] !== i || e[38] !== a || e[39] !== c || e[40] !== k || e[41] !== S ? (D = /* @__PURE__ */ $(Vc, { open: i, onOpenChange: c, modal: a, children: [
    S,
    k
  ] }), e[37] = i, e[38] = a, e[39] = c, e[40] = k, e[41] = S, e[42] = D) : D = e[42], D;
}, lg = {
  state: {
    active: "bg-primary-xx-light border-primary-xx-light text-primary",
    available: "cursor-pointer bg-white border hover:border-primary-xx-light hover:bg-primary-xx-light hover:shadow-sm active:text-primary active:shadow-inner focus-visible:border-primary-xx-light focus-visible:bg-primary-xx-light focus-visible:shadow-sm outline-primary",
    disabled: ""
  },
  condensed: {
    true: "border-transparent"
  }
}, Nn = Yt("border-grayscale-x-light p-2xs rounded-md border text-xs font-semibold outline-offset-4 transition-colors", {
  variants: {
    ...lg
  },
  compoundVariants: []
}), Sa = 8, cg = 24, Ca = (t) => t * 16 + // Padding. (2 * 8px)
t * 2 + // Borders. (2 * 1px)
(t - 1) * 16 + // Gaps. (8px)
(t - 1) * 16, Ea = (t) => {
  const e = ee(8), {
    crumbs: n,
    portalContainer: r
  } = t;
  let o;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ $("button", { className: Nn({
    state: "available",
    condensed: !0
  }), children: [
    /* @__PURE__ */ b(Wm, { className: "size-md", role: "presentation", "aria-hidden": "true" }),
    /* @__PURE__ */ b("span", { className: "sr-only", children: "Toggle menu" })
  ] }), e[0] = o) : o = e[0];
  let i;
  e[1] !== n ? (i = n.map(ug), e[1] = n, e[2] = i) : i = e[2];
  let a;
  e[3] !== i ? (a = /* @__PURE__ */ b("div", { className: "gap-2xs flex flex-col", children: i }), e[3] = i, e[4] = a) : a = e[4];
  let s;
  return e[5] !== r || e[6] !== a ? (s = /* @__PURE__ */ b(gs, { trigger: o, portalContainer: r, align: "start", children: a }), e[5] = r, e[6] = a, e[7] = s) : s = e[7], s;
}, kr = () => {
  const t = ee(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ b(qi, { className: "size-sm text-grayscale-light shrink-0" }), t[0] = e) : e = t[0], e;
}, dP = (t) => {
  const e = ee(49), {
    crumbs: n,
    portalContainer: r
  } = t, [o, i] = zh(), {
    width: a
  } = i;
  let s;
  e[0] !== n ? (s = n == null ? void 0 : n.slice(0, n.length - 1), e[0] = n, e[1] = s) : s = e[1];
  const l = s;
  let c;
  e[2] !== n ? (c = n == null ? void 0 : n.slice(1, n.length - 1), e[2] = n, e[3] = c) : c = e[3];
  const d = c, m = n.reduce(dg, 0) * Sa + Ca(n.length), v = (n[0].label.length + n[n.length - 1].label.length) * Sa + cg + Ca(3);
  let f, p, g, y;
  if (e[4] !== l || e[5] !== d || e[6] !== n || e[7] !== m || e[8] !== r || e[9] !== o || e[10] !== v || e[11] !== a) {
    let S;
    e[16] !== n.length ? (S = (K, j) => {
      const G = j === n.length - 1, J = G ? "span" : (K == null ? void 0 : K.as) ?? "a";
      return /* @__PURE__ */ $(Ce, { children: [
        /* @__PURE__ */ b("li", { className: "gap-xs flex items-center", children: /* @__PURE__ */ b(J, { className: Nn({
          state: G ? "active" : "available"
        }), href: K.href, children: K.label }) }, j),
        G ? null : /* @__PURE__ */ b(kr, {})
      ] });
    }, e[16] = n.length, e[17] = S) : S = e[17];
    const P = n.map(S), E = n[0].as ?? "a";
    let N;
    e[18] !== E || e[19] !== n[0].href || e[20] !== n[0].label || e[21] !== n.length ? (N = n.length > 1 ? /* @__PURE__ */ $(Ce, { children: [
      /* @__PURE__ */ b("li", { className: "gap-xs flex items-center", children: /* @__PURE__ */ b(E, { className: Nn({
        state: "available"
      }), href: n[0].href, children: n[0].label }) }),
      /* @__PURE__ */ b(kr, {}),
      " "
    ] }) : null, e[18] = E, e[19] = n[0].href, e[20] = n[0].label, e[21] = n.length, e[22] = N) : N = e[22];
    let T;
    e[23] !== d || e[24] !== r ? (T = d.length > 0 ? /* @__PURE__ */ $(Ce, { children: [
      /* @__PURE__ */ b("li", { className: "flex", children: /* @__PURE__ */ b(Ea, { crumbs: d, portalContainer: r }) }),
      /* @__PURE__ */ b(kr, {}),
      " "
    ] }) : null, e[23] = d, e[24] = r, e[25] = T) : T = e[25];
    let k;
    e[26] === Symbol.for("react.memo_cache_sentinel") ? (k = Nn({
      state: "active"
    }), e[26] = k) : k = e[26];
    const D = n[n.length - 1];
    let F;
    e[27] !== D.label ? (F = /* @__PURE__ */ b("li", { className: "gap-xs flex items-center", children: /* @__PURE__ */ b("span", { className: k, children: D.label }) }), e[27] = D.label, e[28] = F) : F = e[28];
    let O;
    e[29] !== T || e[30] !== F || e[31] !== N ? (O = /* @__PURE__ */ $(Ce, { children: [
      N,
      T,
      F
    ] }), e[29] = T, e[30] = F, e[31] = N, e[32] = O) : O = e[32];
    const _ = O;
    let L;
    e[33] !== l || e[34] !== r ? (L = l.length > 0 ? /* @__PURE__ */ $(Ce, { children: [
      /* @__PURE__ */ b("li", { className: "flex", children: /* @__PURE__ */ b(Ea, { crumbs: l, portalContainer: r }) }),
      /* @__PURE__ */ b(kr, {}),
      " "
    ] }) : null, e[33] = l, e[34] = r, e[35] = L) : L = e[35];
    let I;
    e[36] === Symbol.for("react.memo_cache_sentinel") ? (I = Nn({
      state: "active"
    }), e[36] = I) : I = e[36];
    const R = n[n.length - 1];
    let A;
    e[37] !== R.label ? (A = /* @__PURE__ */ b("li", { className: "gap-xs flex items-center", children: /* @__PURE__ */ b("span", { className: I, children: R.label }) }), e[37] = R.label, e[38] = A) : A = e[38];
    let M;
    e[39] !== L || e[40] !== A ? (M = /* @__PURE__ */ $(Ce, { children: [
      L,
      A
    ] }), e[39] = L, e[40] = A, e[41] = M) : M = e[41];
    const W = M, z = () => a < v ? W : a < m ? _ : P;
    g = "breadcrumb", y = o, f = "gap-2xs flex items-center", p = z(), e[4] = l, e[5] = d, e[6] = n, e[7] = m, e[8] = r, e[9] = o, e[10] = v, e[11] = a, e[12] = f, e[13] = p, e[14] = g, e[15] = y;
  } else
    f = e[12], p = e[13], g = e[14], y = e[15];
  let w;
  e[42] !== f || e[43] !== p ? (w = /* @__PURE__ */ b("ol", { className: f, children: p }), e[42] = f, e[43] = p, e[44] = w) : w = e[44];
  let C;
  return e[45] !== g || e[46] !== y || e[47] !== w ? (C = /* @__PURE__ */ b("nav", { "aria-label": g, ref: y, children: w }), e[45] = g, e[46] = y, e[47] = w, e[48] = C) : C = e[48], C;
};
function ug(t, e) {
  const n = (t == null ? void 0 : t.as) ?? "a";
  return /* @__PURE__ */ b("li", { className: "gap-xs flex items-center", children: /* @__PURE__ */ b(go, { asChild: (t == null ? void 0 : t.as) === "button", children: /* @__PURE__ */ b(n, { className: H(Nn({
    state: "available",
    condensed: !0
  }), "w-full"), href: t.href, children: t.label }) }) }, e);
}
function dg(t, e) {
  return t + e.label.length;
}
function In(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
function Nt(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && t.formattingValues) {
      const a = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      o = t.formattingValues[s] || t.formattingValues[a];
    } else {
      const a = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      o = t.values[s] || t.values[a];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return o[i];
  };
}
function Ot(t) {
  return (e, n = {}) => {
    const r = n.width, o = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(o);
    if (!i)
      return null;
    const a = i[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? mg(s, (u) => u.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      fg(s, (u) => u.test(a))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const d = e.slice(a.length);
    return { value: c, rest: d };
  };
}
function fg(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function mg(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Yc(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const o = r[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let a = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = e.slice(o.length);
    return { value: a, rest: s };
  };
}
const Kc = 6048e5, hg = 864e5, Pa = Symbol.for("constructDateFrom");
function ke(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Pa in t ? t[Pa](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Kn(t, ...e) {
  const n = ke.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
let pg = {};
function mr() {
  return pg;
}
function we(t, e) {
  return ke(e || t, t);
}
function Dn(t, e) {
  var s, l, c, d;
  const n = mr(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = we(t, e == null ? void 0 : e.in), i = o.getDay(), a = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
const vg = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, gg = (t, e, n) => {
  let r;
  const o = vg[t];
  return typeof o == "string" ? r = o : e === 1 ? r = o.one : r = o.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
}, bg = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yg = (t, e, n, r) => bg[t], wg = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, xg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Sg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Cg = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Eg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Pg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ng = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Og = {
  ordinalNumber: Ng,
  era: Nt({
    values: wg,
    defaultWidth: "wide"
  }),
  quarter: Nt({
    values: xg,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Nt({
    values: Sg,
    defaultWidth: "wide"
  }),
  day: Nt({
    values: Cg,
    defaultWidth: "wide"
  }),
  dayPeriod: Nt({
    values: Eg,
    defaultWidth: "wide",
    formattingValues: Pg,
    defaultFormattingWidth: "wide"
  })
}, Tg = /^(\d+)(th|st|nd|rd)?/i, Ig = /\d+/i, Mg = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, kg = {
  any: [/^b/i, /^(a|c)/i]
}, _g = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Dg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rg = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ag = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Fg = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Lg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Wg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $g = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Vg = {
  ordinalNumber: Yc({
    matchPattern: Tg,
    parsePattern: Ig,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Ot({
    matchPatterns: Mg,
    defaultMatchWidth: "wide",
    parsePatterns: kg,
    defaultParseWidth: "any"
  }),
  quarter: Ot({
    matchPatterns: _g,
    defaultMatchWidth: "wide",
    parsePatterns: Dg,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ot({
    matchPatterns: Rg,
    defaultMatchWidth: "wide",
    parsePatterns: Ag,
    defaultParseWidth: "any"
  }),
  day: Ot({
    matchPatterns: Fg,
    defaultMatchWidth: "wide",
    parsePatterns: Lg,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ot({
    matchPatterns: Wg,
    defaultMatchWidth: "any",
    parsePatterns: $g,
    defaultParseWidth: "any"
  })
}, Bg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, zg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Hg = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Yg = {
  date: In({
    formats: Bg,
    defaultWidth: "full"
  }),
  time: In({
    formats: zg,
    defaultWidth: "full"
  }),
  dateTime: In({
    formats: Hg,
    defaultWidth: "full"
  })
}, bo = {
  code: "en-US",
  formatDistance: gg,
  formatLong: Yg,
  formatRelative: yg,
  localize: Og,
  match: Vg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Kg = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, Ug = (t, e, n) => {
  let r;
  const o = Kg[t];
  return typeof o == "string" ? r = o : e === 1 ? r = o.one : r = o.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dans " + r : "il y a " + r : r;
}, jg = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Gg = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, qg = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Xg = {
  date: In({
    formats: jg,
    defaultWidth: "full"
  }),
  time: In({
    formats: Gg,
    defaultWidth: "full"
  }),
  dateTime: In({
    formats: qg,
    defaultWidth: "full"
  })
}, Zg = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, Jg = (t, e, n, r) => Zg[t], Qg = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, eb = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, tb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, nb = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, rb = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, ob = (t, e) => {
  const n = Number(t), r = e == null ? void 0 : e.unit;
  if (n === 0) return "0";
  const o = ["year", "week", "hour", "minute", "second"];
  let i;
  return n === 1 ? i = r && o.includes(r) ? "ère" : "er" : i = "ème", n + i;
}, ib = ["MMM", "MMMM"], sb = {
  preprocessor: (t, e) => t.getDate() === 1 || !e.some(
    (r) => r.isToken && ib.includes(r.value)
  ) ? e : e.map(
    (r) => r.isToken && r.value === "do" ? { isToken: !0, value: "d" } : r
  ),
  ordinalNumber: ob,
  era: Nt({
    values: Qg,
    defaultWidth: "wide"
  }),
  quarter: Nt({
    values: eb,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Nt({
    values: tb,
    defaultWidth: "wide"
  }),
  day: Nt({
    values: nb,
    defaultWidth: "wide"
  }),
  dayPeriod: Nt({
    values: rb,
    defaultWidth: "wide"
  })
}, ab = /^(\d+)(ième|ère|ème|er|e)?/i, lb = /\d+/i, cb = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, ub = {
  any: [/^av/i, /^ap/i]
}, db = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, fb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mb = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, hb = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, pb = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, vb = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, gb = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, bb = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, yb = {
  ordinalNumber: Yc({
    matchPattern: ab,
    parsePattern: lb,
    valueCallback: (t) => parseInt(t)
  }),
  era: Ot({
    matchPatterns: cb,
    defaultMatchWidth: "wide",
    parsePatterns: ub,
    defaultParseWidth: "any"
  }),
  quarter: Ot({
    matchPatterns: db,
    defaultMatchWidth: "wide",
    parsePatterns: fb,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ot({
    matchPatterns: mb,
    defaultMatchWidth: "wide",
    parsePatterns: hb,
    defaultParseWidth: "any"
  }),
  day: Ot({
    matchPatterns: pb,
    defaultMatchWidth: "wide",
    parsePatterns: vb,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ot({
    matchPatterns: gb,
    defaultMatchWidth: "any",
    parsePatterns: bb,
    defaultParseWidth: "any"
  })
}, wb = {
  code: "fr",
  formatDistance: Ug,
  formatLong: Xg,
  formatRelative: Jg,
  localize: sb,
  match: yb,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Zo = {}, Xn = {};
function Jn(t, e) {
  try {
    const r = (Zo[t] || (Zo[t] = new Intl.DateTimeFormat("en-GB", {
      timeZone: t,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1] || "";
    return r in Xn ? Xn[r] : Na(r, r.split(":"));
  } catch {
    if (t in Xn) return Xn[t];
    const n = t == null ? void 0 : t.match(xb);
    return n ? Na(t, n.slice(1)) : NaN;
  }
}
const xb = /([+-]\d\d):?(\d\d)?/;
function Na(t, e) {
  const n = +e[0], r = +(e[1] || 0);
  return Xn[t] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Tt extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Jn(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Uc(this), Si(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new Tt(...n, e) : new Tt(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new Tt(+this, e);
  }
  getTimezoneOffset() {
    return -Jn(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), Si(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new Tt(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Oa = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Oa.test(t)) return;
  const e = t.replace(Oa, "$1UTC");
  Tt.prototype[e] && (t.startsWith("get") ? Tt.prototype[t] = function() {
    return this.internal[e]();
  } : (Tt.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), Sb(this), +this;
  }, Tt.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), Si(this), +this;
  }));
});
function Si(t) {
  t.internal.setTime(+t), t.internal.setUTCMinutes(t.internal.getUTCMinutes() - t.getTimezoneOffset());
}
function Sb(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), Uc(t);
}
function Uc(t) {
  const e = Jn(t.timeZone, t), n = /* @__PURE__ */ new Date(+t);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), o = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), i = r - o, a = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  i && a && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + i);
  const s = r - e;
  s && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + s);
  const l = Jn(t.timeZone, t), d = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - l, u = l !== e, m = d - s;
  if (u && m) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + m);
    const h = Jn(t.timeZone, t), v = l - h;
    v && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + v), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + v));
  }
}
class ze extends Tt {
  //#region static
  static tz(e, ...n) {
    return n.length ? new ze(...n, e) : new ze(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, r] = this.tzComponents(), o = `${e}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, r, o] = this.internal.toUTCString().split(" ");
    return `${e == null ? void 0 : e.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${e} GMT${n}${r}${o} (${Cb(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", r = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), o = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(e) {
    return new ze(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new ze(+new Date(e), this.timeZone);
  }
  //#endregion
}
function Cb(t, e) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: t,
    timeZoneName: "long"
  }).format(e).slice(12);
}
var X;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(X || (X = {}));
var Oe;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(Oe || (Oe = {}));
var pt;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(pt || (pt = {}));
var Xe;
(function(t) {
  t.weeks_before_enter = "weeks_before_enter", t.weeks_before_exit = "weeks_before_exit", t.weeks_after_enter = "weeks_after_enter", t.weeks_after_exit = "weeks_after_exit", t.caption_after_enter = "caption_after_enter", t.caption_after_exit = "caption_after_exit", t.caption_before_enter = "caption_before_enter", t.caption_before_exit = "caption_before_exit";
})(Xe || (Xe = {}));
function jc(t, e, n) {
  const r = we(t, n == null ? void 0 : n.in);
  return isNaN(e) ? ke(t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function Gc(t, e, n) {
  const r = we(t, n == null ? void 0 : n.in);
  if (isNaN(e)) return ke(t, NaN);
  if (!e)
    return r;
  const o = r.getDate(), i = ke(t, r.getTime());
  i.setMonth(r.getMonth() + e + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
function or(t, e) {
  return Dn(t, { ...e, weekStartsOn: 1 });
}
function qc(t, e) {
  const n = we(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = ke(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = or(o), a = ke(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = or(a);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function Ta(t) {
  const e = we(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function ir(t, e) {
  const n = we(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Xc(t, e, n) {
  const [r, o] = Kn(
    n == null ? void 0 : n.in,
    t,
    e
  ), i = ir(r), a = ir(o), s = +i - Ta(i), l = +a - Ta(a);
  return Math.round((s - l) / hg);
}
function Eb(t, e) {
  const n = qc(t, e), r = ke(t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), or(r);
}
function Pb(t, e, n) {
  return jc(t, e * 7, n);
}
function Nb(t, e, n) {
  return Gc(t, e * 12, n);
}
function Ob(t, e) {
  let n, r = e == null ? void 0 : e.in;
  return t.forEach((o) => {
    !r && typeof o == "object" && (r = ke.bind(null, o));
    const i = we(o, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), ke(r, n || NaN);
}
function Tb(t, e) {
  let n, r = e == null ? void 0 : e.in;
  return t.forEach((o) => {
    !r && typeof o == "object" && (r = ke.bind(null, o));
    const i = we(o, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), ke(r, n || NaN);
}
function Ib(t, e, n) {
  const [r, o] = Kn(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +ir(r) == +ir(o);
}
function Zc(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Mb(t) {
  return !(!Zc(t) && typeof t != "number" || isNaN(+we(t)));
}
function kb(t, e, n) {
  const [r, o] = Kn(
    n == null ? void 0 : n.in,
    t,
    e
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function _b(t, e) {
  const n = we(t, e == null ? void 0 : e.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Db(t, e) {
  const [n, r] = Kn(t, e.start, e.end);
  return { start: n, end: r };
}
function Rb(t, e) {
  const { start: n, end: r } = Db(e == null ? void 0 : e.in, t);
  let o = +n > +r;
  const i = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setDate(1);
  let s = 1;
  const l = [];
  for (; +a <= i; )
    l.push(ke(n, a)), a.setMonth(a.getMonth() + s);
  return o ? l.reverse() : l;
}
function Ab(t, e) {
  const n = we(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Fb(t, e) {
  const n = we(t, e == null ? void 0 : e.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Jc(t, e) {
  const n = we(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Qc(t, e) {
  var s, l, c, d;
  const n = mr(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = we(t, e == null ? void 0 : e.in), i = o.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function Lb(t, e) {
  return Qc(t, { ...e, weekStartsOn: 1 });
}
function Wb(t, e) {
  const n = we(t, e == null ? void 0 : e.in);
  return Xc(n, Jc(n)) + 1;
}
function eu(t, e) {
  const n = we(t, e == null ? void 0 : e.in), r = +or(n) - +Eb(n);
  return Math.round(r / Kc) + 1;
}
function tu(t, e) {
  var d, u, m, h;
  const n = we(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = mr(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((u = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (m = o.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = ke((e == null ? void 0 : e.in) || t, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = Dn(a, e), l = ke((e == null ? void 0 : e.in) || t, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Dn(l, e);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function $b(t, e) {
  var s, l, c, d;
  const n = mr(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = tu(t, e), i = ke((e == null ? void 0 : e.in) || t, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), Dn(i, e);
}
function nu(t, e) {
  const n = we(t, e == null ? void 0 : e.in), r = +Dn(n, e) - +$b(n, e);
  return Math.round(r / Kc) + 1;
}
function ue(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const qt = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return ue(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : ue(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return ue(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return ue(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return ue(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return ue(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return ue(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return ue(o, e.length);
  }
}, Cn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ia = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return qt.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const o = tu(t, r), i = o > 0 ? o : 1 - o;
    if (e === "YY") {
      const a = i % 100;
      return ue(a, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : ue(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = qc(t);
    return ue(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return ue(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return ue(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return ue(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return qt.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return ue(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const o = nu(t, r);
    return e === "wo" ? n.ordinalNumber(o, { unit: "week" }) : ue(o, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = eu(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ue(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : qt.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = Wb(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ue(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const o = t.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return ue(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const o = t.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return ue(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), o = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return ue(o, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const o = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let o;
    switch (r === 12 ? o = Cn.noon : r === 0 ? o = Cn.midnight : o = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let o;
    switch (r >= 17 ? o = Cn.evening : r >= 12 ? o = Cn.afternoon : r >= 4 ? o = Cn.morning : o = Cn.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return qt.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : qt.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ue(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ue(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : qt.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : qt.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return qt.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return ka(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ln(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ln(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return ka(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ln(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ln(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ma(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ln(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ma(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ln(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return ue(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return ue(+t, e.length);
  }
};
function Ma(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + e + ue(i, 2);
}
function ka(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + ue(Math.abs(t) / 60, 2) : ln(t, e);
}
function ln(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = ue(Math.trunc(r / 60), 2), i = ue(r % 60, 2);
  return n + o + e + i;
}
const _a = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, ru = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Vb = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return _a(t, e);
  let i;
  switch (r) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", _a(r, e)).replace("{{time}}", ru(o, e));
}, Bb = {
  p: ru,
  P: Vb
}, zb = /^D+$/, Hb = /^Y+$/, Yb = ["D", "DD", "YY", "YYYY"];
function Kb(t) {
  return zb.test(t);
}
function Ub(t) {
  return Hb.test(t);
}
function jb(t, e, n) {
  const r = Gb(t, e, n);
  if (console.warn(r), Yb.includes(t)) throw new RangeError(r);
}
function Gb(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const qb = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Xb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Zb = /^'([^]*?)'?$/, Jb = /''/g, Qb = /[a-zA-Z]/;
function ey(t, e, n) {
  var d, u, m, h, v, f, p, g;
  const r = mr(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? bo, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((g = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? 0, s = we(t, n == null ? void 0 : n.in);
  if (!Mb(s))
    throw new RangeError("Invalid time value");
  let l = e.match(Xb).map((y) => {
    const w = y[0];
    if (w === "p" || w === "P") {
      const C = Bb[w];
      return C(y, o.formatLong);
    }
    return y;
  }).join("").match(qb).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const w = y[0];
    if (w === "'")
      return { isToken: !1, value: ty(y) };
    if (Ia[w])
      return { isToken: !0, value: y };
    if (w.match(Qb))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: y };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map((y) => {
    if (!y.isToken) return y.value;
    const w = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Ub(w) || !(n != null && n.useAdditionalDayOfYearTokens) && Kb(w)) && jb(w, e, String(t));
    const C = Ia[w[0]];
    return C(s, w, o.localize, c);
  }).join("");
}
function ty(t) {
  const e = t.match(Zb);
  return e ? e[1].replace(Jb, "'") : t;
}
function ny(t, e) {
  const n = we(t, e == null ? void 0 : e.in);
  if (isNaN(+n))
    throw new RangeError("Invalid time value");
  let r = "", o = "";
  const i = "-", a = ":";
  {
    const s = ue(n.getDate(), 2), l = ue(n.getMonth() + 1, 2);
    r = `${ue(n.getFullYear(), 4)}${i}${l}${i}${s}`;
  }
  {
    const s = n.getTimezoneOffset();
    if (s !== 0) {
      const h = Math.abs(s), v = ue(Math.trunc(h / 60), 2), f = ue(h % 60, 2);
      o = `${s < 0 ? "+" : "-"}${v}:${f}`;
    } else
      o = "Z";
    const l = ue(n.getHours(), 2), c = ue(n.getMinutes(), 2), d = ue(n.getSeconds(), 2), u = r === "" ? "" : "T", m = [l, c, d].join(a);
    r = `${r}${u}${m}${o}`;
  }
  return r;
}
function ry(t, e) {
  const n = we(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = n.getMonth(), i = ke(n, 0);
  return i.setFullYear(r, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function oy(t, e) {
  return we(t, e == null ? void 0 : e.in).getMonth();
}
function iy(t, e) {
  return we(t, e == null ? void 0 : e.in).getFullYear();
}
function sy(t, e) {
  return +we(t) > +we(e);
}
function ay(t, e) {
  return +we(t) < +we(e);
}
function ly(t, e, n) {
  const [r, o] = Kn(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function cy(t, e, n) {
  const [r, o] = Kn(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return r.getFullYear() === o.getFullYear();
}
function uy(t, e, n) {
  const r = we(t, n == null ? void 0 : n.in), o = r.getFullYear(), i = r.getDate(), a = ke(t, 0);
  a.setFullYear(o, e, 15), a.setHours(0, 0, 0, 0);
  const s = ry(a);
  return r.setMonth(e, Math.min(i, s)), r;
}
function dy(t, e, n) {
  const r = we(t, n == null ? void 0 : n.in);
  return isNaN(+r) ? ke(t, NaN) : (r.setFullYear(e), r);
}
const Da = 5, fy = 4;
function my(t, e) {
  const n = e.startOfMonth(t), r = n.getDay() > 0 ? n.getDay() : 7, o = e.addDays(t, -r + 1), i = e.addDays(o, Da * 7 - 1);
  return e.getMonth(t) === e.getMonth(i) ? Da : fy;
}
function ou(t, e) {
  const n = e.startOfMonth(t), r = n.getDay();
  return r === 1 ? n : r === 0 ? e.addDays(n, -1 * 6) : e.addDays(n, -1 * (r - 1));
}
function hy(t, e) {
  const n = ou(t, e), r = my(t, e);
  return e.addDays(n, r * 7 - 1);
}
class Kt {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? ze.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, o, i) => {
      var a;
      return (a = this.overrides) != null && a.newDate ? this.overrides.newDate(r, o, i) : this.options.timeZone ? new ze(r, o, i, this.options.timeZone) : new Date(r, o, i);
    }, this.addDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addDays ? this.overrides.addDays(r, o) : jc(r, o);
    }, this.addMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addMonths ? this.overrides.addMonths(r, o) : Gc(r, o);
    }, this.addWeeks = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addWeeks ? this.overrides.addWeeks(r, o) : Pb(r, o);
    }, this.addYears = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addYears ? this.overrides.addYears(r, o) : Nb(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Xc(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : kb(r, o);
    }, this.eachMonthOfInterval = (r) => {
      var o;
      return (o = this.overrides) != null && o.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : Rb(r);
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : hy(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : Lb(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : _b(r);
    }, this.endOfWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, o) : Qc(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : Fb(r);
    }, this.format = (r, o, i) => {
      var s;
      const a = (s = this.overrides) != null && s.format ? this.overrides.format(r, o, this.options) : ey(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(a) : a;
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : eu(r);
    }, this.getMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getMonth ? this.overrides.getMonth(r, this.options) : oy(r, this.options);
    }, this.getYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getYear ? this.overrides.getYear(r, this.options) : iy(r, this.options);
    }, this.getWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : nu(r, this.options);
    }, this.isAfter = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isAfter ? this.overrides.isAfter(r, o) : sy(r, o);
    }, this.isBefore = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isBefore ? this.overrides.isBefore(r, o) : ay(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : Zc(r);
    }, this.isSameDay = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameDay ? this.overrides.isSameDay(r, o) : Ib(r, o);
    }, this.isSameMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameMonth ? this.overrides.isSameMonth(r, o) : ly(r, o);
    }, this.isSameYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameYear ? this.overrides.isSameYear(r, o) : cy(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : Ob(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : Tb(r);
    }, this.setMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setMonth ? this.overrides.setMonth(r, o) : uy(r, o);
    }, this.setYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setYear ? this.overrides.setYear(r, o) : dy(r, o);
    }, this.startOfBroadcastWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : ou(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : ir(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : or(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : Ab(r);
    }, this.startOfWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Dn(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : Jc(r);
    }, this.options = { locale: bo, ...e }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
}
const Rt = new Kt();
class iu {
  constructor(e, n, r = Rt) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(e, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class py {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class vy {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function Lt(t, e, n = !1, r = Rt) {
  let { from: o, to: i } = t;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return o && i ? (a(i, o) < 0 && ([o, i] = [i, o]), a(e, o) >= (n ? 1 : 0) && a(i, e) >= (n ? 1 : 0)) : !n && i ? s(i, e) : !n && o ? s(o, e) : !1;
}
function su(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function bs(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function au(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function lu(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function cu(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function uu(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function Wt(t, e, n = Rt) {
  const r = Array.isArray(e) ? e : [e], { isSameDay: o, differenceInCalendarDays: i, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return o(t, s);
    if (uu(s, n))
      return s.includes(t);
    if (bs(s))
      return Lt(s, t, !1, n);
    if (cu(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(t.getDay()) : s.dayOfWeek === t.getDay();
    if (su(s)) {
      const l = i(s.before, t), c = i(s.after, t), d = l > 0, u = c < 0;
      return a(s.before, s.after) ? u && d : d || u;
    }
    return au(s) ? i(t, s.after) > 0 : lu(s) ? i(s.before, t) > 0 : typeof s == "function" ? s(t) : !1;
  });
}
function gy(t, e, n) {
  const { disabled: r, hidden: o, modifiers: i, showOutsideDays: a, broadcastCalendar: s, today: l } = e, { isSameDay: c, isSameMonth: d, startOfMonth: u, isBefore: m, endOfMonth: h, isAfter: v } = n, f = e.startMonth && u(e.startMonth), p = e.endMonth && h(e.endMonth), g = {
    [Oe.focused]: [],
    [Oe.outside]: [],
    [Oe.disabled]: [],
    [Oe.hidden]: [],
    [Oe.today]: []
  }, y = {};
  for (const w of t) {
    const { date: C, displayMonth: S } = w, P = !!(S && !d(C, S)), E = !!(f && m(C, f)), N = !!(p && v(C, p)), T = !!(r && Wt(C, r, n)), k = !!(o && Wt(C, o, n)) || E || N || // Broadcast calendar will show outside days as default
    !s && !a && P || s && a === !1 && P, D = c(C, l ?? n.today());
    P && g.outside.push(w), T && g.disabled.push(w), k && g.hidden.push(w), D && g.today.push(w), i && Object.keys(i).forEach((F) => {
      const O = i == null ? void 0 : i[F];
      O && Wt(C, O, n) && (y[F] ? y[F].push(w) : y[F] = [w]);
    });
  }
  return (w) => {
    const C = {
      [Oe.focused]: !1,
      [Oe.disabled]: !1,
      [Oe.hidden]: !1,
      [Oe.outside]: !1,
      [Oe.today]: !1
    }, S = {};
    for (const P in g) {
      const E = g[P];
      C[P] = E.some((N) => N === w);
    }
    for (const P in y)
      S[P] = y[P].some((E) => E === w);
    return {
      ...C,
      // custom modifiers should override all the previous ones
      ...S
    };
  };
}
function by(t, e, n = {}) {
  return Object.entries(t).filter(([, o]) => o === !0).reduce((o, [i]) => (n[i] ? o.push(n[i]) : e[Oe[i]] ? o.push(e[Oe[i]]) : e[pt[i]] && o.push(e[pt[i]]), o), [e[X.Day]]);
}
function yy(t) {
  return B.createElement("button", { ...t });
}
function wy(t) {
  return B.createElement("span", { ...t });
}
function xy(t) {
  const { size: e = 24, orientation: n = "left", className: r } = t;
  return B.createElement(
    "svg",
    { className: r, width: e, height: e, viewBox: "0 0 24 24" },
    n === "up" && B.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && B.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && B.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && B.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function Sy(t) {
  const { day: e, modifiers: n, ...r } = t;
  return B.createElement("td", { ...r });
}
function Cy(t) {
  const { day: e, modifiers: n, ...r } = t, o = B.useRef(null);
  return B.useEffect(() => {
    var i;
    n.focused && ((i = o.current) == null || i.focus());
  }, [n.focused]), B.createElement("button", { ref: o, ...r });
}
function Ey(t) {
  const { options: e, className: n, components: r, classNames: o, ...i } = t, a = [o[X.Dropdown], n].join(" "), s = e == null ? void 0 : e.find(({ value: l }) => l === i.value);
  return B.createElement(
    "span",
    { "data-disabled": i.disabled, className: o[X.DropdownRoot] },
    B.createElement(r.Select, { className: a, ...i }, e == null ? void 0 : e.map(({ value: l, label: c, disabled: d }) => B.createElement(r.Option, { key: l, value: l, disabled: d }, c))),
    B.createElement(
      "span",
      { className: o[X.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      B.createElement(r.Chevron, { orientation: "down", size: 18, className: o[X.Chevron] })
    )
  );
}
function Py(t) {
  return B.createElement("div", { ...t });
}
function Ny(t) {
  return B.createElement("div", { ...t });
}
function Oy(t) {
  const { calendarMonth: e, displayIndex: n, ...r } = t;
  return B.createElement("div", { ...r }, t.children);
}
function Ty(t) {
  const { calendarMonth: e, displayIndex: n, ...r } = t;
  return B.createElement("div", { ...r });
}
function Iy(t) {
  return B.createElement("table", { ...t });
}
function My(t) {
  return B.createElement("div", { ...t });
}
const du = lt(void 0);
function hr() {
  const t = ar(du);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function ky(t) {
  const { components: e } = hr();
  return B.createElement(e.Dropdown, { ...t });
}
function _y(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: r, nextMonth: o, ...i } = t, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = hr(), d = Ne((m) => {
    o && (n == null || n(m));
  }, [o, n]), u = Ne((m) => {
    r && (e == null || e(m));
  }, [r, e]);
  return B.createElement(
    "nav",
    { ...i },
    B.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[X.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: u },
      B.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[X.Chevron], orientation: "left" })
    ),
    B.createElement(
      a.NextMonthButton,
      { type: "button", className: s[X.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": c(o), onClick: d },
      B.createElement(a.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: s[X.Chevron] })
    )
  );
}
function Dy(t) {
  const { components: e } = hr();
  return B.createElement(e.Button, { ...t });
}
function Ry(t) {
  return B.createElement("option", { ...t });
}
function Ay(t) {
  const { components: e } = hr();
  return B.createElement(e.Button, { ...t });
}
function Fy(t) {
  const { rootRef: e, ...n } = t;
  return B.createElement("div", { ...n, ref: e });
}
function Ly(t) {
  return B.createElement("select", { ...t });
}
function Wy(t) {
  const { week: e, ...n } = t;
  return B.createElement("tr", { ...n });
}
function $y(t) {
  return B.createElement("th", { ...t });
}
function Vy(t) {
  return B.createElement(
    "thead",
    { "aria-hidden": !0 },
    B.createElement("tr", { ...t })
  );
}
function By(t) {
  const { week: e, ...n } = t;
  return B.createElement("th", { ...n });
}
function zy(t) {
  return B.createElement("th", { ...t });
}
function Hy(t) {
  return B.createElement("tbody", { ...t });
}
function Yy(t) {
  const { components: e } = hr();
  return B.createElement(e.Dropdown, { ...t });
}
const Ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: yy,
  CaptionLabel: wy,
  Chevron: xy,
  Day: Sy,
  DayButton: Cy,
  Dropdown: Ey,
  DropdownNav: Py,
  Footer: Ny,
  Month: Oy,
  MonthCaption: Ty,
  MonthGrid: Iy,
  Months: My,
  MonthsDropdown: ky,
  Nav: _y,
  NextMonthButton: Dy,
  Option: Ry,
  PreviousMonthButton: Ay,
  Root: Fy,
  Select: Ly,
  Week: Wy,
  WeekNumber: By,
  WeekNumberHeader: zy,
  Weekday: $y,
  Weekdays: Vy,
  Weeks: Hy,
  YearsDropdown: Yy
}, Symbol.toStringTag, { value: "Module" }));
function Uy(t) {
  return {
    ...Ky,
    ...t
  };
}
function jy(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0,
    "data-nav-layout": t.navLayout || void 0
  };
  return Object.entries(t).forEach(([n, r]) => {
    n.startsWith("data-") && (e[n] = r);
  }), e;
}
function Gy() {
  const t = {};
  for (const e in X)
    t[X[e]] = `rdp-${X[e]}`;
  for (const e in Oe)
    t[Oe[e]] = `rdp-${Oe[e]}`;
  for (const e in pt)
    t[pt[e]] = `rdp-${pt[e]}`;
  for (const e in Xe)
    t[Xe[e]] = `rdp-${Xe[e]}`;
  return t;
}
function fu(t, e, n) {
  return (n ?? new Kt(e)).format(t, "LLLL y");
}
const qy = fu;
function Xy(t, e, n) {
  return (n ?? new Kt(e)).format(t, "d");
}
function Zy(t, e = Rt) {
  return e.format(t, "LLLL");
}
function Jy(t, e = Rt) {
  return t < 10 ? e.formatNumber(`0${t.toLocaleString()}`) : e.formatNumber(`${t.toLocaleString()}`);
}
function Qy() {
  return "";
}
function ew(t, e, n) {
  return (n ?? new Kt(e)).format(t, "cccccc");
}
function mu(t, e = Rt) {
  return e.format(t, "yyyy");
}
const tw = mu, nw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: fu,
  formatDay: Xy,
  formatMonthCaption: qy,
  formatMonthDropdown: Zy,
  formatWeekNumber: Jy,
  formatWeekNumberHeader: Qy,
  formatWeekdayName: ew,
  formatYearCaption: tw,
  formatYearDropdown: mu
}, Symbol.toStringTag, { value: "Module" }));
function rw(t) {
  return t != null && t.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t != null && t.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...nw,
    ...t
  };
}
function ow(t, e, n, r, o) {
  const { startOfMonth: i, startOfYear: a, endOfYear: s, eachMonthOfInterval: l, getMonth: c } = o;
  return l({
    start: a(t),
    end: s(t)
  }).map((m) => {
    const h = r.formatMonthDropdown(m, o), v = c(m), f = e && m < i(e) || n && m > i(n) || !1;
    return { value: v, label: h, disabled: f };
  });
}
function iw(t, e = {}, n = {}) {
  let r = { ...e == null ? void 0 : e[X.Day] };
  return Object.entries(t).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
function sw(t, e, n) {
  const r = t.today(), o = e ? t.startOfISOWeek(r) : t.startOfWeek(r), i = [];
  for (let a = 0; a < 7; a++) {
    const s = t.addDays(o, a);
    i.push(s);
  }
  return i;
}
function aw(t, e, n, r) {
  if (!t || !e)
    return;
  const { startOfYear: o, endOfYear: i, addYears: a, getYear: s, isBefore: l, isSameYear: c } = r, d = o(t), u = i(e), m = [];
  let h = d;
  for (; l(h, u) || c(h, u); )
    m.push(h), h = a(h, 1);
  return m.map((v) => {
    const f = n.formatYearDropdown(v, r);
    return {
      value: s(v),
      label: f,
      disabled: !1
    };
  });
}
function hu(t, e, n) {
  return (n ?? new Kt(e)).format(t, "LLLL y");
}
const lw = hu;
function cw(t, e, n, r) {
  let o = (r ?? new Kt(n)).format(t, "PPPP");
  return e != null && e.today && (o = `Today, ${o}`), o;
}
function pu(t, e, n, r) {
  let o = (r ?? new Kt(n)).format(t, "PPPP");
  return e.today && (o = `Today, ${o}`), e.selected && (o = `${o}, selected`), o;
}
const uw = pu;
function dw() {
  return "";
}
function fw(t) {
  return "Choose the Month";
}
function mw(t) {
  return "Go to the Next Month";
}
function hw(t) {
  return "Go to the Previous Month";
}
function pw(t, e, n) {
  return (n ?? new Kt(e)).format(t, "cccc");
}
function vw(t, e) {
  return `Week ${t}`;
}
function gw(t) {
  return "Week Number";
}
function bw(t) {
  return "Choose the Year";
}
const yw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: lw,
  labelDay: uw,
  labelDayButton: pu,
  labelGrid: hu,
  labelGridcell: cw,
  labelMonthDropdown: fw,
  labelNav: dw,
  labelNext: mw,
  labelPrevious: hw,
  labelWeekNumber: vw,
  labelWeekNumberHeader: gw,
  labelWeekday: pw,
  labelYearDropdown: bw
}, Symbol.toStringTag, { value: "Module" })), pr = (t) => t instanceof HTMLElement ? t : null, Jo = (t) => [
  ...t.querySelectorAll("[data-animated-month]") ?? []
], ww = (t) => pr(t.querySelector("[data-animated-month]")), Qo = (t) => pr(t.querySelector("[data-animated-caption]")), ei = (t) => pr(t.querySelector("[data-animated-weeks]")), xw = (t) => pr(t.querySelector("[data-animated-nav]")), Sw = (t) => pr(t.querySelector("[data-animated-weekdays]"));
function Cw(t, e, { classNames: n, months: r, focused: o, dateLib: i }) {
  const a = pe(null), s = pe(r), l = pe(!1);
  ji(() => {
    const c = s.current;
    if (s.current = r, !e || !t.current || // safety check because the ref can be set to anything by consumers
    !(t.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const d = i.isSameMonth(r[0].date, c[0].date), u = i.isAfter(r[0].date, c[0].date), m = u ? n[Xe.caption_after_enter] : n[Xe.caption_before_enter], h = u ? n[Xe.weeks_after_enter] : n[Xe.weeks_before_enter], v = a.current, f = t.current.cloneNode(!0);
    if (f instanceof HTMLElement ? (Jo(f).forEach((w) => {
      if (!(w instanceof HTMLElement))
        return;
      const C = ww(w);
      C && w.contains(C) && w.removeChild(C);
      const S = Qo(w);
      S && S.classList.remove(m);
      const P = ei(w);
      P && P.classList.remove(h);
    }), a.current = f) : a.current = null, l.current || d || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const p = v instanceof HTMLElement ? Jo(v) : [], g = Jo(t.current);
    if (g && g.every((y) => y instanceof HTMLElement) && p && p.every((y) => y instanceof HTMLElement)) {
      l.current = !0, t.current.style.isolation = "isolate";
      const y = xw(t.current);
      y && (y.style.zIndex = "1"), g.forEach((w, C) => {
        const S = p[C];
        if (!S)
          return;
        w.style.position = "relative", w.style.overflow = "hidden";
        const P = Qo(w);
        P && P.classList.add(m);
        const E = ei(w);
        E && E.classList.add(h);
        const N = () => {
          l.current = !1, t.current && (t.current.style.isolation = ""), y && (y.style.zIndex = ""), P && P.classList.remove(m), E && E.classList.remove(h), w.style.position = "", w.style.overflow = "", w.contains(S) && w.removeChild(S);
        };
        S.style.pointerEvents = "none", S.style.position = "absolute", S.style.overflow = "hidden", S.setAttribute("aria-hidden", "true");
        const T = Sw(S);
        T && (T.style.opacity = "0");
        const k = Qo(S);
        k && (k.classList.add(u ? n[Xe.caption_before_exit] : n[Xe.caption_after_exit]), k.addEventListener("animationend", N));
        const D = ei(S);
        D && D.classList.add(u ? n[Xe.weeks_before_exit] : n[Xe.weeks_after_exit]), w.insertBefore(S, w.firstChild);
      });
    }
  });
}
function Ew(t, e, n, r) {
  const o = t[0], i = t[t.length - 1], { ISOWeek: a, fixedWeeks: s, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: d, differenceInCalendarMonths: u, endOfBroadcastWeek: m, endOfISOWeek: h, endOfMonth: v, endOfWeek: f, isAfter: p, startOfBroadcastWeek: g, startOfISOWeek: y, startOfWeek: w } = r, C = l ? g(o, r) : a ? y(o) : w(o), S = l ? m(i) : a ? h(v(i)) : f(v(i)), P = d(S, C), E = u(i, o) + 1, N = [];
  for (let D = 0; D <= P; D++) {
    const F = c(C, D);
    if (e && p(F, e))
      break;
    N.push(F);
  }
  const k = (l ? 35 : 42) * E;
  if (s && N.length < k) {
    const D = k - N.length;
    for (let F = 0; F < D; F++) {
      const O = c(N[N.length - 1], 1);
      N.push(O);
    }
  }
  return N;
}
function Pw(t) {
  const e = [];
  return t.reduce((n, r) => {
    const o = r.weeks.reduce((i, a) => [...i, ...a.days], e);
    return [...n, ...o];
  }, e);
}
function Nw(t, e, n, r) {
  const { numberOfMonths: o = 1 } = n, i = [];
  for (let a = 0; a < o; a++) {
    const s = r.addMonths(t, a);
    if (e && s > e)
      break;
    i.push(s);
  }
  return i;
}
function Ra(t, e) {
  const { month: n, defaultMonth: r, today: o = e.today(), numberOfMonths: i = 1, endMonth: a, startMonth: s } = t;
  let l = n || r || o;
  const { differenceInCalendarMonths: c, addMonths: d, startOfMonth: u } = e;
  if (a && c(a, l) < 0) {
    const m = -1 * (i - 1);
    l = d(a, m);
  }
  return s && c(l, s) < 0 && (l = s), u(l);
}
function Ow(t, e, n, r) {
  const { addDays: o, endOfBroadcastWeek: i, endOfISOWeek: a, endOfMonth: s, endOfWeek: l, getISOWeek: c, getWeek: d, startOfBroadcastWeek: u, startOfISOWeek: m, startOfWeek: h } = r, v = t.reduce((f, p) => {
    const g = n.broadcastCalendar ? u(p, r) : n.ISOWeek ? m(p) : h(p), y = n.broadcastCalendar ? i(p) : n.ISOWeek ? a(s(p)) : l(s(p)), w = e.filter((E) => E >= g && E <= y), C = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && w.length < C) {
      const E = e.filter((N) => {
        const T = C - w.length;
        return N > y && N <= o(y, T);
      });
      w.push(...E);
    }
    const S = w.reduce((E, N) => {
      const T = n.ISOWeek ? c(N) : d(N), k = E.find((F) => F.weekNumber === T), D = new iu(N, p, r);
      return k ? k.days.push(D) : E.push(new vy(T, [D])), E;
    }, []), P = new py(p, S);
    return f.push(P), f;
  }, []);
  return n.reverseMonths ? v.reverse() : v;
}
function Tw(t, e) {
  let { startMonth: n, endMonth: r } = t;
  const { startOfYear: o, startOfDay: i, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c, newDate: d, today: u } = e, { fromYear: m, toYear: h, fromMonth: v, toMonth: f } = t;
  !n && v && (n = v), !n && m && (n = e.newDate(m, 0, 1)), !r && f && (r = f), !r && h && (r = d(h, 11, 31));
  const p = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = a(n) : m ? n = d(m, 0, 1) : !n && p && (n = o(l(t.today ?? u(), -100))), r ? r = s(r) : h ? r = d(h, 11, 31) : !r && p && (r = c(t.today ?? u())), [
    n && i(n),
    r && i(r)
  ];
}
function Iw(t, e, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i : 1, d = a(t);
  if (!e)
    return s(d, c);
  if (!(l(e, t) < i))
    return s(d, c);
}
function Mw(t, e, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i ?? 1 : 1, d = a(t);
  if (!e)
    return s(d, -c);
  if (!(l(d, e) <= 0))
    return s(d, -c);
}
function kw(t) {
  const e = [];
  return t.reduce((n, r) => [...n, ...r.weeks], e);
}
function yo(t, e) {
  const [n, r] = le(t);
  return [e === void 0 ? n : e, r];
}
function _w(t, e) {
  const [n, r] = Tw(t, e), { startOfMonth: o, endOfMonth: i } = e, a = Ra(t, e), [s, l] = yo(
    a,
    // initialMonth is always computed from props.month if provided
    t.month ? a : void 0
  );
  fe(() => {
    const P = Ra(t, e);
    l(P);
  }, [t.timeZone]);
  const c = Nw(s, r, t, e), d = Ew(c, t.endMonth ? i(t.endMonth) : void 0, t, e), u = Ow(c, d, t, e), m = kw(u), h = Pw(u), v = Mw(s, n, t, e), f = Iw(s, r, t, e), { disableNavigation: p, onMonthChange: g } = t, y = (P) => m.some((E) => E.days.some((N) => N.isEqualTo(P))), w = (P) => {
    if (p)
      return;
    let E = o(P);
    n && E < o(n) && (E = o(n)), r && E > o(r) && (E = o(r)), l(E), g == null || g(E);
  };
  return {
    months: u,
    weeks: m,
    days: h,
    navStart: n,
    navEnd: r,
    previousMonth: v,
    nextMonth: f,
    goToMonth: w,
    goToDay: (P) => {
      y(P) || w(P.date);
    }
  };
}
var Et;
(function(t) {
  t[t.Today = 0] = "Today", t[t.Selected = 1] = "Selected", t[t.LastFocused = 2] = "LastFocused", t[t.FocusedModifier = 3] = "FocusedModifier";
})(Et || (Et = {}));
function Aa(t) {
  return !t[Oe.disabled] && !t[Oe.hidden] && !t[Oe.outside];
}
function Dw(t, e, n, r) {
  let o, i = -1;
  for (const a of t) {
    const s = e(a);
    Aa(s) && (s[Oe.focused] && i < Et.FocusedModifier ? (o = a, i = Et.FocusedModifier) : r != null && r.isEqualTo(a) && i < Et.LastFocused ? (o = a, i = Et.LastFocused) : n(a.date) && i < Et.Selected ? (o = a, i = Et.Selected) : s[Oe.today] && i < Et.Today && (o = a, i = Et.Today));
  }
  return o || (o = t.find((a) => Aa(e(a)))), o;
}
function Rw(t, e, n, r, o, i, a) {
  const { ISOWeek: s, broadcastCalendar: l } = i, { addDays: c, addMonths: d, addWeeks: u, addYears: m, endOfBroadcastWeek: h, endOfISOWeek: v, endOfWeek: f, max: p, min: g, startOfBroadcastWeek: y, startOfISOWeek: w, startOfWeek: C } = a;
  let P = {
    day: c,
    week: u,
    month: d,
    year: m,
    startOfWeek: (E) => l ? y(E, a) : s ? w(E) : C(E),
    endOfWeek: (E) => l ? h(E) : s ? v(E) : f(E)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && r ? P = p([r, P]) : e === "after" && o && (P = g([o, P])), P;
}
function vu(t, e, n, r, o, i, a, s = 0) {
  if (s > 365)
    return;
  const l = Rw(t, e, n.date, r, o, i, a), c = !!(i.disabled && Wt(l, i.disabled, a)), d = !!(i.hidden && Wt(l, i.hidden, a)), u = l, m = new iu(l, u, a);
  return !c && !d ? m : vu(t, e, m, r, o, i, a, s + 1);
}
function Aw(t, e, n, r, o) {
  const { autoFocus: i } = t, [a, s] = le(), l = Dw(e.days, n, r || (() => !1), a), [c, d] = le(i ? l : void 0);
  return {
    isFocusTarget: (f) => !!(l != null && l.isEqualTo(f)),
    setFocused: d,
    focused: c,
    blur: () => {
      s(c), d(void 0);
    },
    moveFocus: (f, p) => {
      if (!c)
        return;
      const g = vu(f, p, c, e.navStart, e.navEnd, t, o);
      g && (e.goToDay(g), d(g));
    }
  };
}
function Fw(t, e) {
  const { selected: n, required: r, onSelect: o } = t, [i, a] = yo(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = e, c = (h) => (s == null ? void 0 : s.some((v) => l(v, h))) ?? !1, { min: d, max: u } = t;
  return {
    selected: s,
    select: (h, v, f) => {
      let p = [...s ?? []];
      if (c(h)) {
        if ((s == null ? void 0 : s.length) === d || r && (s == null ? void 0 : s.length) === 1)
          return;
        p = s == null ? void 0 : s.filter((g) => !l(g, h));
      } else
        (s == null ? void 0 : s.length) === u ? p = [h] : p = [...p, h];
      return o || a(p), o == null || o(p, h, v, f), p;
    },
    isSelected: c
  };
}
function Lw(t, e, n = 0, r = 0, o = !1, i = Rt) {
  const { from: a, to: s } = e || {}, { isSameDay: l, isAfter: c, isBefore: d } = i;
  let u;
  if (!a && !s)
    u = { from: t, to: n > 0 ? void 0 : t };
  else if (a && !s)
    l(a, t) ? o ? u = { from: a, to: void 0 } : u = void 0 : d(t, a) ? u = { from: t, to: a } : u = { from: a, to: t };
  else if (a && s)
    if (l(a, t) && l(s, t))
      o ? u = { from: a, to: s } : u = void 0;
    else if (l(a, t))
      u = { from: a, to: n > 0 ? void 0 : t };
    else if (l(s, t))
      u = { from: t, to: n > 0 ? void 0 : t };
    else if (d(t, a))
      u = { from: t, to: s };
    else if (c(t, a))
      u = { from: a, to: t };
    else if (c(t, s))
      u = { from: a, to: t };
    else
      throw new Error("Invalid range");
  if (u != null && u.from && (u != null && u.to)) {
    const m = i.differenceInCalendarDays(u.to, u.from);
    r > 0 && m > r ? u = { from: t, to: void 0 } : n > 1 && m < n && (u = { from: t, to: void 0 });
  }
  return u;
}
function Ww(t, e, n = Rt) {
  const r = Array.isArray(e) ? e : [e];
  let o = t.from;
  const i = n.differenceInCalendarDays(t.to, t.from), a = Math.min(i, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Fa(t, e, n = Rt) {
  return Lt(t, e.from, !1, n) || Lt(t, e.to, !1, n) || Lt(e, t.from, !1, n) || Lt(e, t.to, !1, n);
}
function $w(t, e, n = Rt) {
  const r = Array.isArray(e) ? e : [e];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Lt(t, s, !1, n) : uu(s, n) ? s.some((l) => Lt(t, l, !1, n)) : bs(s) ? s.from && s.to ? Fa(t, { from: s.from, to: s.to }, n) : !1 : cu(s) ? Ww(t, s.dayOfWeek, n) : su(s) ? n.isAfter(s.before, s.after) ? Fa(t, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Wt(t.from, s, n) || Wt(t.to, s, n) : au(s) || lu(s) ? Wt(t.from, s, n) || Wt(t.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = t.from;
    const l = n.differenceInCalendarDays(t.to, t.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((d) => d(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function Vw(t, e) {
  const { disabled: n, excludeDisabled: r, selected: o, required: i, onSelect: a } = t, [s, l] = yo(o, a ? o : void 0), c = a ? o : s;
  return {
    selected: c,
    select: (m, h, v) => {
      const { min: f, max: p } = t, g = m ? Lw(m, c, f, p, i, e) : void 0;
      return r && n && (g != null && g.from) && g.to && $w({ from: g.from, to: g.to }, n, e) && (g.from = m, g.to = void 0), a || l(g), a == null || a(g, m, h, v), g;
    },
    isSelected: (m) => c && Lt(c, m, !1, e)
  };
}
function Bw(t, e) {
  const { selected: n, required: r, onSelect: o } = t, [i, a] = yo(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = e;
  return {
    selected: s,
    select: (u, m, h) => {
      let v = u;
      return !r && s && s && l(u, s) && (v = void 0), o || a(v), o == null || o(v, u, m, h), v;
    },
    isSelected: (u) => s ? l(s, u) : !1
  };
}
function zw(t, e) {
  const n = Bw(t, e), r = Fw(t, e), o = Vw(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function Hw(t) {
  var qs;
  let e = t;
  e.timeZone && (e = {
    ...t
  }, e.today && (e.today = new ze(e.today, e.timeZone)), e.month && (e.month = new ze(e.month, e.timeZone)), e.defaultMonth && (e.defaultMonth = new ze(e.defaultMonth, e.timeZone)), e.startMonth && (e.startMonth = new ze(e.startMonth, e.timeZone)), e.endMonth && (e.endMonth = new ze(e.endMonth, e.timeZone)), e.mode === "single" && e.selected ? e.selected = new ze(e.selected, e.timeZone) : e.mode === "multiple" && e.selected ? e.selected = (qs = e.selected) == null ? void 0 : qs.map((ce) => new ze(ce, e.timeZone)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? new ze(e.selected.from, e.timeZone) : void 0,
    to: e.selected.to ? new ze(e.selected.to, e.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: o, dateLib: i, locale: a, classNames: s } = It(() => {
    const ce = { ...bo, ...e.locale };
    return {
      dateLib: new Kt({
        locale: ce,
        weekStartsOn: e.broadcastCalendar ? 1 : e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
        timeZone: e.timeZone,
        numerals: e.numerals
      }, e.dateLib),
      components: Uy(e.components),
      formatters: rw(e.formatters),
      labels: { ...yw, ...e.labels },
      locale: ce,
      classNames: { ...Gy(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]), { captionLayout: l, mode: c, navLayout: d, numberOfMonths: u = 1, onDayBlur: m, onDayClick: h, onDayFocus: v, onDayKeyDown: f, onDayMouseEnter: p, onDayMouseLeave: g, onNextClick: y, onPrevClick: w, showWeekNumber: C, styles: S } = e, { formatCaption: P, formatDay: E, formatMonthDropdown: N, formatWeekNumber: T, formatWeekNumberHeader: k, formatWeekdayName: D, formatYearDropdown: F } = r, O = _w(e, i), { days: _, months: L, navStart: I, navEnd: R, previousMonth: A, nextMonth: M, goToMonth: W } = O, z = gy(_, e, i), { isSelected: K, select: j, selected: G } = zw(e, i) ?? {}, { blur: J, focused: oe, isFocusTarget: Y, moveFocus: Z, setFocused: ie } = Aw(e, O, z, K ?? (() => !1), i), { labelDayButton: te, labelGridcell: ne, labelGrid: re, labelMonthDropdown: xe, labelNav: Ee, labelPrevious: Ke, labelNext: Ae, labelWeekday: Ge, labelWeekNumber: nt, labelWeekNumberHeader: Ve, labelYearDropdown: wt } = o, xt = It(() => sw(i, e.ISOWeek), [i, e.ISOWeek]), ut = c !== void 0 || h !== void 0, St = Ne(() => {
    A && (W(A), w == null || w(A));
  }, [A, W, w]), V = Ne(() => {
    M && (W(M), y == null || y(M));
  }, [W, M, y]), se = Ne((ce, Pe) => (Se) => {
    Se.preventDefault(), Se.stopPropagation(), ie(ce), j == null || j(ce.date, Pe, Se), h == null || h(ce.date, Pe, Se);
  }, [j, h, ie]), me = Ne((ce, Pe) => (Se) => {
    ie(ce), v == null || v(ce.date, Pe, Se);
  }, [v, ie]), de = Ne((ce, Pe) => (Se) => {
    J(), m == null || m(ce.date, Pe, Se);
  }, [J, m]), Fe = Ne((ce, Pe) => (Se) => {
    const Gt = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [Se.shiftKey ? "year" : "month", "before"],
      PageDown: [Se.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Gt[Se.key]) {
      Se.preventDefault(), Se.stopPropagation();
      const [ft, Er] = Gt[Se.key];
      Z(ft, Er);
    }
    f == null || f(ce.date, Pe, Se);
  }, [Z, f, e.dir]), dt = Ne((ce, Pe) => (Se) => {
    p == null || p(ce.date, Pe, Se);
  }, [p]), _e = Ne((ce, Pe) => (Se) => {
    g == null || g(ce.date, Pe, Se);
  }, [g]), At = Ne((ce) => (Pe) => {
    const Se = Number(Pe.target.value), Gt = i.setMonth(i.startOfMonth(ce), Se);
    W(Gt);
  }, [i, W]), Wo = Ne((ce) => (Pe) => {
    const Se = Number(Pe.target.value), Gt = i.setYear(i.startOfMonth(ce), Se);
    W(Gt);
  }, [i, W]), { className: Cm, style: Em } = It(() => ({
    className: [s[X.Root], e.className].filter(Boolean).join(" "),
    style: { ...S == null ? void 0 : S[X.Root], ...e.style }
  }), [s, e.className, e.style, S]), Pm = jy(e), Gs = pe(null);
  Cw(Gs, !!e.animate, {
    classNames: s,
    months: L,
    focused: oe,
    dateLib: i
  });
  const Nm = {
    dayPickerProps: e,
    selected: G,
    select: j,
    isSelected: K,
    months: L,
    nextMonth: M,
    previousMonth: A,
    goToMonth: W,
    getModifiers: z,
    components: n,
    classNames: s,
    styles: S,
    labels: o,
    formatters: r
  };
  return B.createElement(
    du.Provider,
    { value: Nm },
    B.createElement(
      n.Root,
      { rootRef: e.animate ? Gs : void 0, className: Cm, style: Em, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], ...Pm },
      B.createElement(
        n.Months,
        { className: s[X.Months], style: S == null ? void 0 : S[X.Months] },
        !e.hideNavigation && !d && B.createElement(n.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: s[X.Nav], style: S == null ? void 0 : S[X.Nav], "aria-label": Ee(), onPreviousClick: St, onNextClick: V, previousMonth: A, nextMonth: M }),
        L.map((ce, Pe) => {
          const Se = ow(ce.date, I, R, r, i), Gt = aw(I, R, r, i);
          return B.createElement(
            n.Month,
            { "data-animated-month": e.animate ? "true" : void 0, className: s[X.Month], style: S == null ? void 0 : S[X.Month], key: Pe, displayIndex: Pe, calendarMonth: ce },
            d === "around" && !e.hideNavigation && Pe === 0 && B.createElement(
              n.PreviousMonthButton,
              { type: "button", className: s[X.PreviousMonthButton], tabIndex: A ? void 0 : -1, "aria-disabled": A ? void 0 : !0, "aria-label": Ke(A), onClick: St, "data-animated-button": e.animate ? "true" : void 0 },
              B.createElement(n.Chevron, { disabled: A ? void 0 : !0, className: s[X.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
            ),
            B.createElement(n.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: s[X.MonthCaption], style: S == null ? void 0 : S[X.MonthCaption], calendarMonth: ce, displayIndex: Pe }, l != null && l.startsWith("dropdown") ? B.createElement(
              n.DropdownNav,
              { className: s[X.Dropdowns], style: S == null ? void 0 : S[X.Dropdowns] },
              l === "dropdown" || l === "dropdown-months" ? B.createElement(n.MonthsDropdown, { className: s[X.MonthsDropdown], "aria-label": xe(), classNames: s, components: n, disabled: !!e.disableNavigation, onChange: At(ce.date), options: Se, style: S == null ? void 0 : S[X.Dropdown], value: i.getMonth(ce.date) }) : B.createElement("span", null, N(ce.date, i)),
              l === "dropdown" || l === "dropdown-years" ? B.createElement(n.YearsDropdown, { className: s[X.YearsDropdown], "aria-label": wt(i.options), classNames: s, components: n, disabled: !!e.disableNavigation, onChange: Wo(ce.date), options: Gt, style: S == null ? void 0 : S[X.Dropdown], value: i.getYear(ce.date) }) : B.createElement("span", null, F(ce.date, i)),
              B.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, P(ce.date, i.options, i))
            ) : B.createElement(n.CaptionLabel, { className: s[X.CaptionLabel], role: "status", "aria-live": "polite" }, P(ce.date, i.options, i))),
            d === "around" && !e.hideNavigation && Pe === u - 1 && B.createElement(
              n.NextMonthButton,
              { type: "button", className: s[X.NextMonthButton], tabIndex: M ? void 0 : -1, "aria-disabled": M ? void 0 : !0, "aria-label": Ae(M), onClick: V, "data-animated-button": e.animate ? "true" : void 0 },
              B.createElement(n.Chevron, { disabled: M ? void 0 : !0, className: s[X.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
            ),
            Pe === u - 1 && d === "after" && !e.hideNavigation && B.createElement(n.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: s[X.Nav], style: S == null ? void 0 : S[X.Nav], "aria-label": Ee(), onPreviousClick: St, onNextClick: V, previousMonth: A, nextMonth: M }),
            B.createElement(
              n.MonthGrid,
              { role: "grid", "aria-multiselectable": c === "multiple" || c === "range", "aria-label": re(ce.date, i.options, i) || void 0, className: s[X.MonthGrid], style: S == null ? void 0 : S[X.MonthGrid] },
              !e.hideWeekdays && B.createElement(
                n.Weekdays,
                { "data-animated-weekdays": e.animate ? "true" : void 0, className: s[X.Weekdays], style: S == null ? void 0 : S[X.Weekdays] },
                C && B.createElement(n.WeekNumberHeader, { "aria-label": Ve(i.options), className: s[X.WeekNumberHeader], style: S == null ? void 0 : S[X.WeekNumberHeader], scope: "col" }, k()),
                xt.map((ft, Er) => B.createElement(n.Weekday, { "aria-label": Ge(ft, i.options, i), className: s[X.Weekday], key: Er, style: S == null ? void 0 : S[X.Weekday], scope: "col" }, D(ft, i.options, i)))
              ),
              B.createElement(n.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: s[X.Weeks], style: S == null ? void 0 : S[X.Weeks] }, ce.weeks.map((ft, Er) => B.createElement(
                n.Week,
                { className: s[X.Week], key: ft.weekNumber, style: S == null ? void 0 : S[X.Week], week: ft },
                C && B.createElement(n.WeekNumber, { week: ft, style: S == null ? void 0 : S[X.WeekNumber], "aria-label": nt(ft.weekNumber, {
                  locale: a
                }), className: s[X.WeekNumber], scope: "row", role: "rowheader" }, T(ft.weekNumber, i)),
                ft.days.map((Be) => {
                  const { date: Ct } = Be, ye = z(Be);
                  if (ye[Oe.focused] = !ye.hidden && !!(oe != null && oe.isEqualTo(Be)), ye[pt.selected] = (K == null ? void 0 : K(Ct)) || ye.selected, bs(G)) {
                    const { from: $o, to: Vo } = G;
                    ye[pt.range_start] = !!($o && Vo && i.isSameDay(Ct, $o)), ye[pt.range_end] = !!($o && Vo && i.isSameDay(Ct, Vo)), ye[pt.range_middle] = Lt(G, Ct, !0, i);
                  }
                  const Om = iw(ye, S, e.modifiersStyles), Tm = by(ye, s, e.modifiersClassNames), Im = !ut && !ye.hidden ? ne(Ct, ye, i.options, i) : void 0;
                  return B.createElement(n.Day, { key: `${i.format(Ct, "yyyy-MM-dd")}_${i.format(Be.displayMonth, "yyyy-MM")}`, day: Be, modifiers: ye, className: Tm.join(" "), style: Om, role: "gridcell", "aria-selected": ye.selected || void 0, "aria-label": Im, "data-day": i.format(Ct, "yyyy-MM-dd"), "data-month": Be.outside ? i.format(Ct, "yyyy-MM") : void 0, "data-selected": ye.selected || void 0, "data-disabled": ye.disabled || void 0, "data-hidden": ye.hidden || void 0, "data-outside": Be.outside || void 0, "data-focused": ye.focused || void 0, "data-today": ye.today || void 0 }, !ye.hidden && ut ? B.createElement(n.DayButton, { className: s[X.DayButton], style: S == null ? void 0 : S[X.DayButton], type: "button", day: Be, modifiers: ye, disabled: ye.disabled || void 0, tabIndex: Y(Be) ? 0 : -1, "aria-label": te(Ct, ye, i.options, i), onClick: se(Be, ye), onBlur: de(Be, ye), onFocus: me(Be, ye), onKeyDown: Fe(Be, ye), onMouseEnter: dt(Be, ye), onMouseLeave: _e(Be, ye) }, E(Ct, i.options, i)) : !ye.hidden && E(Be.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      e.footer && B.createElement(n.Footer, { className: s[X.Footer], style: S == null ? void 0 : S[X.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
const gu = {
  en: bo,
  fr: wb
}, Yw = (t) => {
  const e = ee(20);
  let n, r, o, i, a, s;
  e[0] !== t ? ({
    onChange: i,
    className: n,
    classNames: r,
    language: s,
    selected: o,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6]);
  const l = s === void 0 ? "fr" : s, [c, d] = le(o);
  let u;
  e[7] !== i ? (u = (y) => {
    d(y), i == null || i(y);
  }, e[7] = i, e[8] = u) : u = e[8];
  const m = u, h = gu[l];
  let v;
  e[9] === Symbol.for("react.memo_cache_sentinel") ? (v = H("size-lg relative z-10 flex justify-center rounded-lg text-center text-sm font-normal transition-colors", "before:size-lg hover:before:bg-grayscale-x-light focus-visible:before:bg-grayscale-x-light before:absolute before:top-[-1px] before:-z-10 before:scale-50 before:rounded-full before:bg-transparent before:transition-all before:duration-200 before:ease-out before:content-[''] hover:before:scale-100 active:before:bg-transparent", "aria-selected:bg-primary aria-selected:hover:bg-primary-dark aria-selected:text-white aria-selected:before:hidden aria-selected:hover:text-white"), e[9] = v) : v = e[9];
  let f;
  e[10] !== r ? (f = {
    root: "w-fit",
    months: "relative",
    nav: "absolute top-0 w-full flex justify-between",
    button_previous: "flex justify-center items-center rounded-full size-lg hover:bg-grayscale-x-light focus-visible:bg-grayscale-x-light active:bg-grayscale-xx-light transition-colors",
    button_next: "flex justify-center items-center rounded-full size-lg hover:bg-grayscale-x-light focus-visible:bg-grayscale-x-light active:bg-grayscale-xx-light transition-colors",
    month: "flex flex-col items-center",
    month_caption: "capitalize text-lg font-bold z-10 mb-sm pt-3xs",
    month_grid: "w-full",
    weekdays: "flex px-md mb-xs gap-3xs",
    weekday: "w-lg text-sm text-grayscale font-normal",
    weeks: "flex flex-col gap-y-3xs",
    week: "w-full flex px-md gap-3xs",
    day: v,
    day_button: "w-full line-height-0",
    outside: "opacity-50 aria-selected:opacity-100",
    today: "border-grayscale-xx-light border",
    ...r
  }, e[10] = r, e[11] = f) : f = e[11];
  let p;
  e[12] === Symbol.for("react.memo_cache_sentinel") ? (p = {
    Chevron: Kw
  }, e[12] = p) : p = e[12];
  let g;
  return e[13] !== n || e[14] !== m || e[15] !== a || e[16] !== c || e[17] !== h || e[18] !== f ? (g = /* @__PURE__ */ b(Hw, { ...a, mode: "single", selected: c, onSelect: m, required: !0, showOutsideDays: !0, locale: h, className: n, classNames: f, components: p }), e[13] = n, e[14] = m, e[15] = a, e[16] = c, e[17] = h, e[18] = f, e[19] = g) : g = e[19], g;
};
function Kw(t) {
  return t.orientation === "left" ? /* @__PURE__ */ b(El, { ...t, className: "size-md" }) : /* @__PURE__ */ b(qi, { ...t, className: "size-md" });
}
function fP(t) {
  const e = ee(6), {
    className: n,
    isFlat: r,
    children: o
  } = t, a = (r === void 0 ? !1 : r) ? "px-lg" : "px-md border-grayscale-xx-light border shadow-sm";
  let s;
  e[0] !== n || e[1] !== a ? (s = H("py-lg rounded-lg bg-white", a, n), e[0] = n, e[1] = a, e[2] = s) : s = e[2];
  let l;
  return e[3] !== o || e[4] !== s ? (l = /* @__PURE__ */ b("div", { className: s, children: o }), e[3] = o, e[4] = s, e[5] = l) : l = e[5], l;
}
function vr(t) {
  const e = x.useRef({ value: t, previous: t });
  return x.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var wo = "Checkbox", [Uw, mP] = Ye(wo), [jw, ys] = Uw(wo);
function Gw(t) {
  const {
    __scopeCheckbox: e,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: i,
    form: a,
    name: s,
    onCheckedChange: l,
    required: c,
    value: d = "on",
    // @ts-expect-error
    internal_do_not_use_render: u
  } = t, [m, h] = je({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: wo
  }), [v, f] = x.useState(null), [p, g] = x.useState(null), y = x.useRef(!1), w = v ? !!a || !!v.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), C = {
    checked: m,
    disabled: i,
    setChecked: h,
    control: v,
    setControl: f,
    name: s,
    form: a,
    value: d,
    hasConsumerStoppedPropagationRef: y,
    required: c,
    defaultChecked: Qt(o) ? !1 : o,
    isFormControl: w,
    bubbleInput: p,
    setBubbleInput: g
  };
  return /* @__PURE__ */ b(
    jw,
    {
      scope: e,
      ...C,
      children: qw(u) ? u(C) : r
    }
  );
}
var bu = "CheckboxTrigger", yu = x.forwardRef(
  ({ __scopeCheckbox: t, onKeyDown: e, onClick: n, ...r }, o) => {
    const {
      control: i,
      value: a,
      disabled: s,
      checked: l,
      required: c,
      setControl: d,
      setChecked: u,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: h,
      bubbleInput: v
    } = ys(bu, t), f = ae(o, d), p = x.useRef(l);
    return x.useEffect(() => {
      const g = i == null ? void 0 : i.form;
      if (g) {
        const y = () => u(p.current);
        return g.addEventListener("reset", y), () => g.removeEventListener("reset", y);
      }
    }, [i, u]), /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": Qt(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": Pu(l),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: a,
        ...r,
        ref: f,
        onKeyDown: U(e, (g) => {
          g.key === "Enter" && g.preventDefault();
        }),
        onClick: U(n, (g) => {
          u((y) => Qt(y) ? !0 : !y), v && h && (m.current = g.isPropagationStopped(), m.current || g.stopPropagation());
        })
      }
    );
  }
);
yu.displayName = bu;
var wu = x.forwardRef(
  (t, e) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: l,
      onCheckedChange: c,
      form: d,
      ...u
    } = t;
    return /* @__PURE__ */ b(
      Gw,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: i,
        disabled: s,
        required: a,
        onCheckedChange: c,
        name: r,
        form: d,
        value: l,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ $(Ce, { children: [
          /* @__PURE__ */ b(
            yu,
            {
              ...u,
              ref: e,
              __scopeCheckbox: n
            }
          ),
          m && /* @__PURE__ */ b(
            Eu,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
wu.displayName = wo;
var xu = "CheckboxIndicator", Su = x.forwardRef(
  (t, e) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = t, i = ys(xu, n);
    return /* @__PURE__ */ b(
      tt,
      {
        present: r || Qt(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ b(
          q.span,
          {
            "data-state": Pu(i.checked),
            "data-disabled": i.disabled ? "" : void 0,
            ...o,
            ref: e,
            style: { pointerEvents: "none", ...t.style }
          }
        )
      }
    );
  }
);
Su.displayName = xu;
var Cu = "CheckboxBubbleInput", Eu = x.forwardRef(
  ({ __scopeCheckbox: t, ...e }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: i,
      defaultChecked: a,
      required: s,
      disabled: l,
      name: c,
      value: d,
      form: u,
      bubbleInput: m,
      setBubbleInput: h
    } = ys(Cu, t), v = ae(n, h), f = vr(i), p = dr(r);
    x.useEffect(() => {
      const y = m;
      if (!y) return;
      const w = window.HTMLInputElement.prototype, S = Object.getOwnPropertyDescriptor(
        w,
        "checked"
      ).set, P = !o.current;
      if (f !== i && S) {
        const E = new Event("click", { bubbles: P });
        y.indeterminate = Qt(i), S.call(y, Qt(i) ? !1 : i), y.dispatchEvent(E);
      }
    }, [m, f, i, o]);
    const g = x.useRef(Qt(i) ? !1 : i);
    return /* @__PURE__ */ b(
      q.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a ?? g.current,
        required: s,
        disabled: l,
        name: c,
        value: d,
        form: u,
        ...e,
        tabIndex: -1,
        ref: v,
        style: {
          ...e.style,
          ...p,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Eu.displayName = Cu;
function qw(t) {
  return typeof t == "function";
}
function Qt(t) {
  return t === "indeterminate";
}
function Pu(t) {
  return Qt(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
const Qe = {
  size: {
    medium: "text-sm",
    large: "text-base"
  },
  fieldType: {
    input: "flex w-full grow placeholder:text-grayscale-light border-grayscale-xx-light invalid:border-negative-x-light invalid:text-negative-dark invalid:shadow-negative-xx-light rounded-md border-2 border-solid transition shadow-sm placeholder:font-normal hover:shadow-lg focus-visible:shadow-lg active:shadow-inner",
    dropdown: "flex w-full grow placeholder:text-grayscale-light border-grayscale-x-light rounded-md border transition-all ease-out focus-visible:ring-primary focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 hover:shadow-lg hover:duration-200 active:duration-150",
    radio: "",
    checkbox: "disabled:text-grayscale"
  }
}, pn = Yt("text-main bg-white font-semibold", {
  variants: Qe,
  compoundVariants: [{
    size: "medium",
    fieldType: "input",
    className: "p-xs"
  }, {
    size: "large",
    fieldType: "input",
    className: "p-sm"
  }, {
    size: "medium",
    fieldType: "dropdown",
    className: "p-xs"
  }, {
    size: "large",
    fieldType: "dropdown",
    className: "p-sm"
  }],
  defaultVariants: {
    size: "large",
    fieldType: "input"
  }
});
function hP(t) {
  const e = ee(31);
  let n, r, o, i;
  e[0] !== t ? ({
    size: i,
    label: n,
    name: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i) : (n = e[1], r = e[2], o = e[3], i = e[4]);
  const a = i === void 0 ? "large" : i, s = nn(), l = o.disabled ? "text-grayscale" : "text-typography";
  let c;
  e[5] !== l ? (c = H("gap-x-2xs p-xs flex items-center", l), e[5] = l, e[6] = c) : c = e[6];
  let d;
  e[7] !== o.disabled || e[8] !== a ? (d = H(pn({
    fieldType: "checkbox",
    size: a
  }), "group relative z-10", !o.disabled && "before:-left-3xs before:-top-3xs before:size-md hover:before:bg-grayscale-x-light focus-visible:before:bg-grayscale-x-light before:absolute before:-z-10 before:scale-50 before:rounded-full before:bg-transparent before:transition-all before:duration-200 before:ease-out before:content-[''] hover:before:scale-110 active:before:bg-transparent"), e[7] = o.disabled, e[8] = a, e[9] = d) : d = e[9];
  let u;
  e[10] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ b($m, { className: "size-sm group-radix-state-checked:hidden" }), e[10] = u) : u = e[10];
  let m;
  e[11] === Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ b(Su, { children: /* @__PURE__ */ b(Vm, { className: "size-sm" }) }), e[11] = m) : m = e[11];
  let h;
  e[12] !== s || e[13] !== r || e[14] !== o || e[15] !== d ? (h = /* @__PURE__ */ $(wu, { ...o, name: r, id: s, className: d, children: [
    u,
    m
  ] }), e[12] = s, e[13] = r, e[14] = o, e[15] = d, e[16] = h) : h = e[16];
  const v = o.disabled, f = o.disabled ? "text-grayscale" : "cursor-pointer", p = a === "large" ? Qe.size.large : Qe.size.medium;
  let g;
  e[17] !== p || e[18] !== f ? (g = H(f, p), e[17] = p, e[18] = f, e[19] = g) : g = e[19];
  let y;
  e[20] !== n || e[21] !== g ? (y = /* @__PURE__ */ b(ve, { step: "-1", as: "span", className: g, weight: "semibold", children: n }), e[20] = n, e[21] = g, e[22] = y) : y = e[22];
  let w;
  e[23] !== s || e[24] !== o.disabled || e[25] !== y ? (w = /* @__PURE__ */ b("label", { "aria-disabled": v, htmlFor: s, children: y }), e[23] = s, e[24] = o.disabled, e[25] = y, e[26] = w) : w = e[26];
  let C;
  return e[27] !== w || e[28] !== c || e[29] !== h ? (C = /* @__PURE__ */ $("div", { className: c, children: [
    h,
    w
  ] }), e[27] = w, e[28] = c, e[29] = h, e[30] = C) : C = e[30], C;
}
var Xw = Object.defineProperty, Zw = Object.defineProperties, Jw = Object.getOwnPropertyDescriptors, Gr = Object.getOwnPropertySymbols, Nu = Object.prototype.hasOwnProperty, Ou = Object.prototype.propertyIsEnumerable, La = (t, e, n) => e in t ? Xw(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Q = (t, e) => {
  for (var n in e || (e = {}))
    Nu.call(e, n) && La(t, n, e[n]);
  if (Gr)
    for (var n of Gr(e))
      Ou.call(e, n) && La(t, n, e[n]);
  return t;
}, be = (t, e) => Zw(t, Jw(e)), Me = (t, e) => {
  var n = {};
  for (var r in t)
    Nu.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && Gr)
    for (var r of Gr(t))
      e.indexOf(r) < 0 && Ou.call(t, r) && (n[r] = t[r]);
  return n;
}, Qw = Object.defineProperty, ex = Object.defineProperties, tx = Object.getOwnPropertyDescriptors, qr = Object.getOwnPropertySymbols, Tu = Object.prototype.hasOwnProperty, Iu = Object.prototype.propertyIsEnumerable, Wa = (t, e, n) => e in t ? Qw(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Te = (t, e) => {
  for (var n in e || (e = {}))
    Tu.call(e, n) && Wa(t, n, e[n]);
  if (qr)
    for (var n of qr(e))
      Iu.call(e, n) && Wa(t, n, e[n]);
  return t;
}, qe = (t, e) => ex(t, tx(e)), Mu = (t, e) => {
  var n = {};
  for (var r in t)
    Tu.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && qr)
    for (var r of qr(t))
      e.indexOf(r) < 0 && Iu.call(t, r) && (n[r] = t[r]);
  return n;
};
function ku(...t) {
}
function nx(t, e) {
  if (rx(t)) {
    const n = ox(e) ? e() : e;
    return t(n);
  }
  return t;
}
function rx(t) {
  return typeof t == "function";
}
function ox(t) {
  return typeof t == "function";
}
function _t(t, e) {
  return typeof Object.hasOwn == "function" ? Object.hasOwn(t, e) : Object.prototype.hasOwnProperty.call(t, e);
}
function Xr(...t) {
  return (...e) => {
    for (const n of t)
      typeof n == "function" && n(...e);
  };
}
function ix(t) {
  return t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function sx(t, e) {
  const n = Te({}, t);
  for (const r of e)
    _t(n, r) && delete n[r];
  return n;
}
function ax(t, e) {
  const n = {};
  for (const r of e)
    _t(t, r) && (n[r] = t[r]);
  return n;
}
function _u(t) {
  return t;
}
function Ut(t, e) {
  if (!t)
    throw typeof e != "string" ? new Error("Invariant failed") : new Error(e);
}
function lx(t) {
  return Object.keys(t);
}
function cx(t, ...e) {
  const n = typeof t == "function" ? t(...e) : t;
  return n == null ? !1 : !n;
}
function ws(t) {
  return t.disabled || t["aria-disabled"] === !0 || t["aria-disabled"] === "true";
}
function on(t) {
  const e = {};
  for (const n in t)
    t[n] !== void 0 && (e[n] = t[n]);
  return e;
}
function he(...t) {
  for (const e of t)
    if (e !== void 0) return e;
}
function ux(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function dx(t) {
  return !t || !_m(t) ? !1 : "ref" in t.props || "ref" in t;
}
function fx(t) {
  return dx(t) ? Q({}, t.props).ref || t.ref : null;
}
function mx(t, e) {
  const n = Q({}, t);
  for (const r in e) {
    if (!_t(e, r)) continue;
    if (r === "className") {
      const i = "className";
      n[i] = t[i] ? `${t[i]} ${e[i]}` : e[i];
      continue;
    }
    if (r === "style") {
      const i = "style";
      n[i] = t[i] ? Q(Q({}, t[i]), e[i]) : e[i];
      continue;
    }
    const o = e[r];
    if (typeof o == "function" && r.startsWith("on")) {
      const i = t[r];
      if (typeof i == "function") {
        n[r] = (...a) => {
          o(...a), i(...a);
        };
        continue;
      }
    }
    n[r] = o;
  }
  return n;
}
var gr = hx();
function hx() {
  var t;
  return typeof window < "u" && !!((t = window.document) != null && t.createElement);
}
function Rn(t) {
  return t ? "self" in t ? t.document : t.ownerDocument || document : document;
}
function xo(t, e = !1) {
  const { activeElement: n } = Rn(t);
  if (!(n != null && n.nodeName))
    return null;
  if (px(n) && n.contentDocument)
    return xo(
      n.contentDocument.body,
      e
    );
  if (e) {
    const r = n.getAttribute("aria-activedescendant");
    if (r) {
      const o = Rn(n).getElementById(r);
      if (o)
        return o;
    }
  }
  return n;
}
function An(t, e) {
  return t === e || t.contains(e);
}
function px(t) {
  return t.tagName === "IFRAME";
}
function un(t) {
  const e = t.tagName.toLowerCase();
  return e === "button" ? !0 : e === "input" && t.type ? vx.indexOf(t.type) !== -1 : !1;
}
var vx = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function gx(t) {
  if (typeof t.checkVisibility == "function")
    return t.checkVisibility();
  const e = t;
  return e.offsetWidth > 0 || e.offsetHeight > 0 || t.getClientRects().length > 0;
}
function jt(t) {
  try {
    const e = t instanceof HTMLInputElement && t.selectionStart !== null, n = t.tagName === "TEXTAREA";
    return e || n || !1;
  } catch {
    return !1;
  }
}
function Ci(t) {
  return t.isContentEditable || jt(t);
}
function bx(t) {
  if (jt(t))
    return t.value;
  if (t.isContentEditable) {
    const e = Rn(t).createRange();
    return e.selectNodeContents(t), e.toString();
  }
  return "";
}
function Ei(t) {
  let e = 0, n = 0;
  if (jt(t))
    e = t.selectionStart || 0, n = t.selectionEnd || 0;
  else if (t.isContentEditable) {
    const r = Rn(t).getSelection();
    if (r != null && r.rangeCount && r.anchorNode && An(t, r.anchorNode) && r.focusNode && An(t, r.focusNode)) {
      const o = r.getRangeAt(0), i = o.cloneRange();
      i.selectNodeContents(t), i.setEnd(o.startContainer, o.startOffset), e = i.toString().length, i.setEnd(o.endContainer, o.endOffset), n = i.toString().length;
    }
  }
  return { start: e, end: n };
}
function yx(t, e) {
  const n = ["dialog", "menu", "listbox", "tree", "grid"], r = t == null ? void 0 : t.getAttribute("role");
  return r && n.indexOf(r) !== -1 ? r : e;
}
function xs(t) {
  if (!t) return null;
  const e = (n) => n === "auto" || n === "scroll";
  if (t.clientHeight && t.scrollHeight > t.clientHeight) {
    const { overflowY: n } = getComputedStyle(t);
    if (e(n)) return t;
  } else if (t.clientWidth && t.scrollWidth > t.clientWidth) {
    const { overflowX: n } = getComputedStyle(t);
    if (e(n)) return t;
  }
  return xs(t.parentElement) || document.scrollingElement || document.body;
}
function ti(t, ...e) {
  /text|search|password|tel|url/i.test(t.type) && t.setSelectionRange(...e);
}
function wx(t, e) {
  const n = t.map((o, i) => [i, o]);
  let r = !1;
  return n.sort(([o, i], [a, s]) => {
    const l = e(i), c = e(s);
    return l === c || !l || !c ? 0 : xx(l, c) ? (o > a && (r = !0), -1) : (o < a && (r = !0), 1);
  }), r ? n.map(([o, i]) => i) : t;
}
function xx(t, e) {
  return !!(e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING);
}
function Sx() {
  return gr && !!navigator.maxTouchPoints;
}
function Du() {
  return gr ? /mac|iphone|ipad|ipod/i.test(navigator.platform) : !1;
}
function Ss() {
  return gr && Du() && /apple/i.test(navigator.vendor);
}
function Cx() {
  return gr && /firefox\//i.test(navigator.userAgent);
}
function Ru(t) {
  return !!(t.currentTarget && !An(t.currentTarget, t.target));
}
function ot(t) {
  return t.target === t.currentTarget;
}
function Ex(t) {
  const e = t.currentTarget;
  if (!e) return !1;
  const n = Du();
  if (n && !t.metaKey || !n && !t.ctrlKey) return !1;
  const r = e.tagName.toLowerCase();
  return r === "a" || r === "button" && e.type === "submit" || r === "input" && e.type === "submit";
}
function Px(t) {
  const e = t.currentTarget;
  if (!e) return !1;
  const n = e.tagName.toLowerCase();
  return t.altKey ? n === "a" || n === "button" && e.type === "submit" || n === "input" && e.type === "submit" : !1;
}
function En(t, e) {
  const n = new FocusEvent("blur", e), r = t.dispatchEvent(n), o = qe(Te({}, e), { bubbles: !0 });
  return t.dispatchEvent(new FocusEvent("focusout", o)), r;
}
function Nx(t, e, n) {
  const r = new KeyboardEvent(e, n);
  return t.dispatchEvent(r);
}
function $a(t, e) {
  const n = new MouseEvent("click", e);
  return t.dispatchEvent(n);
}
function Au(t, e) {
  const n = e || t.currentTarget, r = t.relatedTarget;
  return !r || !An(n, r);
}
function Qn(t, e, n, r) {
  const i = ((s) => {
    const l = requestAnimationFrame(s);
    return () => cancelAnimationFrame(l);
  })(() => {
    t.removeEventListener(e, a, !0), n();
  }), a = () => {
    i(), n();
  };
  return t.addEventListener(e, a, { once: !0, capture: !0 }), i;
}
function Zt(t, e, n, r = window) {
  const o = [];
  try {
    r.document.addEventListener(t, e, n);
    for (const a of Array.from(r.frames))
      o.push(Zt(t, e, n, a));
  } catch {
  }
  return () => {
    try {
      r.document.removeEventListener(t, e, n);
    } catch {
    }
    for (const a of o)
      a();
  };
}
var Cs = Q({}, x), Va = Cs.useId;
Cs.useDeferredValue;
var Ba = Cs.useInsertionEffect, Ie = gr ? ji : fe;
function Ox(t) {
  const [e] = le(t);
  return e;
}
function Tx(t) {
  const e = pe(t);
  return Ie(() => {
    e.current = t;
  }), e;
}
function ge(t) {
  const e = pe(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return Ba ? Ba(() => {
    e.current = t;
  }) : e.current = t, Ne((...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function Ix(t) {
  const [e, n] = le(null);
  return Ie(() => {
    if (e == null || !t) return;
    let r = null;
    return t((o) => (r = o, e)), () => {
      t(r);
    };
  }, [e, t]), [e, n];
}
function ct(...t) {
  return It(() => {
    if (t.some(Boolean))
      return (e) => {
        for (const n of t)
          ux(n, e);
      };
  }, t);
}
function vn(t) {
  if (Va) {
    const r = Va();
    return t || r;
  }
  const [e, n] = le(t);
  return Ie(() => {
    if (t || e) return;
    const r = Math.random().toString(36).slice(2, 8);
    n(`id-${r}`);
  }, [t, e]), t || e;
}
function Fu(t, e) {
  const n = (i) => {
    if (typeof i == "string")
      return i;
  }, [r, o] = le(() => n(e));
  return Ie(() => {
    const i = t && "current" in t ? t.current : t;
    o((i == null ? void 0 : i.tagName.toLowerCase()) || n(e));
  }, [t, e]), r;
}
function Mx(t, e, n) {
  const r = Ox(n), [o, i] = le(r);
  return fe(() => {
    const a = t && "current" in t ? t.current : t;
    if (!a) return;
    const s = () => {
      const c = a.getAttribute(e);
      i(c ?? r);
    }, l = new MutationObserver(s);
    return l.observe(a, { attributeFilter: [e] }), s(), () => l.disconnect();
  }, [t, e, r]), o;
}
function br(t, e) {
  const n = pe(!1);
  fe(() => {
    if (n.current)
      return t();
    n.current = !0;
  }, e), fe(
    () => () => {
      n.current = !1;
    },
    []
  );
}
function kx(t, e) {
  const n = pe(!1);
  Ie(() => {
    if (n.current)
      return t();
    n.current = !0;
  }, e), Ie(
    () => () => {
      n.current = !1;
    },
    []
  );
}
function _x() {
  return Dm(() => [], []);
}
function He(t) {
  return ge(
    typeof t == "function" ? t : () => t
  );
}
function Un(t, e, n = []) {
  const r = Ne(
    (o) => (t.wrapElement && (o = t.wrapElement(o)), e(o)),
    [...n, t.wrapElement]
  );
  return be(Q({}, t), { wrapElement: r });
}
function Dx(t, e, n) {
  const r = t.onLoadedMetadataCapture, o = It(() => Object.assign(() => {
  }, be(Q({}, r), { [e]: n })), [r, e, n]);
  return [r == null ? void 0 : r[e], { onLoadedMetadataCapture: o }];
}
function Rx() {
  return fe(() => {
    Zt("mousemove", Fx, !0), Zt("mousedown", _r, !0), Zt("mouseup", _r, !0), Zt("keydown", _r, !0), Zt("scroll", _r, !0);
  }, []), ge(() => Es);
}
var Es = !1, za = 0, Ha = 0;
function Ax(t) {
  const e = t.movementX || t.screenX - za, n = t.movementY || t.screenY - Ha;
  return za = t.screenX, Ha = t.screenY, e || n || process.env.NODE_ENV === "test";
}
function Fx(t) {
  Ax(t) && (Es = !0);
}
function _r() {
  Es = !1;
}
function Re(t) {
  const e = x.forwardRef((n, r) => t(be(Q({}, n), { ref: r })));
  return e.displayName = t.displayName || t.name, e;
}
function So(t, e) {
  return x.memo(t, e);
}
function We(t, e) {
  const n = e, { wrapElement: r, render: o } = n, i = Me(n, ["wrapElement", "render"]), a = ct(e.ref, fx(o));
  let s;
  if (x.isValidElement(o)) {
    const l = be(Q({}, o.props), { ref: a });
    s = x.cloneElement(o, mx(i, l));
  } else o ? s = o(i) : s = /* @__PURE__ */ b(t, Q({}, i));
  return r ? r(s) : s;
}
function $e(t) {
  const e = (n = {}) => t(n);
  return e.displayName = t.name, e;
}
function gn(t = [], e = []) {
  const n = x.createContext(void 0), r = x.createContext(void 0), o = () => x.useContext(n), i = (c = !1) => {
    const d = x.useContext(r), u = o();
    return c ? d : d || u;
  }, a = () => {
    const c = x.useContext(r), d = o();
    if (!(c && c === d))
      return d;
  }, s = (c) => t.reduceRight(
    (d, u) => /* @__PURE__ */ b(u, be(Q({}, c), { children: d })),
    /* @__PURE__ */ b(n.Provider, Q({}, c))
  );
  return {
    context: n,
    scopedContext: r,
    useContext: o,
    useScopedContext: i,
    useProviderContext: a,
    ContextProvider: s,
    ScopedContextProvider: (c) => /* @__PURE__ */ b(s, be(Q({}, c), { children: e.reduceRight(
      (d, u) => /* @__PURE__ */ b(u, be(Q({}, c), { children: d })),
      /* @__PURE__ */ b(r.Provider, Q({}, c))
    ) }))
  };
}
var yr = gn();
yr.useContext;
yr.useScopedContext;
var Lu = yr.useProviderContext, Lx = yr.ContextProvider, Wx = yr.ScopedContextProvider, Wu = gn(
  [Lx],
  [Wx]
), $x = Wu.ContextProvider, $u = Wu.ScopedContextProvider;
lt(void 0);
lt(void 0);
var Ps = gn(
  [$x],
  [$u]
), Vx = Ps.useProviderContext, Bx = Ps.ContextProvider, zx = Ps.ScopedContextProvider, Ns = gn(), Hx = Ns.useContext, Yx = Ns.ContextProvider, Kx = Ns.ScopedContextProvider, Co = gn(
  [Yx],
  [Kx]
), Vu = Co.useContext, Ux = Co.useProviderContext, Os = Co.ContextProvider, Bu = Co.ScopedContextProvider, jx = lt(
  void 0
), Gx = lt(
  void 0
);
function bn(t, e) {
  const n = t.__unstableInternals;
  return Ut(n, "Invalid store"), n[e];
}
function Ht(t, ...e) {
  let n = t, r = n, o = Symbol(), i = ku;
  const a = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), h = (N) => (l.add(N), () => l.delete(N)), v = () => {
    const N = a.size, T = Symbol();
    a.add(T);
    const k = () => {
      a.delete(T), !a.size && i();
    };
    if (N) return k;
    const D = lx(n).map(
      (_) => Xr(
        ...e.map((L) => {
          var I;
          const R = (I = L == null ? void 0 : L.getState) == null ? void 0 : I.call(L);
          if (R && _t(R, _))
            return rt(L, [_], (A) => {
              P(
                _,
                A[_],
                // @ts-expect-error - Not public API. This is just to prevent
                // infinite loops.
                !0
              );
            });
        })
      )
    ), F = [];
    for (const _ of l)
      F.push(_());
    const O = e.map(Ts);
    return i = Xr(...D, ...F, ...O), k;
  }, f = (N, T, k = c) => (k.add(T), m.set(T, N), () => {
    var D;
    (D = u.get(T)) == null || D(), u.delete(T), m.delete(T), k.delete(T);
  }), p = (N, T) => f(N, T), g = (N, T) => (u.set(T, T(n, n)), f(N, T)), y = (N, T) => (u.set(T, T(n, r)), f(N, T, d)), w = (N) => Ht(ax(n, N), E), C = (N) => Ht(sx(n, N), E), S = () => n, P = (N, T, k = !1) => {
    var D;
    if (!_t(n, N)) return;
    const F = nx(T, n[N]);
    if (F === n[N]) return;
    if (!k)
      for (const I of e)
        (D = I == null ? void 0 : I.setState) == null || D.call(I, N, F);
    const O = n;
    n = qe(Te({}, n), { [N]: F });
    const _ = Symbol();
    o = _, s.add(N);
    const L = (I, R, A) => {
      var M;
      const W = m.get(I), z = (K) => A ? A.has(K) : K === N;
      (!W || W.some(z)) && ((M = u.get(I)) == null || M(), u.set(I, I(n, R)));
    };
    for (const I of c)
      L(I, O);
    queueMicrotask(() => {
      if (o !== _) return;
      const I = n;
      for (const R of d)
        L(R, r, s);
      r = I, s.clear();
    });
  }, E = {
    getState: S,
    setState: P,
    __unstableInternals: {
      setup: h,
      init: v,
      subscribe: p,
      sync: g,
      batch: y,
      pick: w,
      omit: C
    }
  };
  return E;
}
function Je(t, ...e) {
  if (t)
    return bn(t, "setup")(...e);
}
function Ts(t, ...e) {
  if (t)
    return bn(t, "init")(...e);
}
function Is(t, ...e) {
  if (t)
    return bn(t, "subscribe")(...e);
}
function rt(t, ...e) {
  if (t)
    return bn(t, "sync")(...e);
}
function Zr(t, ...e) {
  if (t)
    return bn(t, "batch")(...e);
}
function zu(t, ...e) {
  if (t)
    return bn(t, "omit")(...e);
}
function qx(t, ...e) {
  if (t)
    return bn(t, "pick")(...e);
}
function Ms(...t) {
  const e = t.reduce((r, o) => {
    var i;
    const a = (i = o == null ? void 0 : o.getState) == null ? void 0 : i.call(o);
    return a ? Object.assign(r, a) : r;
  }, {}), n = Ht(e, ...t);
  return Object.assign({}, ...t, n);
}
function Eo(t, e) {
  if (process.env.NODE_ENV === "production" || !e) return;
  const n = Object.entries(t).filter(([i, a]) => i.startsWith("default") && a !== void 0).map(([i]) => {
    var a;
    const s = i.replace("default", "");
    return `${((a = s[0]) == null ? void 0 : a.toLowerCase()) || ""}${s.slice(1)}`;
  });
  if (!n.length) return;
  const r = e.getState();
  if (n.filter(
    (i) => _t(r, i)
  ).length)
    throw new Error(
      `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
    );
}
function Hu(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Dr = { exports: {} }, ni = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ya;
function Xx() {
  if (Ya) return ni;
  Ya = 1;
  var t = B;
  function e(u, m) {
    return u === m && (u !== 0 || 1 / u === 1 / m) || u !== u && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, o = t.useEffect, i = t.useLayoutEffect, a = t.useDebugValue;
  function s(u, m) {
    var h = m(), v = r({ inst: { value: h, getSnapshot: m } }), f = v[0].inst, p = v[1];
    return i(
      function() {
        f.value = h, f.getSnapshot = m, l(f) && p({ inst: f });
      },
      [u, h, m]
    ), o(
      function() {
        return l(f) && p({ inst: f }), u(function() {
          l(f) && p({ inst: f });
        });
      },
      [u]
    ), a(h), h;
  }
  function l(u) {
    var m = u.getSnapshot;
    u = u.value;
    try {
      var h = m();
      return !n(u, h);
    } catch {
      return !0;
    }
  }
  function c(u, m) {
    return m();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return ni.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, ni;
}
var ri = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ka;
function Zx() {
  return Ka || (Ka = 1, process.env.NODE_ENV !== "production" && function() {
    function t(h, v) {
      return h === v && (h !== 0 || 1 / h === 1 / v) || h !== h && v !== v;
    }
    function e(h, v) {
      d || o.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var f = v();
      if (!u) {
        var p = v();
        i(f, p) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), u = !0);
      }
      p = a({
        inst: { value: f, getSnapshot: v }
      });
      var g = p[0].inst, y = p[1];
      return l(
        function() {
          g.value = f, g.getSnapshot = v, n(g) && y({ inst: g });
        },
        [h, f, v]
      ), s(
        function() {
          return n(g) && y({ inst: g }), h(function() {
            n(g) && y({ inst: g });
          });
        },
        [h]
      ), c(f), f;
    }
    function n(h) {
      var v = h.getSnapshot;
      h = h.value;
      try {
        var f = v();
        return !i(h, f);
      } catch {
        return !0;
      }
    }
    function r(h, v) {
      return v();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = B, i = typeof Object.is == "function" ? Object.is : t, a = o.useState, s = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, d = !1, u = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    ri.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ri;
}
var Ua;
function Jx() {
  return Ua || (Ua = 1, process.env.NODE_ENV === "production" ? Dr.exports = Xx() : Dr.exports = Zx()), Dr.exports;
}
var Qx = Jx();
const e1 = /* @__PURE__ */ Hu(Qx);
var { useSyncExternalStore: Yu } = e1, Ku = () => () => {
};
function ks(t, e = _u) {
  const n = x.useCallback(
    (o) => t ? Is(t, null, o) : Ku(),
    [t]
  ), r = () => {
    const o = typeof e == "string" ? e : null, i = typeof e == "function" ? e : null, a = t == null ? void 0 : t.getState();
    if (i) return i(a);
    if (a && o && _t(a, o))
      return a[o];
  };
  return Yu(n, r, r);
}
function Uu(t, e) {
  const n = x.useRef(
    {}
  ), r = x.useCallback(
    (i) => t ? Is(t, null, i) : Ku(),
    [t]
  ), o = () => {
    const i = t == null ? void 0 : t.getState();
    let a = !1;
    const s = n.current;
    for (const l in e) {
      const c = e[l];
      if (typeof c == "function") {
        const d = c(i);
        d !== s[l] && (s[l] = d, a = !0);
      }
      if (typeof c == "string") {
        if (!i || !_t(i, c)) continue;
        const d = i[c];
        d !== s[l] && (s[l] = d, a = !0);
      }
    }
    return a && (n.current = Q({}, s)), n.current;
  };
  return Yu(r, o, o);
}
function Le(t, e, n, r) {
  const o = _t(e, n) ? e[n] : void 0, i = r ? e[r] : void 0, a = Tx({ value: o, setValue: i });
  Ie(() => rt(t, [n], (s, l) => {
    const { value: c, setValue: d } = a.current;
    d && s[n] !== l[n] && s[n] !== c && d(s[n]);
  }), [t, n]), Ie(() => {
    if (o !== void 0)
      return t.setState(n, o), Zr(t, [n], () => {
        o !== void 0 && t.setState(n, o);
      });
  });
}
function t1(t, e) {
  const [n, r] = x.useState(() => t(e));
  Ie(() => Ts(n), [n]);
  const o = x.useCallback(
    (s) => ks(n, s),
    [n]
  ), i = x.useMemo(
    () => be(Q({}, n), { useState: o }),
    [n, o]
  ), a = ge(() => {
    r((s) => t(Q(Q({}, e), s.getState())));
  });
  return [i, a];
}
function n1(t) {
  var e;
  const n = t.find((i) => !!i.element), r = [...t].reverse().find((i) => !!i.element);
  let o = (e = n == null ? void 0 : n.element) == null ? void 0 : e.parentElement;
  for (; o && (r != null && r.element); ) {
    if (r && o.contains(r.element))
      return o;
    o = o.parentElement;
  }
  return Rn(o).body;
}
function r1(t) {
  return t == null ? void 0 : t.__unstablePrivateStore;
}
function o1(t = {}) {
  var e;
  Eo(t, t.store);
  const n = (e = t.store) == null ? void 0 : e.getState(), r = he(
    t.items,
    n == null ? void 0 : n.items,
    t.defaultItems,
    []
  ), o = new Map(r.map((m) => [m.id, m])), i = {
    items: r,
    renderedItems: he(n == null ? void 0 : n.renderedItems, [])
  }, a = r1(t.store), s = Ht(
    { items: r, renderedItems: i.renderedItems },
    a
  ), l = Ht(i, t.store), c = (m) => {
    const h = wx(m, (v) => v.element);
    s.setState("renderedItems", h), l.setState("renderedItems", h);
  };
  Je(l, () => Ts(s)), Je(s, () => Zr(s, ["items"], (m) => {
    l.setState("items", m.items);
  })), Je(s, () => Zr(s, ["renderedItems"], (m) => {
    let h = !0, v = requestAnimationFrame(() => {
      const { renderedItems: y } = l.getState();
      m.renderedItems !== y && c(m.renderedItems);
    });
    if (typeof IntersectionObserver != "function")
      return () => cancelAnimationFrame(v);
    const f = () => {
      if (h) {
        h = !1;
        return;
      }
      cancelAnimationFrame(v), v = requestAnimationFrame(() => c(m.renderedItems));
    }, p = n1(m.renderedItems), g = new IntersectionObserver(f, { root: p });
    for (const y of m.renderedItems)
      y.element && g.observe(y.element);
    return () => {
      cancelAnimationFrame(v), g.disconnect();
    };
  }));
  const d = (m, h, v = !1) => {
    let f;
    return h((g) => {
      const y = g.findIndex(({ id: C }) => C === m.id), w = g.slice();
      if (y !== -1) {
        f = g[y];
        const C = Te(Te({}, f), m);
        w[y] = C, o.set(m.id, C);
      } else
        w.push(m), o.set(m.id, m);
      return w;
    }), () => {
      h((g) => {
        if (!f)
          return v && o.delete(m.id), g.filter(({ id: C }) => C !== m.id);
        const y = g.findIndex(({ id: C }) => C === m.id);
        if (y === -1) return g;
        const w = g.slice();
        return w[y] = f, o.set(m.id, f), w;
      });
    };
  }, u = (m) => d(
    m,
    (h) => s.setState("items", h),
    !0
  );
  return qe(Te({}, l), {
    registerItem: u,
    renderItem: (m) => Xr(
      u(m),
      d(
        m,
        (h) => s.setState("renderedItems", h)
      )
    ),
    item: (m) => {
      if (!m) return null;
      let h = o.get(m);
      if (!h) {
        const { items: v } = s.getState();
        h = v.find((f) => f.id === m), h && o.set(m, h);
      }
      return h || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: s
  });
}
function i1(t, e, n) {
  return br(e, [n.store]), Le(t, n, "items", "setItems"), t;
}
function ju(t) {
  const e = [];
  for (const n of t)
    e.push(...n);
  return e;
}
function Pi(t) {
  return t.slice().reverse();
}
var s1 = { id: null };
function Ft(t, e) {
  return t.find((n) => e ? !n.disabled && n.id !== e : !n.disabled);
}
function a1(t, e) {
  return t.filter((n) => e ? !n.disabled && n.id !== e : !n.disabled);
}
function ja(t, e) {
  return t.filter((n) => n.rowId === e);
}
function l1(t, e, n = !1) {
  const r = t.findIndex((o) => o.id === e);
  return [
    ...t.slice(r + 1),
    ...n ? [s1] : [],
    ...t.slice(0, r)
  ];
}
function Gu(t) {
  const e = [];
  for (const n of t) {
    const r = e.find((o) => {
      var i;
      return ((i = o[0]) == null ? void 0 : i.rowId) === n.rowId;
    });
    r ? r.push(n) : e.push([n]);
  }
  return e;
}
function qu(t) {
  let e = 0;
  for (const { length: n } of t)
    n > e && (e = n);
  return e;
}
function c1(t) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    rowId: t
  };
}
function u1(t, e, n) {
  const r = qu(t);
  for (const o of t)
    for (let i = 0; i < r; i += 1) {
      const a = o[i];
      if (!a || n && a.disabled) {
        const l = i === 0 && n ? Ft(o) : o[i - 1];
        o[i] = l && e !== l.id && n ? l : c1(l == null ? void 0 : l.rowId);
      }
    }
  return t;
}
function d1(t) {
  const e = Gu(t), n = qu(e), r = [];
  for (let o = 0; o < n; o += 1)
    for (const i of e) {
      const a = i[o];
      a && r.push(qe(Te({}, a), {
        // If there's no rowId, it means that it's not a grid composite, but
        // a single row instead. So, instead of verticalizing it, that is,
        // assigning a different rowId based on the column index, we keep it
        // undefined so they will be part of the same row. This is useful
        // when using up/down on one-dimensional composites.
        rowId: a.rowId ? `${o}` : void 0
      }));
    }
  return r;
}
function f1(t = {}) {
  var e;
  const n = (e = t.store) == null ? void 0 : e.getState(), r = o1(t), o = he(
    t.activeId,
    n == null ? void 0 : n.activeId,
    t.defaultActiveId
  ), i = qe(Te({}, r.getState()), {
    id: he(
      t.id,
      n == null ? void 0 : n.id,
      `id-${Math.random().toString(36).slice(2, 8)}`
    ),
    activeId: o,
    baseElement: he(n == null ? void 0 : n.baseElement, null),
    includesBaseElement: he(
      t.includesBaseElement,
      n == null ? void 0 : n.includesBaseElement,
      o === null
    ),
    moves: he(n == null ? void 0 : n.moves, 0),
    orientation: he(
      t.orientation,
      n == null ? void 0 : n.orientation,
      "both"
    ),
    rtl: he(t.rtl, n == null ? void 0 : n.rtl, !1),
    virtualFocus: he(
      t.virtualFocus,
      n == null ? void 0 : n.virtualFocus,
      !1
    ),
    focusLoop: he(t.focusLoop, n == null ? void 0 : n.focusLoop, !1),
    focusWrap: he(t.focusWrap, n == null ? void 0 : n.focusWrap, !1),
    focusShift: he(t.focusShift, n == null ? void 0 : n.focusShift, !1)
  }), a = Ht(i, r, t.store);
  Je(
    a,
    () => rt(a, ["renderedItems", "activeId"], (l) => {
      a.setState("activeId", (c) => {
        var d;
        return c !== void 0 ? c : (d = Ft(l.renderedItems)) == null ? void 0 : d.id;
      });
    })
  );
  const s = (l = "next", c = {}) => {
    var d, u;
    const m = a.getState(), {
      skip: h = 0,
      activeId: v = m.activeId,
      focusShift: f = m.focusShift,
      focusLoop: p = m.focusLoop,
      focusWrap: g = m.focusWrap,
      includesBaseElement: y = m.includesBaseElement,
      renderedItems: w = m.renderedItems,
      rtl: C = m.rtl
    } = c, S = l === "up" || l === "down", P = l === "next" || l === "down", E = P ? C && !S : !C || S, N = f && !h;
    let T = S ? ju(
      u1(Gu(w), v, N)
    ) : w;
    if (T = E ? Pi(T) : T, T = S ? d1(T) : T, v == null)
      return (d = Ft(T)) == null ? void 0 : d.id;
    const k = T.find((M) => M.id === v);
    if (!k)
      return (u = Ft(T)) == null ? void 0 : u.id;
    const D = T.some((M) => M.rowId), F = T.indexOf(k), O = T.slice(F + 1), _ = ja(O, k.rowId);
    if (h) {
      const M = a1(_, v), W = M.slice(h)[0] || // If we can't find an item, just return the last one.
      M[M.length - 1];
      return W == null ? void 0 : W.id;
    }
    const L = p && (S ? p !== "horizontal" : p !== "vertical"), I = D && g && (S ? g !== "horizontal" : g !== "vertical"), R = P ? (!D || S) && L && y : S ? y : !1;
    if (L) {
      const M = I && !R ? T : ja(T, k.rowId), W = l1(M, v, R), z = Ft(W, v);
      return z == null ? void 0 : z.id;
    }
    if (I) {
      const M = Ft(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        R ? _ : O,
        v
      );
      return R ? (M == null ? void 0 : M.id) || null : M == null ? void 0 : M.id;
    }
    const A = Ft(_, v);
    return !A && R ? null : A == null ? void 0 : A.id;
  };
  return qe(Te(Te({}, r), a), {
    setBaseElement: (l) => a.setState("baseElement", l),
    setActiveId: (l) => a.setState("activeId", l),
    move: (l) => {
      l !== void 0 && (a.setState("activeId", l), a.setState("moves", (c) => c + 1));
    },
    first: () => {
      var l;
      return (l = Ft(a.getState().renderedItems)) == null ? void 0 : l.id;
    },
    last: () => {
      var l;
      return (l = Ft(Pi(a.getState().renderedItems))) == null ? void 0 : l.id;
    },
    next: (l) => (l !== void 0 && typeof l == "number" && (l = { skip: l }), s("next", l)),
    previous: (l) => (l !== void 0 && typeof l == "number" && (l = { skip: l }), s("previous", l)),
    down: (l) => (l !== void 0 && typeof l == "number" && (l = { skip: l }), s("down", l)),
    up: (l) => (l !== void 0 && typeof l == "number" && (l = { skip: l }), s("up", l))
  });
}
function m1(t) {
  const e = vn(t.id);
  return Q({ id: e }, t);
}
function h1(t, e, n) {
  return t = i1(t, e, n), Le(t, n, "activeId", "setActiveId"), Le(t, n, "includesBaseElement"), Le(t, n, "virtualFocus"), Le(t, n, "orientation"), Le(t, n, "rtl"), Le(t, n, "focusLoop"), Le(t, n, "focusWrap"), Le(t, n, "focusShift"), t;
}
var Xu = lt(
  void 0
), wr = gn(
  [Bx, Os],
  [zx, Bu]
), p1 = wr.useContext, Zu = wr.useScopedContext, _s = wr.useProviderContext, v1 = wr.ContextProvider, g1 = wr.ScopedContextProvider, b1 = lt(
  void 0
), y1 = lt(!1);
function w1(t, e) {
  return t.find((n) => !n.disabled);
}
function Jt(t, e) {
  return e && t.item(e) || null;
}
function x1(t) {
  const e = [];
  for (const n of t) {
    const r = e.find((o) => {
      var i;
      return ((i = o[0]) == null ? void 0 : i.rowId) === n.rowId;
    });
    r ? r.push(n) : e.push([n]);
  }
  return e;
}
function S1(t, e = !1) {
  if (jt(t))
    t.setSelectionRange(
      e ? t.value.length : 0,
      t.value.length
    );
  else if (t.isContentEditable) {
    const n = Rn(t).getSelection();
    n == null || n.selectAllChildren(t), e && (n == null || n.collapseToEnd());
  }
}
var Ni = Symbol("FOCUS_SILENTLY");
function C1(t) {
  t[Ni] = !0, t.focus({ preventScroll: !0 });
}
function E1(t) {
  const e = t[Ni];
  return delete t[Ni], e;
}
function er(t, e, n) {
  return !(!e || e === n || !t.item(e.id));
}
var P1 = "div", Ju = $e(
  function(e) {
    var n = e, {
      store: r,
      shouldRegisterItem: o = !0,
      getItem: i = _u,
      element: a
    } = n, s = Me(n, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const l = Hx();
    r = r || l;
    const c = vn(s.id), d = pe(a);
    return fe(() => {
      const u = d.current;
      if (!c || !u || !o) return;
      const m = i({ id: c, element: u });
      return r == null ? void 0 : r.renderItem(m);
    }, [c, o, i, r]), s = be(Q({}, s), {
      ref: ct(d, s.ref)
    }), on(s);
  }
);
Re(function(e) {
  const n = Ju(e);
  return We(P1, n);
});
var N1 = lt(!0), Qu = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function Jr(t) {
  return !(!t.matches(Qu) || !gx(t) || t.closest("[inert]"));
}
function O1(t) {
  for (; t && !Jr(t); )
    t = t.closest(Qu);
  return t || null;
}
function dn(t) {
  const e = xo(t);
  if (!e) return !1;
  if (e === t) return !0;
  const n = e.getAttribute("aria-activedescendant");
  return n ? n === t.id : !1;
}
function ed(t) {
  const e = xo(t);
  if (!e) return !1;
  if (An(t, e)) return !0;
  const n = e.getAttribute("aria-activedescendant");
  return !n || !("id" in t) ? !1 : n === t.id ? !0 : !!t.querySelector(`#${CSS.escape(n)}`);
}
function T1(t) {
  !ed(t) && Jr(t) && t.focus();
}
function I1(t, e) {
  "scrollIntoView" in t ? (t.focus({ preventScroll: !0 }), t.scrollIntoView(Te({ block: "nearest", inline: "nearest" }, e))) : t.focus();
}
var M1 = "div", Ga = Ss(), k1 = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
], _1 = Symbol("safariFocusAncestor");
function qa(t, e) {
  t && (t[_1] = e);
}
function D1(t) {
  const { tagName: e, readOnly: n, type: r } = t;
  return e === "TEXTAREA" && !n || e === "SELECT" && !n ? !0 : e === "INPUT" && !n ? k1.includes(r) : !!(t.isContentEditable || t.getAttribute("role") === "combobox" && t.dataset.name);
}
function R1(t) {
  return "labels" in t ? t.labels : null;
}
function Xa(t) {
  return t.tagName.toLowerCase() === "input" && t.type ? t.type === "radio" || t.type === "checkbox" : !1;
}
function A1(t) {
  return t ? t === "button" || t === "summary" || t === "input" || t === "select" || t === "textarea" || t === "a" : !0;
}
function F1(t) {
  return t ? t === "button" || t === "input" || t === "select" || t === "textarea" : !0;
}
function L1(t, e, n, r, o) {
  return t ? e ? n && !r ? -1 : void 0 : n ? o : o || 0 : o;
}
function oi(t, e) {
  return ge((n) => {
    t == null || t(n), !n.defaultPrevented && e && (n.stopPropagation(), n.preventDefault());
  });
}
var Ds = !0;
function W1(t) {
  const e = t.target;
  e && "hasAttribute" in e && (e.hasAttribute("data-focus-visible") || (Ds = !1));
}
function $1(t) {
  t.metaKey || t.ctrlKey || t.altKey || (Ds = !0);
}
var Rs = $e(
  function(e) {
    var n = e, {
      focusable: r = !0,
      accessibleWhenDisabled: o,
      autoFocus: i,
      onFocusVisible: a
    } = n, s = Me(n, [
      "focusable",
      "accessibleWhenDisabled",
      "autoFocus",
      "onFocusVisible"
    ]);
    const l = pe(null);
    fe(() => {
      r && (Zt("mousedown", W1, !0), Zt("keydown", $1, !0));
    }, [r]), Ga && fe(() => {
      if (!r) return;
      const I = l.current;
      if (!I || !Xa(I)) return;
      const R = R1(I);
      if (!R) return;
      const A = () => queueMicrotask(() => I.focus());
      for (const M of R)
        M.addEventListener("mouseup", A);
      return () => {
        for (const M of R)
          M.removeEventListener("mouseup", A);
      };
    }, [r]);
    const c = r && ws(s), d = !!c && !o, [u, m] = le(!1);
    fe(() => {
      r && d && u && m(!1);
    }, [r, d, u]), fe(() => {
      if (!r || !u) return;
      const I = l.current;
      if (!I || typeof IntersectionObserver > "u") return;
      const R = new IntersectionObserver(() => {
        Jr(I) || m(!1);
      });
      return R.observe(I), () => R.disconnect();
    }, [r, u]);
    const h = oi(
      s.onKeyPressCapture,
      c
    ), v = oi(
      s.onMouseDownCapture,
      c
    ), f = oi(s.onClickCapture, c), p = s.onMouseDown, g = ge((I) => {
      if (p == null || p(I), I.defaultPrevented || !r) return;
      const R = I.currentTarget;
      if (!Ga || Ru(I) || !un(R) && !Xa(R)) return;
      let A = !1;
      const M = () => {
        A = !0;
      }, W = { capture: !0, once: !0 };
      R.addEventListener("focusin", M, W);
      const z = O1(R.parentElement);
      qa(z, !0), Qn(R, "mouseup", () => {
        R.removeEventListener("focusin", M, !0), qa(z, !1), !A && T1(R);
      });
    }), y = (I, R) => {
      if (R && (I.currentTarget = R), !r) return;
      const A = I.currentTarget;
      A && dn(A) && (a == null || a(I), !I.defaultPrevented && (A.dataset.focusVisible = "true", m(!0)));
    }, w = s.onKeyDownCapture, C = ge((I) => {
      if (w == null || w(I), I.defaultPrevented || !r || u || I.metaKey || I.altKey || I.ctrlKey || !ot(I)) return;
      const R = I.currentTarget;
      Qn(R, "focusout", () => y(I, R));
    }), S = s.onFocusCapture, P = ge((I) => {
      if (S == null || S(I), I.defaultPrevented || !r) return;
      if (!ot(I)) {
        m(!1);
        return;
      }
      const R = I.currentTarget, A = () => y(I, R);
      Ds || D1(I.target) ? Qn(I.target, "focusout", A) : m(!1);
    }), E = s.onBlur, N = ge((I) => {
      E == null || E(I), r && Au(I) && (I.currentTarget.removeAttribute("data-focus-visible"), m(!1));
    }), T = ar(N1), k = ge((I) => {
      r && i && I && T && queueMicrotask(() => {
        dn(I) || Jr(I) && I.focus();
      });
    }), D = Fu(l), F = r && A1(D), O = r && F1(D), _ = s.style, L = It(() => d ? Q({ pointerEvents: "none" }, _) : _, [d, _]);
    return s = be(Q({
      "data-focus-visible": r && u || void 0,
      "data-autofocus": i || void 0,
      "aria-disabled": c || void 0
    }, s), {
      ref: ct(l, k, s.ref),
      style: L,
      tabIndex: L1(
        r,
        d,
        F,
        O,
        s.tabIndex
      ),
      disabled: O && d ? !0 : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: c ? void 0 : s.contentEditable,
      onKeyPressCapture: h,
      onClickCapture: f,
      onMouseDownCapture: v,
      onMouseDown: g,
      onKeyDownCapture: C,
      onFocusCapture: P,
      onBlur: N
    }), on(s);
  }
);
Re(function(e) {
  const n = Rs(e);
  return We(M1, n);
});
var V1 = "button";
function Za(t) {
  if (!t.isTrusted) return !1;
  const e = t.currentTarget;
  return t.key === "Enter" ? un(e) || e.tagName === "SUMMARY" || e.tagName === "A" : t.key === " " ? un(e) || e.tagName === "SUMMARY" || e.tagName === "INPUT" || e.tagName === "SELECT" : !1;
}
var B1 = Symbol("command"), As = $e(
  function(e) {
    var n = e, { clickOnEnter: r = !0, clickOnSpace: o = !0 } = n, i = Me(n, ["clickOnEnter", "clickOnSpace"]);
    const a = pe(null), [s, l] = le(!1);
    fe(() => {
      a.current && l(un(a.current));
    }, []);
    const [c, d] = le(!1), u = pe(!1), m = ws(i), [h, v] = Dx(i, B1, !0), f = i.onKeyDown, p = ge((w) => {
      f == null || f(w);
      const C = w.currentTarget;
      if (w.defaultPrevented || h || m || !ot(w) || jt(C) || C.isContentEditable) return;
      const S = r && w.key === "Enter", P = o && w.key === " ", E = w.key === "Enter" && !r, N = w.key === " " && !o;
      if (E || N) {
        w.preventDefault();
        return;
      }
      if (S || P) {
        const T = Za(w);
        if (S) {
          if (!T) {
            w.preventDefault();
            const k = w, { view: D } = k, F = Me(k, ["view"]), O = () => $a(C, F);
            Cx() ? Qn(C, "keyup", O) : queueMicrotask(O);
          }
        } else P && (u.current = !0, T || (w.preventDefault(), d(!0)));
      }
    }), g = i.onKeyUp, y = ge((w) => {
      if (g == null || g(w), w.defaultPrevented || h || m || w.metaKey) return;
      const C = o && w.key === " ";
      if (u.current && C && (u.current = !1, !Za(w))) {
        w.preventDefault(), d(!1);
        const S = w.currentTarget, P = w, { view: E } = P, N = Me(P, ["view"]);
        queueMicrotask(() => $a(S, N));
      }
    });
    return i = be(Q(Q({
      "data-active": c || void 0,
      type: s ? "button" : void 0
    }, v), i), {
      ref: ct(a, i.ref),
      onKeyDown: p,
      onKeyUp: y
    }), i = Rs(i), i;
  }
);
Re(function(e) {
  const n = As(e);
  return We(V1, n);
});
var z1 = "button";
function H1(t) {
  return Ci(t) ? !0 : t.tagName === "INPUT" && !un(t);
}
function Y1(t, e = !1) {
  const n = t.clientHeight, { top: r } = t.getBoundingClientRect(), o = Math.max(n * 0.875, n - 40) * 1.5, i = e ? n - o + r : o + r;
  return t.tagName === "HTML" ? i + t.scrollTop : i;
}
function K1(t, e = !1) {
  const { top: n } = t.getBoundingClientRect();
  return e ? n + t.clientHeight : n;
}
function Ja(t, e, n, r = !1) {
  var o;
  if (!e || !n) return;
  const { renderedItems: i } = e.getState(), a = xs(t);
  if (!a) return;
  const s = Y1(a, r);
  let l, c;
  for (let d = 0; d < i.length; d += 1) {
    const u = l;
    if (l = n(d), !l) break;
    if (l === u) continue;
    const m = (o = Jt(e, l)) == null ? void 0 : o.element;
    if (!m) continue;
    const v = K1(m, r) - s, f = Math.abs(v);
    if (r && v <= 0 || !r && v >= 0) {
      c !== void 0 && c < f && (l = u);
      break;
    }
    c = f;
  }
  return l;
}
function U1(t, e) {
  return ot(t) ? !1 : er(e, t.target);
}
var td = $e(
  function(e) {
    var n = e, {
      store: r,
      rowId: o,
      preventScrollOnKeyDown: i = !1,
      moveOnKeyPress: a = !0,
      tabbable: s = !1,
      getItem: l,
      "aria-setsize": c,
      "aria-posinset": d
    } = n, u = Me(n, [
      "store",
      "rowId",
      "preventScrollOnKeyDown",
      "moveOnKeyPress",
      "tabbable",
      "getItem",
      "aria-setsize",
      "aria-posinset"
    ]);
    const m = Vu();
    r = r || m;
    const h = vn(u.id), v = pe(null), f = ar(Gx), g = ws(u) && !u.accessibleWhenDisabled, {
      rowId: y,
      baseElement: w,
      isActiveItem: C,
      ariaSetSize: S,
      ariaPosInSet: P,
      isTabbable: E
    } = Uu(r, {
      rowId(M) {
        if (o) return o;
        if (M && f != null && f.baseElement && f.baseElement === M.baseElement)
          return f.id;
      },
      baseElement(M) {
        return (M == null ? void 0 : M.baseElement) || void 0;
      },
      isActiveItem(M) {
        return !!M && M.activeId === h;
      },
      ariaSetSize(M) {
        if (c != null) return c;
        if (M && f != null && f.ariaSetSize && f.baseElement === M.baseElement)
          return f.ariaSetSize;
      },
      ariaPosInSet(M) {
        if (d != null) return d;
        if (!M || !(f != null && f.ariaPosInSet) || f.baseElement !== M.baseElement) return;
        const W = M.renderedItems.filter(
          (z) => z.rowId === y
        );
        return f.ariaPosInSet + W.findIndex((z) => z.id === h);
      },
      isTabbable(M) {
        if (!(M != null && M.renderedItems.length)) return !0;
        if (M.virtualFocus) return !1;
        if (s) return !0;
        if (M.activeId === null) return !1;
        const W = r == null ? void 0 : r.item(M.activeId);
        return W != null && W.disabled || !(W != null && W.element) ? !0 : M.activeId === h;
      }
    }), N = Ne(
      (M) => {
        var W;
        const z = be(Q({}, M), {
          id: h || M.id,
          rowId: y,
          disabled: !!g,
          children: (W = M.element) == null ? void 0 : W.textContent
        });
        return l ? l(z) : z;
      },
      [h, y, g, l]
    ), T = u.onFocus, k = pe(!1), D = ge((M) => {
      if (T == null || T(M), M.defaultPrevented || Ru(M) || !h || !r || U1(M, r)) return;
      const { virtualFocus: W, baseElement: z } = r.getState();
      if (r.setActiveId(h), Ci(M.currentTarget) && S1(M.currentTarget), !W || !ot(M) || H1(M.currentTarget) || !(z != null && z.isConnected)) return;
      Ss() && M.currentTarget.hasAttribute("data-autofocus") && M.currentTarget.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      }), k.current = !0, M.relatedTarget === z || er(r, M.relatedTarget) ? C1(z) : z.focus();
    }), F = u.onBlurCapture, O = ge((M) => {
      if (F == null || F(M), M.defaultPrevented) return;
      const W = r == null ? void 0 : r.getState();
      W != null && W.virtualFocus && k.current && (k.current = !1, M.preventDefault(), M.stopPropagation());
    }), _ = u.onKeyDown, L = He(i), I = He(a), R = ge((M) => {
      if (_ == null || _(M), M.defaultPrevented || !ot(M) || !r) return;
      const { currentTarget: W } = M, z = r.getState(), K = r.item(h), j = !!(K != null && K.rowId), G = z.orientation !== "horizontal", J = z.orientation !== "vertical", oe = () => !!(j || J || !z.baseElement || !jt(z.baseElement)), Z = {
        ArrowUp: (j || G) && r.up,
        ArrowRight: (j || J) && r.next,
        ArrowDown: (j || G) && r.down,
        ArrowLeft: (j || J) && r.previous,
        Home: () => {
          if (oe())
            return !j || M.ctrlKey ? r == null ? void 0 : r.first() : r == null ? void 0 : r.previous(-1);
        },
        End: () => {
          if (oe())
            return !j || M.ctrlKey ? r == null ? void 0 : r.last() : r == null ? void 0 : r.next(-1);
        },
        PageUp: () => Ja(W, r, r == null ? void 0 : r.up, !0),
        PageDown: () => Ja(W, r, r == null ? void 0 : r.down)
      }[M.key];
      if (Z) {
        if (Ci(W)) {
          const te = Ei(W), ne = J && M.key === "ArrowLeft", re = J && M.key === "ArrowRight", xe = G && M.key === "ArrowUp", Ee = G && M.key === "ArrowDown";
          if (re || Ee) {
            const { length: Ke } = bx(W);
            if (te.end !== Ke) return;
          } else if ((ne || xe) && te.start !== 0) return;
        }
        const ie = Z();
        if (L(M) || ie !== void 0) {
          if (!I(M)) return;
          M.preventDefault(), r.move(ie);
        }
      }
    }), A = It(
      () => ({ id: h, baseElement: w }),
      [h, w]
    );
    return u = Un(
      u,
      (M) => /* @__PURE__ */ b(jx.Provider, { value: A, children: M }),
      [A]
    ), u = be(Q({
      id: h,
      "data-active-item": C || void 0
    }, u), {
      ref: ct(v, u.ref),
      tabIndex: E ? u.tabIndex : -1,
      onFocus: D,
      onBlurCapture: O,
      onKeyDown: R
    }), u = As(u), u = Ju(be(Q({
      store: r
    }, u), {
      getItem: N,
      shouldRegisterItem: h ? u.shouldRegisterItem : !1
    })), on(be(Q({}, u), {
      "aria-setsize": S,
      "aria-posinset": P
    }));
  }
);
So(
  Re(function(e) {
    const n = td(e);
    return We(z1, n);
  })
);
var j1 = "div";
function G1(t) {
  return t.some((e) => !!e.rowId);
}
function q1(t) {
  const e = t.target;
  return e && !jt(e) ? !1 : t.key.length === 1 && !t.ctrlKey && !t.metaKey;
}
function X1(t) {
  return t.key === "Shift" || t.key === "Control" || t.key === "Alt" || t.key === "Meta";
}
function Qa(t, e, n) {
  return ge((r) => {
    var o;
    if (e == null || e(r), r.defaultPrevented || r.isPropagationStopped() || !ot(r) || X1(r) || q1(r)) return;
    const i = t.getState(), a = (o = Jt(t, i.activeId)) == null ? void 0 : o.element;
    if (!a) return;
    const s = r, { view: l } = s, c = Me(s, ["view"]), d = n == null ? void 0 : n.current;
    a !== d && a.focus(), Nx(a, r.type, c) || r.preventDefault(), r.currentTarget.contains(a) && r.stopPropagation();
  });
}
function Z1(t) {
  return w1(
    ju(Pi(x1(t)))
  );
}
function J1(t) {
  const [e, n] = le(!1), r = Ne(() => n(!0), []), o = t.useState(
    (i) => Jt(t, i.activeId)
  );
  return fe(() => {
    const i = o == null ? void 0 : o.element;
    e && i && (n(!1), i.focus({ preventScroll: !0 }));
  }, [o, e]), r;
}
var nd = $e(
  function(e) {
    var n = e, {
      store: r,
      composite: o = !0,
      focusOnMove: i = o,
      moveOnKeyPress: a = !0
    } = n, s = Me(n, [
      "store",
      "composite",
      "focusOnMove",
      "moveOnKeyPress"
    ]);
    const l = Ux();
    r = r || l, Ut(
      r,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const c = pe(null), d = pe(null), u = J1(r), m = r.useState("moves"), [, h] = Ix(
      o ? r.setBaseElement : null
    );
    fe(() => {
      var O;
      if (!r || !m || !o || !i) return;
      const { activeId: _ } = r.getState(), L = (O = Jt(r, _)) == null ? void 0 : O.element;
      L && I1(L);
    }, [r, m, o, i]), Ie(() => {
      if (!r || !m || !o) return;
      const { baseElement: O, activeId: _ } = r.getState();
      if (!(_ === null) || !O) return;
      const I = d.current;
      d.current = null, I && En(I, { relatedTarget: O }), dn(O) || O.focus();
    }, [r, m, o]);
    const v = r.useState("activeId"), f = r.useState("virtualFocus");
    Ie(() => {
      var O;
      if (!r || !o || !f) return;
      const _ = d.current;
      if (d.current = null, !_) return;
      const I = ((O = Jt(r, v)) == null ? void 0 : O.element) || xo(_);
      I !== _ && En(_, { relatedTarget: I });
    }, [r, v, f, o]);
    const p = Qa(
      r,
      s.onKeyDownCapture,
      d
    ), g = Qa(
      r,
      s.onKeyUpCapture,
      d
    ), y = s.onFocusCapture, w = ge((O) => {
      if (y == null || y(O), O.defaultPrevented || !r) return;
      const { virtualFocus: _ } = r.getState();
      if (!_) return;
      const L = O.relatedTarget, I = E1(O.currentTarget);
      ot(O) && I && (O.stopPropagation(), d.current = L);
    }), C = s.onFocus, S = ge((O) => {
      if (C == null || C(O), O.defaultPrevented || !o || !r) return;
      const { relatedTarget: _ } = O, { virtualFocus: L } = r.getState();
      L ? ot(O) && !er(r, _) && queueMicrotask(u) : ot(O) && r.setActiveId(null);
    }), P = s.onBlurCapture, E = ge((O) => {
      var _;
      if (P == null || P(O), O.defaultPrevented || !r) return;
      const { virtualFocus: L, activeId: I } = r.getState();
      if (!L) return;
      const R = (_ = Jt(r, I)) == null ? void 0 : _.element, A = O.relatedTarget, M = er(r, A), W = d.current;
      d.current = null, ot(O) && M ? (A === R ? W && W !== A && En(W, O) : R ? En(R, O) : W && En(W, O), O.stopPropagation()) : !er(r, O.target) && R && En(R, O);
    }), N = s.onKeyDown, T = He(a), k = ge((O) => {
      var _;
      if (N == null || N(O), O.nativeEvent.isComposing || O.defaultPrevented || !r || !ot(O)) return;
      const { orientation: L, renderedItems: I, activeId: R } = r.getState(), A = Jt(r, R);
      if ((_ = A == null ? void 0 : A.element) != null && _.isConnected) return;
      const M = L !== "horizontal", W = L !== "vertical", z = G1(I);
      if ((O.key === "ArrowLeft" || O.key === "ArrowRight" || O.key === "Home" || O.key === "End") && jt(O.currentTarget)) return;
      const J = {
        ArrowUp: (z || M) && (() => {
          if (z) {
            const oe = Z1(I);
            return oe == null ? void 0 : oe.id;
          }
          return r == null ? void 0 : r.last();
        }),
        ArrowRight: (z || W) && r.first,
        ArrowDown: (z || M) && r.first,
        ArrowLeft: (z || W) && r.last,
        Home: r.first,
        End: r.last,
        PageUp: r.first,
        PageDown: r.last
      }[O.key];
      if (J) {
        const oe = J();
        if (oe !== void 0) {
          if (!T(O)) return;
          O.preventDefault(), r.move(oe);
        }
      }
    });
    s = Un(
      s,
      (O) => /* @__PURE__ */ b(Os, { value: r, children: O }),
      [r]
    );
    const D = r.useState((O) => {
      var _;
      if (r && o && O.virtualFocus)
        return (_ = Jt(r, O.activeId)) == null ? void 0 : _.id;
    });
    s = be(Q({
      "aria-activedescendant": D
    }, s), {
      ref: ct(c, h, s.ref),
      onKeyDownCapture: p,
      onKeyUpCapture: g,
      onFocusCapture: w,
      onFocus: S,
      onBlurCapture: E,
      onKeyDown: k
    });
    const F = r.useState(
      (O) => o && (O.virtualFocus || O.activeId === null)
    );
    return s = Rs(Q({ focusable: F }, s)), s;
  }
);
Re(function(e) {
  const n = nd(e);
  return We(j1, n);
});
var Q1 = "div";
function el(t, e) {
  const n = setTimeout(e, t);
  return () => clearTimeout(n);
}
function eS(t) {
  let e = requestAnimationFrame(() => {
    e = requestAnimationFrame(t);
  });
  return () => cancelAnimationFrame(e);
}
function tl(...t) {
  return t.join(", ").split(", ").reduce((e, n) => {
    const r = n.endsWith("ms") ? 1 : 1e3, o = Number.parseFloat(n || "0s") * r;
    return o > e ? o : e;
  }, 0);
}
function rd(t, e, n) {
  return !n && e !== !1 && (!t || !!e);
}
var tS = $e(function(e) {
  var n = e, { store: r, alwaysVisible: o } = n, i = Me(n, ["store", "alwaysVisible"]);
  const a = Lu();
  r = r || a, Ut(
    r,
    process.env.NODE_ENV !== "production" && "DisclosureContent must receive a `store` prop or be wrapped in a DisclosureProvider component."
  );
  const s = pe(null), l = vn(i.id), [c, d] = le(null), u = r.useState("open"), m = r.useState("mounted"), h = r.useState("animated"), v = r.useState("contentElement"), f = ks(r.disclosure, "contentElement");
  Ie(() => {
    s.current && (r == null || r.setContentElement(s.current));
  }, [r]), Ie(() => {
    let w;
    return r == null || r.setState("animated", (C) => (w = C, !0)), () => {
      w !== void 0 && (r == null || r.setState("animated", w));
    };
  }, [r]), Ie(() => {
    if (h) {
      if (!(v != null && v.isConnected)) {
        d(null);
        return;
      }
      return eS(() => {
        d(u ? "enter" : m ? "leave" : null);
      });
    }
  }, [h, v, u, m]), Ie(() => {
    if (!r || !h || !c || !v) return;
    const w = () => r == null ? void 0 : r.setState("animating", !1), C = () => Lm(w);
    if (c === "leave" && u || c === "enter" && !u) return;
    if (typeof h == "number")
      return el(h, C);
    const {
      transitionDuration: S,
      animationDuration: P,
      transitionDelay: E,
      animationDelay: N
    } = getComputedStyle(v), {
      transitionDuration: T = "0",
      animationDuration: k = "0",
      transitionDelay: D = "0",
      animationDelay: F = "0"
    } = f ? getComputedStyle(f) : {}, O = tl(
      E,
      N,
      D,
      F
    ), _ = tl(
      S,
      P,
      T,
      k
    ), L = O + _;
    if (!L) {
      c === "enter" && r.setState("animated", !1), w();
      return;
    }
    const I = 1e3 / 60, R = Math.max(L - I, 0);
    return el(R, C);
  }, [r, h, v, f, u, c]), i = Un(
    i,
    (w) => /* @__PURE__ */ b($u, { value: r, children: w }),
    [r]
  );
  const p = rd(m, i.hidden, o), g = i.style, y = It(() => p ? be(Q({}, g), { display: "none" }) : g, [p, g]);
  return i = be(Q({
    id: l,
    "data-open": u || void 0,
    "data-enter": c === "enter" || void 0,
    "data-leave": c === "leave" || void 0,
    hidden: p
  }, i), {
    ref: ct(l ? r.setContentElement : null, s, i.ref),
    style: y
  }), on(i);
}), nS = Re(function(e) {
  const n = tS(e);
  return We(Q1, n);
});
Re(function(e) {
  var n = e, {
    unmountOnHide: r
  } = n, o = Me(n, [
    "unmountOnHide"
  ]);
  const i = Lu(), a = o.store || i;
  return ks(
    a,
    (l) => !r || (l == null ? void 0 : l.mounted)
  ) === !1 ? null : /* @__PURE__ */ b(nS, Q({}, o));
});
function rS(t = {}) {
  const e = Ms(
    t.store,
    zu(t.disclosure, ["contentElement", "disclosureElement"])
  );
  Eo(t, e);
  const n = e == null ? void 0 : e.getState(), r = he(
    t.open,
    n == null ? void 0 : n.open,
    t.defaultOpen,
    !1
  ), o = he(t.animated, n == null ? void 0 : n.animated, !1), i = {
    open: r,
    animated: o,
    animating: !!o && r,
    mounted: r,
    contentElement: he(n == null ? void 0 : n.contentElement, null),
    disclosureElement: he(n == null ? void 0 : n.disclosureElement, null)
  }, a = Ht(i, e);
  return Je(
    a,
    () => rt(a, ["animated", "animating"], (s) => {
      s.animated || a.setState("animating", !1);
    })
  ), Je(
    a,
    () => Is(a, ["open"], () => {
      a.getState().animated && a.setState("animating", !0);
    })
  ), Je(
    a,
    () => rt(a, ["open", "animating"], (s) => {
      a.setState("mounted", s.open || s.animating);
    })
  ), qe(Te({}, a), {
    disclosure: t.disclosure,
    setOpen: (s) => a.setState("open", s),
    show: () => a.setState("open", !0),
    hide: () => a.setState("open", !1),
    toggle: () => a.setState("open", (s) => !s),
    stopAnimation: () => a.setState("animating", !1),
    setContentElement: (s) => a.setState("contentElement", s),
    setDisclosureElement: (s) => a.setState("disclosureElement", s)
  });
}
function oS(t, e, n) {
  return br(e, [n.store, n.disclosure]), Le(t, n, "open", "setOpen"), Le(t, n, "mounted", "setMounted"), Le(t, n, "animated"), Object.assign(t, { disclosure: n.disclosure });
}
function iS(t = {}) {
  return rS(t);
}
function sS(t, e, n) {
  return oS(t, e, n);
}
function aS(t = {}) {
  var e = t, {
    popover: n
  } = e, r = Mu(e, [
    "popover"
  ]);
  const o = Ms(
    r.store,
    zu(n, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  Eo(r, o);
  const i = o == null ? void 0 : o.getState(), a = iS(qe(Te({}, r), { store: o })), s = he(
    r.placement,
    i == null ? void 0 : i.placement,
    "bottom"
  ), l = qe(Te({}, a.getState()), {
    placement: s,
    currentPlacement: s,
    anchorElement: he(i == null ? void 0 : i.anchorElement, null),
    popoverElement: he(i == null ? void 0 : i.popoverElement, null),
    arrowElement: he(i == null ? void 0 : i.arrowElement, null),
    rendered: Symbol("rendered")
  }), c = Ht(l, a, o);
  return qe(Te(Te({}, a), c), {
    setAnchorElement: (d) => c.setState("anchorElement", d),
    setPopoverElement: (d) => c.setState("popoverElement", d),
    setArrowElement: (d) => c.setState("arrowElement", d),
    render: () => c.setState("rendered", Symbol("rendered"))
  });
}
function lS(t, e, n) {
  return br(e, [n.popover]), Le(t, n, "placement"), sS(t, e, n);
}
var cS = "div", od = $e(
  function(e) {
    var n = e, { store: r } = n, o = Me(n, ["store"]);
    const i = Vx();
    return r = r || i, o = be(Q({}, o), {
      ref: ct(r == null ? void 0 : r.setAnchorElement, o.ref)
    }), o;
  }
);
Re(function(e) {
  const n = od(e);
  return We(cS, n);
});
var id = "button", sd = $e(
  function(e) {
    const n = pe(null), r = Fu(n, id), [o, i] = le(
      () => !!r && un({ tagName: r, type: e.type })
    );
    return fe(() => {
      n.current && i(un(n.current));
    }, []), e = be(Q({
      role: !o && r !== "a" ? "button" : void 0
    }, e), {
      ref: ct(n, e.ref)
    }), e = As(e), e;
  }
);
Re(function(e) {
  const n = sd(e);
  return We(id, n);
});
var uS = lt(void 0), dS = "div", ad = $e(
  function(e) {
    const n = ar(uS), r = vn(e.id);
    return Ie(() => (n == null || n(r), () => n == null ? void 0 : n(void 0)), [n, r]), e = Q({
      id: r,
      "aria-hidden": !0
    }, e), on(e);
  }
);
Re(function(e) {
  const n = ad(e);
  return We(dS, n);
});
var fS = "div", ld = $e(function(e) {
  var n = e, { store: r } = n, o = Me(n, ["store"]);
  return o = ad(o), o;
});
Re(function(e) {
  const n = ld(e);
  return We(fS, n);
});
var mS = "div";
function cd(t) {
  const e = t.relatedTarget;
  return (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE ? e : null;
}
function hS(t) {
  const e = cd(t);
  return e ? An(t.currentTarget, e) : !1;
}
var Oi = Symbol("composite-hover");
function pS(t) {
  let e = cd(t);
  if (!e) return !1;
  do {
    if (_t(e, Oi) && e[Oi]) return !0;
    e = e.parentElement;
  } while (e);
  return !1;
}
var ud = $e(
  function(e) {
    var n = e, {
      store: r,
      focusOnHover: o = !0,
      blurOnHoverEnd: i = !!o
    } = n, a = Me(n, [
      "store",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const s = Vu();
    r = r || s, Ut(
      r,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component."
    );
    const l = Rx(), c = a.onMouseMove, d = He(o), u = ge((p) => {
      if (c == null || c(p), !p.defaultPrevented && l() && d(p)) {
        if (!ed(p.currentTarget)) {
          const g = r == null ? void 0 : r.getState().baseElement;
          g && !dn(g) && g.focus();
        }
        r == null || r.setActiveId(p.currentTarget.id);
      }
    }), m = a.onMouseLeave, h = He(i), v = ge((p) => {
      var g;
      m == null || m(p), !p.defaultPrevented && l() && (hS(p) || pS(p) || d(p) && h(p) && (r == null || r.setActiveId(null), (g = r == null ? void 0 : r.getState().baseElement) == null || g.focus()));
    }), f = Ne((p) => {
      p && (p[Oi] = !0);
    }, []);
    return a = be(Q({}, a), {
      ref: ct(f, a.ref),
      onMouseMove: u,
      onMouseLeave: v
    }), on(a);
  }
);
So(
  Re(function(e) {
    const n = ud(e);
    return We(mS, n);
  })
);
lt(null);
lt(
  null
);
var vS = gn(
  [Os],
  [Bu]
), gS = vS.useContext, bS = Ss() && Sx();
function yS(t = {}) {
  var e = t, {
    tag: n
  } = e, r = Mu(e, [
    "tag"
  ]);
  const o = Ms(r.store, qx(n, ["value", "rtl"]));
  Eo(r, o);
  const i = n == null ? void 0 : n.getState(), a = o == null ? void 0 : o.getState(), s = he(
    r.activeId,
    a == null ? void 0 : a.activeId,
    r.defaultActiveId,
    null
  ), l = f1(qe(Te({}, r), {
    activeId: s,
    includesBaseElement: he(
      r.includesBaseElement,
      a == null ? void 0 : a.includesBaseElement,
      !0
    ),
    orientation: he(
      r.orientation,
      a == null ? void 0 : a.orientation,
      "vertical"
    ),
    focusLoop: he(r.focusLoop, a == null ? void 0 : a.focusLoop, !0),
    focusWrap: he(r.focusWrap, a == null ? void 0 : a.focusWrap, !0),
    virtualFocus: he(
      r.virtualFocus,
      a == null ? void 0 : a.virtualFocus,
      !0
    )
  })), c = aS(qe(Te({}, r), {
    placement: he(
      r.placement,
      a == null ? void 0 : a.placement,
      "bottom-start"
    )
  })), d = he(
    r.value,
    a == null ? void 0 : a.value,
    r.defaultValue,
    ""
  ), u = he(
    r.selectedValue,
    a == null ? void 0 : a.selectedValue,
    i == null ? void 0 : i.values,
    r.defaultSelectedValue,
    ""
  ), m = Array.isArray(u), h = qe(Te(Te({}, l.getState()), c.getState()), {
    value: d,
    selectedValue: u,
    resetValueOnSelect: he(
      r.resetValueOnSelect,
      a == null ? void 0 : a.resetValueOnSelect,
      m
    ),
    resetValueOnHide: he(
      r.resetValueOnHide,
      a == null ? void 0 : a.resetValueOnHide,
      m && !n
    ),
    activeValue: a == null ? void 0 : a.activeValue
  }), v = Ht(h, l, c, o);
  return bS && Je(
    v,
    () => rt(v, ["virtualFocus"], () => {
      v.setState("virtualFocus", !1);
    })
  ), Je(v, () => {
    if (n)
      return Xr(
        rt(v, ["selectedValue"], (f) => {
          Array.isArray(f.selectedValue) && n.setValues(f.selectedValue);
        }),
        rt(n, ["values"], (f) => {
          v.setState("selectedValue", f.values);
        })
      );
  }), Je(
    v,
    () => rt(v, ["resetValueOnHide", "mounted"], (f) => {
      f.resetValueOnHide && (f.mounted || v.setState("value", d));
    })
  ), Je(
    v,
    () => rt(v, ["open"], (f) => {
      f.open || (v.setState("activeId", s), v.setState("moves", 0));
    })
  ), Je(
    v,
    () => rt(v, ["moves", "activeId"], (f, p) => {
      f.moves === p.moves && v.setState("activeValue", void 0);
    })
  ), Je(
    v,
    () => Zr(v, ["moves", "renderedItems"], (f, p) => {
      if (f.moves === p.moves) return;
      const { activeId: g } = v.getState(), y = l.item(g);
      v.setState("activeValue", y == null ? void 0 : y.value);
    })
  ), qe(Te(Te(Te({}, c), l), v), {
    tag: n,
    setValue: (f) => v.setState("value", f),
    resetValue: () => v.setState("value", h.value),
    setSelectedValue: (f) => v.setState("selectedValue", f)
  });
}
function wS(t) {
  const e = gS();
  return t = be(Q({}, t), {
    tag: t.tag !== void 0 ? t.tag : e
  }), m1(t);
}
function xS(t, e, n) {
  return br(e, [n.tag]), Le(t, n, "value", "setValue"), Le(t, n, "selectedValue", "setSelectedValue"), Le(t, n, "resetValueOnHide"), Le(t, n, "resetValueOnSelect"), Object.assign(
    h1(
      lS(t, e, n),
      e,
      n
    ),
    { tag: n.tag }
  );
}
function SS(t = {}) {
  t = wS(t);
  const [e, n] = t1(yS, t);
  return xS(e, n, t);
}
var CS = "input";
function nl(t, e, n) {
  if (!n) return !1;
  const r = t.find((o) => !o.disabled && o.value);
  return (r == null ? void 0 : r.value) === e;
}
function rl(t, e) {
  return !e || t == null ? !1 : (t = ix(t), e.length > t.length && e.toLowerCase().indexOf(t.toLowerCase()) === 0);
}
function ES(t) {
  return t.type === "input";
}
function PS(t) {
  return t === "inline" || t === "list" || t === "both" || t === "none";
}
function NS(t) {
  const e = t.find((n) => {
    var r;
    return n.disabled ? !1 : ((r = n.element) == null ? void 0 : r.getAttribute("role")) !== "tab";
  });
  return e == null ? void 0 : e.id;
}
var OS = $e(
  function(e) {
    var n = e, {
      store: r,
      focusable: o = !0,
      autoSelect: i = !1,
      getAutoSelectId: a,
      setValueOnChange: s,
      showMinLength: l = 0,
      showOnChange: c,
      showOnMouseDown: d,
      showOnClick: u = d,
      showOnKeyDown: m,
      showOnKeyPress: h = m,
      blurActiveItemOnClick: v,
      setValueOnClick: f = !0,
      moveOnKeyPress: p = !0,
      autoComplete: g = "list"
    } = n, y = Me(n, [
      "store",
      "focusable",
      "autoSelect",
      "getAutoSelectId",
      "setValueOnChange",
      "showMinLength",
      "showOnChange",
      "showOnMouseDown",
      "showOnClick",
      "showOnKeyDown",
      "showOnKeyPress",
      "blurActiveItemOnClick",
      "setValueOnClick",
      "moveOnKeyPress",
      "autoComplete"
    ]);
    const w = _s();
    r = r || w, Ut(
      r,
      process.env.NODE_ENV !== "production" && "Combobox must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const C = pe(null), [S, P] = _x(), E = pe(!1), N = pe(!1), T = r.useState(
      (V) => V.virtualFocus && i
    ), k = g === "inline" || g === "both", [D, F] = le(k);
    kx(() => {
      k && F(!0);
    }, [k]);
    const O = r.useState("value"), _ = pe();
    fe(() => rt(r, ["selectedValue", "activeId"], (V, se) => {
      _.current = se.selectedValue;
    }), []);
    const L = r.useState((V) => {
      var se;
      if (k && D && !(V.activeValue && Array.isArray(V.selectedValue) && (V.selectedValue.includes(V.activeValue) || (se = _.current) != null && se.includes(V.activeValue))))
        return V.activeValue;
    }), I = r.useState("renderedItems"), R = r.useState("open"), A = r.useState("contentElement"), M = It(() => {
      if (!k || !D) return O;
      if (nl(
        I,
        L,
        T
      )) {
        if (rl(O, L)) {
          const se = (L == null ? void 0 : L.slice(O.length)) || "";
          return O + se;
        }
        return O;
      }
      return L || O;
    }, [k, D, I, L, T, O]);
    fe(() => {
      const V = C.current;
      if (!V) return;
      const se = () => F(!0);
      return V.addEventListener("combobox-item-move", se), () => {
        V.removeEventListener("combobox-item-move", se);
      };
    }, []), fe(() => {
      if (!k || !D || !L || !nl(
        I,
        L,
        T
      ) || !rl(O, L)) return;
      let se = ku;
      return queueMicrotask(() => {
        const me = C.current;
        if (!me) return;
        const { start: de, end: Fe } = Ei(me), dt = O.length, _e = L.length;
        ti(me, dt, _e), se = () => {
          if (!dn(me)) return;
          const { start: At, end: Wo } = Ei(me);
          At === dt && Wo === _e && ti(me, de, Fe);
        };
      }), () => se();
    }, [
      S,
      k,
      D,
      L,
      I,
      T,
      O
    ]);
    const W = pe(null), z = ge(a), K = pe(null);
    fe(() => {
      if (!R || !A) return;
      const V = xs(A);
      if (!V) return;
      W.current = V;
      const se = () => {
        E.current = !1;
      }, me = () => {
        if (!r || !E.current) return;
        const { activeId: Fe } = r.getState();
        Fe !== null && Fe !== K.current && (E.current = !1);
      }, de = { passive: !0, capture: !0 };
      return V.addEventListener("wheel", se, de), V.addEventListener("touchmove", se, de), V.addEventListener("scroll", me, de), () => {
        V.removeEventListener("wheel", se, !0), V.removeEventListener("touchmove", se, !0), V.removeEventListener("scroll", me, !0);
      };
    }, [R, A, r]), Ie(() => {
      O && (N.current || (E.current = !0));
    }, [O]), Ie(() => {
      T !== "always" && R || (E.current = R);
    }, [T, R]);
    const j = r.useState("resetValueOnSelect");
    br(() => {
      var V, se;
      const me = E.current;
      if (!r || !R || !me && !j) return;
      const { baseElement: de, contentElement: Fe, activeId: dt } = r.getState();
      if (!(de && !dn(de))) {
        if (Fe != null && Fe.hasAttribute("data-placing")) {
          const _e = new MutationObserver(P);
          return _e.observe(Fe, { attributeFilter: ["data-placing"] }), () => _e.disconnect();
        }
        if (T && me) {
          const _e = z(I), At = _e !== void 0 ? _e : (V = NS(I)) != null ? V : r.first();
          K.current = At, r.move(At ?? null);
        } else {
          const _e = (se = r.item(dt || r.first())) == null ? void 0 : se.element;
          _e && "scrollIntoView" in _e && _e.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
    }, [
      r,
      R,
      S,
      O,
      T,
      j,
      z,
      I
    ]), fe(() => {
      if (!k) return;
      const V = C.current;
      if (!V) return;
      const se = [V, A].filter(
        (de) => !!de
      ), me = (de) => {
        se.every((Fe) => Au(de, Fe)) && (r == null || r.setValue(M));
      };
      for (const de of se)
        de.addEventListener("focusout", me);
      return () => {
        for (const de of se)
          de.removeEventListener("focusout", me);
      };
    }, [k, A, r, M]);
    const G = (V) => V.currentTarget.value.length >= l, J = y.onChange, oe = He(c ?? G), Y = He(
      // If the combobox is combined with tags, the value will be set by the tag
      // input component.
      s ?? !r.tag
    ), Z = ge((V) => {
      if (J == null || J(V), V.defaultPrevented || !r) return;
      const se = V.currentTarget, { value: me, selectionStart: de, selectionEnd: Fe } = se, dt = V.nativeEvent;
      if (E.current = !0, ES(dt) && (dt.isComposing && (E.current = !1, N.current = !0), k)) {
        const _e = dt.inputType === "insertText" || dt.inputType === "insertCompositionText", At = de === me.length;
        F(_e && At);
      }
      if (Y(V)) {
        const _e = me === r.getState().value;
        r.setValue(me), queueMicrotask(() => {
          ti(se, de, Fe);
        }), k && T && _e && P();
      }
      oe(V) && r.show(), (!T || !E.current) && r.setActiveId(null);
    }), ie = y.onCompositionEnd, te = ge((V) => {
      E.current = !0, N.current = !1, ie == null || ie(V), !V.defaultPrevented && T && P();
    }), ne = y.onMouseDown, re = He(
      v ?? (() => !!(r != null && r.getState().includesBaseElement))
    ), xe = He(f), Ee = He(u ?? G), Ke = ge((V) => {
      ne == null || ne(V), !V.defaultPrevented && (V.button || V.ctrlKey || r && (re(V) && r.setActiveId(null), xe(V) && r.setValue(M), Ee(V) && Qn(V.currentTarget, "mouseup", r.show)));
    }), Ae = y.onKeyDown, Ge = He(h ?? G), nt = ge((V) => {
      if (Ae == null || Ae(V), V.repeat || (E.current = !1), V.defaultPrevented || V.ctrlKey || V.altKey || V.shiftKey || V.metaKey || !r) return;
      const { open: se } = r.getState();
      se || (V.key === "ArrowUp" || V.key === "ArrowDown") && Ge(V) && (V.preventDefault(), r.show());
    }), Ve = y.onBlur, wt = ge((V) => {
      E.current = !1, Ve == null || Ve(V), V.defaultPrevented;
    }), xt = vn(y.id), ut = PS(g) ? g : void 0, St = r.useState((V) => V.activeId === null);
    return y = be(Q({
      id: xt,
      role: "combobox",
      "aria-autocomplete": ut,
      "aria-haspopup": yx(A, "listbox"),
      "aria-expanded": R,
      "aria-controls": A == null ? void 0 : A.id,
      "data-active-item": St || void 0,
      value: M
    }, y), {
      ref: ct(C, y.ref),
      onChange: Z,
      onCompositionEnd: te,
      onMouseDown: Ke,
      onKeyDown: nt,
      onBlur: wt
    }), y = nd(be(Q({
      store: r,
      focusable: o
    }, y), {
      // Enable inline autocomplete when the user moves from the combobox input
      // to an item.
      moveOnKeyPress: (V) => cx(p, V) ? !1 : (k && F(!0), !0)
    })), y = od(Q({ store: r }, y)), Q({ autoComplete: "off" }, y);
  }
), TS = Re(function(e) {
  const n = OS(e);
  return We(CS, n);
});
function IS(t = {}) {
  const e = SS(t);
  return /* @__PURE__ */ b(v1, { value: e, children: t.children });
}
var MS = "button", kS = /* @__PURE__ */ $(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    width: "1em",
    height: "1em",
    pointerEvents: "none",
    children: [
      /* @__PURE__ */ b("line", { x1: "5", y1: "5", x2: "11", y2: "11" }),
      /* @__PURE__ */ b("line", { x1: "5", y1: "11", x2: "11", y2: "5" })
    ]
  }
), _S = $e(
  function(e) {
    var n = e, { store: r, hideWhenEmpty: o } = n, i = Me(n, ["store", "hideWhenEmpty"]);
    const a = _s();
    r = r || a, Ut(
      r,
      process.env.NODE_ENV !== "production" && "ComboboxCancel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const s = i.onClick, l = ge((u) => {
      s == null || s(u), !u.defaultPrevented && (r == null || r.setValue(""), r == null || r.move(null));
    }), c = r.useState((u) => {
      var m;
      return (m = u.baseElement) == null ? void 0 : m.id;
    }), d = r.useState((u) => u.value === "");
    return i = Un(
      i,
      (u) => o && d ? /* @__PURE__ */ b(oo, {}) : u,
      [o, d]
    ), i = be(Q({
      children: kS,
      "aria-label": "Clear input",
      // This aria-controls will ensure the combobox popup remains visible when
      // this element gets focused. This logic is done in the ComboboxPopover
      // component.
      "aria-controls": c
    }, i), {
      onClick: l
    }), i = sd(i), i;
  }
), DS = Re(function(e) {
  const n = _S(e);
  return We(MS, n);
}), RS = "div", AS = $e(function(e) {
  return e = ld(e), e;
}), FS = Re(function(e) {
  const n = AS(e);
  return We(RS, n);
}), LS = "div";
function WS(t, e) {
  if (e != null)
    return t == null ? !1 : Array.isArray(t) ? t.includes(e) : t === e;
}
function $S(t) {
  var e;
  return (e = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }[t]) != null ? e : "option";
}
var VS = $e(
  function(e) {
    var n = e, {
      store: r,
      value: o,
      hideOnClick: i,
      setValueOnClick: a,
      selectValueOnClick: s = !0,
      resetValueOnSelect: l,
      focusOnHover: c = !1,
      moveOnKeyPress: d = !0,
      getItem: u
    } = n, m = Me(n, [
      "store",
      "value",
      "hideOnClick",
      "setValueOnClick",
      "selectValueOnClick",
      "resetValueOnSelect",
      "focusOnHover",
      "moveOnKeyPress",
      "getItem"
    ]), h;
    const v = Zu();
    r = r || v, Ut(
      r,
      process.env.NODE_ENV !== "production" && "ComboboxItem must be wrapped in a ComboboxList or ComboboxPopover component."
    );
    const { resetValueOnSelectState: f, multiSelectable: p, selected: g } = Uu(r, {
      resetValueOnSelectState: "resetValueOnSelect",
      multiSelectable(O) {
        return Array.isArray(O.selectedValue);
      },
      selected(O) {
        return WS(O.selectedValue, o);
      }
    }), y = Ne(
      (O) => {
        const _ = be(Q({}, O), { value: o });
        return u ? u(_) : _;
      },
      [o, u]
    );
    a = a ?? !p, i = i ?? (o != null && !p);
    const w = m.onClick, C = He(a), S = He(s), P = He(
      (h = l ?? f) != null ? h : p
    ), E = He(i), N = ge((O) => {
      w == null || w(O), !O.defaultPrevented && (Px(O) || Ex(O) || (o != null && (S(O) && (P(O) && (r == null || r.resetValue()), r == null || r.setSelectedValue((_) => Array.isArray(_) ? _.includes(o) ? _.filter((L) => L !== o) : [..._, o] : o)), C(O) && (r == null || r.setValue(o))), E(O) && (r == null || r.hide())));
    }), T = m.onKeyDown, k = ge((O) => {
      if (T == null || T(O), O.defaultPrevented) return;
      const _ = r == null ? void 0 : r.getState().baseElement;
      if (!_ || dn(_)) return;
      (O.key.length === 1 || O.key === "Backspace" || O.key === "Delete") && (queueMicrotask(() => _.focus()), jt(_) && (r == null || r.setValue(_.value)));
    });
    p && g != null && (m = Q({
      "aria-selected": g
    }, m)), m = Un(
      m,
      (O) => /* @__PURE__ */ b(b1.Provider, { value: o, children: /* @__PURE__ */ b(y1.Provider, { value: g ?? !1, children: O }) }),
      [o, g]
    );
    const D = ar(Xu);
    m = be(Q({
      role: $S(D),
      children: o
    }, m), {
      onClick: N,
      onKeyDown: k
    });
    const F = He(d);
    return m = td(be(Q({
      store: r
    }, m), {
      getItem: y,
      // Dispatch a custom event on the combobox input when moving to an item
      // with the keyboard so the Combobox component can enable inline
      // autocompletion.
      moveOnKeyPress: (O) => {
        if (!F(O)) return !1;
        const _ = new Event("combobox-item-move"), L = r == null ? void 0 : r.getState().baseElement;
        return L == null || L.dispatchEvent(_), !0;
      }
    })), m = ud(Q({ store: r, focusOnHover: c }, m)), m;
  }
), ii = So(
  Re(function(e) {
    const n = VS(e);
    return We(LS, n);
  })
), BS = "label", zS = $e(
  function(e) {
    var n = e, { store: r } = n, o = Me(n, ["store"]);
    const i = _s();
    r = r || i, Ut(
      r,
      process.env.NODE_ENV !== "production" && "ComboboxLabel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const a = r.useState((s) => {
      var l;
      return (l = s.baseElement) == null ? void 0 : l.id;
    });
    return o = Q({
      htmlFor: a
    }, o), on(o);
  }
), HS = So(
  Re(function(e) {
    const n = zS(e);
    return We(BS, n);
  })
), YS = "div", KS = $e(
  function(e) {
    var n = e, { store: r, alwaysVisible: o } = n, i = Me(n, ["store", "alwaysVisible"]);
    const a = Zu(!0), s = p1();
    r = r || s;
    const l = !!r && r === a;
    Ut(
      r,
      process.env.NODE_ENV !== "production" && "ComboboxList must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const c = pe(null), d = vn(i.id), u = r.useState("mounted"), m = rd(u, i.hidden, o), h = m ? be(Q({}, i.style), { display: "none" }) : i.style, v = r.useState(
      (P) => Array.isArray(P.selectedValue)
    ), f = Mx(c, "role", i.role), g = (f === "listbox" || f === "tree" || f === "grid") && v || void 0, [y, w] = le(!1), C = r.useState("contentElement");
    Ie(() => {
      if (!u) return;
      const P = c.current;
      if (!P || C !== P) return;
      const E = () => {
        w(!!P.querySelector("[role='listbox']"));
      }, N = new MutationObserver(E);
      return N.observe(P, {
        subtree: !0,
        childList: !0,
        attributeFilter: ["role"]
      }), E(), () => N.disconnect();
    }, [u, C]), y || (i = Q({
      role: "listbox",
      "aria-multiselectable": g
    }, i)), i = Un(
      i,
      (P) => /* @__PURE__ */ b(g1, { value: r, children: /* @__PURE__ */ b(Xu.Provider, { value: f, children: P }) }),
      [r, f]
    );
    const S = d && (!a || !l) ? r.setContentElement : null;
    return i = be(Q({
      id: d,
      hidden: m
    }, i), {
      ref: ct(S, c, i.ref),
      style: h
    }), on(i);
  }
), US = Re(function(e) {
  const n = KS(e);
  return We(YS, n);
}), qn = { exports: {} }, ol;
function jS() {
  if (ol) return qn.exports;
  ol = 1;
  var t = {
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    Ấ: "A",
    Ắ: "A",
    Ẳ: "A",
    Ẵ: "A",
    Ặ: "A",
    Æ: "AE",
    Ầ: "A",
    Ằ: "A",
    Ȃ: "A",
    Ả: "A",
    Ạ: "A",
    Ẩ: "A",
    Ẫ: "A",
    Ậ: "A",
    Ç: "C",
    Ḉ: "C",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    Ế: "E",
    Ḗ: "E",
    Ề: "E",
    Ḕ: "E",
    Ḝ: "E",
    Ȇ: "E",
    Ẻ: "E",
    Ẽ: "E",
    Ẹ: "E",
    Ể: "E",
    Ễ: "E",
    Ệ: "E",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    Ḯ: "I",
    Ȋ: "I",
    Ỉ: "I",
    Ị: "I",
    Ð: "D",
    Ñ: "N",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    Ố: "O",
    Ṍ: "O",
    Ṓ: "O",
    Ȏ: "O",
    Ỏ: "O",
    Ọ: "O",
    Ổ: "O",
    Ỗ: "O",
    Ộ: "O",
    Ờ: "O",
    Ở: "O",
    Ỡ: "O",
    Ớ: "O",
    Ợ: "O",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    Ủ: "U",
    Ụ: "U",
    Ử: "U",
    Ữ: "U",
    Ự: "U",
    Ý: "Y",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    ấ: "a",
    ắ: "a",
    ẳ: "a",
    ẵ: "a",
    ặ: "a",
    æ: "ae",
    ầ: "a",
    ằ: "a",
    ȃ: "a",
    ả: "a",
    ạ: "a",
    ẩ: "a",
    ẫ: "a",
    ậ: "a",
    ç: "c",
    ḉ: "c",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    ế: "e",
    ḗ: "e",
    ề: "e",
    ḕ: "e",
    ḝ: "e",
    ȇ: "e",
    ẻ: "e",
    ẽ: "e",
    ẹ: "e",
    ể: "e",
    ễ: "e",
    ệ: "e",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    ḯ: "i",
    ȋ: "i",
    ỉ: "i",
    ị: "i",
    ð: "d",
    ñ: "n",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    ố: "o",
    ṍ: "o",
    ṓ: "o",
    ȏ: "o",
    ỏ: "o",
    ọ: "o",
    ổ: "o",
    ỗ: "o",
    ộ: "o",
    ờ: "o",
    ở: "o",
    ỡ: "o",
    ớ: "o",
    ợ: "o",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    ủ: "u",
    ụ: "u",
    ử: "u",
    ữ: "u",
    ự: "u",
    ý: "y",
    ÿ: "y",
    Ā: "A",
    ā: "a",
    Ă: "A",
    ă: "a",
    Ą: "A",
    ą: "a",
    Ć: "C",
    ć: "c",
    Ĉ: "C",
    ĉ: "c",
    Ċ: "C",
    ċ: "c",
    Č: "C",
    č: "c",
    C̆: "C",
    c̆: "c",
    Ď: "D",
    ď: "d",
    Đ: "D",
    đ: "d",
    Ē: "E",
    ē: "e",
    Ĕ: "E",
    ĕ: "e",
    Ė: "E",
    ė: "e",
    Ę: "E",
    ę: "e",
    Ě: "E",
    ě: "e",
    Ĝ: "G",
    Ǵ: "G",
    ĝ: "g",
    ǵ: "g",
    Ğ: "G",
    ğ: "g",
    Ġ: "G",
    ġ: "g",
    Ģ: "G",
    ģ: "g",
    Ĥ: "H",
    ĥ: "h",
    Ħ: "H",
    ħ: "h",
    Ḫ: "H",
    ḫ: "h",
    Ĩ: "I",
    ĩ: "i",
    Ī: "I",
    ī: "i",
    Ĭ: "I",
    ĭ: "i",
    Į: "I",
    į: "i",
    İ: "I",
    ı: "i",
    Ĳ: "IJ",
    ĳ: "ij",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    Ḱ: "K",
    ḱ: "k",
    K̆: "K",
    k̆: "k",
    Ĺ: "L",
    ĺ: "l",
    Ļ: "L",
    ļ: "l",
    Ľ: "L",
    ľ: "l",
    Ŀ: "L",
    ŀ: "l",
    Ł: "l",
    ł: "l",
    Ḿ: "M",
    ḿ: "m",
    M̆: "M",
    m̆: "m",
    Ń: "N",
    ń: "n",
    Ņ: "N",
    ņ: "n",
    Ň: "N",
    ň: "n",
    ŉ: "n",
    N̆: "N",
    n̆: "n",
    Ō: "O",
    ō: "o",
    Ŏ: "O",
    ŏ: "o",
    Ő: "O",
    ő: "o",
    Œ: "OE",
    œ: "oe",
    P̆: "P",
    p̆: "p",
    Ŕ: "R",
    ŕ: "r",
    Ŗ: "R",
    ŗ: "r",
    Ř: "R",
    ř: "r",
    R̆: "R",
    r̆: "r",
    Ȓ: "R",
    ȓ: "r",
    Ś: "S",
    ś: "s",
    Ŝ: "S",
    ŝ: "s",
    Ş: "S",
    Ș: "S",
    ș: "s",
    ş: "s",
    Š: "S",
    š: "s",
    Ţ: "T",
    ţ: "t",
    ț: "t",
    Ț: "T",
    Ť: "T",
    ť: "t",
    Ŧ: "T",
    ŧ: "t",
    T̆: "T",
    t̆: "t",
    Ũ: "U",
    ũ: "u",
    Ū: "U",
    ū: "u",
    Ŭ: "U",
    ŭ: "u",
    Ů: "U",
    ů: "u",
    Ű: "U",
    ű: "u",
    Ų: "U",
    ų: "u",
    Ȗ: "U",
    ȗ: "u",
    V̆: "V",
    v̆: "v",
    Ŵ: "W",
    ŵ: "w",
    Ẃ: "W",
    ẃ: "w",
    X̆: "X",
    x̆: "x",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Y̆: "Y",
    y̆: "y",
    Ź: "Z",
    ź: "z",
    Ż: "Z",
    ż: "z",
    Ž: "Z",
    ž: "z",
    ſ: "s",
    ƒ: "f",
    Ơ: "O",
    ơ: "o",
    Ư: "U",
    ư: "u",
    Ǎ: "A",
    ǎ: "a",
    Ǐ: "I",
    ǐ: "i",
    Ǒ: "O",
    ǒ: "o",
    Ǔ: "U",
    ǔ: "u",
    Ǖ: "U",
    ǖ: "u",
    Ǘ: "U",
    ǘ: "u",
    Ǚ: "U",
    ǚ: "u",
    Ǜ: "U",
    ǜ: "u",
    Ứ: "U",
    ứ: "u",
    Ṹ: "U",
    ṹ: "u",
    Ǻ: "A",
    ǻ: "a",
    Ǽ: "AE",
    ǽ: "ae",
    Ǿ: "O",
    ǿ: "o",
    Þ: "TH",
    þ: "th",
    Ṕ: "P",
    ṕ: "p",
    Ṥ: "S",
    ṥ: "s",
    X́: "X",
    x́: "x",
    Ѓ: "Г",
    ѓ: "г",
    Ќ: "К",
    ќ: "к",
    A̋: "A",
    a̋: "a",
    E̋: "E",
    e̋: "e",
    I̋: "I",
    i̋: "i",
    Ǹ: "N",
    ǹ: "n",
    Ồ: "O",
    ồ: "o",
    Ṑ: "O",
    ṑ: "o",
    Ừ: "U",
    ừ: "u",
    Ẁ: "W",
    ẁ: "w",
    Ỳ: "Y",
    ỳ: "y",
    Ȁ: "A",
    ȁ: "a",
    Ȅ: "E",
    ȅ: "e",
    Ȉ: "I",
    ȉ: "i",
    Ȍ: "O",
    ȍ: "o",
    Ȑ: "R",
    ȑ: "r",
    Ȕ: "U",
    ȕ: "u",
    B̌: "B",
    b̌: "b",
    Č̣: "C",
    č̣: "c",
    Ê̌: "E",
    ê̌: "e",
    F̌: "F",
    f̌: "f",
    Ǧ: "G",
    ǧ: "g",
    Ȟ: "H",
    ȟ: "h",
    J̌: "J",
    ǰ: "j",
    Ǩ: "K",
    ǩ: "k",
    M̌: "M",
    m̌: "m",
    P̌: "P",
    p̌: "p",
    Q̌: "Q",
    q̌: "q",
    Ř̩: "R",
    ř̩: "r",
    Ṧ: "S",
    ṧ: "s",
    V̌: "V",
    v̌: "v",
    W̌: "W",
    w̌: "w",
    X̌: "X",
    x̌: "x",
    Y̌: "Y",
    y̌: "y",
    A̧: "A",
    a̧: "a",
    B̧: "B",
    b̧: "b",
    Ḑ: "D",
    ḑ: "d",
    Ȩ: "E",
    ȩ: "e",
    Ɛ̧: "E",
    ɛ̧: "e",
    Ḩ: "H",
    ḩ: "h",
    I̧: "I",
    i̧: "i",
    Ɨ̧: "I",
    ɨ̧: "i",
    M̧: "M",
    m̧: "m",
    O̧: "O",
    o̧: "o",
    Q̧: "Q",
    q̧: "q",
    U̧: "U",
    u̧: "u",
    X̧: "X",
    x̧: "x",
    Z̧: "Z",
    z̧: "z",
    й: "и",
    Й: "И",
    ё: "е",
    Ё: "Е"
  }, e = Object.keys(t).join("|"), n = new RegExp(e, "g"), r = new RegExp(e, "");
  function o(s) {
    return t[s];
  }
  var i = function(s) {
    return s.replace(n, o);
  }, a = function(s) {
    return !!s.match(r);
  };
  return qn.exports = i, qn.exports.has = a, qn.exports.remove = i, qn.exports;
}
var GS = jS();
const qS = /* @__PURE__ */ Hu(GS);
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2020 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const Ue = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
}, XS = (t, e) => String(t.rankedValue).localeCompare(String(e.rankedValue));
function dd(t, e, n) {
  n === void 0 && (n = {});
  const {
    keys: r,
    threshold: o = Ue.MATCHES,
    baseSort: i = XS,
    sorter: a = (c) => c.sort((d, u) => e0(d, u, i))
  } = n, s = t.reduce(l, []);
  return a(s).map((c) => {
    let {
      item: d
    } = c;
    return d;
  });
  function l(c, d, u) {
    const m = ZS(d, r, e, n), {
      rank: h,
      keyThreshold: v = o
    } = m;
    return h >= v && c.push({
      ...m,
      item: d,
      index: u
    }), c;
  }
}
dd.rankings = Ue;
function ZS(t, e, n, r) {
  if (!e) {
    const i = t;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: i,
      rank: il(i, n, r),
      keyIndex: -1,
      keyThreshold: r.threshold
    };
  }
  return r0(t, e).reduce((i, a, s) => {
    let {
      rank: l,
      rankedValue: c,
      keyIndex: d,
      keyThreshold: u
    } = i, {
      itemValue: m,
      attributes: h
    } = a, v = il(m, n, r), f = c;
    const {
      minRanking: p,
      maxRanking: g,
      threshold: y
    } = h;
    return v < p && v >= Ue.MATCHES ? v = p : v > g && (v = g), v > l && (l = v, d = s, u = y, f = m), {
      rankedValue: f,
      rank: l,
      keyIndex: d,
      keyThreshold: u
    };
  }, {
    rankedValue: t,
    rank: Ue.NO_MATCH,
    keyIndex: -1,
    keyThreshold: r.threshold
  });
}
function il(t, e, n) {
  return t = sl(t, n), e = sl(e, n), e.length > t.length ? Ue.NO_MATCH : t === e ? Ue.CASE_SENSITIVE_EQUAL : (t = t.toLowerCase(), e = e.toLowerCase(), t === e ? Ue.EQUAL : t.startsWith(e) ? Ue.STARTS_WITH : t.includes(` ${e}`) ? Ue.WORD_STARTS_WITH : t.includes(e) ? Ue.CONTAINS : e.length === 1 ? Ue.NO_MATCH : JS(t).includes(e) ? Ue.ACRONYM : QS(t, e));
}
function JS(t) {
  let e = "";
  return t.split(" ").forEach((r) => {
    r.split("-").forEach((i) => {
      e += i.substr(0, 1);
    });
  }), e;
}
function QS(t, e) {
  let n = 0, r = 0;
  function o(l, c, d) {
    for (let u = d, m = c.length; u < m; u++)
      if (c[u] === l)
        return n += 1, u + 1;
    return -1;
  }
  function i(l) {
    const c = 1 / l, d = n / e.length;
    return Ue.MATCHES + d * c;
  }
  const a = o(e[0], t, 0);
  if (a < 0)
    return Ue.NO_MATCH;
  r = a;
  for (let l = 1, c = e.length; l < c; l++) {
    const d = e[l];
    if (r = o(d, t, r), !(r > -1))
      return Ue.NO_MATCH;
  }
  const s = r - a;
  return i(s);
}
function e0(t, e, n) {
  const {
    rank: i,
    keyIndex: a
  } = t, {
    rank: s,
    keyIndex: l
  } = e;
  return i === s ? a === l ? n(t, e) : a < l ? -1 : 1 : i > s ? -1 : 1;
}
function sl(t, e) {
  let {
    keepDiacritics: n
  } = e;
  return t = `${t}`, n || (t = qS(t)), t;
}
function t0(t, e) {
  typeof e == "object" && (e = e.key);
  let n;
  if (typeof e == "function")
    n = e(t);
  else if (t == null)
    n = null;
  else if (Object.hasOwnProperty.call(t, e))
    n = t[e];
  else {
    if (e.includes("."))
      return n0(e, t);
    n = null;
  }
  return n == null ? [] : Array.isArray(n) ? n : [String(n)];
}
function n0(t, e) {
  const n = t.split(".");
  let r = [e];
  for (let o = 0, i = n.length; o < i; o++) {
    const a = n[o];
    let s = [];
    for (let l = 0, c = r.length; l < c; l++) {
      const d = r[l];
      if (d != null)
        if (Object.hasOwnProperty.call(d, a)) {
          const u = d[a];
          u != null && s.push(u);
        } else a === "*" && (s = s.concat(d));
    }
    r = s;
  }
  return Array.isArray(r[0]) ? [].concat(...r) : r;
}
function r0(t, e) {
  const n = [];
  for (let r = 0, o = e.length; r < o; r++) {
    const i = e[r], a = o0(i), s = t0(t, i);
    for (let l = 0, c = s.length; l < c; l++)
      n.push({
        itemValue: s[l],
        attributes: a
      });
  }
  return n;
}
const al = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function o0(t) {
  return typeof t == "string" ? al : {
    ...al,
    ...t
  };
}
function Ti() {
  return Ti = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ti.apply(null, arguments);
}
function ll(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ii(t, e) {
  return Ii = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Ii(t, e);
}
function i0(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Ii(t, e);
}
var cl = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function s0(t, e) {
  return !!(t === e || cl(t) && cl(e));
}
function a0(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!s0(t[n], e[n]))
      return !1;
  return !0;
}
function si(t, e) {
  e === void 0 && (e = a0);
  var n, r = [], o, i = !1;
  function a() {
    for (var s = [], l = 0; l < arguments.length; l++)
      s[l] = arguments[l];
    return i && n === this && e(s, r) || (o = t.apply(this, s), i = !0, n = this, r = s), o;
  }
  return a;
}
var l0 = typeof performance == "object" && typeof performance.now == "function", ul = l0 ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function dl(t) {
  cancelAnimationFrame(t.id);
}
function c0(t, e) {
  var n = ul();
  function r() {
    ul() - n >= e ? t.call(null) : o.id = requestAnimationFrame(r);
  }
  var o = {
    id: requestAnimationFrame(r)
  };
  return o;
}
var ai = -1;
function fl(t) {
  if (t === void 0 && (t = !1), ai === -1 || t) {
    var e = document.createElement("div"), n = e.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", document.body.appendChild(e), ai = e.offsetWidth - e.clientWidth, document.body.removeChild(e);
  }
  return ai;
}
var Pn = null;
function ml(t) {
  if (t === void 0 && (t = !1), Pn === null || t) {
    var e = document.createElement("div"), n = e.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    var r = document.createElement("div"), o = r.style;
    return o.width = "100px", o.height = "100px", e.appendChild(r), document.body.appendChild(e), e.scrollLeft > 0 ? Pn = "positive-descending" : (e.scrollLeft = 1, e.scrollLeft === 0 ? Pn = "negative" : Pn = "positive-ascending"), document.body.removeChild(e), Pn;
  }
  return Pn;
}
process.env.NODE_ENV;
var u0 = 150, d0 = function(e, n) {
  return e;
}, Wr = null, $r = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (Wr = /* @__PURE__ */ new WeakSet(), $r = /* @__PURE__ */ new WeakSet());
function f0(t) {
  var e, n = t.getItemOffset, r = t.getEstimatedTotalSize, o = t.getItemSize, i = t.getOffsetForIndexAndAlignment, a = t.getStartIndexForOffset, s = t.getStopIndexForStartIndex, l = t.initInstanceProps, c = t.shouldResetStyleCacheOnItemSizeChange, d = t.validateProps;
  return e = /* @__PURE__ */ function(u) {
    i0(m, u);
    function m(v) {
      var f;
      return f = u.call(this, v) || this, f._instanceProps = l(f.props, ll(f)), f._outerRef = void 0, f._resetIsScrollingTimeoutId = null, f.state = {
        instance: ll(f),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof f.props.initialScrollOffset == "number" ? f.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, f._callOnItemsRendered = void 0, f._callOnItemsRendered = si(function(p, g, y, w) {
        return f.props.onItemsRendered({
          overscanStartIndex: p,
          overscanStopIndex: g,
          visibleStartIndex: y,
          visibleStopIndex: w
        });
      }), f._callOnScroll = void 0, f._callOnScroll = si(function(p, g, y) {
        return f.props.onScroll({
          scrollDirection: p,
          scrollOffset: g,
          scrollUpdateWasRequested: y
        });
      }), f._getItemStyle = void 0, f._getItemStyle = function(p) {
        var g = f.props, y = g.direction, w = g.itemSize, C = g.layout, S = f._getItemStyleCache(c && w, c && C, c && y), P;
        if (S.hasOwnProperty(p))
          P = S[p];
        else {
          var E = n(f.props, p, f._instanceProps), N = o(f.props, p, f._instanceProps), T = y === "horizontal" || C === "horizontal", k = y === "rtl", D = T ? E : 0;
          S[p] = P = {
            position: "absolute",
            left: k ? void 0 : D,
            right: k ? D : void 0,
            top: T ? 0 : E,
            height: T ? "100%" : N,
            width: T ? N : "100%"
          };
        }
        return P;
      }, f._getItemStyleCache = void 0, f._getItemStyleCache = si(function(p, g, y) {
        return {};
      }), f._onScrollHorizontal = function(p) {
        var g = p.currentTarget, y = g.clientWidth, w = g.scrollLeft, C = g.scrollWidth;
        f.setState(function(S) {
          if (S.scrollOffset === w)
            return null;
          var P = f.props.direction, E = w;
          if (P === "rtl")
            switch (ml()) {
              case "negative":
                E = -w;
                break;
              case "positive-descending":
                E = C - y - w;
                break;
            }
          return E = Math.max(0, Math.min(E, C - y)), {
            isScrolling: !0,
            scrollDirection: S.scrollOffset < E ? "forward" : "backward",
            scrollOffset: E,
            scrollUpdateWasRequested: !1
          };
        }, f._resetIsScrollingDebounced);
      }, f._onScrollVertical = function(p) {
        var g = p.currentTarget, y = g.clientHeight, w = g.scrollHeight, C = g.scrollTop;
        f.setState(function(S) {
          if (S.scrollOffset === C)
            return null;
          var P = Math.max(0, Math.min(C, w - y));
          return {
            isScrolling: !0,
            scrollDirection: S.scrollOffset < P ? "forward" : "backward",
            scrollOffset: P,
            scrollUpdateWasRequested: !1
          };
        }, f._resetIsScrollingDebounced);
      }, f._outerRefSetter = function(p) {
        var g = f.props.outerRef;
        f._outerRef = p, typeof g == "function" ? g(p) : g != null && typeof g == "object" && g.hasOwnProperty("current") && (g.current = p);
      }, f._resetIsScrollingDebounced = function() {
        f._resetIsScrollingTimeoutId !== null && dl(f._resetIsScrollingTimeoutId), f._resetIsScrollingTimeoutId = c0(f._resetIsScrolling, u0);
      }, f._resetIsScrolling = function() {
        f._resetIsScrollingTimeoutId = null, f.setState({
          isScrolling: !1
        }, function() {
          f._getItemStyleCache(-1, null);
        });
      }, f;
    }
    m.getDerivedStateFromProps = function(f, p) {
      return m0(f, p), d(f), null;
    };
    var h = m.prototype;
    return h.scrollTo = function(f) {
      f = Math.max(0, f), this.setState(function(p) {
        return p.scrollOffset === f ? null : {
          scrollDirection: p.scrollOffset < f ? "forward" : "backward",
          scrollOffset: f,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, h.scrollToItem = function(f, p) {
      p === void 0 && (p = "auto");
      var g = this.props, y = g.itemCount, w = g.layout, C = this.state.scrollOffset;
      f = Math.max(0, Math.min(f, y - 1));
      var S = 0;
      if (this._outerRef) {
        var P = this._outerRef;
        w === "vertical" ? S = P.scrollWidth > P.clientWidth ? fl() : 0 : S = P.scrollHeight > P.clientHeight ? fl() : 0;
      }
      this.scrollTo(i(this.props, f, p, C, this._instanceProps, S));
    }, h.componentDidMount = function() {
      var f = this.props, p = f.direction, g = f.initialScrollOffset, y = f.layout;
      if (typeof g == "number" && this._outerRef != null) {
        var w = this._outerRef;
        p === "horizontal" || y === "horizontal" ? w.scrollLeft = g : w.scrollTop = g;
      }
      this._callPropsCallbacks();
    }, h.componentDidUpdate = function() {
      var f = this.props, p = f.direction, g = f.layout, y = this.state, w = y.scrollOffset, C = y.scrollUpdateWasRequested;
      if (C && this._outerRef != null) {
        var S = this._outerRef;
        if (p === "horizontal" || g === "horizontal")
          if (p === "rtl")
            switch (ml()) {
              case "negative":
                S.scrollLeft = -w;
                break;
              case "positive-ascending":
                S.scrollLeft = w;
                break;
              default:
                var P = S.clientWidth, E = S.scrollWidth;
                S.scrollLeft = E - P - w;
                break;
            }
          else
            S.scrollLeft = w;
        else
          S.scrollTop = w;
      }
      this._callPropsCallbacks();
    }, h.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && dl(this._resetIsScrollingTimeoutId);
    }, h.render = function() {
      var f = this.props, p = f.children, g = f.className, y = f.direction, w = f.height, C = f.innerRef, S = f.innerElementType, P = f.innerTagName, E = f.itemCount, N = f.itemData, T = f.itemKey, k = T === void 0 ? d0 : T, D = f.layout, F = f.outerElementType, O = f.outerTagName, _ = f.style, L = f.useIsScrolling, I = f.width, R = this.state.isScrolling, A = y === "horizontal" || D === "horizontal", M = A ? this._onScrollHorizontal : this._onScrollVertical, W = this._getRangeToRender(), z = W[0], K = W[1], j = [];
      if (E > 0)
        for (var G = z; G <= K; G++)
          j.push(Bo(p, {
            data: N,
            key: k(G, N),
            index: G,
            isScrolling: L ? R : void 0,
            style: this._getItemStyle(G)
          }));
      var J = r(this.props, this._instanceProps);
      return Bo(F || O || "div", {
        className: g,
        onScroll: M,
        ref: this._outerRefSetter,
        style: Ti({
          position: "relative",
          height: w,
          width: I,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: y
        }, _)
      }, Bo(S || P || "div", {
        children: j,
        ref: C,
        style: {
          height: A ? "100%" : J,
          pointerEvents: R ? "none" : void 0,
          width: A ? J : "100%"
        }
      }));
    }, h._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var f = this.props.itemCount;
        if (f > 0) {
          var p = this._getRangeToRender(), g = p[0], y = p[1], w = p[2], C = p[3];
          this._callOnItemsRendered(g, y, w, C);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var S = this.state, P = S.scrollDirection, E = S.scrollOffset, N = S.scrollUpdateWasRequested;
        this._callOnScroll(P, E, N);
      }
    }, h._getRangeToRender = function() {
      var f = this.props, p = f.itemCount, g = f.overscanCount, y = this.state, w = y.isScrolling, C = y.scrollDirection, S = y.scrollOffset;
      if (p === 0)
        return [0, 0, 0, 0];
      var P = a(this.props, S, this._instanceProps), E = s(this.props, P, S, this._instanceProps), N = !w || C === "backward" ? Math.max(1, g) : 1, T = !w || C === "forward" ? Math.max(1, g) : 1;
      return [Math.max(0, P - N), Math.max(0, Math.min(p - 1, E + T)), P, E];
    }, m;
  }(Rm), e.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, e;
}
var m0 = function(e, n) {
  var r = e.children, o = e.direction, i = e.height, a = e.layout, s = e.innerTagName, l = e.outerTagName, c = e.width, d = n.instance;
  if (process.env.NODE_ENV !== "production") {
    (s != null || l != null) && $r && !$r.has(d) && ($r.add(d), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var u = o === "horizontal" || a === "horizontal";
    switch (o) {
      case "horizontal":
      case "vertical":
        Wr && !Wr.has(d) && (Wr.add(d), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + o + '" was specified.'));
    }
    switch (a) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + a + '" was specified.'));
    }
    if (r == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    if (u && typeof c != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (c === null ? "null" : typeof c) + '" was specified.'));
    if (!u && typeof i != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (i === null ? "null" : typeof i) + '" was specified.'));
  }
}, h0 = /* @__PURE__ */ f0({
  getItemOffset: function(e, n) {
    var r = e.itemSize;
    return n * r;
  },
  getItemSize: function(e, n) {
    var r = e.itemSize;
    return r;
  },
  getEstimatedTotalSize: function(e) {
    var n = e.itemCount, r = e.itemSize;
    return r * n;
  },
  getOffsetForIndexAndAlignment: function(e, n, r, o, i, a) {
    var s = e.direction, l = e.height, c = e.itemCount, d = e.itemSize, u = e.layout, m = e.width, h = s === "horizontal" || u === "horizontal", v = h ? m : l, f = Math.max(0, c * d - v), p = Math.min(f, n * d), g = Math.max(0, n * d - v + d + a);
    switch (r === "smart" && (o >= g - v && o <= p + v ? r = "auto" : r = "center"), r) {
      case "start":
        return p;
      case "end":
        return g;
      case "center": {
        var y = Math.round(g + (p - g) / 2);
        return y < Math.ceil(v / 2) ? 0 : y > f + Math.floor(v / 2) ? f : y;
      }
      case "auto":
      default:
        return o >= g && o <= p ? o : o < g ? g : p;
    }
  },
  getStartIndexForOffset: function(e, n) {
    var r = e.itemCount, o = e.itemSize;
    return Math.max(0, Math.min(r - 1, Math.floor(n / o)));
  },
  getStopIndexForStartIndex: function(e, n, r) {
    var o = e.direction, i = e.height, a = e.itemCount, s = e.itemSize, l = e.layout, c = e.width, d = o === "horizontal" || l === "horizontal", u = n * s, m = d ? c : i, h = Math.ceil((m + r - u) / s);
    return Math.max(0, Math.min(
      a - 1,
      n + h - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(e) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(e) {
    var n = e.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof n != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
  }
});
function yn(t) {
  const e = ee(8);
  let n, r;
  e[0] !== t ? ({
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  let o;
  e[3] !== n ? (o = H("text-grayscale-dark", n), e[3] = n, e[4] = o) : o = e[4];
  let i;
  return e[5] !== r || e[6] !== o ? (i = /* @__PURE__ */ b(ve, { step: "-1", weight: "semibold", as: "label", className: o, ...r }), e[5] = r, e[6] = o, e[7] = i) : i = e[7], i;
}
const li = H("gap-lg px-sm py-xs relative flex items-center justify-between font-semibold transition-colors select-none", "aria-disabled:text-grayscale data-[active-item=true]:bg-grayscale-xx-light aria-disabled:pointer-events-none"), hl = "group col-start-2 col-end-2 row-start-1 justify-self-end mr-sm";
function p0(t) {
  const e = ee(87), {
    size: n,
    groups: r,
    placeholder: o,
    defaultValue: i,
    noOptionsMessage: a,
    loading: s,
    loadingMessage: l,
    name: c,
    label: d,
    PrefixIcon: u,
    onChange: m,
    onInputChange: h
  } = t, v = n === void 0 ? "large" : n, [f, p] = le(!1), [g, y] = le(""), w = nn(), C = r.reduce(b0, []);
  let S;
  e[0] !== i ? (S = (V) => V.value === i, e[0] = i, e[1] = S) : S = e[1];
  const P = C.find(S), E = (P == null ? void 0 : P.label) || "", [N, T] = le(E || ""), k = {};
  C.forEach((V) => k[V.label] = V.value);
  let D, F;
  if (e[2] !== r || e[3] !== g) {
    let V;
    e[6] !== g ? (V = (se, me) => {
      const de = dd(me.items, g, {
        keys: ["label"]
      });
      return de.length > 0 && se.push({
        ...me,
        items: de
      }), se;
    }, e[6] = g, e[7] = V) : V = e[7], D = r.reduce(V, []), F = D.flatMap(g0), F.shift(), F.forEach((se, me) => {
      se.isGroupName && !se.label && F.splice(me, 1);
    }), e[2] = r, e[3] = g, e[4] = D, e[5] = F;
  } else
    D = e[4], F = e[5];
  const O = pe(null), _ = pe(null), L = v === "large" ? "size-md" : "size-sm";
  let I;
  e[8] !== L ? (I = H("animate-spin", L), e[8] = L, e[9] = I) : I = e[9];
  let R;
  e[10] !== I ? (R = /* @__PURE__ */ b(Gi, { className: I }), e[10] = I, e[11] = R) : R = e[11];
  let A;
  e[12] !== l || e[13] !== R ? (A = /* @__PURE__ */ $(ii, { className: li, disabled: !0, children: [
    l,
    R
  ] }), e[12] = l, e[13] = R, e[14] = A) : A = e[14];
  const M = A;
  let W;
  e[15] !== F ? (W = (V) => {
    const {
      index: se,
      style: me
    } = V, de = F[se];
    return de.isSeparator ? /* @__PURE__ */ b("div", { "aria-hidden": !0, style: me, className: "px-2xs flex flex-col justify-center", children: /* @__PURE__ */ b("div", { className: "bg-grayscale-x-light h-[1px]" }) }) : de.isGroupName ? /* @__PURE__ */ b(FS, { style: me, className: "px-sm py-xs text-grayscale font-normal", children: de.label }) : /* @__PURE__ */ b(ii, { style: me, focusOnHover: !0, value: de.label, disabled: de == null ? void 0 : de.disabled, className: li, children: de.label });
  }, e[15] = F, e[16] = W) : W = e[16];
  const z = W;
  let K;
  e[17] !== k || e[18] !== m || e[19] !== T ? (K = (V) => {
    T(V), m == null || m(V ? k[V] : "");
  }, e[17] = k, e[18] = m, e[19] = T, e[20] = K) : K = e[20];
  const j = K;
  let G;
  e[21] !== j || e[22] !== h || e[23] !== N ? (G = (V) => {
    Am(() => y(V)), h == null || h(V), !V && N && j("");
  }, e[21] = j, e[22] = h, e[23] = N, e[24] = G) : G = e[24];
  let J;
  e[25] !== j ? (J = (V) => j(V), e[25] = j, e[26] = J) : J = e[26];
  let oe;
  e[27] !== w || e[28] !== d ? (oe = d && /* @__PURE__ */ b(HS, { render: /* @__PURE__ */ b(yn, { htmlFor: w, children: d }) }), e[27] = w, e[28] = d, e[29] = oe) : oe = e[29];
  let Y;
  e[30] !== k || e[31] !== c || e[32] !== N ? (Y = c && /* @__PURE__ */ b("input", { readOnly: !0, type: "text", name: c, value: N ? k[N] : "", "aria-hidden": !0, className: "hidden", "data-testid": "hidden-combobox-input" }), e[30] = k, e[31] = c, e[32] = N, e[33] = Y) : Y = e[33];
  let Z;
  e[34] !== u || e[35] !== v ? (Z = H(pn({
    fieldType: "dropdown",
    size: v
  }), "col-start-1 col-end-3 row-start-1 focus-visible:ring-0 focus-visible:ring-offset-0 aria-expanded:shadow-sm", u && v === "large" && "pl-xl", u && v === "medium" && "pl-[36px]!"), e[34] = u, e[35] = v, e[36] = Z) : Z = e[36];
  let ie;
  e[37] !== w || e[38] !== o || e[39] !== Z ? (ie = /* @__PURE__ */ b(TS, { id: w, ref: O, placeholder: o, className: Z }), e[37] = w, e[38] = o, e[39] = Z, e[40] = ie) : ie = e[40];
  let te;
  e[41] !== u || e[42] !== L || e[43] !== v ? (te = u ? /* @__PURE__ */ b("span", { className: H("absolute", v === "large" ? "left-sm" : "left-xs"), children: /* @__PURE__ */ b(u, { className: H("text-grayscale", L), role: "img" }) }) : null, e[41] = u, e[42] = L, e[43] = v, e[44] = te) : te = e[44];
  let ne;
  e[45] !== L || e[46] !== g || e[47] !== v ? (ne = g ? /* @__PURE__ */ b(DS, { className: H(hl, v === "medium" && "mr-xs"), children: /* @__PURE__ */ b(Wn, { className: H("text-grayscale", L) }) }) : /* @__PURE__ */ b(zc, { className: H(hl, v === "medium" && "mr-xs"), children: /* @__PURE__ */ b(zr, { className: H("text-grayscale transition-all ease-out group-aria-expanded:rotate-180", L) }) }), e[45] = L, e[46] = g, e[47] = v, e[48] = ne) : ne = e[48];
  let re;
  e[49] !== ie || e[50] !== te || e[51] !== ne ? (re = /* @__PURE__ */ b(Bc, { asChild: !0, children: /* @__PURE__ */ $("div", { className: "grid grid-cols-2 items-center p-0!", children: [
    ie,
    te,
    ne
  ] }) }), e[49] = ie, e[50] = te, e[51] = ne, e[52] = re) : re = e[52];
  let xe;
  e[53] !== Y || e[54] !== re ? (xe = /* @__PURE__ */ $("div", { className: "lasagne-combobox", children: [
    Y,
    re
  ] }), e[53] = Y, e[54] = re, e[55] = xe) : xe = e[55];
  let Ee;
  e[56] !== oe || e[57] !== xe ? (Ee = /* @__PURE__ */ $("div", { className: "gap-2xs flex flex-col", children: [
    oe,
    xe
  ] }), e[56] = oe, e[57] = xe, e[58] = Ee) : Ee = e[58];
  const Ke = v === "large" ? Qe.size.large : Qe.size.medium;
  let Ae;
  e[59] !== Ke ? (Ae = H("z-10", Ke), e[59] = Ke, e[60] = Ae) : Ae = e[60];
  let Ge;
  e[61] === Symbol.for("react.memo_cache_sentinel") ? (Ge = (V) => {
    var Fe;
    const se = V.target, me = se === O.current, de = se && ((Fe = _ == null ? void 0 : _.current) == null ? void 0 : Fe.contains(se));
    (me || de) && V.preventDefault();
  }, e[61] = Ge) : Ge = e[61];
  let nt;
  e[62] !== z || e[63] !== F.length || e[64] !== s || e[65] !== M ? (nt = s ? M : /* @__PURE__ */ b(h0, { height: Math.min(F.length * 47, 800), itemCount: F.length, itemSize: 47, children: z }), e[62] = z, e[63] = F.length, e[64] = s, e[65] = M, e[66] = nt) : nt = e[66];
  let Ve;
  e[67] !== D.length || e[68] !== s || e[69] !== a ? (Ve = D.length < 1 && !s ? /* @__PURE__ */ b(ii, { className: li, disabled: !0, children: a }) : null, e[67] = D.length, e[68] = s, e[69] = a, e[70] = Ve) : Ve = e[70];
  let wt;
  e[71] !== nt || e[72] !== Ve ? (wt = /* @__PURE__ */ $(US, { ref: _, role: "listbox", className: "ComboboxContent border-grayscale-x-light relative overflow-y-hidden rounded-b-md border border-t-0 border-solid bg-white", children: [
    nt,
    Ve
  ] }), e[71] = nt, e[72] = Ve, e[73] = wt) : wt = e[73];
  let xt;
  e[74] !== Ae || e[75] !== wt ? (xt = /* @__PURE__ */ b(Hc, { className: Ae, sideOffset: 10, side: "bottom", avoidCollisions: !1, asChild: !0, onOpenAutoFocus: v0, onInteractOutside: Ge, children: wt }), e[74] = Ae, e[75] = wt, e[76] = xt) : xt = e[76];
  let ut;
  e[77] !== E || e[78] !== f || e[79] !== Ee || e[80] !== xt || e[81] !== G || e[82] !== J ? (ut = /* @__PURE__ */ $(IS, { defaultValue: E, open: f, setOpen: p, setValue: G, setSelectedValue: J, children: [
    Ee,
    xt
  ] }), e[77] = E, e[78] = f, e[79] = Ee, e[80] = xt, e[81] = G, e[82] = J, e[83] = ut) : ut = e[83];
  let St;
  return e[84] !== f || e[85] !== ut ? (St = /* @__PURE__ */ b(Vc, { open: f, onOpenChange: p, children: ut }), e[84] = f, e[85] = ut, e[86] = St) : St = e[86], St;
}
function v0(t) {
  return t.preventDefault();
}
function g0(t) {
  return [{
    isSeparator: !0
  }, {
    label: t.groupName,
    isGroupName: !0
  }, ...t.items];
}
function b0(t, e) {
  return [...t, ...e.items];
}
const pP = (t) => {
  var I;
  const e = ee(39), {
    size: n,
    onChange: r,
    className: o,
    language: i,
    name: a,
    placeholder: s,
    defaultValue: l,
    label: c,
    popoverProps: d
  } = t, u = n === void 0 ? "large" : n, m = i === void 0 ? "fr" : i, [h, v] = le(l), [f, p] = le(!1), g = nn();
  let y;
  e[0] !== r ? (y = (R) => {
    v(R), p(!1), r == null || r(R);
  }, e[0] = r, e[1] = y) : y = e[1];
  const w = y;
  let C;
  e[2] !== a || e[3] !== h ? (C = a ? /* @__PURE__ */ b("input", { readOnly: !0, type: "text", name: a, value: h ? ny(h) : void 0, className: "hidden", "data-testid": "hidden-date-input" }) : null, e[2] = a, e[3] = h, e[4] = C) : C = e[4];
  let S;
  e[5] !== g || e[6] !== c ? (S = c && /* @__PURE__ */ b(yn, { className: "mb-2xs inline-block", htmlFor: g, children: c }), e[5] = g, e[6] = c, e[7] = S) : S = e[7];
  let P;
  e[8] !== o || e[9] !== u ? (P = H(pn({
    fieldType: "input",
    size: u,
    className: o
  }), "gap-xs flex w-full cursor-pointer flex-row items-center", o), e[8] = o, e[9] = u, e[10] = P) : P = e[10];
  const E = u === "large" ? "size-md" : "size-sm";
  let N;
  e[11] !== E ? (N = H("shrink-0", E), e[11] = E, e[12] = N) : N = e[12];
  let T;
  e[13] !== N ? (T = /* @__PURE__ */ b(Bc, { asChild: !0, children: /* @__PURE__ */ b(Bm, { className: N, role: "img" }) }), e[13] = N, e[14] = T) : T = e[14];
  let k;
  e[15] !== m || e[16] !== h ? (k = h == null ? void 0 : h.toLocaleDateString((I = gu[m]) == null ? void 0 : I.code, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  }), e[15] = m, e[16] = h, e[17] = k) : k = e[17];
  let D;
  e[18] !== g || e[19] !== s || e[20] !== k ? (D = /* @__PURE__ */ b("input", { id: g, className: "placeholder:text-grayscale-light pl-xs border-grayscale-x-light pointer-events-none w-full border-l select-none", placeholder: s, value: k, tabIndex: -1, readOnly: !0 }), e[18] = g, e[19] = s, e[20] = k, e[21] = D) : D = e[21];
  let F;
  e[22] !== D || e[23] !== P || e[24] !== T ? (F = /* @__PURE__ */ $("button", { className: P, children: [
    T,
    D
  ] }), e[22] = D, e[23] = P, e[24] = T, e[25] = F) : F = e[25];
  let O;
  e[26] !== w || e[27] !== m || e[28] !== h ? (O = /* @__PURE__ */ b(Yw, { onChange: w, selected: h, defaultMonth: h, language: m }), e[26] = w, e[27] = m, e[28] = h, e[29] = O) : O = e[29];
  let _;
  e[30] !== f || e[31] !== d || e[32] !== F || e[33] !== O ? (_ = /* @__PURE__ */ b(gs, { ...d, align: "center", sideOffset: 18, modal: !0, isOpen: f, setIsOpen: p, trigger: F, children: O }), e[30] = f, e[31] = d, e[32] = F, e[33] = O, e[34] = _) : _ = e[34];
  let L;
  return e[35] !== _ || e[36] !== C || e[37] !== S ? (L = /* @__PURE__ */ $("div", { children: [
    C,
    S,
    _
  ] }), e[35] = _, e[36] = C, e[37] = S, e[38] = L) : L = e[38], L;
};
var Po = "Dialog", [fd, vP] = Ye(Po), [y0, yt] = fd(Po), md = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !0
  } = t, s = x.useRef(null), l = x.useRef(null), [c, d] = je({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Po
  });
  return /* @__PURE__ */ b(
    y0,
    {
      scope: e,
      triggerRef: s,
      contentRef: l,
      contentId: st(),
      titleId: st(),
      descriptionId: st(),
      open: c,
      onOpenChange: d,
      onOpenToggle: x.useCallback(() => d((u) => !u), [d]),
      modal: a,
      children: n
    }
  );
};
md.displayName = Po;
var hd = "DialogTrigger", pd = x.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = yt(hd, n), i = ae(e, o.triggerRef);
    return /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Ws(o.open),
        ...r,
        ref: i,
        onClick: U(t.onClick, o.onOpenToggle)
      }
    );
  }
);
pd.displayName = hd;
var Fs = "DialogPortal", [w0, vd] = fd(Fs, {
  forceMount: void 0
}), gd = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: o } = t, i = yt(Fs, e);
  return /* @__PURE__ */ b(w0, { scope: e, forceMount: n, children: x.Children.map(r, (a) => /* @__PURE__ */ b(tt, { present: n || i.open, children: /* @__PURE__ */ b(Yn, { asChild: !0, container: o, children: a }) })) });
};
gd.displayName = Fs;
var Qr = "DialogOverlay", bd = x.forwardRef(
  (t, e) => {
    const n = vd(Qr, t.__scopeDialog), { forceMount: r = n.forceMount, ...o } = t, i = yt(Qr, t.__scopeDialog);
    return i.modal ? /* @__PURE__ */ b(tt, { present: r || i.open, children: /* @__PURE__ */ b(S0, { ...o, ref: e }) }) : null;
  }
);
bd.displayName = Qr;
var x0 = /* @__PURE__ */ Mn("DialogOverlay.RemoveScroll"), S0 = x.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = yt(Qr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ b(po, { as: x0, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ b(
        q.div,
        {
          "data-state": Ws(o.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), fn = "DialogContent", yd = x.forwardRef(
  (t, e) => {
    const n = vd(fn, t.__scopeDialog), { forceMount: r = n.forceMount, ...o } = t, i = yt(fn, t.__scopeDialog);
    return /* @__PURE__ */ b(tt, { present: r || i.open, children: i.modal ? /* @__PURE__ */ b(C0, { ...o, ref: e }) : /* @__PURE__ */ b(E0, { ...o, ref: e }) });
  }
);
yd.displayName = fn;
var C0 = x.forwardRef(
  (t, e) => {
    const n = yt(fn, t.__scopeDialog), r = x.useRef(null), o = ae(e, n.contentRef, r);
    return x.useEffect(() => {
      const i = r.current;
      if (i) return ps(i);
    }, []), /* @__PURE__ */ b(
      wd,
      {
        ...t,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: U(t.onCloseAutoFocus, (i) => {
          var a;
          i.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: U(t.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: U(
          t.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), E0 = x.forwardRef(
  (t, e) => {
    const n = yt(fn, t.__scopeDialog), r = x.useRef(!1), o = x.useRef(!1);
    return /* @__PURE__ */ b(
      wd,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, s;
          (a = t.onCloseAutoFocus) == null || a.call(t, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), wd = x.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = t, s = yt(fn, n), l = x.useRef(null), c = ae(e, l);
    return ns(), /* @__PURE__ */ $(Ce, { children: [
      /* @__PURE__ */ b(
        lo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ b(
            Vn,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Ws(s.open),
              ...a,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ $(Ce, { children: [
        /* @__PURE__ */ b(P0, { titleId: s.titleId }),
        /* @__PURE__ */ b(O0, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Ls = "DialogTitle", xd = x.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = yt(Ls, n);
    return /* @__PURE__ */ b(q.h2, { id: o.titleId, ...r, ref: e });
  }
);
xd.displayName = Ls;
var Sd = "DialogDescription", Cd = x.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = yt(Sd, n);
    return /* @__PURE__ */ b(q.p, { id: o.descriptionId, ...r, ref: e });
  }
);
Cd.displayName = Sd;
var Ed = "DialogClose", Pd = x.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = yt(Ed, n);
    return /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: U(t.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Pd.displayName = Ed;
function Ws(t) {
  return t ? "open" : "closed";
}
var Nd = "DialogTitleWarning", [gP, Od] = Jm(Nd, {
  contentName: fn,
  titleName: Ls,
  docsSlug: "dialog"
}), P0 = ({ titleId: t }) => {
  const e = Od(Nd), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return x.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, N0 = "DialogDescriptionWarning", O0 = ({ contentRef: t, descriptionId: e }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Od(N0).contentName}}.`;
  return x.useEffect(() => {
    var i;
    const o = (i = t.current) == null ? void 0 : i.getAttribute("aria-describedby");
    e && o && (document.getElementById(e) || console.warn(r));
  }, [r, t, e]), null;
}, T0 = md, I0 = pd, M0 = gd, k0 = bd, _0 = yd, D0 = xd, R0 = Cd, ci = Pd;
function bP(t) {
  const e = ee(34), {
    trigger: n,
    title: r,
    description: o,
    warningMessage: i,
    primaryAction: a,
    secondaryAction: s,
    portalContainer: l,
    size: c,
    children: d
  } = t, u = c === void 0 ? "small" : c;
  let m;
  e[0] !== n ? (m = /* @__PURE__ */ b(I0, { asChild: !0, children: n }), e[0] = n, e[1] = m) : m = e[1];
  const h = u === "small" ? "max-w-[576px]" : "max-w-[1080px]";
  let v;
  e[2] !== h ? (v = H("border-grayscale-xx-light p-lg text-main z-50 max-h-full w-11/12 overflow-y-auto rounded-lg border bg-white shadow-xl duration-200 focus-visible:outline-hidden", h, ["radix-state-closed:animate-out", "radix-state-closed:fade-out-0", "radix-state-closed:zoom-out-95", "radix-state-open:animate-in", "radix-state-open:fade-in-0", "radix-state-open:zoom-in-95"]), e[2] = h, e[3] = v) : v = e[3];
  let f;
  e[4] !== o ? (f = o ? {} : {
    "aria-describedby": void 0
  }, e[4] = o, e[5] = f) : f = e[5];
  let p;
  e[6] !== r ? (p = /* @__PURE__ */ b(D0, { asChild: !0, children: /* @__PURE__ */ b(ve, { step: "2", weight: "bold", children: r }) }), e[6] = r, e[7] = p) : p = e[7];
  let g;
  e[8] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ b(ci, { asChild: !0, children: /* @__PURE__ */ b($t, { Icon: Wn, shape: "link", size: "medium", className: "!p-none self-start" }) }), e[8] = g) : g = e[8];
  let y;
  e[9] !== p ? (y = /* @__PURE__ */ $("div", { className: "gap-x-md flex justify-between", children: [
    p,
    g
  ] }), e[9] = p, e[10] = y) : y = e[10];
  let w;
  e[11] !== o ? (w = o ? /* @__PURE__ */ b(R0, { asChild: !0, children: /* @__PURE__ */ b(ve, { className: "mt-sm text-grayscale-dark", children: o }) }) : null, e[11] = o, e[12] = w) : w = e[12];
  let C;
  e[13] !== i ? (C = i ? /* @__PURE__ */ b("div", { className: "mt-sm bg-negative-xx-light p-2xs rounded-md", children: /* @__PURE__ */ b(ve, { className: "text-grayscale-dark", children: i }) }) : null, e[13] = i, e[14] = C) : C = e[14];
  let S;
  e[15] !== d ? (S = d ? /* @__PURE__ */ b("div", { className: "mt-lg", children: d }) : null, e[15] = d, e[16] = S) : S = e[16];
  let P;
  e[17] !== a || e[18] !== s ? (P = a ? /* @__PURE__ */ $("div", { className: "mt-lg gap-x-md flex items-center justify-center", children: [
    !!s && /* @__PURE__ */ b(ci, { asChild: !0, children: /* @__PURE__ */ b($t, { shape: "link", intent: "primary", type: (s == null ? void 0 : s.buttonType) || "button", onClick: s == null ? void 0 : s.onClick, children: s == null ? void 0 : s.buttonText }) }),
    /* @__PURE__ */ b(ci, { asChild: !0, children: /* @__PURE__ */ b($t, { shape: "solid", intent: "primary", type: a.buttonType || "button", onClick: a.onClick, children: a.buttonText }) })
  ] }) : null, e[17] = a, e[18] = s, e[19] = P) : P = e[19];
  let E;
  e[20] !== C || e[21] !== S || e[22] !== P || e[23] !== v || e[24] !== f || e[25] !== y || e[26] !== w ? (E = /* @__PURE__ */ b(k0, { className: "py-lg bg-grayscale-dark/[0.11] radix-state-closed:animate-out radix-state-closed:fade-out-0 radix-state-open:animate-in radix-state-open:fade-in-0 fixed inset-0 z-50 grid place-items-center backdrop-blur-sm", children: /* @__PURE__ */ $(_0, { className: v, ...f, children: [
    y,
    w,
    C,
    S,
    P
  ] }) }), e[20] = C, e[21] = S, e[22] = P, e[23] = v, e[24] = f, e[25] = y, e[26] = w, e[27] = E) : E = e[27];
  let N;
  e[28] !== l || e[29] !== E ? (N = /* @__PURE__ */ b(M0, { container: l, children: E }), e[28] = l, e[29] = E, e[30] = N) : N = e[30];
  let T;
  return e[31] !== N || e[32] !== m ? (T = /* @__PURE__ */ $(T0, { children: [
    m,
    N
  ] }), e[31] = N, e[32] = m, e[33] = T) : T = e[33], T;
}
function eo(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
var Td = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), A0 = "VisuallyHidden", No = x.forwardRef(
  (t, e) => /* @__PURE__ */ b(
    q.span,
    {
      ...t,
      ref: e,
      style: { ...Td, ...t.style }
    }
  )
);
No.displayName = A0;
var F0 = No, L0 = [" ", "Enter", "ArrowUp", "ArrowDown"], W0 = [" ", "Enter"], mn = "Select", [Oo, To, $0] = cr(mn), [jn, yP] = Ye(mn, [
  $0,
  Hn
]), Io = Hn(), [V0, sn] = jn(mn), [B0, z0] = jn(mn), Id = (t) => {
  const {
    __scopeSelect: e,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: d,
    autoComplete: u,
    disabled: m,
    required: h,
    form: v
  } = t, f = Io(e), [p, g] = x.useState(null), [y, w] = x.useState(null), [C, S] = x.useState(!1), P = $n(c), [E, N] = je({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: mn
  }), [T, k] = je({
    prop: a,
    defaultProp: s,
    onChange: l,
    caller: mn
  }), D = x.useRef(null), F = p ? v || !!p.closest("form") : !0, [O, _] = x.useState(/* @__PURE__ */ new Set()), L = Array.from(O).map((I) => I.props.value).join(";");
  return /* @__PURE__ */ b(fs, { ...f, children: /* @__PURE__ */ $(
    V0,
    {
      required: h,
      scope: e,
      trigger: p,
      onTriggerChange: g,
      valueNode: y,
      onValueNodeChange: w,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: S,
      contentId: st(),
      value: T,
      onValueChange: k,
      open: E,
      onOpenChange: N,
      dir: P,
      triggerPointerDownPosRef: D,
      disabled: m,
      children: [
        /* @__PURE__ */ b(Oo.Provider, { scope: e, children: /* @__PURE__ */ b(
          B0,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: x.useCallback((I) => {
              _((R) => new Set(R).add(I));
            }, []),
            onNativeOptionRemove: x.useCallback((I) => {
              _((R) => {
                const A = new Set(R);
                return A.delete(I), A;
              });
            }, []),
            children: n
          }
        ) }),
        F ? /* @__PURE__ */ $(
          ef,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: d,
            autoComplete: u,
            value: T,
            onChange: (I) => k(I.target.value),
            disabled: m,
            form: v,
            children: [
              T === void 0 ? /* @__PURE__ */ b("option", { value: "" }) : null,
              Array.from(O)
            ]
          },
          L
        ) : null
      ]
    }
  ) });
};
Id.displayName = mn;
var Md = "SelectTrigger", kd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = t, i = Io(n), a = sn(Md, n), s = a.disabled || r, l = ae(e, a.onTriggerChange), c = To(n), d = x.useRef("touch"), [u, m, h] = nf((f) => {
      const p = c().filter((w) => !w.disabled), g = p.find((w) => w.value === a.value), y = rf(p, f, g);
      y !== void 0 && a.onValueChange(y.value);
    }), v = (f) => {
      s || (a.onOpenChange(!0), h()), f && (a.triggerPointerDownPosRef.current = {
        x: Math.round(f.pageX),
        y: Math.round(f.pageY)
      });
    };
    return /* @__PURE__ */ b(mo, { asChild: !0, ...i, children: /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": tf(a.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: U(o.onClick, (f) => {
          f.currentTarget.focus(), d.current !== "mouse" && v(f);
        }),
        onPointerDown: U(o.onPointerDown, (f) => {
          d.current = f.pointerType;
          const p = f.target;
          p.hasPointerCapture(f.pointerId) && p.releasePointerCapture(f.pointerId), f.button === 0 && f.ctrlKey === !1 && f.pointerType === "mouse" && (v(f), f.preventDefault());
        }),
        onKeyDown: U(o.onKeyDown, (f) => {
          const p = u.current !== "";
          !(f.ctrlKey || f.altKey || f.metaKey) && f.key.length === 1 && m(f.key), !(p && f.key === " ") && L0.includes(f.key) && (v(), f.preventDefault());
        })
      }
    ) });
  }
);
kd.displayName = Md;
var _d = "SelectValue", Dd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: a = "", ...s } = t, l = sn(_d, n), { onValueNodeHasChildrenChange: c } = l, d = i !== void 0, u = ae(e, l.onValueNodeChange);
    return De(() => {
      c(d);
    }, [c, d]), /* @__PURE__ */ b(
      q.span,
      {
        ...s,
        ref: u,
        style: { pointerEvents: "none" },
        children: tf(l.value) ? /* @__PURE__ */ b(Ce, { children: a }) : i
      }
    );
  }
);
Dd.displayName = _d;
var H0 = "SelectIcon", Rd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, children: r, ...o } = t;
    return /* @__PURE__ */ b(q.span, { "aria-hidden": !0, ...o, ref: e, children: r || "▼" });
  }
);
Rd.displayName = H0;
var Y0 = "SelectPortal", Ad = (t) => /* @__PURE__ */ b(Yn, { asChild: !0, ...t });
Ad.displayName = Y0;
var hn = "SelectContent", Fd = x.forwardRef(
  (t, e) => {
    const n = sn(hn, t.__scopeSelect), [r, o] = x.useState();
    if (De(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? lr.createPortal(
        /* @__PURE__ */ b(Ld, { scope: t.__scopeSelect, children: /* @__PURE__ */ b(Oo.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ b("div", { children: t.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ b(Wd, { ...t, ref: e });
  }
);
Fd.displayName = hn;
var mt = 10, [Ld, an] = jn(hn), K0 = "SelectContentImpl", U0 = /* @__PURE__ */ Mn("SelectContent.RemoveScroll"), Wd = x.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: d,
      arrowPadding: u,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: f,
      avoidCollisions: p,
      //
      ...g
    } = t, y = sn(hn, n), [w, C] = x.useState(null), [S, P] = x.useState(null), E = ae(e, (Y) => C(Y)), [N, T] = x.useState(null), [k, D] = x.useState(
      null
    ), F = To(n), [O, _] = x.useState(!1), L = x.useRef(!1);
    x.useEffect(() => {
      if (w) return ps(w);
    }, [w]), ns();
    const I = x.useCallback(
      (Y) => {
        const [Z, ...ie] = F().map((re) => re.ref.current), [te] = ie.slice(-1), ne = document.activeElement;
        for (const re of Y)
          if (re === ne || (re == null || re.scrollIntoView({ block: "nearest" }), re === Z && S && (S.scrollTop = 0), re === te && S && (S.scrollTop = S.scrollHeight), re == null || re.focus(), document.activeElement !== ne)) return;
      },
      [F, S]
    ), R = x.useCallback(
      () => I([N, w]),
      [I, N, w]
    );
    x.useEffect(() => {
      O && R();
    }, [O, R]);
    const { onOpenChange: A, triggerPointerDownPosRef: M } = y;
    x.useEffect(() => {
      if (w) {
        let Y = { x: 0, y: 0 };
        const Z = (te) => {
          var ne, re;
          Y = {
            x: Math.abs(Math.round(te.pageX) - (((ne = M.current) == null ? void 0 : ne.x) ?? 0)),
            y: Math.abs(Math.round(te.pageY) - (((re = M.current) == null ? void 0 : re.y) ?? 0))
          };
        }, ie = (te) => {
          Y.x <= 10 && Y.y <= 10 ? te.preventDefault() : w.contains(te.target) || A(!1), document.removeEventListener("pointermove", Z), M.current = null;
        };
        return M.current !== null && (document.addEventListener("pointermove", Z), document.addEventListener("pointerup", ie, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Z), document.removeEventListener("pointerup", ie, { capture: !0 });
        };
      }
    }, [w, A, M]), x.useEffect(() => {
      const Y = () => A(!1);
      return window.addEventListener("blur", Y), window.addEventListener("resize", Y), () => {
        window.removeEventListener("blur", Y), window.removeEventListener("resize", Y);
      };
    }, [A]);
    const [W, z] = nf((Y) => {
      const Z = F().filter((ne) => !ne.disabled), ie = Z.find((ne) => ne.ref.current === document.activeElement), te = rf(Z, Y, ie);
      te && setTimeout(() => te.ref.current.focus());
    }), K = x.useCallback(
      (Y, Z, ie) => {
        const te = !L.current && !ie;
        (y.value !== void 0 && y.value === Z || te) && (T(Y), te && (L.current = !0));
      },
      [y.value]
    ), j = x.useCallback(() => w == null ? void 0 : w.focus(), [w]), G = x.useCallback(
      (Y, Z, ie) => {
        const te = !L.current && !ie;
        (y.value !== void 0 && y.value === Z || te) && D(Y);
      },
      [y.value]
    ), J = r === "popper" ? Mi : $d, oe = J === Mi ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: d,
      arrowPadding: u,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: f,
      avoidCollisions: p
    } : {};
    return /* @__PURE__ */ b(
      Ld,
      {
        scope: n,
        content: w,
        viewport: S,
        onViewportChange: P,
        itemRefCallback: K,
        selectedItem: N,
        onItemLeave: j,
        itemTextRefCallback: G,
        focusSelectedItem: R,
        selectedItemText: k,
        position: r,
        isPositioned: O,
        searchRef: W,
        children: /* @__PURE__ */ b(po, { as: U0, allowPinchZoom: !0, children: /* @__PURE__ */ b(
          lo,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (Y) => {
              Y.preventDefault();
            },
            onUnmountAutoFocus: U(o, (Y) => {
              var Z;
              (Z = y.trigger) == null || Z.focus({ preventScroll: !0 }), Y.preventDefault();
            }),
            children: /* @__PURE__ */ b(
              Vn,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (Y) => Y.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ b(
                  J,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (Y) => Y.preventDefault(),
                    ...g,
                    ...oe,
                    onPlaced: () => _(!0),
                    ref: E,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...g.style
                    },
                    onKeyDown: U(g.onKeyDown, (Y) => {
                      const Z = Y.ctrlKey || Y.altKey || Y.metaKey;
                      if (Y.key === "Tab" && Y.preventDefault(), !Z && Y.key.length === 1 && z(Y.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(Y.key)) {
                        let te = F().filter((ne) => !ne.disabled).map((ne) => ne.ref.current);
                        if (["ArrowUp", "End"].includes(Y.key) && (te = te.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(Y.key)) {
                          const ne = Y.target, re = te.indexOf(ne);
                          te = te.slice(re + 1);
                        }
                        setTimeout(() => I(te)), Y.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Wd.displayName = K0;
var j0 = "SelectItemAlignedPosition", $d = x.forwardRef((t, e) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = t, i = sn(hn, n), a = an(hn, n), [s, l] = x.useState(null), [c, d] = x.useState(null), u = ae(e, (E) => d(E)), m = To(n), h = x.useRef(!1), v = x.useRef(!0), { viewport: f, selectedItem: p, selectedItemText: g, focusSelectedItem: y } = a, w = x.useCallback(() => {
    if (i.trigger && i.valueNode && s && c && f && p && g) {
      const E = i.trigger.getBoundingClientRect(), N = c.getBoundingClientRect(), T = i.valueNode.getBoundingClientRect(), k = g.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ne = k.left - N.left, re = T.left - ne, xe = E.left - re, Ee = E.width + xe, Ke = Math.max(Ee, N.width), Ae = window.innerWidth - mt, Ge = eo(re, [
          mt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(mt, Ae - Ke)
        ]);
        s.style.minWidth = Ee + "px", s.style.left = Ge + "px";
      } else {
        const ne = N.right - k.right, re = window.innerWidth - T.right - ne, xe = window.innerWidth - E.right - re, Ee = E.width + xe, Ke = Math.max(Ee, N.width), Ae = window.innerWidth - mt, Ge = eo(re, [
          mt,
          Math.max(mt, Ae - Ke)
        ]);
        s.style.minWidth = Ee + "px", s.style.right = Ge + "px";
      }
      const D = m(), F = window.innerHeight - mt * 2, O = f.scrollHeight, _ = window.getComputedStyle(c), L = parseInt(_.borderTopWidth, 10), I = parseInt(_.paddingTop, 10), R = parseInt(_.borderBottomWidth, 10), A = parseInt(_.paddingBottom, 10), M = L + I + O + A + R, W = Math.min(p.offsetHeight * 5, M), z = window.getComputedStyle(f), K = parseInt(z.paddingTop, 10), j = parseInt(z.paddingBottom, 10), G = E.top + E.height / 2 - mt, J = F - G, oe = p.offsetHeight / 2, Y = p.offsetTop + oe, Z = L + I + Y, ie = M - Z;
      if (Z <= G) {
        const ne = D.length > 0 && p === D[D.length - 1].ref.current;
        s.style.bottom = "0px";
        const re = c.clientHeight - f.offsetTop - f.offsetHeight, xe = Math.max(
          J,
          oe + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ne ? j : 0) + re + R
        ), Ee = Z + xe;
        s.style.height = Ee + "px";
      } else {
        const ne = D.length > 0 && p === D[0].ref.current;
        s.style.top = "0px";
        const xe = Math.max(
          G,
          L + f.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ne ? K : 0) + oe
        ) + ie;
        s.style.height = xe + "px", f.scrollTop = Z - G + f.offsetTop;
      }
      s.style.margin = `${mt}px 0`, s.style.minHeight = W + "px", s.style.maxHeight = F + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    m,
    i.trigger,
    i.valueNode,
    s,
    c,
    f,
    p,
    g,
    i.dir,
    r
  ]);
  De(() => w(), [w]);
  const [C, S] = x.useState();
  De(() => {
    c && S(window.getComputedStyle(c).zIndex);
  }, [c]);
  const P = x.useCallback(
    (E) => {
      E && v.current === !0 && (w(), y == null || y(), v.current = !1);
    },
    [w, y]
  );
  return /* @__PURE__ */ b(
    q0,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: P,
      children: /* @__PURE__ */ b(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ b(
            q.div,
            {
              ...o,
              ref: u,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
$d.displayName = j0;
var G0 = "SelectPopperPosition", Mi = x.forwardRef((t, e) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = mt,
    ...i
  } = t, a = Io(n);
  return /* @__PURE__ */ b(
    ms,
    {
      ...a,
      ...i,
      ref: e,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Mi.displayName = G0;
var [q0, $s] = jn(hn, {}), ki = "SelectViewport", Vd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, nonce: r, ...o } = t, i = an(ki, n), a = $s(ki, n), s = ae(e, i.onViewportChange), l = x.useRef(0);
    return /* @__PURE__ */ $(Ce, { children: [
      /* @__PURE__ */ b(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ b(Oo.Slot, { scope: n, children: /* @__PURE__ */ b(
        q.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: U(o.onScroll, (c) => {
            const d = c.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: m } = a;
            if (m != null && m.current && u) {
              const h = Math.abs(l.current - d.scrollTop);
              if (h > 0) {
                const v = window.innerHeight - mt * 2, f = parseFloat(u.style.minHeight), p = parseFloat(u.style.height), g = Math.max(f, p);
                if (g < v) {
                  const y = g + h, w = Math.min(v, y), C = y - w;
                  u.style.height = w + "px", u.style.bottom === "0px" && (d.scrollTop = C > 0 ? C : 0, u.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Vd.displayName = ki;
var Bd = "SelectGroup", [X0, Z0] = jn(Bd), zd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, o = st();
    return /* @__PURE__ */ b(X0, { scope: n, id: o, children: /* @__PURE__ */ b(q.div, { role: "group", "aria-labelledby": o, ...r, ref: e }) });
  }
);
zd.displayName = Bd;
var Hd = "SelectLabel", Yd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, o = Z0(Hd, n);
    return /* @__PURE__ */ b(q.div, { id: o.id, ...r, ref: e });
  }
);
Yd.displayName = Hd;
var to = "SelectItem", [J0, Kd] = jn(to), Ud = x.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...a
    } = t, s = sn(to, n), l = an(to, n), c = s.value === r, [d, u] = x.useState(i ?? ""), [m, h] = x.useState(!1), v = ae(
      e,
      (y) => {
        var w;
        return (w = l.itemRefCallback) == null ? void 0 : w.call(l, y, r, o);
      }
    ), f = st(), p = x.useRef("touch"), g = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ b(
      J0,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: f,
        isSelected: c,
        onItemTextChange: x.useCallback((y) => {
          u((w) => w || ((y == null ? void 0 : y.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ b(
          Oo.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: d,
            children: /* @__PURE__ */ b(
              q.div,
              {
                role: "option",
                "aria-labelledby": f,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: v,
                onFocus: U(a.onFocus, () => h(!0)),
                onBlur: U(a.onBlur, () => h(!1)),
                onClick: U(a.onClick, () => {
                  p.current !== "mouse" && g();
                }),
                onPointerUp: U(a.onPointerUp, () => {
                  p.current === "mouse" && g();
                }),
                onPointerDown: U(a.onPointerDown, (y) => {
                  p.current = y.pointerType;
                }),
                onPointerMove: U(a.onPointerMove, (y) => {
                  var w;
                  p.current = y.pointerType, o ? (w = l.onItemLeave) == null || w.call(l) : p.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: U(a.onPointerLeave, (y) => {
                  var w;
                  y.currentTarget === document.activeElement && ((w = l.onItemLeave) == null || w.call(l));
                }),
                onKeyDown: U(a.onKeyDown, (y) => {
                  var C;
                  ((C = l.searchRef) == null ? void 0 : C.current) !== "" && y.key === " " || (W0.includes(y.key) && g(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ud.displayName = to;
var Zn = "SelectItemText", jd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = t, a = sn(Zn, n), s = an(Zn, n), l = Kd(Zn, n), c = z0(Zn, n), [d, u] = x.useState(null), m = ae(
      e,
      (g) => u(g),
      l.onItemTextChange,
      (g) => {
        var y;
        return (y = s.itemTextRefCallback) == null ? void 0 : y.call(s, g, l.value, l.disabled);
      }
    ), h = d == null ? void 0 : d.textContent, v = x.useMemo(
      () => /* @__PURE__ */ b("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: f, onNativeOptionRemove: p } = c;
    return De(() => (f(v), () => p(v)), [f, p, v]), /* @__PURE__ */ $(Ce, { children: [
      /* @__PURE__ */ b(q.span, { id: l.textId, ...i, ref: m }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? lr.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
jd.displayName = Zn;
var Gd = "SelectItemIndicator", qd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return Kd(Gd, n).isSelected ? /* @__PURE__ */ b(q.span, { "aria-hidden": !0, ...r, ref: e }) : null;
  }
);
qd.displayName = Gd;
var _i = "SelectScrollUpButton", Xd = x.forwardRef((t, e) => {
  const n = an(_i, t.__scopeSelect), r = $s(_i, t.__scopeSelect), [o, i] = x.useState(!1), a = ae(e, r.onScrollButtonChange);
  return De(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ b(
    Jd,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Xd.displayName = _i;
var Di = "SelectScrollDownButton", Zd = x.forwardRef((t, e) => {
  const n = an(Di, t.__scopeSelect), r = $s(Di, t.__scopeSelect), [o, i] = x.useState(!1), a = ae(e, r.onScrollButtonChange);
  return De(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < c;
        i(d);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ b(
    Jd,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Zd.displayName = Di;
var Jd = x.forwardRef((t, e) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = t, i = an("SelectScrollButton", n), a = x.useRef(null), s = To(n), l = x.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return x.useEffect(() => () => l(), [l]), De(() => {
    var d;
    const c = s().find((u) => u.ref.current === document.activeElement);
    (d = c == null ? void 0 : c.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ b(
    q.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: e,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: U(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: U(o.onPointerMove, () => {
        var c;
        (c = i.onItemLeave) == null || c.call(i), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: U(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), Q0 = "SelectSeparator", Qd = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return /* @__PURE__ */ b(q.div, { "aria-hidden": !0, ...r, ref: e });
  }
);
Qd.displayName = Q0;
var Ri = "SelectArrow", eC = x.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, o = Io(n), i = sn(Ri, n), a = an(Ri, n);
    return i.open && a.position === "popper" ? /* @__PURE__ */ b(hs, { ...o, ...r, ref: e }) : null;
  }
);
eC.displayName = Ri;
var tC = "SelectBubbleInput", ef = x.forwardRef(
  ({ __scopeSelect: t, value: e, ...n }, r) => {
    const o = x.useRef(null), i = ae(r, o), a = vr(e);
    return x.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== e && d) {
        const u = new Event("change", { bubbles: !0 });
        d.call(s, e), s.dispatchEvent(u);
      }
    }, [a, e]), /* @__PURE__ */ b(
      q.select,
      {
        ...n,
        style: { ...Td, ...n.style },
        ref: i,
        defaultValue: e
      }
    );
  }
);
ef.displayName = tC;
function tf(t) {
  return t === "" || t === void 0;
}
function nf(t) {
  const e = at(t), n = x.useRef(""), r = x.useRef(0), o = x.useCallback(
    (a) => {
      const s = n.current + a;
      e(s), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [e]
  ), i = x.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return x.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function rf(t, e, n) {
  const o = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, i = n ? t.indexOf(n) : -1;
  let a = nC(t, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function nC(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var rC = Id, oC = kd, iC = Dd, sC = Rd, aC = Ad, lC = Fd, cC = Vd, uC = zd, dC = Yd, Ai = Ud, Fi = jd, fC = qd, mC = Xd, hC = Zd, pC = Qd;
const Li = H("gap-lg px-sm py-xs relative flex items-center justify-between font-semibold transition-colors select-none", "radix-highlighted:bg-grayscale-xx-light radix-highlighted:text-main radix-highlighted:outline-hidden", "radix-disabled:pointer-events-none radix-disabled:text-grayscale"), wP = (t) => {
  const e = ee(58), {
    size: n,
    groups: r,
    placeholder: o,
    noOptionsMessage: i,
    defaultValue: a,
    onChange: s,
    name: l,
    loading: c,
    loadingMessage: d,
    portalContainer: u,
    label: m,
    className: h
  } = t, v = n === void 0 ? "large" : n, f = i === void 0 ? "No option available" : i, p = d === void 0 ? "Loading" : d, g = nn(), y = v === "large" ? "size-md" : "size-sm";
  let w;
  e[0] !== p ? (w = /* @__PURE__ */ b(Fi, { children: p }), e[0] = p, e[1] = w) : w = e[1];
  let C;
  e[2] !== y ? (C = H("animate-spin", y), e[2] = y, e[3] = C) : C = e[3];
  let S;
  e[4] !== C ? (S = /* @__PURE__ */ b(Gi, { className: C }), e[4] = C, e[5] = S) : S = e[5];
  let P;
  e[6] !== w || e[7] !== S ? (P = /* @__PURE__ */ $(Ai, { className: Li, disabled: !0, value: "loading", children: [
    w,
    S
  ] }), e[6] = w, e[7] = S, e[8] = P) : P = e[8];
  const E = P;
  let N;
  e[9] !== r ? (N = r.map(gC), e[9] = r, e[10] = N) : N = e[10];
  const T = N;
  let k;
  e[11] !== h ? (k = H("gap-y-2xs flex flex-col", h), e[11] = h, e[12] = k) : k = e[12];
  let D;
  e[13] !== g || e[14] !== m ? (D = m && /* @__PURE__ */ b(yn, { className: "inline-block", htmlFor: g, children: m }), e[13] = g, e[14] = m, e[15] = D) : D = e[15];
  let F;
  e[16] !== v ? (F = H(pn({
    fieldType: "dropdown",
    size: v
  }), "group gap-x-2xs flex w-full items-center justify-between", "radix-state-open:shadow-sm"), e[16] = v, e[17] = F) : F = e[17];
  const O = v === "large" ? Qe.size.large : Qe.size.medium;
  let _;
  e[18] !== o ? (_ = /* @__PURE__ */ b(iC, { placeholder: o }), e[18] = o, e[19] = _) : _ = e[19];
  let L;
  e[20] !== O || e[21] !== _ ? (L = /* @__PURE__ */ b(ve, { step: "0", weight: "semibold", className: O, children: _ }), e[20] = O, e[21] = _, e[22] = L) : L = e[22];
  let I;
  e[23] !== y ? (I = /* @__PURE__ */ b(sC, { className: "group-radix-state-open:rotate-180", children: /* @__PURE__ */ b(zr, { className: y }) }), e[23] = y, e[24] = I) : I = e[24];
  let R;
  e[25] !== g || e[26] !== F || e[27] !== L || e[28] !== I ? (R = /* @__PURE__ */ b("div", { className: "lasagne-dropdown", children: /* @__PURE__ */ $(oC, { className: F, id: g, children: [
    L,
    I
  ] }) }), e[25] = g, e[26] = F, e[27] = L, e[28] = I, e[29] = R) : R = e[29];
  const A = v === "large" ? Qe.size.large : Qe.size.medium;
  let M;
  e[30] !== A ? (M = H("SelectContent border-grayscale-x-light relative overflow-hidden rounded-b-md border border-t-0 border-solid bg-white", A), e[30] = A, e[31] = M) : M = e[31];
  let W;
  e[32] === Symbol.for("react.memo_cache_sentinel") ? (W = /* @__PURE__ */ b(mC, { className: "border-grayscale-xx-light pb-3xs hover:bg-grayscale-xx-light absolute top-0 z-50 flex w-full items-center justify-center border-b bg-white transition-colors", children: /* @__PURE__ */ b(Hm, {}) }), e[32] = W) : W = e[32];
  const z = c ? E : T;
  let K;
  e[33] !== r.length || e[34] !== y || e[35] !== c || e[36] !== f ? (K = r.length < 1 && !c ? /* @__PURE__ */ $(Ai, { className: Li, disabled: !0, value: "no-option", children: [
    /* @__PURE__ */ b(Fi, { children: f }),
    /* @__PURE__ */ b(zm, { className: y })
  ] }) : null, e[33] = r.length, e[34] = y, e[35] = c, e[36] = f, e[37] = K) : K = e[37];
  let j;
  e[38] !== z || e[39] !== K ? (j = /* @__PURE__ */ $(cC, { children: [
    z,
    K
  ] }), e[38] = z, e[39] = K, e[40] = j) : j = e[40];
  let G;
  e[41] === Symbol.for("react.memo_cache_sentinel") ? (G = /* @__PURE__ */ b(hC, { className: "border-grayscale-xx-light py-3xs hover:bg-grayscale-xx-light flex items-center justify-center border-t transition-colors", children: /* @__PURE__ */ b(zr, {}) }), e[41] = G) : G = e[41];
  let J;
  e[42] !== M || e[43] !== j ? (J = /* @__PURE__ */ $(lC, { position: "popper", sideOffset: 10, className: M, children: [
    W,
    j,
    G
  ] }), e[42] = M, e[43] = j, e[44] = J) : J = e[44];
  let oe;
  e[45] !== u || e[46] !== J ? (oe = /* @__PURE__ */ b(aC, { container: u, children: J }), e[45] = u, e[46] = J, e[47] = oe) : oe = e[47];
  let Y;
  e[48] !== a || e[49] !== l || e[50] !== s || e[51] !== R || e[52] !== oe ? (Y = /* @__PURE__ */ $(rC, { defaultValue: a, onValueChange: s, name: l, children: [
    R,
    oe
  ] }), e[48] = a, e[49] = l, e[50] = s, e[51] = R, e[52] = oe, e[53] = Y) : Y = e[53];
  let Z;
  return e[54] !== D || e[55] !== Y || e[56] !== k ? (Z = /* @__PURE__ */ $("div", { className: k, children: [
    D,
    Y
  ] }), e[54] = D, e[55] = Y, e[56] = k, e[57] = Z) : Z = e[57], Z;
};
function vC(t) {
  return /* @__PURE__ */ $(Ai, { className: Li, disabled: t.disabled, value: t.value, children: [
    /* @__PURE__ */ b(Fi, { children: t.label }),
    /* @__PURE__ */ b(fC, { children: /* @__PURE__ */ b(Pl, { className: "size-sm" }) })
  ] }, t.value);
}
function gC(t) {
  const {
    groupName: e,
    items: n
  } = t;
  return /* @__PURE__ */ $(oo, { children: [
    /* @__PURE__ */ b(pC, { className: "mx-2xs my-sm bg-grayscale-x-light h-[1px] first:hidden" }),
    /* @__PURE__ */ $(uC, { children: [
      e ? /* @__PURE__ */ b(dC, { className: "px-sm py-xs text-grayscale", children: e }) : null,
      n.map(vC)
    ] })
  ] }, e || `${n[0].value}`);
}
const bC = (t) => {
  const e = ee(4), {
    symbol: n,
    label: r
  } = t, o = r === void 0 ? "" : r, i = o || "", a = o ? "false" : "true";
  let s;
  return e[0] !== n || e[1] !== i || e[2] !== a ? (s = /* @__PURE__ */ b("span", { role: "img", "aria-label": i, "aria-hidden": a, children: n }), e[0] = n, e[1] = i, e[2] = a, e[3] = s) : s = e[3], s;
};
var yC = process.env.NODE_ENV === "production", ui = "Invariant failed";
function of(t, e) {
  if (!t) {
    if (yC)
      throw new Error(ui);
    var n = typeof e == "function" ? e() : e, r = n ? "".concat(ui, ": ").concat(n) : ui;
    throw new Error(r);
  }
}
function no() {
  return no = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, no.apply(this, arguments);
}
var pl = function(t) {
  var e = pe(t);
  return e.current = t, e;
}, wC = function(t, e) {
  var n;
  return function() {
    for (var r = this, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    n !== null && (clearTimeout(n), n = null), n = setTimeout(function() {
      return t.apply(r, i);
    }, e);
  };
}, xC = "💡 use-places-autocomplete: Google Maps Places API library must be loaded. See: https://github.com/wellyshen/use-places-autocomplete#load-the-library", SC = function(e) {
  var n = e === void 0 ? {} : e, r = n.requestOptions, o = n.debounce, i = o === void 0 ? 200 : o, a = n.cache, s = a === void 0 ? 24 * 60 * 60 : a, l = n.cacheKey, c = l === void 0 ? "upa" : l, d = n.googleMaps, u = n.callbackName, m = n.defaultValue, h = m === void 0 ? "" : m, v = n.initOnMount, f = v === void 0 ? !0 : v, p = le(!1), g = p[0], y = p[1], w = le(h), C = w[0], S = w[1], P = le({
    loading: !1,
    status: "",
    data: []
  }), E = P[0], N = P[1], T = pe(), k = pl(r), D = pl(d), F = Ne(function() {
    var R;
    if (!T.current) {
      var A = window, M = A.google, W = D.current, z = (W == null ? void 0 : W.places) || (M == null || (R = M.maps) == null ? void 0 : R.places);
      if (!z) {
        console.error(xC);
        return;
      }
      T.current = new z.AutocompleteService(), y(!0);
    }
  }, [D]), O = Ne(function() {
    N({
      loading: !1,
      status: "",
      data: []
    });
  }, []), _ = Ne(function(R) {
    R === void 0 && (R = c);
    try {
      sessionStorage.removeItem(R);
    } catch {
    }
  }, [c]), L = Ne(wC(function(R) {
    var A;
    if (!R) {
      O();
      return;
    }
    N(function(W) {
      return no({}, W, {
        loading: !0
      });
    });
    var M = {};
    try {
      M = JSON.parse(sessionStorage.getItem(c) || "{}");
    } catch {
    }
    if (s && (M = Object.keys(M).reduce(function(W, z) {
      return M[z].maxAge - Date.now() >= 0 && (W[z] = M[z]), W;
    }, {}), M[R])) {
      N({
        loading: !1,
        status: "OK",
        data: M[R].data
      });
      return;
    }
    (A = T.current) == null || A.getPlacePredictions(no({}, k.current, {
      input: R
    }), function(W, z) {
      if (N({
        loading: !1,
        status: z,
        data: W || []
      }), s && z === "OK") {
        M[R] = {
          data: W,
          maxAge: Date.now() + s * 1e3
        };
        try {
          sessionStorage.setItem(c, JSON.stringify(M));
        } catch {
        }
      }
    });
  }, i), [s, c, O, k]), I = Ne(function(R, A) {
    A === void 0 && (A = !0), S(R), T.current && A && L(R);
  }, [L]);
  return fe(function() {
    if (!f) return function() {
      return null;
    };
    var R = window, A = R.google;
    return !D.current && !(A != null && A.maps) && u ? window[u] = F : F(), function() {
      window[u] && delete window[u];
    };
  }, [u, D, F, f]), {
    ready: g,
    value: C,
    suggestions: E,
    setValue: I,
    clearSuggestions: O,
    clearCache: _,
    init: F
  };
}, CC = "💡 use-places-autocomplete: Please provide an address when using getGeocode() with the componentRestrictions.", EC = function(e) {
  var n = new window.google.maps.Geocoder();
  return new Promise(function(r, o) {
    n.geocode(e, function(i, a) {
      a !== "OK" && o(a), !e.address && e.componentRestrictions && (console.error(CC), r(i)), r(i);
    });
  });
}, PC = function(e) {
  var n = e.geometry.location, r = n.lat, o = n.lng;
  return {
    lat: r(),
    lng: o()
  };
};
function xP(t) {
  const e = ee(44);
  let n, r, o, i;
  e[0] !== t ? ({
    name: o,
    defaultValue: r,
    callbackName: n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i) : (n = e[1], r = e[2], o = e[3], i = e[4]), of(Xs() && window.google, "The google apis script is required. You must load it.");
  const [a, s] = le(r);
  let l;
  e[5] !== r ? (l = r ? [{
    label: r.label,
    value: r.placeId
  }] : [], e[5] = r, e[6] = l) : l = e[6];
  const [c, d] = le(l), [u, m] = le(!0), [h, v] = le();
  let f;
  e[7] !== h ? (f = () => h, e[7] = h, e[8] = f) : f = e[8];
  const p = f;
  let g;
  e[9] !== p ? (g = p(), e[9] = p, e[10] = g) : g = e[10];
  let y;
  e[11] !== g ? (y = {
    sessionToken: g
  }, e[11] = g, e[12] = y) : y = e[12];
  let w;
  e[13] !== n || e[14] !== y ? (w = {
    callbackName: n,
    requestOptions: y,
    debounce: 300
  }, e[13] = n, e[14] = y, e[15] = w) : w = e[15];
  const {
    ready: C,
    suggestions: S,
    setValue: P,
    clearSuggestions: E
  } = SC(w), {
    loading: N,
    status: T,
    data: k
  } = S;
  let D, F;
  e[16] !== u ? (D = () => {
    if (Xs() && window.google && u) {
      const J = new window.google.maps.places.AutocompleteSessionToken();
      v(J), m(!1);
    }
  }, F = [u], e[16] = u, e[17] = D, e[18] = F) : (D = e[17], F = e[18]), fe(D, F);
  let O;
  e[19] !== E || e[20] !== P ? (O = (J) => {
    P(J), J || (E(), d([]));
  }, e[19] = E, e[20] = P, e[21] = O) : O = e[21];
  const _ = O;
  let L;
  e[22] !== (a == null ? void 0 : a.placeId) || e[23] !== k ? (L = (J) => {
    if (J) {
      if (m(!0), J !== (a == null ? void 0 : a.placeId)) {
        const oe = k.find((ie) => ie.place_id === J), {
          description: Y,
          place_id: Z
        } = oe;
        EC({
          placeId: Z
        }).then((ie) => {
          const {
            lat: te,
            lng: ne
          } = PC(ie[0]);
          s({
            label: Y,
            latitude: te,
            longitude: ne,
            placeId: Z
          });
        });
      }
    } else
      J || s(void 0);
  }, e[22] = a == null ? void 0 : a.placeId, e[23] = k, e[24] = L) : L = e[24];
  const I = L;
  let R, A;
  e[25] !== k || e[26] !== T ? (R = () => {
    T === "OK" && k && d(k.map(NC));
  }, A = [T, k], e[25] = k, e[26] = T, e[27] = R, e[28] = A) : (R = e[27], A = e[28]), fe(R, A);
  let M;
  e[29] !== a || e[30] !== o ? (M = o && /* @__PURE__ */ b("input", { readOnly: !0, type: "text", name: o, value: a ? JSON.stringify(km(a)) : "", className: "hidden" }), e[29] = a, e[30] = o, e[31] = M) : M = e[31];
  const W = r == null ? void 0 : r.placeId, z = N || !C;
  let K;
  e[32] !== c ? (K = [{
    items: c
  }], e[32] = c, e[33] = K) : K = e[33];
  let j;
  e[34] !== _ || e[35] !== I || e[36] !== i || e[37] !== W || e[38] !== z || e[39] !== K ? (j = /* @__PURE__ */ b(p0, { defaultValue: W, loading: z, onInputChange: _, onChange: I, PrefixIcon: Ym, groups: K, ...i }), e[34] = _, e[35] = I, e[36] = i, e[37] = W, e[38] = z, e[39] = K, e[40] = j) : j = e[40];
  let G;
  return e[41] !== M || e[42] !== j ? (G = /* @__PURE__ */ $("div", { children: [
    M,
    j
  ] }), e[41] = M, e[42] = j, e[43] = G) : G = e[43], G;
}
function NC(t) {
  return {
    label: t.description,
    value: t.place_id
  };
}
const OC = {
  size: {
    medium: "gap-2xs",
    large: "gap-xs"
  },
  hasIcon: {
    true: "inline-flex items-center"
  },
  openNewTab: {
    true: "inline-flex items-center"
  }
}, TC = Yt("text-primary", {
  variants: {
    ...OC
  },
  defaultVariants: {
    size: "medium"
  }
});
function SP(t) {
  const e = ee(33);
  let n, r, o, i, a, s, l;
  e[0] !== t ? ({
    as: o,
    className: a,
    size: l,
    children: i,
    PrefixIcon: n,
    SuffixIcon: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s, e[7] = l) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6], l = e[7]);
  const c = l === void 0 ? "medium" : l, {
    shouldOpenNewTab: d
  } = s, u = o || "a";
  let m;
  e[8] !== s || e[9] !== u ? (m = jl({
    as: u,
    ...s
  }), e[8] = s, e[9] = u, e[10] = m) : m = e[10];
  let h, v;
  e[11] !== m ? ({
    as: h,
    ...v
  } = m, e[11] = m, e[12] = h, e[13] = v) : (h = e[12], v = e[13]);
  const {
    disabled: f
  } = v, p = h, g = c === "medium" ? "size-sm" : "size-md", y = c === "medium" ? "0" : "1", w = c === "medium" ? "semibold" : "bold", C = !!n || !!r;
  let S;
  e[14] !== a || e[15] !== f || e[16] !== d || e[17] !== c || e[18] !== C ? (S = H(TC({
    size: c,
    hasIcon: C,
    openNewTab: d
  }), f ? "text-grayscale cursor-default" : "text-primary visited:text-secondary hover:text-primary-light visited:hover:text-secondary-light focus-visible:text-primary-light visited:focus-visible:text-secondary-light active:text-primary visited:active:text-secondary cursor-pointer hover:underline focus-visible:underline", a), e[14] = a, e[15] = f, e[16] = d, e[17] = c, e[18] = C, e[19] = S) : S = e[19];
  let P;
  e[20] !== n || e[21] !== r || e[22] !== i || e[23] !== g || e[24] !== d ? (P = d ? /* @__PURE__ */ $(Ce, { children: [
    /* @__PURE__ */ b(Km, { className: H("relative", g) }),
    i
  ] }) : /* @__PURE__ */ $(Ce, { children: [
    n ? /* @__PURE__ */ b(n, { className: g }) : null,
    i,
    r ? /* @__PURE__ */ b(r, { className: g }) : null
  ] }), e[20] = n, e[21] = r, e[22] = i, e[23] = g, e[24] = d, e[25] = P) : P = e[25];
  let E;
  return e[26] !== p || e[27] !== v || e[28] !== y || e[29] !== w || e[30] !== S || e[31] !== P ? (E = /* @__PURE__ */ b(ve, { step: y, weight: w, className: S, as: p, ...v, children: P }), e[26] = p, e[27] = v, e[28] = y, e[29] = w, e[30] = S, e[31] = P, e[32] = E) : E = e[32], E;
}
const IC = {
  positive: "text-positive",
  warning: "text-warning",
  negative: "text-negative"
}, MC = (t) => {
  const e = ee(18), {
    name: n,
    onClick: r,
    status: o,
    isSelected: i,
    selectedText: a
  } = t, s = i && "bg-grayscale-xx-light";
  let l;
  e[0] !== s ? (l = H("gap-md px-xs py-2xs flex items-center justify-between rounded-md bg-white transition-colors active:bg-white", "hover:bg-grayscale-xx-light focus-visible:bg-grayscale-xx-light", s), e[0] = s, e[1] = l) : l = e[1];
  let c;
  e[2] !== n ? (c = /* @__PURE__ */ b(ve, { step: "-2", weight: "bold", children: n }), e[2] = n, e[3] = c) : c = e[3];
  const d = IC[o.state];
  let u;
  e[4] !== o.name || e[5] !== d ? (u = /* @__PURE__ */ b(ve, { step: "-2", weight: "semibold", className: d, children: o.name }), e[4] = o.name, e[5] = d, e[6] = u) : u = e[6];
  let m;
  e[7] !== c || e[8] !== u ? (m = /* @__PURE__ */ $("div", { className: "flex flex-col items-start", children: [
    c,
    u
  ] }), e[7] = c, e[8] = u, e[9] = m) : m = e[9];
  let h;
  e[10] !== i || e[11] !== a ? (h = i && a ? /* @__PURE__ */ b(ve, { step: "-2", className: "text-grayscale", children: a }) : null, e[10] = i, e[11] = a, e[12] = h) : h = e[12];
  let v;
  return e[13] !== r || e[14] !== l || e[15] !== m || e[16] !== h ? (v = /* @__PURE__ */ b(go, { asChild: !0, children: /* @__PURE__ */ $("button", { className: l, onClick: r, children: [
    m,
    h
  ] }) }), e[13] = r, e[14] = l, e[15] = m, e[16] = h, e[17] = v) : v = e[17], v;
}, sf = (t) => {
  const e = ee(7), {
    trigger: n,
    portalContainer: r,
    className: o,
    children: i
  } = t;
  let a;
  e[0] !== o ? (a = H("border-grayscale-xx-light p-xs rounded-md shadow-lg", o), e[0] = o, e[1] = a) : a = e[1];
  let s;
  return e[2] !== i || e[3] !== r || e[4] !== a || e[5] !== n ? (s = /* @__PURE__ */ b(gs, { side: "right", hasArrow: !1, sideOffset: 20, align: "start", className: a, trigger: n, portalContainer: r, children: i }), e[2] = i, e[3] = r, e[4] = a, e[5] = n, e[6] = s) : s = e[6], s;
}, vl = (t, e) => t.find((n) => n.id === e), kC = (t) => {
  const e = ee(43), {
    label: n,
    contexts: r,
    selectedContextId: o,
    portalContainer: i,
    newContextButton: a,
    onChange: s,
    disabled: l,
    selectedText: c
  } = t;
  let d;
  e[0] !== r || e[1] !== o ? (d = vl(r, o), e[0] = r, e[1] = o, e[2] = d) : d = e[2];
  const [u, m] = le(d);
  let h, v;
  e[3] !== r || e[4] !== o ? (h = () => {
    m(vl(r, o));
  }, v = [o, r], e[3] = r, e[4] = o, e[5] = h, e[6] = v) : (h = e[5], v = e[6]), fe(h, v);
  let f;
  e[7] !== s ? (f = (O) => {
    m(O), s == null || s(O.id);
  }, e[7] = s, e[8] = f) : f = e[8];
  const p = f;
  let g;
  e[9] !== n ? (g = /* @__PURE__ */ b(ve, { step: "-2", className: "text-grayscale", children: n }), e[9] = n, e[10] = g) : g = e[10];
  let y;
  e[11] === Symbol.for("react.memo_cache_sentinel") ? (y = H("border-grayscale-x-light px-2xs py-xs z-10 flex justify-between rounded-md border bg-white shadow-sm transition-shadow", "hover:shadow-lg focus-visible:shadow-lg active:shadow-inner", "disabled:pointer-events-none disabled:shadow-none"), e[11] = y) : y = e[11];
  const w = u == null ? void 0 : u.name;
  let C;
  e[12] !== w ? (C = /* @__PURE__ */ b(ve, { weight: "bold", step: "-2", className: "text-grayscale-dark disabled:text-grayscale-light", children: w }), e[12] = w, e[13] = C) : C = e[13];
  let S;
  e[14] !== l ? (S = l ? null : /* @__PURE__ */ b(Nl, { className: "size-sm text-grayscale-dark disabled:text-grayscale-light" }), e[14] = l, e[15] = S) : S = e[15];
  let P;
  e[16] !== l || e[17] !== C || e[18] !== S ? (P = /* @__PURE__ */ $("button", { className: y, disabled: l, children: [
    C,
    S
  ] }), e[16] = l, e[17] = C, e[18] = S, e[19] = P) : P = e[19];
  let E;
  if (e[20] !== r || e[21] !== p || e[22] !== (u == null ? void 0 : u.id) || e[23] !== c) {
    let O;
    e[25] !== p || e[26] !== (u == null ? void 0 : u.id) || e[27] !== c ? (O = (_) => /* @__PURE__ */ b(MC, { ..._, selectedText: c, isSelected: _.id === (u == null ? void 0 : u.id), onClick: () => p(_) }, _.id), e[25] = p, e[26] = u == null ? void 0 : u.id, e[27] = c, e[28] = O) : O = e[28], E = r.map(O), e[20] = r, e[21] = p, e[22] = u == null ? void 0 : u.id, e[23] = c, e[24] = E;
  } else
    E = e[24];
  let N;
  e[29] !== E ? (N = /* @__PURE__ */ b("div", { className: "gap-2xs flex flex-col", children: E }), e[29] = E, e[30] = N) : N = e[30];
  let T;
  e[31] !== a ? (T = a ? /* @__PURE__ */ b(go, { asChild: !0, children: /* @__PURE__ */ b($t, { intent: "positive", shape: "soft", size: "small", onClick: a.onClick, children: a.label }) }) : null, e[31] = a, e[32] = T) : T = e[32];
  let k;
  e[33] !== N || e[34] !== T ? (k = /* @__PURE__ */ $("div", { className: "gap-xs flex flex-col", children: [
    N,
    T
  ] }), e[33] = N, e[34] = T, e[35] = k) : k = e[35];
  let D;
  e[36] !== i || e[37] !== P || e[38] !== k ? (D = /* @__PURE__ */ b(sf, { trigger: P, portalContainer: i, children: k }), e[36] = i, e[37] = P, e[38] = k, e[39] = D) : D = e[39];
  let F;
  return e[40] !== D || e[41] !== g ? (F = /* @__PURE__ */ $("div", { className: "gap-3xs flex flex-col", children: [
    g,
    D
  ] }), e[40] = D, e[41] = g, e[42] = F) : F = e[42], F;
};
function _C(t) {
  const e = ee(15), {
    title: n,
    Icon: r,
    buttonText: o,
    href: i,
    onClick: a
  } = t;
  let s;
  e[0] !== r ? (s = /* @__PURE__ */ b(r, { className: "size-sm text-secondary-light" }), e[0] = r, e[1] = s) : s = e[1];
  let l;
  e[2] !== n ? (l = /* @__PURE__ */ b(ve, { weight: "semibold", step: "-2", children: n }), e[2] = n, e[3] = l) : l = e[3];
  const c = i ? "a" : "button";
  let d;
  e[4] !== i ? (d = i ? {
    href: i
  } : {}, e[4] = i, e[5] = d) : d = e[5];
  let u;
  e[6] !== o || e[7] !== a || e[8] !== c || e[9] !== d ? (u = /* @__PURE__ */ b($t, { intent: "secondary", size: "small", onClick: a, as: c, className: "col-span-2", ...d, children: o }), e[6] = o, e[7] = a, e[8] = c, e[9] = d, e[10] = u) : u = e[10];
  let m;
  return e[11] !== s || e[12] !== l || e[13] !== u ? (m = /* @__PURE__ */ $("div", { className: "gap-x-2xs gap-y-xs bg-secondary-xx-light px-xs py-2xs grid grid-cols-[auto_1fr] items-center rounded-md", children: [
    s,
    l,
    u
  ] }), e[11] = s, e[12] = l, e[13] = u, e[14] = m) : m = e[14], m;
}
var [Mo, CP] = Ye("Tooltip", [
  Hn
]), ko = Hn(), af = "TooltipProvider", DC = 700, Wi = "tooltip.open", [RC, Vs] = Mo(af), lf = (t) => {
  const {
    __scopeTooltip: e,
    delayDuration: n = DC,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = t, a = x.useRef(!0), s = x.useRef(!1), l = x.useRef(0);
  return x.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ b(
    RC,
    {
      scope: e,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: x.useCallback(() => {
        window.clearTimeout(l.current), a.current = !1;
      }, []),
      onClose: x.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: x.useCallback((c) => {
        s.current = c;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
lf.displayName = af;
var sr = "Tooltip", [AC, xr] = Mo(sr), cf = (t) => {
  const {
    __scopeTooltip: e,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: s
  } = t, l = Vs(sr, t.__scopeTooltip), c = ko(e), [d, u] = x.useState(null), m = st(), h = x.useRef(0), v = a ?? l.disableHoverableContent, f = s ?? l.delayDuration, p = x.useRef(!1), [g, y] = je({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (E) => {
      E ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Wi))) : l.onClose(), i == null || i(E);
    },
    caller: sr
  }), w = x.useMemo(() => g ? p.current ? "delayed-open" : "instant-open" : "closed", [g]), C = x.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, p.current = !1, y(!0);
  }, [y]), S = x.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, y(!1);
  }, [y]), P = x.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      p.current = !0, y(!0), h.current = 0;
    }, f);
  }, [f, y]);
  return x.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ b(fs, { ...c, children: /* @__PURE__ */ b(
    AC,
    {
      scope: e,
      contentId: m,
      open: g,
      stateAttribute: w,
      trigger: d,
      onTriggerChange: u,
      onTriggerEnter: x.useCallback(() => {
        l.isOpenDelayedRef.current ? P() : C();
      }, [l.isOpenDelayedRef, P, C]),
      onTriggerLeave: x.useCallback(() => {
        v ? S() : (window.clearTimeout(h.current), h.current = 0);
      }, [S, v]),
      onOpen: C,
      onClose: S,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
cf.displayName = sr;
var $i = "TooltipTrigger", uf = x.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, o = xr($i, n), i = Vs($i, n), a = ko(n), s = x.useRef(null), l = ae(e, s, o.onTriggerChange), c = x.useRef(!1), d = x.useRef(!1), u = x.useCallback(() => c.current = !1, []);
    return x.useEffect(() => () => document.removeEventListener("pointerup", u), [u]), /* @__PURE__ */ b(mo, { asChild: !0, ...a, children: /* @__PURE__ */ b(
      q.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: U(t.onPointerMove, (m) => {
          m.pointerType !== "touch" && !d.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: U(t.onPointerLeave, () => {
          o.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: U(t.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", u, { once: !0 });
        }),
        onFocus: U(t.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: U(t.onBlur, o.onClose),
        onClick: U(t.onClick, o.onClose)
      }
    ) });
  }
);
uf.displayName = $i;
var Bs = "TooltipPortal", [FC, LC] = Mo(Bs, {
  forceMount: void 0
}), df = (t) => {
  const { __scopeTooltip: e, forceMount: n, children: r, container: o } = t, i = xr(Bs, e);
  return /* @__PURE__ */ b(FC, { scope: e, forceMount: n, children: /* @__PURE__ */ b(tt, { present: n || i.open, children: /* @__PURE__ */ b(Yn, { asChild: !0, container: o, children: r }) }) });
};
df.displayName = Bs;
var Fn = "TooltipContent", ff = x.forwardRef(
  (t, e) => {
    const n = LC(Fn, t.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = t, a = xr(Fn, t.__scopeTooltip);
    return /* @__PURE__ */ b(tt, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ b(mf, { side: o, ...i, ref: e }) : /* @__PURE__ */ b(WC, { side: o, ...i, ref: e }) });
  }
), WC = x.forwardRef((t, e) => {
  const n = xr(Fn, t.__scopeTooltip), r = Vs(Fn, t.__scopeTooltip), o = x.useRef(null), i = ae(e, o), [a, s] = x.useState(null), { trigger: l, onClose: c } = n, d = o.current, { onPointerInTransitChange: u } = r, m = x.useCallback(() => {
    s(null), u(!1);
  }, [u]), h = x.useCallback(
    (v, f) => {
      const p = v.currentTarget, g = { x: v.clientX, y: v.clientY }, y = HC(g, p.getBoundingClientRect()), w = YC(g, y), C = KC(f.getBoundingClientRect()), S = jC([...w, ...C]);
      s(S), u(!0);
    },
    [u]
  );
  return x.useEffect(() => () => m(), [m]), x.useEffect(() => {
    if (l && d) {
      const v = (p) => h(p, d), f = (p) => h(p, l);
      return l.addEventListener("pointerleave", v), d.addEventListener("pointerleave", f), () => {
        l.removeEventListener("pointerleave", v), d.removeEventListener("pointerleave", f);
      };
    }
  }, [l, d, h, m]), x.useEffect(() => {
    if (a) {
      const v = (f) => {
        const p = f.target, g = { x: f.clientX, y: f.clientY }, y = (l == null ? void 0 : l.contains(p)) || (d == null ? void 0 : d.contains(p)), w = !UC(g, a);
        y ? m() : w && (m(), c());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, d, a, c, m]), /* @__PURE__ */ b(mf, { ...t, ref: i });
}), [$C, VC] = Mo(sr, { isInside: !1 }), BC = /* @__PURE__ */ th("TooltipContent"), mf = x.forwardRef(
  (t, e) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...s
    } = t, l = xr(Fn, n), c = ko(n), { onClose: d } = l;
    return x.useEffect(() => (document.addEventListener(Wi, d), () => document.removeEventListener(Wi, d)), [d]), x.useEffect(() => {
      if (l.trigger) {
        const u = (m) => {
          const h = m.target;
          h != null && h.contains(l.trigger) && d();
        };
        return window.addEventListener("scroll", u, { capture: !0 }), () => window.removeEventListener("scroll", u, { capture: !0 });
      }
    }, [l.trigger, d]), /* @__PURE__ */ b(
      Vn,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (u) => u.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ $(
          ms,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: e,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ b(BC, { children: r }),
              /* @__PURE__ */ b($C, { scope: n, isInside: !0, children: /* @__PURE__ */ b(F0, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
ff.displayName = Fn;
var hf = "TooltipArrow", zC = x.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, o = ko(n);
    return VC(
      hf,
      n
    ).isInside ? null : /* @__PURE__ */ b(hs, { ...o, ...r, ref: e });
  }
);
zC.displayName = hf;
function HC(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), o = Math.abs(e.right - t.x), i = Math.abs(e.left - t.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function YC(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: t.x - n, y: t.y + n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x + n, y: t.y - n }
      );
      break;
    case "left":
      r.push(
        { x: t.x + n, y: t.y - n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "right":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x - n, y: t.y + n }
      );
      break;
  }
  return r;
}
function KC(t) {
  const { top: e, right: n, bottom: r, left: o } = t;
  return [
    { x: o, y: e },
    { x: n, y: e },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function UC(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let i = 0, a = e.length - 1; i < e.length; a = i++) {
    const s = e[i], l = e[a], c = s.x, d = s.y, u = l.x, m = l.y;
    d > r != m > r && n < (u - c) * (r - d) / (m - d) + c && (o = !o);
  }
  return o;
}
function jC(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), GC(e);
}
function GC(t) {
  if (t.length <= 1) return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    for (; e.length >= 2; ) {
      const i = e[e.length - 1], a = e[e.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) e.pop();
      else break;
    }
    e.push(o);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const o = t[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
var EP = lf, qC = cf, XC = uf, ZC = df, JC = ff;
function QC(t) {
  const e = ee(15), {
    content: n,
    children: r,
    side: o,
    portalContainer: i,
    triggerAsChild: a
  } = t, s = o === void 0 ? "right" : o, l = a === void 0 ? !1 : a;
  let c;
  e[0] !== r || e[1] !== l ? (c = /* @__PURE__ */ b(XC, { asChild: l, children: r }), e[0] = r, e[1] = l, e[2] = c) : c = e[2];
  let d;
  e[3] === Symbol.for("react.memo_cache_sentinel") ? (d = H("border-grayscale-x-light p-2xs z-50 rounded-sm border bg-white shadow-xl", ["animate-in fade-in-0 zoom-in-95", "radix-state-closed:animate-out", "radix-state-closed:fade-out-0", "radix-state-closed:zoom-out-95", "radix-side-bottom:slide-in-from-top-[1rem]", "radix-side-left:slide-in-from-right-[1rem]", "radix-side-right:slide-in-from-left-[1rem]", "radix-side-top:slide-in-from-bottom-[1rem]"]), e[3] = d) : d = e[3];
  let u;
  e[4] !== n ? (u = /* @__PURE__ */ b(ve, { step: "-1", weight: "semibold", children: n }), e[4] = n, e[5] = u) : u = e[5];
  let m;
  e[6] !== s || e[7] !== u ? (m = /* @__PURE__ */ b(JC, { side: s, align: "center", sideOffset: 4, avoidCollisions: !0, className: d, children: u }), e[6] = s, e[7] = u, e[8] = m) : m = e[8];
  let h;
  e[9] !== i || e[10] !== m ? (h = /* @__PURE__ */ b(ZC, { container: i, children: m }), e[9] = i, e[10] = m, e[11] = h) : h = e[11];
  let v;
  return e[12] !== c || e[13] !== h ? (v = /* @__PURE__ */ $(qC, { delayDuration: 0, children: [
    c,
    h
  ] }), e[12] = c, e[13] = h, e[14] = v) : v = e[14], v;
}
function ro(t) {
  const e = ee(30), {
    title: n,
    subtitle: r,
    Icon: o,
    href: i,
    disabled: a,
    onClick: s,
    active: l,
    shouldOpenNewTab: c
  } = t, d = i ? a ? "span" : "a" : "button", u = a && "text-grayscale-light pointer-events-none", m = l && "bg-primary-xx-light text-primary-light";
  let h;
  e[0] !== u || e[1] !== m ? (h = H("group gap-2xs p-2xs text-grayscale-dark hover:bg-primary-xx-light focus-visible:bg-primary-xx-light active:text-primary-light flex w-full items-center rounded-md bg-white text-start transition-colors duration-100", u, m), e[0] = u, e[1] = m, e[2] = h) : h = e[2];
  const v = a ? void 0 : i, f = a ? void 0 : s, p = l ? "page" : void 0;
  let g;
  e[3] !== c ? (g = c ? {
    target: "_blank",
    rel: "noopener noreferrer"
  } : {}, e[3] = c, e[4] = g) : g = e[4];
  let y;
  e[5] !== o ? (y = /* @__PURE__ */ b(o, { className: "size-sm" }), e[5] = o, e[6] = y) : y = e[6];
  const w = a && "text-grayscale-light", C = l && "text-primary-light";
  let S;
  e[7] !== C || e[8] !== w ? (S = H("text-grayscale-dark group-active:text-primary-light", w, C), e[7] = C, e[8] = w, e[9] = S) : S = e[9];
  let P;
  e[10] !== S || e[11] !== n ? (P = /* @__PURE__ */ b(ve, { className: S, step: "-2", weight: "bold", children: n }), e[10] = S, e[11] = n, e[12] = P) : P = e[12];
  let E;
  e[13] !== l || e[14] !== a || e[15] !== r ? (E = r && /* @__PURE__ */ b(ve, { className: H("text-grayscale-dark group-active:text-primary-light", a && "text-grayscale-light", l && "text-primary-light"), step: "-2", children: r }), e[13] = l, e[14] = a, e[15] = r, e[16] = E) : E = e[16];
  let N;
  e[17] !== P || e[18] !== E ? (N = /* @__PURE__ */ $("div", { className: "flex flex-col", children: [
    P,
    E
  ] }), e[17] = P, e[18] = E, e[19] = N) : N = e[19];
  let T;
  return e[20] !== d || e[21] !== a || e[22] !== N || e[23] !== h || e[24] !== v || e[25] !== f || e[26] !== p || e[27] !== g || e[28] !== y ? (T = /* @__PURE__ */ $(d, { className: h, href: v, onClick: f, disabled: a, "aria-current": p, ...g, children: [
    y,
    N
  ] }), e[20] = d, e[21] = a, e[22] = N, e[23] = h, e[24] = v, e[25] = f, e[26] = p, e[27] = g, e[28] = y, e[29] = T) : T = e[29], T;
}
const eE = (t) => {
  const e = ee(10);
  let n, r, o;
  e[0] !== t ? ({
    disabledTooltipContent: n,
    portalContainer: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o) : (n = e[1], r = e[2], o = e[3]);
  const i = `${n}`;
  let a;
  e[4] !== o ? (a = /* @__PURE__ */ b(ro, { ...o }), e[4] = o, e[5] = a) : a = e[5];
  let s;
  return e[6] !== r || e[7] !== i || e[8] !== a ? (s = /* @__PURE__ */ b(QC, { content: i, portalContainer: r, children: a }), e[6] = r, e[7] = i, e[8] = a, e[9] = s) : s = e[9], s;
};
function di(t) {
  const e = ee(36), {
    title: n,
    subtitle: r,
    Icon: o,
    href: i,
    onClick: a,
    disabled: s,
    active: l,
    subItems: c,
    portalContainer: d,
    disabledTooltipContent: u,
    shouldOpenNewTab: m
  } = t;
  if (s && u) {
    let g;
    return e[0] !== o || e[1] !== l || e[2] !== s || e[3] !== u || e[4] !== i || e[5] !== d || e[6] !== m || e[7] !== r || e[8] !== n ? (g = /* @__PURE__ */ b(eE, { title: n, subtitle: r, Icon: o, href: i, disabled: s, active: l, portalContainer: d, disabledTooltipContent: u, shouldOpenNewTab: m }), e[0] = o, e[1] = l, e[2] = s, e[3] = u, e[4] = i, e[5] = d, e[6] = m, e[7] = r, e[8] = n, e[9] = g) : g = e[9], g;
  }
  if (!c) {
    let g;
    return e[10] !== o || e[11] !== l || e[12] !== s || e[13] !== u || e[14] !== i || e[15] !== m || e[16] !== r || e[17] !== n ? (g = /* @__PURE__ */ b(ro, { title: n, subtitle: r, Icon: o, href: i, disabled: s, active: l, disabledTooltipContent: u, shouldOpenNewTab: m }), e[10] = o, e[11] = l, e[12] = s, e[13] = u, e[14] = i, e[15] = m, e[16] = r, e[17] = n, e[18] = g) : g = e[18], g;
  }
  let h;
  e[19] !== o || e[20] !== l || e[21] !== s || e[22] !== u || e[23] !== a || e[24] !== m || e[25] !== r || e[26] !== n ? (h = /* @__PURE__ */ b("div", { className: "w-full", children: /* @__PURE__ */ b(ro, { title: n, subtitle: r, Icon: o, onClick: a, disabled: s, active: l, disabledTooltipContent: u, shouldOpenNewTab: m }) }), e[19] = o, e[20] = l, e[21] = s, e[22] = u, e[23] = a, e[24] = m, e[25] = r, e[26] = n, e[27] = h) : h = e[27];
  let v;
  e[28] !== c ? (v = c == null ? void 0 : c.map(tE), e[28] = c, e[29] = v) : v = e[29];
  let f;
  e[30] !== v ? (f = /* @__PURE__ */ b("div", { className: "gap-2xs flex w-[136px] flex-col", children: v }), e[30] = v, e[31] = f) : f = e[31];
  let p;
  return e[32] !== d || e[33] !== h || e[34] !== f ? (p = /* @__PURE__ */ b(sf, { trigger: h, portalContainer: d, children: f }), e[32] = d, e[33] = h, e[34] = f, e[35] = p) : p = e[35], p;
}
function tE(t) {
  return /* @__PURE__ */ b(ro, { ...t }, t.title);
}
const PP = (t) => {
  const e = ee(29), {
    logoUrl: n,
    homeItem: r,
    contextSwitcher: o,
    groups: i,
    highlight: a,
    footer: s,
    portalContainer: l
  } = t;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ b("img", { src: n, alt: "Logo", className: "h-xl" }), e[0] = n, e[1] = c) : c = e[1];
  let d;
  e[2] !== r ? (d = r ? /* @__PURE__ */ b(di, { ...r }) : null, e[2] = r, e[3] = d) : d = e[3];
  let u;
  e[4] !== o || e[5] !== l ? (u = o ? /* @__PURE__ */ b(kC, { ...o, portalContainer: l }) : null, e[4] = o, e[5] = l, e[6] = u) : u = e[6];
  let m;
  if (e[7] !== i || e[8] !== l) {
    let y;
    e[10] !== i.length || e[11] !== l ? (y = (w, C) => /* @__PURE__ */ $(oo, { children: [
      w.map((S) => /* @__PURE__ */ b(di, { ...S, portalContainer: l }, S.title)),
      C !== i.length - 1 && /* @__PURE__ */ b("hr", { className: "my-2xs border-grayscale-x-light" })
    ] }, C), e[10] = i.length, e[11] = l, e[12] = y) : y = e[12], m = i.map(y), e[7] = i, e[8] = l, e[9] = m;
  } else
    m = e[9];
  let h;
  e[13] !== d || e[14] !== u || e[15] !== m ? (h = /* @__PURE__ */ $("nav", { className: "gap-2xs flex flex-col", children: [
    d,
    u,
    m
  ] }), e[13] = d, e[14] = u, e[15] = m, e[16] = h) : h = e[16];
  let v;
  e[17] !== a ? (v = a ? /* @__PURE__ */ b(_C, { ...a }) : null, e[17] = a, e[18] = v) : v = e[18];
  let f;
  e[19] !== s || e[20] !== l ? (f = s == null ? void 0 : s.map((y) => /* @__PURE__ */ b(di, { ...y, portalContainer: l }, y.title)), e[19] = s, e[20] = l, e[21] = f) : f = e[21];
  let p;
  e[22] !== f ? (p = /* @__PURE__ */ b("div", { className: "gap-2xs flex grow flex-col justify-end", children: f }), e[22] = f, e[23] = p) : p = e[23];
  let g;
  return e[24] !== c || e[25] !== h || e[26] !== v || e[27] !== p ? (g = /* @__PURE__ */ $("div", { className: "gap-md p-sm flex h-screen w-[210px] flex-col bg-white shadow-md", children: [
    c,
    h,
    v,
    p
  ] }), e[24] = c, e[25] = h, e[26] = v, e[27] = p, e[28] = g) : g = e[28], g;
}, nE = (t) => {
  const e = ee(85);
  let n, r, o, i, a, s, l, c, d, u, m, h, v;
  e[0] !== t ? ({
    className: n,
    size: l,
    label: o,
    unit: v,
    defaultValue: c,
    showControls: s,
    onChange: i,
    min: d,
    max: u,
    step: m,
    disabled: r,
    fullWidth: h,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s, e[7] = l, e[8] = c, e[9] = d, e[10] = u, e[11] = m, e[12] = h, e[13] = v) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6], l = e[7], c = e[8], d = e[9], u = e[10], m = e[11], h = e[12], v = e[13]);
  const f = l === void 0 ? "large" : l, p = c === void 0 ? 0 : c, g = d === void 0 ? 0 : d, y = u === void 0 ? 1 / 0 : u, w = m === void 0 ? 1 : m, C = h === void 0 ? !1 : h, [S, P] = le(p || 0), E = nn();
  let N;
  e[14] !== i ? (N = (re) => {
    i == null || i(re), P(re);
  }, e[14] = i, e[15] = N) : N = e[15];
  const T = N;
  let k;
  e[16] !== p || e[17] !== T || e[18] !== g || e[19] !== w || e[20] !== S ? (k = () => {
    T(Math.max((S || p) - Number(w), Number(g)));
  }, e[16] = p, e[17] = T, e[18] = g, e[19] = w, e[20] = S, e[21] = k) : k = e[21];
  const D = k;
  let F;
  e[22] !== p || e[23] !== T || e[24] !== y || e[25] !== w || e[26] !== S ? (F = () => {
    T(Math.min((S || p) + Number(w), Number(y)));
  }, e[22] = p, e[23] = T, e[24] = y, e[25] = w, e[26] = S, e[27] = F) : F = e[27];
  const O = F;
  let _;
  e[28] !== v || e[29] !== S ? (_ = () => S <= 1 && (v == null ? void 0 : v[v.length - 1]) === "s" ? v == null ? void 0 : v.slice(0, -1) : v, e[28] = v, e[29] = S, e[30] = _) : _ = e[30];
  const L = _, I = C && "w-full";
  let R;
  e[31] !== I ? (R = H("gap-2xs inline-flex flex-col", I), e[31] = I, e[32] = R) : R = e[32];
  let A;
  e[33] !== r || e[34] !== E || e[35] !== o ? (A = o && /* @__PURE__ */ b(yn, { htmlFor: E, className: r ? "pointer-events-none" : "", children: o }), e[33] = r, e[34] = E, e[35] = o, e[36] = A) : A = e[36];
  let M;
  e[37] !== r || e[38] !== g || e[39] !== D || e[40] !== s || e[41] !== S ? (M = s ? /* @__PURE__ */ b($t, { onClick: D, disabled: S <= Number(g) || r, size: "large", Icon: Um, shape: "solid", className: "lg:hidden", children: "Minus" }) : null, e[37] = r, e[38] = g, e[39] = D, e[40] = s, e[41] = S, e[42] = M) : M = e[42];
  const W = C ? "flex w-full" : "grid grid-cols-[100px_1fr]", z = r && "bg-grayscale-x-light";
  let K;
  e[43] !== W || e[44] !== z ? (K = H("bg-grayscale-xx-light rounded-md", W, z), e[43] = W, e[44] = z, e[45] = K) : K = e[45];
  let j;
  e[46] !== T ? (j = (re) => T(Number(re.target.value)), e[46] = T, e[47] = j) : j = e[47];
  let G;
  e[48] !== n || e[49] !== r || e[50] !== s || e[51] !== f ? (G = H(pn({
    fieldType: "input",
    size: f,
    className: n
  }), "min-w-0", s && "[appearance:textfield] text-center lg:[appearance:auto] [&::-webkit-inner-spin-button]:appearance-none lg:[&::-webkit-inner-spin-button]:appearance-auto [&::-webkit-outer-spin-button]:appearance-none lg:[&::-webkit-outer-spin-button]:appearance-auto", r && "border-grayscale-xx-light bg-grayscale-xx-light text-grayscale-dark pointer-events-none shadow-none"), e[48] = n, e[49] = r, e[50] = s, e[51] = f, e[52] = G) : G = e[52];
  const J = S || p || 0;
  let oe;
  e[53] !== r || e[54] !== E || e[55] !== y || e[56] !== g || e[57] !== a || e[58] !== w || e[59] !== j || e[60] !== G || e[61] !== J ? (oe = /* @__PURE__ */ b("input", { ...a, id: E, min: g, max: y, step: w, onChange: j, onFocus: rE, type: "number", title: "", className: G, disabled: r, value: J }), e[53] = r, e[54] = E, e[55] = y, e[56] = g, e[57] = a, e[58] = w, e[59] = j, e[60] = G, e[61] = J, e[62] = oe) : oe = e[62];
  let Y;
  e[63] !== L || e[64] !== f || e[65] !== v ? (Y = v && /* @__PURE__ */ b("div", { className: H("text-grayscale content-center whitespace-nowrap", f === "large" ? "p-sm" : "p-xs", f === "large" ? Qe.size.large : Qe.size.medium), children: L() }), e[63] = L, e[64] = f, e[65] = v, e[66] = Y) : Y = e[66];
  let Z;
  e[67] !== K || e[68] !== oe || e[69] !== Y ? (Z = /* @__PURE__ */ $("div", { className: K, children: [
    oe,
    Y
  ] }), e[67] = K, e[68] = oe, e[69] = Y, e[70] = Z) : Z = e[70];
  let ie;
  e[71] !== r || e[72] !== y || e[73] !== O || e[74] !== s || e[75] !== S ? (ie = s ? /* @__PURE__ */ b($t, { onClick: O, disabled: S >= Number(y) || r, shape: "solid", size: "large", Icon: jm, className: "lg:hidden", children: "Plus" }) : null, e[71] = r, e[72] = y, e[73] = O, e[74] = s, e[75] = S, e[76] = ie) : ie = e[76];
  let te;
  e[77] !== M || e[78] !== Z || e[79] !== ie ? (te = /* @__PURE__ */ $("div", { className: "gap-sm flex items-center", children: [
    M,
    Z,
    ie
  ] }), e[77] = M, e[78] = Z, e[79] = ie, e[80] = te) : te = e[80];
  let ne;
  return e[81] !== R || e[82] !== A || e[83] !== te ? (ne = /* @__PURE__ */ $("div", { className: R, "data-testid": "question-field", children: [
    A,
    te
  ] }), e[81] = R, e[82] = A, e[83] = te, e[84] = ne) : ne = e[84], ne;
};
nE.displayName = "NumberField";
function rE(t) {
  return t.target.select();
}
const gl = [{
  key: "minLength",
  test: (t) => (t == null ? void 0 : t.length) >= 8
}, {
  key: "hasUppercase",
  test: (t) => /[A-Z]/.test(t)
}, {
  key: "hasLowercase",
  test: (t) => /[a-z]/.test(t)
}, {
  key: "hasDigit",
  test: (t) => /[0-9]/.test(t)
}, {
  key: "hasSymbol",
  test: (t) => /[^\d\w\s]|[ _]/.test(t)
}];
function oE(t) {
  const e = ee(11), {
    touched: n,
    valid: r,
    children: o
  } = t, i = r ? Pl : Wn, a = n ? r ? "text-positive-dark" : "text-negative-dark" : "";
  let s;
  e[0] !== a ? (s = H("gap-2xs flex items-center transition-colors", a), e[0] = a, e[1] = s) : s = e[1];
  const l = n && "opacity-100";
  let c;
  e[2] !== l ? (c = H("size-md opacity-0 transition-opacity", l), e[2] = l, e[3] = c) : c = e[3];
  let d;
  e[4] !== i || e[5] !== c ? (d = /* @__PURE__ */ b(i, { className: c }), e[4] = i, e[5] = c, e[6] = d) : d = e[6];
  let u;
  return e[7] !== o || e[8] !== s || e[9] !== d ? (u = /* @__PURE__ */ $(ve, { as: "li", autoSpacing: !0, className: s, children: [
    d,
    o
  ] }), e[7] = o, e[8] = s, e[9] = d, e[10] = u) : u = e[10], u;
}
function NP(t) {
  const e = ee(17), {
    password: n,
    constraintText: r,
    text: o,
    setValid: i,
    isInvalid: a
  } = t;
  let s, l;
  e[0] !== n || e[1] !== i ? (s = () => {
    i(gl.every((f) => {
      const {
        test: p
      } = f;
      return p(n);
    }));
  }, l = [n, i], e[0] = n, e[1] = i, e[2] = s, e[3] = l) : (s = e[2], l = e[3]), fe(s, l);
  const c = a && "text-negative-dark";
  let d;
  e[4] !== c ? (d = H(c), e[4] = c, e[5] = d) : d = e[5];
  let u;
  e[6] !== d || e[7] !== o ? (u = /* @__PURE__ */ b(ve, { step: "0", className: d, autoSpacing: !0, children: o }), e[6] = d, e[7] = o, e[8] = u) : u = e[8];
  let m;
  e[9] !== r || e[10] !== n ? (m = gl.map((f) => {
    const {
      key: p,
      test: g
    } = f;
    return /* @__PURE__ */ b(oE, { touched: !!n, valid: g(n), children: r[p] }, p);
  }), e[9] = r, e[10] = n, e[11] = m) : m = e[11];
  let h;
  e[12] !== m ? (h = /* @__PURE__ */ b("ul", { className: "list-none", children: m }), e[12] = m, e[13] = h) : h = e[13];
  let v;
  return e[14] !== u || e[15] !== h ? (v = /* @__PURE__ */ $("div", { children: [
    u,
    h
  ] }), e[14] = u, e[15] = h, e[16] = v) : v = e[16], v;
}
const OP = (t) => {
  const e = ee(21), {
    percentage: n,
    completed: r,
    language: o,
    maximumFractionDigits: i
  } = t, a = o === void 0 ? "fr" : o, s = i === void 0 ? 0 : i, [l, c] = le(0);
  let d, u;
  e[0] !== n ? (d = () => {
    setTimeout(() => {
      c(Math.max(Math.min(n, 100), 0));
    }, 150);
  }, u = [n], e[0] = n, e[1] = d, e[2] = u) : (d = e[1], u = e[2]), fe(d, u);
  const m = `${l / 100 * 360}deg`, h = r && "completed";
  let v;
  e[3] !== h ? (v = H("radial-progress-bar grid place-items-center", h), e[3] = h, e[4] = v) : v = e[4];
  let f;
  e[5] !== m ? (f = {
    "--percentage": m
  }, e[5] = m, e[6] = f) : f = e[6];
  const p = f;
  let g;
  e[7] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ b("div", { className: "radial-progress-bar-container bg-positive-xx-light col-start-1 row-start-1 rounded-full", children: /* @__PURE__ */ b("div", { className: "radial-progress-bar-end" }) }), e[7] = g) : g = e[7];
  const y = r && "text-positive";
  let w;
  e[8] !== y ? (w = H("text-warning col-start-1 row-start-1", y), e[8] = y, e[9] = w) : w = e[9];
  const C = l / 100;
  let S;
  e[10] !== a || e[11] !== s || e[12] !== C ? (S = C.toLocaleString(a, {
    style: "percent",
    maximumFractionDigits: s
  }), e[10] = a, e[11] = s, e[12] = C, e[13] = S) : S = e[13];
  let P;
  e[14] !== w || e[15] !== S ? (P = /* @__PURE__ */ b(ve, { step: "-1", weight: "semibold", className: w, children: S }), e[14] = w, e[15] = S, e[16] = P) : P = e[16];
  let E;
  return e[17] !== P || e[18] !== v || e[19] !== p ? (E = /* @__PURE__ */ $("div", { className: v, style: p, children: [
    g,
    P
  ] }), e[17] = P, e[18] = v, e[19] = p, e[20] = E) : E = e[20], E;
};
var fi = "rovingFocusGroup.onEntryFocus", iE = { bubbles: !1, cancelable: !0 }, Sr = "RovingFocusGroup", [Vi, pf, sE] = cr(Sr), [aE, _o] = Ye(
  Sr,
  [sE]
), [lE, cE] = aE(Sr), vf = x.forwardRef(
  (t, e) => /* @__PURE__ */ b(Vi.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ b(Vi.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ b(uE, { ...t, ref: e }) }) })
);
vf.displayName = Sr;
var uE = x.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: d = !1,
    ...u
  } = t, m = x.useRef(null), h = ae(e, m), v = $n(i), [f, p] = je({
    prop: a,
    defaultProp: s ?? null,
    onChange: l,
    caller: Sr
  }), [g, y] = x.useState(!1), w = at(c), C = pf(n), S = x.useRef(!1), [P, E] = x.useState(0);
  return x.useEffect(() => {
    const N = m.current;
    if (N)
      return N.addEventListener(fi, w), () => N.removeEventListener(fi, w);
  }, [w]), /* @__PURE__ */ b(
    lE,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: o,
      currentTabStopId: f,
      onItemFocus: x.useCallback(
        (N) => p(N),
        [p]
      ),
      onItemShiftTab: x.useCallback(() => y(!0), []),
      onFocusableItemAdd: x.useCallback(
        () => E((N) => N + 1),
        []
      ),
      onFocusableItemRemove: x.useCallback(
        () => E((N) => N - 1),
        []
      ),
      children: /* @__PURE__ */ b(
        q.div,
        {
          tabIndex: g || P === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: h,
          style: { outline: "none", ...t.style },
          onMouseDown: U(t.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: U(t.onFocus, (N) => {
            const T = !S.current;
            if (N.target === N.currentTarget && T && !g) {
              const k = new CustomEvent(fi, iE);
              if (N.currentTarget.dispatchEvent(k), !k.defaultPrevented) {
                const D = C().filter((I) => I.focusable), F = D.find((I) => I.active), O = D.find((I) => I.id === f), L = [F, O, ...D].filter(
                  Boolean
                ).map((I) => I.ref.current);
                yf(L, d);
              }
            }
            S.current = !1;
          }),
          onBlur: U(t.onBlur, () => y(!1))
        }
      )
    }
  );
}), gf = "RovingFocusGroupItem", bf = x.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      children: a,
      ...s
    } = t, l = st(), c = i || l, d = cE(gf, n), u = d.currentTabStopId === c, m = pf(n), { onFocusableItemAdd: h, onFocusableItemRemove: v, currentTabStopId: f } = d;
    return x.useEffect(() => {
      if (r)
        return h(), () => v();
    }, [r, h, v]), /* @__PURE__ */ b(
      Vi.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ b(
          q.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: e,
            onMouseDown: U(t.onMouseDown, (p) => {
              r ? d.onItemFocus(c) : p.preventDefault();
            }),
            onFocus: U(t.onFocus, () => d.onItemFocus(c)),
            onKeyDown: U(t.onKeyDown, (p) => {
              if (p.key === "Tab" && p.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (p.target !== p.currentTarget) return;
              const g = mE(p, d.orientation, d.dir);
              if (g !== void 0) {
                if (p.metaKey || p.ctrlKey || p.altKey || p.shiftKey) return;
                p.preventDefault();
                let w = m().filter((C) => C.focusable).map((C) => C.ref.current);
                if (g === "last") w.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && w.reverse();
                  const C = w.indexOf(p.currentTarget);
                  w = d.loop ? hE(w, C + 1) : w.slice(C + 1);
                }
                setTimeout(() => yf(w));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: u, hasTabStop: f != null }) : a
          }
        )
      }
    );
  }
);
bf.displayName = gf;
var dE = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function fE(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function mE(t, e, n) {
  const r = fE(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return dE[r];
}
function yf(t, e = !1) {
  const n = document.activeElement;
  for (const r of t)
    if (r === n || (r.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function hE(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var wf = vf, xf = bf, zs = "Radio", [pE, Sf] = Ye(zs), [vE, gE] = pE(zs), Cf = x.forwardRef(
  (t, e) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: i,
      disabled: a,
      value: s = "on",
      onCheck: l,
      form: c,
      ...d
    } = t, [u, m] = x.useState(null), h = ae(e, (p) => m(p)), v = x.useRef(!1), f = u ? c || !!u.closest("form") : !0;
    return /* @__PURE__ */ $(vE, { scope: n, checked: o, disabled: a, children: [
      /* @__PURE__ */ b(
        q.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Of(o),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: s,
          ...d,
          ref: h,
          onClick: U(t.onClick, (p) => {
            o || l == null || l(), f && (v.current = p.isPropagationStopped(), v.current || p.stopPropagation());
          })
        }
      ),
      f && /* @__PURE__ */ b(
        Nf,
        {
          control: u,
          bubbles: !v.current,
          name: r,
          value: s,
          checked: o,
          required: i,
          disabled: a,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Cf.displayName = zs;
var Ef = "RadioIndicator", Pf = x.forwardRef(
  (t, e) => {
    const { __scopeRadio: n, forceMount: r, ...o } = t, i = gE(Ef, n);
    return /* @__PURE__ */ b(tt, { present: r || i.checked, children: /* @__PURE__ */ b(
      q.span,
      {
        "data-state": Of(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: e
      }
    ) });
  }
);
Pf.displayName = Ef;
var bE = "RadioBubbleInput", Nf = x.forwardRef(
  ({
    __scopeRadio: t,
    control: e,
    checked: n,
    bubbles: r = !0,
    ...o
  }, i) => {
    const a = x.useRef(null), s = ae(a, i), l = vr(n), c = dr(e);
    return x.useEffect(() => {
      const d = a.current;
      if (!d) return;
      const u = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && h) {
        const v = new Event("click", { bubbles: r });
        h.call(d, n), d.dispatchEvent(v);
      }
    }, [l, n, r]), /* @__PURE__ */ b(
      q.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Nf.displayName = bE;
function Of(t) {
  return t ? "checked" : "unchecked";
}
var yE = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Do = "RadioGroup", [wE, TP] = Ye(Do, [
  _o,
  Sf
]), Tf = _o(), If = Sf(), [xE, SE] = wE(Do), Mf = x.forwardRef(
  (t, e) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: i,
      required: a = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: d = !0,
      onValueChange: u,
      ...m
    } = t, h = Tf(n), v = $n(c), [f, p] = je({
      prop: i,
      defaultProp: o ?? null,
      onChange: u,
      caller: Do
    });
    return /* @__PURE__ */ b(
      xE,
      {
        scope: n,
        name: r,
        required: a,
        disabled: s,
        value: f,
        onValueChange: p,
        children: /* @__PURE__ */ b(
          wf,
          {
            asChild: !0,
            ...h,
            orientation: l,
            dir: v,
            loop: d,
            children: /* @__PURE__ */ b(
              q.div,
              {
                role: "radiogroup",
                "aria-required": a,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: v,
                ...m,
                ref: e
              }
            )
          }
        )
      }
    );
  }
);
Mf.displayName = Do;
var kf = "RadioGroupItem", _f = x.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = t, i = SE(kf, n), a = i.disabled || r, s = Tf(n), l = If(n), c = x.useRef(null), d = ae(e, c), u = i.value === o.value, m = x.useRef(!1);
    return x.useEffect(() => {
      const h = (f) => {
        yE.includes(f.key) && (m.current = !0);
      }, v = () => m.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ b(
      xf,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ b(
          Cf,
          {
            disabled: a,
            required: i.required,
            checked: u,
            ...l,
            ...o,
            name: i.name,
            ref: d,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: U((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: U(o.onFocus, () => {
              var h;
              m.current && ((h = c.current) == null || h.click());
            })
          }
        )
      }
    );
  }
);
_f.displayName = kf;
var CE = "RadioGroupIndicator", Df = x.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, ...r } = t, o = If(n);
    return /* @__PURE__ */ b(Pf, { ...o, ...r, ref: e });
  }
);
Df.displayName = CE;
var EE = Mf, bl = _f, PE = Df;
function Rf(t) {
  const e = ee(30);
  let n, r, o, i, a, s;
  e[0] !== t ? ({
    size: i,
    items: n,
    label: r,
    orientation: a,
    type: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6]);
  const l = i === void 0 ? "large" : i, c = a === void 0 ? "vertical" : a, d = s === void 0 ? "default" : s;
  of(n, "Radio: must have items");
  const u = nn();
  let m;
  e[7] !== u || e[8] !== r ? (m = r && /* @__PURE__ */ b(yn, { htmlFor: u, children: r }), e[7] = u, e[8] = r, e[9] = m) : m = e[9];
  const h = c === "vertical" ? "gap-2xs grid" : "gap-lg flex items-center justify-center", v = o.defaultValue;
  let f;
  e[10] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ b(bl, { className: "hidden", value: "null", "aria-hidden": !0 }), e[10] = f) : f = e[10];
  let p;
  if (e[11] !== u || e[12] !== n || e[13] !== c || e[14] !== l || e[15] !== d) {
    let w;
    e[17] !== u || e[18] !== c || e[19] !== l || e[20] !== d ? (w = (C) => {
      const S = `${u}-${C.value}`;
      return /* @__PURE__ */ $(bl, { className: H("group gap-2xs radix-disabled:pointer-events-none radix-disabled:text-grayscale flex cursor-pointer items-center justify-items-start", pn({
        fieldType: d === "button" ? "input" : "radio",
        size: l
      }), d === "button" && "radix-state-checked:border-primary-light radix-state-checked:bg-primary radix-state-checked:text-white", c === "horizontal" && "grow-0"), value: C.value, disabled: C.disabled, id: S, children: [
        /* @__PURE__ */ $("div", { className: H("relative z-10", d === "default" && "before:-left-3xs before:-top-3xs before:size-md group-hover:before:bg-grayscale-x-light group-focus-visible:before:bg-grayscale-x-light before:absolute before:-z-10 before:scale-50 before:self-center before:rounded-full before:bg-transparent before:transition-all before:duration-200 before:ease-out before:content-[''] group-hover:before:scale-110 group-active:before:bg-transparent"), children: [
          /* @__PURE__ */ b(Gm, { className: "size-sm group-radix-state-checked:hidden" }),
          /* @__PURE__ */ b(PE, { children: /* @__PURE__ */ b(qm, { className: "size-sm" }) })
        ] }),
        /* @__PURE__ */ b(ve, { step: d === "default" ? "-1" : "0", weight: "semibold", as: "label", htmlFor: S, className: H("group-radix-disabled:text-grayscale row-start-1 cursor-pointer", d === "button" && "group-radix-state-checked:text-white", l === "large" ? Qe.size.large : Qe.size.medium), children: C.label })
      ] }, S);
    }, e[17] = u, e[18] = c, e[19] = l, e[20] = d, e[21] = w) : w = e[21], p = n.map(w), e[11] = u, e[12] = n, e[13] = c, e[14] = l, e[15] = d, e[16] = p;
  } else
    p = e[16];
  let g;
  e[22] !== u || e[23] !== o || e[24] !== h || e[25] !== p ? (g = /* @__PURE__ */ $(EE, { id: u, className: h, defaultValue: v, ...o, children: [
    f,
    p
  ] }), e[22] = u, e[23] = o, e[24] = h, e[25] = p, e[26] = g) : g = e[26];
  let y;
  return e[27] !== m || e[28] !== g ? (y = /* @__PURE__ */ $("div", { className: "gap-2xs flex flex-col", children: [
    m,
    g
  ] }), e[27] = m, e[28] = g, e[29] = y) : y = e[29], y;
}
Rf.displayName = "Radio";
function NE(t) {
  const e = ee(2);
  console.warn("This component will be deprecated in the next major release. Use the Radio component now.");
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ b(Rf, { ...t, type: "button" }), e[0] = t, e[1] = n) : n = e[1], n;
}
NE.displayName = "RadioGroup";
var Af = ["PageUp", "PageDown"], Ff = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Lf = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Gn = "Slider", [Bi, OE, TE] = cr(Gn), [Wf, IP] = Ye(Gn, [
  TE
]), [IE, Ro] = Wf(Gn), $f = x.forwardRef(
  (t, e) => {
    const {
      name: n,
      min: r = 0,
      max: o = 100,
      step: i = 1,
      orientation: a = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: c = [r],
      value: d,
      onValueChange: u = () => {
      },
      onValueCommit: m = () => {
      },
      inverted: h = !1,
      form: v,
      ...f
    } = t, p = x.useRef(/* @__PURE__ */ new Set()), g = x.useRef(0), w = a === "horizontal" ? ME : kE, [C = [], S] = je({
      prop: d,
      defaultProp: c,
      onChange: (D) => {
        var O;
        (O = [...p.current][g.current]) == null || O.focus(), u(D);
      }
    }), P = x.useRef(C);
    function E(D) {
      const F = FE(C, D);
      k(D, F);
    }
    function N(D) {
      k(D, g.current);
    }
    function T() {
      const D = P.current[g.current];
      C[g.current] !== D && m(C);
    }
    function k(D, F, { commit: O } = { commit: !1 }) {
      const _ = VE(i), L = BE(Math.round((D - r) / i) * i + r, _), I = eo(L, [r, o]);
      S((R = []) => {
        const A = RE(R, I, F);
        if ($E(A, l * i)) {
          g.current = A.indexOf(I);
          const M = String(A) !== String(R);
          return M && O && m(A), M ? A : R;
        } else
          return R;
      });
    }
    return /* @__PURE__ */ b(
      IE,
      {
        scope: t.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: o,
        valueIndexToChangeRef: g,
        thumbs: p.current,
        values: C,
        orientation: a,
        form: v,
        children: /* @__PURE__ */ b(Bi.Provider, { scope: t.__scopeSlider, children: /* @__PURE__ */ b(Bi.Slot, { scope: t.__scopeSlider, children: /* @__PURE__ */ b(
          w,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...f,
            ref: e,
            onPointerDown: U(f.onPointerDown, () => {
              s || (P.current = C);
            }),
            min: r,
            max: o,
            inverted: h,
            onSlideStart: s ? void 0 : E,
            onSlideMove: s ? void 0 : N,
            onSlideEnd: s ? void 0 : T,
            onHomeKeyDown: () => !s && k(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && k(o, C.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: D, direction: F }) => {
              if (!s) {
                const L = Af.includes(D.key) || D.shiftKey && Ff.includes(D.key) ? 10 : 1, I = g.current, R = C[I], A = i * L * F;
                k(R + A, I, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
$f.displayName = Gn;
var [Vf, Bf] = Wf(Gn, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), ME = x.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: r,
      dir: o,
      inverted: i,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: c,
      ...d
    } = t, [u, m] = x.useState(null), h = ae(e, (w) => m(w)), v = x.useRef(void 0), f = $n(o), p = f === "ltr", g = p && !i || !p && i;
    function y(w) {
      const C = v.current || u.getBoundingClientRect(), S = [0, C.width], E = Hs(S, g ? [n, r] : [r, n]);
      return v.current = C, E(w - C.left);
    }
    return /* @__PURE__ */ b(
      Vf,
      {
        scope: t.__scopeSlider,
        startEdge: g ? "left" : "right",
        endEdge: g ? "right" : "left",
        direction: g ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ b(
          zf,
          {
            dir: f,
            "data-orientation": "horizontal",
            ...d,
            ref: h,
            style: {
              ...d.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (w) => {
              const C = y(w.clientX);
              a == null || a(C);
            },
            onSlideMove: (w) => {
              const C = y(w.clientX);
              s == null || s(C);
            },
            onSlideEnd: () => {
              v.current = void 0, l == null || l();
            },
            onStepKeyDown: (w) => {
              const S = Lf[g ? "from-left" : "from-right"].includes(w.key);
              c == null || c({ event: w, direction: S ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), kE = x.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: r,
      inverted: o,
      onSlideStart: i,
      onSlideMove: a,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...c
    } = t, d = x.useRef(null), u = ae(e, d), m = x.useRef(void 0), h = !o;
    function v(f) {
      const p = m.current || d.current.getBoundingClientRect(), g = [0, p.height], w = Hs(g, h ? [r, n] : [n, r]);
      return m.current = p, w(f - p.top);
    }
    return /* @__PURE__ */ b(
      Vf,
      {
        scope: t.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ b(
          zf,
          {
            "data-orientation": "vertical",
            ...c,
            ref: u,
            style: {
              ...c.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (f) => {
              const p = v(f.clientY);
              i == null || i(p);
            },
            onSlideMove: (f) => {
              const p = v(f.clientY);
              a == null || a(p);
            },
            onSlideEnd: () => {
              m.current = void 0, s == null || s();
            },
            onStepKeyDown: (f) => {
              const g = Lf[h ? "from-bottom" : "from-top"].includes(f.key);
              l == null || l({ event: f, direction: g ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), zf = x.forwardRef(
  (t, e) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: o,
      onSlideEnd: i,
      onHomeKeyDown: a,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...c
    } = t, d = Ro(Gn, n);
    return /* @__PURE__ */ b(
      q.span,
      {
        ...c,
        ref: e,
        onKeyDown: U(t.onKeyDown, (u) => {
          u.key === "Home" ? (a(u), u.preventDefault()) : u.key === "End" ? (s(u), u.preventDefault()) : Af.concat(Ff).includes(u.key) && (l(u), u.preventDefault());
        }),
        onPointerDown: U(t.onPointerDown, (u) => {
          const m = u.target;
          m.setPointerCapture(u.pointerId), u.preventDefault(), d.thumbs.has(m) ? m.focus() : r(u);
        }),
        onPointerMove: U(t.onPointerMove, (u) => {
          u.target.hasPointerCapture(u.pointerId) && o(u);
        }),
        onPointerUp: U(t.onPointerUp, (u) => {
          const m = u.target;
          m.hasPointerCapture(u.pointerId) && (m.releasePointerCapture(u.pointerId), i(u));
        })
      }
    );
  }
), Hf = "SliderTrack", Yf = x.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...r } = t, o = Ro(Hf, n);
    return /* @__PURE__ */ b(
      q.span,
      {
        "data-disabled": o.disabled ? "" : void 0,
        "data-orientation": o.orientation,
        ...r,
        ref: e
      }
    );
  }
);
Yf.displayName = Hf;
var zi = "SliderRange", Kf = x.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...r } = t, o = Ro(zi, n), i = Bf(zi, n), a = x.useRef(null), s = ae(e, a), l = o.values.length, c = o.values.map(
      (m) => Gf(m, o.min, o.max)
    ), d = l > 1 ? Math.min(...c) : 0, u = 100 - Math.max(...c);
    return /* @__PURE__ */ b(
      q.span,
      {
        "data-orientation": o.orientation,
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...t.style,
          [i.startEdge]: d + "%",
          [i.endEdge]: u + "%"
        }
      }
    );
  }
);
Kf.displayName = zi;
var Hi = "SliderThumb", Uf = x.forwardRef(
  (t, e) => {
    const n = OE(t.__scopeSlider), [r, o] = x.useState(null), i = ae(e, (s) => o(s)), a = x.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ b(_E, { ...t, ref: i, index: a });
  }
), _E = x.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, index: r, name: o, ...i } = t, a = Ro(Hi, n), s = Bf(Hi, n), [l, c] = x.useState(null), d = ae(e, (y) => c(y)), u = l ? a.form || !!l.closest("form") : !0, m = dr(l), h = a.values[r], v = h === void 0 ? 0 : Gf(h, a.min, a.max), f = AE(r, a.values.length), p = m == null ? void 0 : m[s.size], g = p ? LE(p, v, s.direction) : 0;
    return x.useEffect(() => {
      if (l)
        return a.thumbs.add(l), () => {
          a.thumbs.delete(l);
        };
    }, [l, a.thumbs]), /* @__PURE__ */ $(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${v}% + ${g}px)`
        },
        children: [
          /* @__PURE__ */ b(Bi.ItemSlot, { scope: t.__scopeSlider, children: /* @__PURE__ */ b(
            q.span,
            {
              role: "slider",
              "aria-label": t["aria-label"] || f,
              "aria-valuemin": a.min,
              "aria-valuenow": h,
              "aria-valuemax": a.max,
              "aria-orientation": a.orientation,
              "data-orientation": a.orientation,
              "data-disabled": a.disabled ? "" : void 0,
              tabIndex: a.disabled ? void 0 : 0,
              ...i,
              ref: d,
              style: h === void 0 ? { display: "none" } : t.style,
              onFocus: U(t.onFocus, () => {
                a.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          u && /* @__PURE__ */ b(
            jf,
            {
              name: o ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0),
              form: a.form,
              value: h
            },
            r
          )
        ]
      }
    );
  }
);
Uf.displayName = Hi;
var DE = "RadioBubbleInput", jf = x.forwardRef(
  ({ __scopeSlider: t, value: e, ...n }, r) => {
    const o = x.useRef(null), i = ae(o, r), a = vr(e);
    return x.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "value").set;
      if (a !== e && d) {
        const u = new Event("input", { bubbles: !0 });
        d.call(s, e), s.dispatchEvent(u);
      }
    }, [a, e]), /* @__PURE__ */ b(
      q.input,
      {
        style: { display: "none" },
        ...n,
        ref: i,
        defaultValue: e
      }
    );
  }
);
jf.displayName = DE;
function RE(t = [], e, n) {
  const r = [...t];
  return r[n] = e, r.sort((o, i) => o - i);
}
function Gf(t, e, n) {
  const i = 100 / (n - e) * (t - e);
  return eo(i, [0, 100]);
}
function AE(t, e) {
  return e > 2 ? `Value ${t + 1} of ${e}` : e === 2 ? ["Minimum", "Maximum"][t] : void 0;
}
function FE(t, e) {
  if (t.length === 1) return 0;
  const n = t.map((o) => Math.abs(o - e)), r = Math.min(...n);
  return n.indexOf(r);
}
function LE(t, e, n) {
  const r = t / 2, i = Hs([0, 50], [0, r]);
  return (r - i(e) * n) * n;
}
function WE(t) {
  return t.slice(0, -1).map((e, n) => t[n + 1] - e);
}
function $E(t, e) {
  if (e > 0) {
    const n = WE(t);
    return Math.min(...n) >= e;
  }
  return !0;
}
function Hs(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1]) return e[0];
    const r = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + r * (n - t[0]);
  };
}
function VE(t) {
  return (String(t).split(".")[1] || "").length;
}
function BE(t, e) {
  const n = Math.pow(10, e);
  return Math.round(t * n) / n;
}
var zE = $f, HE = Yf, YE = Kf, KE = Uf;
const MP = (t) => {
  const e = ee(54);
  let n, r, o, i, a, s, l;
  e[0] !== t ? ({
    label: n,
    defaultValue: i,
    min: a,
    max: s,
    step: l,
    onChange: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s, e[7] = l) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6], l = e[7]);
  const c = i === void 0 ? 50 : i, d = a === void 0 ? 0 : a, u = s === void 0 ? 100 : s, m = l === void 0 ? 1 : l, [h, v] = le(c), f = pe(null), p = nn();
  let g, y;
  e[8] !== u || e[9] !== r || e[10] !== h ? (g = () => {
    if (h !== "") {
      if (h > u) {
        v(u);
        return;
      }
      r == null || r(h);
    }
  }, y = [h, u, r], e[8] = u, e[9] = r, e[10] = h, e[11] = g, e[12] = y) : (g = e[11], y = e[12]), fe(g, y);
  const w = n ? "justify-between" : "justify-end";
  let C;
  e[13] !== w ? (C = H("mb-2xs flex items-center", w), e[13] = w, e[14] = C) : C = e[14];
  let S;
  e[15] !== p || e[16] !== n ? (S = n && /* @__PURE__ */ b(yn, { className: "inline-block", htmlFor: p, children: n }), e[15] = p, e[16] = n, e[17] = S) : S = e[17];
  let P;
  e[18] === Symbol.for("react.memo_cache_sentinel") ? (P = () => {
    var K;
    return (K = f.current) == null ? void 0 : K.focus();
  }, e[18] = P) : P = e[18];
  let E;
  e[19] === Symbol.for("react.memo_cache_sentinel") ? (E = (K) => v(K.target.value ? Number(K.target.value) : ""), e[19] = E) : E = e[19];
  const N = `${h.toString().length}ch`;
  let T;
  e[20] !== N ? (T = {
    width: N
  }, e[20] = N, e[21] = T) : T = e[21];
  let k;
  e[22] !== d || e[23] !== h ? (k = () => {
    (h === "" || h < d) && v(d);
  }, e[22] = d, e[23] = h, e[24] = k) : k = e[24];
  let D;
  e[25] !== p || e[26] !== u || e[27] !== d || e[28] !== o || e[29] !== m || e[30] !== T || e[31] !== k || e[32] !== h ? (D = /* @__PURE__ */ b("input", { className: "text-secondary selection:bg-secondary-light selection:text-secondary-dark min-w-[1ch] [appearance:textfield] bg-transparent transition-[width] focus:outline-hidden [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none", type: "number", id: p, ...o, value: h, onChange: E, style: T, ref: f, step: m, max: u, min: d, onFocus: UE, onBlur: k }), e[25] = p, e[26] = u, e[27] = d, e[28] = o, e[29] = m, e[30] = T, e[31] = k, e[32] = h, e[33] = D) : D = e[33];
  let F;
  e[34] === Symbol.for("react.memo_cache_sentinel") ? (F = /* @__PURE__ */ b(Nl, { className: "size-sm text-secondary" }), e[34] = F) : F = e[34];
  let O;
  e[35] !== D ? (O = /* @__PURE__ */ $("div", { className: "gap-2xs bg-secondary-xx-light px-2xs py-3xs ring-secondary-x-light flex items-center rounded-md focus-within:ring-2", onClick: P, children: [
    D,
    F
  ] }), e[35] = D, e[36] = O) : O = e[36];
  let _;
  e[37] !== O || e[38] !== C || e[39] !== S ? (_ = /* @__PURE__ */ $("div", { className: C, children: [
    S,
    O
  ] }), e[37] = O, e[38] = C, e[39] = S, e[40] = _) : _ = e[40];
  const L = Number(h);
  let I;
  e[41] !== L ? (I = [L], e[41] = L, e[42] = I) : I = e[42];
  let R;
  e[43] === Symbol.for("react.memo_cache_sentinel") ? (R = (K) => {
    const [j] = K;
    return v(j);
  }, e[43] = R) : R = e[43];
  let A, M;
  e[44] === Symbol.for("react.memo_cache_sentinel") ? (A = /* @__PURE__ */ b(HE, { className: "h-xs bg-secondary-xx-light relative grow rounded-md", children: /* @__PURE__ */ b(YE, { className: "bg-secondary absolute h-full rounded-full" }) }), M = /* @__PURE__ */ b(KE, { className: "size-md relative block cursor-pointer rounded-full bg-white drop-shadow transition-transform hover:scale-110 focus:outline-0 active:scale-95", "aria-label": "Volume" }), e[44] = A, e[45] = M) : (A = e[44], M = e[45]);
  let W;
  e[46] !== u || e[47] !== d || e[48] !== m || e[49] !== I ? (W = /* @__PURE__ */ $(zE, { className: "h-md relative flex items-center", min: d, max: u, step: m, value: I, onValueChange: R, children: [
    A,
    M
  ] }), e[46] = u, e[47] = d, e[48] = m, e[49] = I, e[50] = W) : W = e[50];
  let z;
  return e[51] !== _ || e[52] !== W ? (z = /* @__PURE__ */ $(Ce, { children: [
    _,
    W
  ] }), e[51] = _, e[52] = W, e[53] = z) : z = e[53], z;
};
function UE(t) {
  t.target.select();
}
const kP = (t) => {
  const e = ee(8), {
    steps: n,
    currentStep: r
  } = t, o = `${r}/${n}`;
  let i;
  e[0] !== n ? (i = Array.from({
    length: n
  }, jE), e[0] = n, e[1] = i) : i = e[1];
  let a;
  e[2] !== r || e[3] !== i ? (a = i.map((l) => /* @__PURE__ */ b("i", { className: H("size-xs shrink-0 rounded-full transition-all", r >= l ? "bg-positive" : "bg-white", r === l && "w-md") }, l)), e[2] = r, e[3] = i, e[4] = a) : a = e[4];
  let s;
  return e[5] !== o || e[6] !== a ? (s = /* @__PURE__ */ b("div", { className: "gap-x-3xs flex", "aria-label": o, children: a }), e[5] = o, e[6] = a, e[7] = s) : s = e[7], s;
};
function jE(t, e) {
  return e + 1;
}
var Ao = "Switch", [GE, _P] = Ye(Ao), [qE, XE] = GE(Ao), qf = x.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: d,
      ...u
    } = t, [m, h] = x.useState(null), v = ae(e, (w) => h(w)), f = x.useRef(!1), p = m ? d || !!m.closest("form") : !0, [g, y] = je({
      prop: o,
      defaultProp: i ?? !1,
      onChange: c,
      caller: Ao
    });
    return /* @__PURE__ */ $(qE, { scope: n, checked: g, disabled: s, children: [
      /* @__PURE__ */ b(
        q.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": g,
          "aria-required": a,
          "data-state": Qf(g),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...u,
          ref: v,
          onClick: U(t.onClick, (w) => {
            y((C) => !C), p && (f.current = w.isPropagationStopped(), f.current || w.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ b(
        Jf,
        {
          control: m,
          bubbles: !f.current,
          name: r,
          value: l,
          checked: g,
          required: a,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
qf.displayName = Ao;
var Xf = "SwitchThumb", Zf = x.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...r } = t, o = XE(Xf, n);
    return /* @__PURE__ */ b(
      q.span,
      {
        "data-state": Qf(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
Zf.displayName = Xf;
var ZE = "SwitchBubbleInput", Jf = x.forwardRef(
  ({
    __scopeSwitch: t,
    control: e,
    checked: n,
    bubbles: r = !0,
    ...o
  }, i) => {
    const a = x.useRef(null), s = ae(a, i), l = vr(n), c = dr(e);
    return x.useEffect(() => {
      const d = a.current;
      if (!d) return;
      const u = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && h) {
        const v = new Event("click", { bubbles: r });
        h.call(d, n), d.dispatchEvent(v);
      }
    }, [l, n, r]), /* @__PURE__ */ b(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Jf.displayName = ZE;
function Qf(t) {
  return t ? "checked" : "unchecked";
}
var JE = qf, QE = Zf;
function DP(t) {
  const e = ee(15);
  let n, r;
  e[0] !== t ? ({
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  const o = r.disabled && "pointer-events-none";
  let i;
  e[3] !== n || e[4] !== o ? (i = H("group bg-grayscale-light data-[state=checked]:bg-positive block h-[18px] w-[32px] rounded-full shadow-none transition-colors hover:shadow-md focus-visible:shadow-md active:shadow-none", "hover:bg-grayscale focus-visible:bg-grayscale data-[state=checked]:hover:bg-positive-dark data-[state=checked]:focus-visible:bg-positive-dark", o, n), e[3] = n, e[4] = o, e[5] = i) : i = e[5];
  const a = !r.disabled && "group-hover:shadow-sm group-focus-visible:shadow-sm group-active:h-[8px] group-active:w-[11px] group-active:rounded-[11px] group-active:border-none", s = r.disabled && "border-grayscale-x-light bg-grayscale-x-light";
  let l;
  e[6] !== a || e[7] !== s ? (l = H("border-grayscale-xx-light block size-[12px] translate-x-[3px] rounded-full border bg-white shadow-none transition-all duration-150 will-change-transform data-[state=checked]:translate-x-[17px]", a, s), e[6] = a, e[7] = s, e[8] = l) : l = e[8];
  let c;
  e[9] !== l ? (c = /* @__PURE__ */ b(QE, { className: l }), e[9] = l, e[10] = c) : c = e[10];
  let d;
  return e[11] !== r || e[12] !== i || e[13] !== c ? (d = /* @__PURE__ */ b(JE, { ...r, className: i, children: c }), e[11] = r, e[12] = i, e[13] = c, e[14] = d) : d = e[14], d;
}
function RP(t) {
  const e = ee(5), {
    className: n,
    children: r
  } = t;
  let o;
  e[0] !== n ? (o = H("[&_tr:last-child]:border-0", n), e[0] = n, e[1] = o) : o = e[1];
  let i;
  return e[2] !== r || e[3] !== o ? (i = /* @__PURE__ */ b("tbody", { className: o, children: r }), e[2] = r, e[3] = o, e[4] = i) : i = e[4], i;
}
function AP(t) {
  const e = ee(5), {
    className: n,
    children: r
  } = t;
  let o;
  e[0] !== n ? (o = H("py-sm", n), e[0] = n, e[1] = o) : o = e[1];
  let i;
  return e[2] !== r || e[3] !== o ? (i = /* @__PURE__ */ b(ve, { step: "-1", weight: "semibold", as: "td", className: o, children: r }), e[2] = r, e[3] = o, e[4] = i) : i = e[4], i;
}
function FP(t) {
  const e = ee(5), {
    className: n,
    children: r
  } = t;
  let o;
  e[0] !== n ? (o = H("py-3xs text-grayscale-dark text-left", n), e[0] = n, e[1] = o) : o = e[1];
  let i;
  return e[2] !== r || e[3] !== o ? (i = /* @__PURE__ */ b(ve, { step: "-1", weight: "semibold", as: "th", className: o, scope: "col", children: r }), e[2] = r, e[3] = o, e[4] = i) : i = e[4], i;
}
function LP(t) {
  const e = ee(5), {
    className: n,
    children: r
  } = t;
  let o;
  e[0] !== n ? (o = H("[&_tr]:border-grayscale-x-light [&_tr]:border-b", n), e[0] = n, e[1] = o) : o = e[1];
  let i;
  return e[2] !== r || e[3] !== o ? (i = /* @__PURE__ */ b("thead", { className: o, children: r }), e[2] = r, e[3] = o, e[4] = i) : i = e[4], i;
}
function WP(t) {
  const e = ee(5), {
    className: n,
    children: r
  } = t;
  let o;
  e[0] !== n ? (o = H("border-grayscale-x-light border-b", n), e[0] = n, e[1] = o) : o = e[1];
  let i;
  return e[2] !== r || e[3] !== o ? (i = /* @__PURE__ */ b("tr", { className: o, children: r }), e[2] = r, e[3] = o, e[4] = i) : i = e[4], i;
}
const it = 5, em = (t, e) => {
  const n = e - t + 1;
  return Array.from({
    length: n
  }, (r, o) => t + o);
};
function e2(t, e) {
  return t <= it || e < it ? em(1, Math.min(it, t)) : [1];
}
function t2(t, e) {
  return t > it ? e >= t - it + 1 && e >= it ? em(Math.max(it - 1, t - it + 1), t) : [t] : [];
}
function n2(t, e) {
  return t >= it * 2 && e >= it && e < t - it + 1 ? [e - 1, e, e + 1] : [];
}
function yl() {
  const t = ee(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ b(ve, { step: "-1", weight: "semibold", className: "p-2xs text-grayscale-light", children: "…" }), t[0] = e) : e = t[0], e;
}
function wl(t) {
  const e = ee(4), {
    Icon: n,
    disabled: r,
    onClick: o
  } = t, i = r === void 0 ? !1 : r;
  let a;
  return e[0] !== n || e[1] !== i || e[2] !== o ? (a = /* @__PURE__ */ b($t, { Icon: n, shape: "link", size: "small", disabled: i, onClick: o }), e[0] = n, e[1] = i, e[2] = o, e[3] = a) : a = e[3], a;
}
function r2(t) {
  const e = ee(53), {
    pageCount: n,
    currentPage: r,
    onPageChange: o,
    displayedResultsMessage: i
  } = t;
  let a, s, l, c, d, u, m, h, v, f, p, g;
  if (e[0] !== r || e[1] !== i || e[2] !== o || e[3] !== n) {
    c = Symbol.for("react.early_return_sentinel");
    e: {
      const N = e2(n, r), T = n2(n, r), k = t2(n, r);
      if (n <= 0) {
        c = null;
        break e;
      }
      r > n && console.error("Pagination error: currentPage cannot be greater than pageCount.");
      let D;
      e[16] !== r || e[17] !== o ? (D = (L) => L.map((I) => {
        const R = I === r;
        return /* @__PURE__ */ b("li", { className: "flex items-center", children: /* @__PURE__ */ b("button", { className: H("group hover:bg-primary-xx-light focus-visible:bg-primary-xx-light size-lg relative rounded-full", R && "bg-primary-xx-light"), onClick: () => o(I), children: /* @__PURE__ */ b(ve, { step: "-2", weight: "semibold", className: H("text-grayscale-dark group-active:text-primary-light absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center", R && "text-primary-light"), children: I }) }) }, `page-${I}`);
      }), e[16] = r, e[17] = o, e[18] = D) : D = e[18];
      const F = D;
      g = "table-pagination", s = "mt-sm flex items-center-safe justify-between", e[19] !== i ? (l = i && /* @__PURE__ */ b(ve, { step: "-1", weight: "semibold", className: "text-grayscale-dark invisible lg:visible", children: i }), e[19] = i, e[20] = l) : l = e[20], f = "flex items-center-safe";
      const O = r === 1;
      let _;
      e[21] !== r || e[22] !== o ? (_ = () => o(r - 1), e[21] = r, e[22] = o, e[23] = _) : _ = e[23], e[24] !== O || e[25] !== _ ? (p = /* @__PURE__ */ b(wl, { Icon: El, disabled: O, onClick: _ }), e[24] = O, e[25] = _, e[26] = p) : p = e[26], a = "flex items-center", d = F(N), e[27] !== N || e[28] !== n ? (u = N.length === 1 && n > 1 ? /* @__PURE__ */ b(yl, {}) : null, e[27] = N, e[28] = n, e[29] = u) : u = e[29], m = F(T), h = k.length === 1 && n > it ? /* @__PURE__ */ b(yl, {}) : null, v = F(k);
    }
    e[0] = r, e[1] = i, e[2] = o, e[3] = n, e[4] = a, e[5] = s, e[6] = l, e[7] = c, e[8] = d, e[9] = u, e[10] = m, e[11] = h, e[12] = v, e[13] = f, e[14] = p, e[15] = g;
  } else
    a = e[4], s = e[5], l = e[6], c = e[7], d = e[8], u = e[9], m = e[10], h = e[11], v = e[12], f = e[13], p = e[14], g = e[15];
  if (c !== Symbol.for("react.early_return_sentinel"))
    return c;
  let y;
  e[30] !== a || e[31] !== d || e[32] !== u || e[33] !== m || e[34] !== h || e[35] !== v ? (y = /* @__PURE__ */ $("ol", { className: a, children: [
    d,
    u,
    m,
    h,
    v
  ] }), e[30] = a, e[31] = d, e[32] = u, e[33] = m, e[34] = h, e[35] = v, e[36] = y) : y = e[36];
  const w = r === n;
  let C;
  e[37] !== r || e[38] !== o ? (C = () => o(r + 1), e[37] = r, e[38] = o, e[39] = C) : C = e[39];
  let S;
  e[40] !== w || e[41] !== C ? (S = /* @__PURE__ */ b(wl, { Icon: qi, disabled: w, onClick: C }), e[40] = w, e[41] = C, e[42] = S) : S = e[42];
  let P;
  e[43] !== y || e[44] !== S || e[45] !== f || e[46] !== p ? (P = /* @__PURE__ */ $("div", { className: f, children: [
    p,
    y,
    S
  ] }), e[43] = y, e[44] = S, e[45] = f, e[46] = p, e[47] = P) : P = e[47];
  let E;
  return e[48] !== s || e[49] !== l || e[50] !== P || e[51] !== g ? (E = /* @__PURE__ */ $("div", { "aria-label": g, className: s, children: [
    l,
    P
  ] }), e[48] = s, e[49] = l, e[50] = P, e[51] = g, e[52] = E) : E = e[52], E;
}
function $P(t) {
  const e = ee(18);
  let n, r, o;
  e[0] !== t ? ({
    className: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o) : (n = e[1], r = e[2], o = e[3]);
  let i;
  e[4] !== r ? (i = H("w-full table-auto border-collapse", r), e[4] = r, e[5] = i) : i = e[5];
  let a;
  e[6] !== n || e[7] !== i ? (a = /* @__PURE__ */ b("table", { className: i, children: n }), e[6] = n, e[7] = i, e[8] = a) : a = e[8];
  let s;
  e[9] !== o.currentPage || e[10] !== o.displayedResultsMessage || e[11] !== o.isPaginated || e[12] !== o.onPageChange || e[13] !== o.pageCount ? (s = o.isPaginated && /* @__PURE__ */ b(r2, { pageCount: o.pageCount, currentPage: o.currentPage, onPageChange: o.onPageChange, displayedResultsMessage: o.displayedResultsMessage }), e[9] = o.currentPage, e[10] = o.displayedResultsMessage, e[11] = o.isPaginated, e[12] = o.onPageChange, e[13] = o.pageCount, e[14] = s) : s = e[14];
  let l;
  return e[15] !== a || e[16] !== s ? (l = /* @__PURE__ */ $("div", { className: "h-full w-full overflow-auto", children: [
    a,
    s
  ] }), e[15] = a, e[16] = s, e[17] = l) : l = e[17], l;
}
var Fo = "Tabs", [o2, VP] = Ye(Fo, [
  _o
]), tm = _o(), [i2, Ys] = o2(Fo), nm = x.forwardRef(
  (t, e) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: a = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = t, d = $n(s), [u, m] = je({
      prop: r,
      onChange: o,
      defaultProp: i ?? "",
      caller: Fo
    });
    return /* @__PURE__ */ b(
      i2,
      {
        scope: n,
        baseId: st(),
        value: u,
        onValueChange: m,
        orientation: a,
        dir: d,
        activationMode: l,
        children: /* @__PURE__ */ b(
          q.div,
          {
            dir: d,
            "data-orientation": a,
            ...c,
            ref: e
          }
        )
      }
    );
  }
);
nm.displayName = Fo;
var rm = "TabsList", om = x.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = t, i = Ys(rm, n), a = tm(n);
    return /* @__PURE__ */ b(
      wf,
      {
        asChild: !0,
        ...a,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ b(
          q.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...o,
            ref: e
          }
        )
      }
    );
  }
);
om.displayName = rm;
var im = "TabsTrigger", sm = x.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...i } = t, a = Ys(im, n), s = tm(n), l = cm(a.baseId, r), c = um(a.baseId, r), d = r === a.value;
    return /* @__PURE__ */ b(
      xf,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: d,
        children: /* @__PURE__ */ b(
          q.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": d,
            "aria-controls": c,
            "data-state": d ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...i,
            ref: e,
            onMouseDown: U(t.onMouseDown, (u) => {
              !o && u.button === 0 && u.ctrlKey === !1 ? a.onValueChange(r) : u.preventDefault();
            }),
            onKeyDown: U(t.onKeyDown, (u) => {
              [" ", "Enter"].includes(u.key) && a.onValueChange(r);
            }),
            onFocus: U(t.onFocus, () => {
              const u = a.activationMode !== "manual";
              !d && !o && u && a.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
sm.displayName = im;
var am = "TabsContent", lm = x.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: i, ...a } = t, s = Ys(am, n), l = cm(s.baseId, r), c = um(s.baseId, r), d = r === s.value, u = x.useRef(d);
    return x.useEffect(() => {
      const m = requestAnimationFrame(() => u.current = !1);
      return () => cancelAnimationFrame(m);
    }, []), /* @__PURE__ */ b(tt, { present: o || d, children: ({ present: m }) => /* @__PURE__ */ b(
      q.div,
      {
        "data-state": d ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !m,
        id: c,
        tabIndex: 0,
        ...a,
        ref: e,
        style: {
          ...t.style,
          animationDuration: u.current ? "0s" : void 0
        },
        children: m && i
      }
    ) });
  }
);
lm.displayName = am;
function cm(t, e) {
  return `${t}-trigger-${e}`;
}
function um(t, e) {
  return `${t}-content-${e}`;
}
var s2 = nm, a2 = om, l2 = sm, c2 = lm;
const BP = (t) => {
  const e = ee(21), {
    defaultValue: n,
    value: r,
    onChange: o,
    extraContent: i,
    tabs: a,
    listClassName: s,
    listContainerClassName: l
  } = t;
  let c;
  e[0] !== l ? (c = H("flex items-center justify-between", l), e[0] = l, e[1] = c) : c = e[1];
  let d;
  e[2] !== s ? (d = H("gap-3xs p-3xs bg-grayscale-xx-light flex flex-wrap rounded-md", s), e[2] = s, e[3] = d) : d = e[3];
  let u;
  e[4] !== a ? (u = a.map(u2), e[4] = a, e[5] = u) : u = e[5];
  let m;
  e[6] !== d || e[7] !== u ? (m = /* @__PURE__ */ b(a2, { className: d, children: u }), e[6] = d, e[7] = u, e[8] = m) : m = e[8];
  const h = i || null;
  let v;
  e[9] !== c || e[10] !== m || e[11] !== h ? (v = /* @__PURE__ */ $("div", { className: c, children: [
    m,
    h
  ] }), e[9] = c, e[10] = m, e[11] = h, e[12] = v) : v = e[12];
  let f;
  e[13] !== a ? (f = a.map(d2), e[13] = a, e[14] = f) : f = e[14];
  let p;
  return e[15] !== n || e[16] !== o || e[17] !== v || e[18] !== f || e[19] !== r ? (p = /* @__PURE__ */ $(s2, { className: "gap-md flex h-full flex-col", defaultValue: n, value: r, onValueChange: o, children: [
    v,
    f
  ] }), e[15] = n, e[16] = o, e[17] = v, e[18] = f, e[19] = r, e[20] = p) : p = e[20], p;
};
function u2(t) {
  const {
    value: e,
    label: n,
    disabled: r,
    PrefixIcon: o,
    SuffixIcon: i
  } = t;
  return /* @__PURE__ */ $(l2, { value: e, disabled: r, className: H("gap-2xs py-2xs px-xs text-grayscale-dark flex cursor-pointer items-center rounded-md border border-transparent text-sm font-semibold transition-colors hover:border-white hover:bg-white focus-visible:border-white focus-visible:bg-white focus-visible:outline-hidden", r && "text-grayscale-light cursor-default bg-transparent hover:border-transparent hover:bg-transparent focus-visible:border-white focus-visible:bg-white", "radix-state-active:shadow-sm radix-state-active:bg-white radix-state-active:border-grayscale-x-light radix-state-active:text-grayscale-dark radix-state-active:focus-visible:border-primary-light radix-state-active:active:border-grayscale-light"), children: [
    o && /* @__PURE__ */ b(o, { className: "size-sm" }),
    n,
    i && /* @__PURE__ */ b(i, { className: "size-sm" })
  ] }, e);
}
function d2(t) {
  const {
    value: e,
    content: n
  } = t;
  return /* @__PURE__ */ b(c2, { value: e, asChild: !0, children: n }, e);
}
const f2 = {
  primary: "bg-primary-xx-light text-primary",
  secondary: "bg-secondary-xx-light text-secondary-dark",
  positive: "bg-positive-xx-light text-positive-dark",
  negative: "bg-negative-xx-light text-negative-dark",
  grayscale: "bg-grayscale-xx-light text-grayscale-dark",
  warning: "bg-warning-xx-light text-warning-dark"
}, m2 = Yt("px-2xs py-3xs rounded-sm", {
  variants: {
    intent: f2
  },
  defaultVariants: {
    intent: "primary"
  }
});
function zP(t) {
  const e = ee(5), {
    text: n,
    intent: r
  } = t;
  let o;
  e[0] !== r ? (o = m2({
    intent: r
  }), e[0] = r, e[1] = o) : o = e[1];
  let i;
  return e[2] !== o || e[3] !== n ? (i = /* @__PURE__ */ b(ve, { as: "span", step: "-1", weight: "normal", className: o, children: n }), e[2] = o, e[3] = n, e[4] = i) : i = e[4], i;
}
const h2 = (t) => {
  const e = ee(43);
  let n, r, o, i, a, s, l, c, d;
  e[0] !== t ? ({
    className: r,
    size: c,
    label: s,
    disabled: o,
    error: i,
    isInvalid: a,
    alignWithPasswordField: n,
    fullWidth: d,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s, e[7] = l, e[8] = c, e[9] = d) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6], l = e[7], c = e[8], d = e[9]);
  const u = c === void 0 ? "large" : c, m = d === void 0 ? !1 : d, h = (l == null ? void 0 : l.type) === "password", [v, f] = le(!1), p = nn();
  let g;
  e[10] !== o || e[11] !== p || e[12] !== s ? (g = s && /* @__PURE__ */ b(yn, { className: H("mb-2xs inline-block", o && "pointer-events-none"), htmlFor: p, children: s }), e[10] = o, e[11] = p, e[12] = s, e[13] = g) : g = e[13];
  const y = n && "pr-lg", w = m ? "w-full" : "w-[35ch]";
  let C;
  e[14] !== y || e[15] !== w ? (C = H("gap-2xs flex flex-row", y, w), e[14] = y, e[15] = w, e[16] = C) : C = e[16];
  const S = h && !v ? "password" : "text", P = h && !v ? "••••••••••••" : l == null ? void 0 : l.placeholder;
  let E;
  e[17] !== r || e[18] !== o || e[19] !== i || e[20] !== a || e[21] !== u ? (E = H(pn({
    fieldType: "input",
    size: u,
    className: r
  }), (i || a) && "border-negative-x-light text-negative shadow-negative-x-light hover:shadow-negative-light shadow-md", o && "border-grayscale-xx-light bg-grayscale-xx-light text-grayscale-dark pointer-events-none shadow-none"), e[17] = r, e[18] = o, e[19] = i, e[20] = a, e[21] = u, e[22] = E) : E = e[22];
  let N;
  e[23] !== o || e[24] !== p || e[25] !== l || e[26] !== S || e[27] !== P || e[28] !== E ? (N = /* @__PURE__ */ b("input", { ...l, id: p, type: S, placeholder: P, className: E, disabled: o }), e[23] = o, e[24] = p, e[25] = l, e[26] = S, e[27] = P, e[28] = E, e[29] = N) : N = e[29];
  let T;
  e[30] !== h || e[31] !== v ? (T = h ? /* @__PURE__ */ b("button", { type: "button", onClick: () => f(p2), className: "text-grayscale hover:text-grayscale-dark", "aria-label": "password-reveal-toggle", children: v ? /* @__PURE__ */ b(Xm, { className: "size-md" }) : /* @__PURE__ */ b(Zm, { className: "size-md" }) }) : null, e[30] = h, e[31] = v, e[32] = T) : T = e[32];
  let k;
  e[33] !== N || e[34] !== T || e[35] !== C ? (k = /* @__PURE__ */ $("div", { className: C, children: [
    N,
    T
  ] }), e[33] = N, e[34] = T, e[35] = C, e[36] = k) : k = e[36];
  let D;
  e[37] !== i ? (D = i && /* @__PURE__ */ b(ve, { step: "0", className: "mt-2xs text-negative", children: i }), e[37] = i, e[38] = D) : D = e[38];
  let F;
  return e[39] !== k || e[40] !== D || e[41] !== g ? (F = /* @__PURE__ */ $(Ce, { children: [
    g,
    k,
    D
  ] }), e[39] = k, e[40] = D, e[41] = g, e[42] = F) : F = e[42], F;
};
h2.displayName = "TextField";
function p2(t) {
  return !t;
}
var Ks = "ToastProvider", [Us, v2, g2] = cr("Toast"), [dm, HP] = Ye("Toast", [g2]), [b2, Lo] = dm(Ks), fm = (t) => {
  const {
    __scopeToast: e,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: a
  } = t, [s, l] = x.useState(null), [c, d] = x.useState(0), u = x.useRef(!1), m = x.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Ks}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ b(Us.Provider, { scope: e, children: /* @__PURE__ */ b(
    b2,
    {
      scope: e,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: c,
      viewport: s,
      onViewportChange: l,
      onToastAdd: x.useCallback(() => d((h) => h + 1), []),
      onToastRemove: x.useCallback(() => d((h) => h - 1), []),
      isFocusedToastEscapeKeyDownRef: u,
      isClosePausedRef: m,
      children: a
    }
  ) });
};
fm.displayName = Ks;
var mm = "ToastViewport", y2 = ["F8"], Yi = "toast.viewportPause", Ki = "toast.viewportResume", hm = x.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      hotkey: r = y2,
      label: o = "Notifications ({hotkey})",
      ...i
    } = t, a = Lo(mm, n), s = v2(n), l = x.useRef(null), c = x.useRef(null), d = x.useRef(null), u = x.useRef(null), m = ae(e, u, a.onViewportChange), h = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), v = a.toastCount > 0;
    x.useEffect(() => {
      const p = (g) => {
        var w;
        r.length !== 0 && r.every((C) => g[C] || g.code === C) && ((w = u.current) == null || w.focus());
      };
      return document.addEventListener("keydown", p), () => document.removeEventListener("keydown", p);
    }, [r]), x.useEffect(() => {
      const p = l.current, g = u.current;
      if (v && p && g) {
        const y = () => {
          if (!a.isClosePausedRef.current) {
            const P = new CustomEvent(Yi);
            g.dispatchEvent(P), a.isClosePausedRef.current = !0;
          }
        }, w = () => {
          if (a.isClosePausedRef.current) {
            const P = new CustomEvent(Ki);
            g.dispatchEvent(P), a.isClosePausedRef.current = !1;
          }
        }, C = (P) => {
          !p.contains(P.relatedTarget) && w();
        }, S = () => {
          p.contains(document.activeElement) || w();
        };
        return p.addEventListener("focusin", y), p.addEventListener("focusout", C), p.addEventListener("pointermove", y), p.addEventListener("pointerleave", S), window.addEventListener("blur", y), window.addEventListener("focus", w), () => {
          p.removeEventListener("focusin", y), p.removeEventListener("focusout", C), p.removeEventListener("pointermove", y), p.removeEventListener("pointerleave", S), window.removeEventListener("blur", y), window.removeEventListener("focus", w);
        };
      }
    }, [v, a.isClosePausedRef]);
    const f = x.useCallback(
      ({ tabbingDirection: p }) => {
        const y = s().map((w) => {
          const C = w.ref.current, S = [C, ...D2(C)];
          return p === "forwards" ? S : S.reverse();
        });
        return (p === "forwards" ? y.reverse() : y).flat();
      },
      [s]
    );
    return x.useEffect(() => {
      const p = u.current;
      if (p) {
        const g = (y) => {
          var S, P, E;
          const w = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !w) {
            const N = document.activeElement, T = y.shiftKey;
            if (y.target === p && T) {
              (S = c.current) == null || S.focus();
              return;
            }
            const F = f({ tabbingDirection: T ? "backwards" : "forwards" }), O = F.findIndex((_) => _ === N);
            mi(F.slice(O + 1)) ? y.preventDefault() : T ? (P = c.current) == null || P.focus() : (E = d.current) == null || E.focus();
          }
        };
        return p.addEventListener("keydown", g), () => p.removeEventListener("keydown", g);
      }
    }, [s, f]), /* @__PURE__ */ $(
      tp,
      {
        ref: l,
        role: "region",
        "aria-label": o.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: v ? void 0 : "none" },
        children: [
          v && /* @__PURE__ */ b(
            Ui,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const p = f({
                  tabbingDirection: "forwards"
                });
                mi(p);
              }
            }
          ),
          /* @__PURE__ */ b(Us.Slot, { scope: n, children: /* @__PURE__ */ b(q.ol, { tabIndex: -1, ...i, ref: m }) }),
          v && /* @__PURE__ */ b(
            Ui,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const p = f({
                  tabbingDirection: "backwards"
                });
                mi(p);
              }
            }
          )
        ]
      }
    );
  }
);
hm.displayName = mm;
var pm = "ToastFocusProxy", Ui = x.forwardRef(
  (t, e) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = t, i = Lo(pm, n);
    return /* @__PURE__ */ b(
      No,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: e,
        style: { position: "fixed" },
        onFocus: (a) => {
          var c;
          const s = a.relatedTarget;
          !((c = i.viewport) != null && c.contains(s)) && r();
        }
      }
    );
  }
);
Ui.displayName = pm;
var Cr = "Toast", w2 = "toast.swipeStart", x2 = "toast.swipeMove", S2 = "toast.swipeCancel", C2 = "toast.swipeEnd", vm = x.forwardRef(
  (t, e) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...a } = t, [s, l] = je({
      prop: r,
      defaultProp: o ?? !0,
      onChange: i,
      caller: Cr
    });
    return /* @__PURE__ */ b(tt, { present: n || s, children: /* @__PURE__ */ b(
      N2,
      {
        open: s,
        ...a,
        ref: e,
        onClose: () => l(!1),
        onPause: at(t.onPause),
        onResume: at(t.onResume),
        onSwipeStart: U(t.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: U(t.onSwipeMove, (c) => {
          const { x: d, y: u } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${u}px`);
        }),
        onSwipeCancel: U(t.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: U(t.onSwipeEnd, (c) => {
          const { x: d, y: u } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${u}px`), l(!1);
        })
      }
    ) });
  }
);
vm.displayName = Cr;
var [E2, P2] = dm(Cr, {
  onClose() {
  }
}), N2 = x.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: i,
      onClose: a,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: c,
      onSwipeStart: d,
      onSwipeMove: u,
      onSwipeCancel: m,
      onSwipeEnd: h,
      ...v
    } = t, f = Lo(Cr, n), [p, g] = x.useState(null), y = ae(e, (_) => g(_)), w = x.useRef(null), C = x.useRef(null), S = o || f.duration, P = x.useRef(0), E = x.useRef(S), N = x.useRef(0), { onToastAdd: T, onToastRemove: k } = f, D = at(() => {
      var L;
      (p == null ? void 0 : p.contains(document.activeElement)) && ((L = f.viewport) == null || L.focus()), a();
    }), F = x.useCallback(
      (_) => {
        !_ || _ === 1 / 0 || (window.clearTimeout(N.current), P.current = (/* @__PURE__ */ new Date()).getTime(), N.current = window.setTimeout(D, _));
      },
      [D]
    );
    x.useEffect(() => {
      const _ = f.viewport;
      if (_) {
        const L = () => {
          F(E.current), c == null || c();
        }, I = () => {
          const R = (/* @__PURE__ */ new Date()).getTime() - P.current;
          E.current = E.current - R, window.clearTimeout(N.current), l == null || l();
        };
        return _.addEventListener(Yi, I), _.addEventListener(Ki, L), () => {
          _.removeEventListener(Yi, I), _.removeEventListener(Ki, L);
        };
      }
    }, [f.viewport, S, l, c, F]), x.useEffect(() => {
      i && !f.isClosePausedRef.current && F(S);
    }, [i, S, f.isClosePausedRef, F]), x.useEffect(() => (T(), () => k()), [T, k]);
    const O = x.useMemo(() => p ? Sm(p) : null, [p]);
    return f.viewport ? /* @__PURE__ */ $(Ce, { children: [
      O && /* @__PURE__ */ b(
        O2,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: O
        }
      ),
      /* @__PURE__ */ b(E2, { scope: n, onClose: D, children: lr.createPortal(
        /* @__PURE__ */ b(Us.ItemSlot, { scope: n, children: /* @__PURE__ */ b(
          ep,
          {
            asChild: !0,
            onEscapeKeyDown: U(s, () => {
              f.isFocusedToastEscapeKeyDownRef.current || D(), f.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ b(
              q.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": f.swipeDirection,
                ...v,
                ref: y,
                style: { userSelect: "none", touchAction: "none", ...t.style },
                onKeyDown: U(t.onKeyDown, (_) => {
                  _.key === "Escape" && (s == null || s(_.nativeEvent), _.nativeEvent.defaultPrevented || (f.isFocusedToastEscapeKeyDownRef.current = !0, D()));
                }),
                onPointerDown: U(t.onPointerDown, (_) => {
                  _.button === 0 && (w.current = { x: _.clientX, y: _.clientY });
                }),
                onPointerMove: U(t.onPointerMove, (_) => {
                  if (!w.current) return;
                  const L = _.clientX - w.current.x, I = _.clientY - w.current.y, R = !!C.current, A = ["left", "right"].includes(f.swipeDirection), M = ["left", "up"].includes(f.swipeDirection) ? Math.min : Math.max, W = A ? M(0, L) : 0, z = A ? 0 : M(0, I), K = _.pointerType === "touch" ? 10 : 2, j = { x: W, y: z }, G = { originalEvent: _, delta: j };
                  R ? (C.current = j, Rr(x2, u, G, {
                    discrete: !1
                  })) : xl(j, f.swipeDirection, K) ? (C.current = j, Rr(w2, d, G, {
                    discrete: !1
                  }), _.target.setPointerCapture(_.pointerId)) : (Math.abs(L) > K || Math.abs(I) > K) && (w.current = null);
                }),
                onPointerUp: U(t.onPointerUp, (_) => {
                  const L = C.current, I = _.target;
                  if (I.hasPointerCapture(_.pointerId) && I.releasePointerCapture(_.pointerId), C.current = null, w.current = null, L) {
                    const R = _.currentTarget, A = { originalEvent: _, delta: L };
                    xl(L, f.swipeDirection, f.swipeThreshold) ? Rr(C2, h, A, {
                      discrete: !0
                    }) : Rr(
                      S2,
                      m,
                      A,
                      {
                        discrete: !0
                      }
                    ), R.addEventListener("click", (M) => M.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        f.viewport
      ) })
    ] }) : null;
  }
), O2 = (t) => {
  const { __scopeToast: e, children: n, ...r } = t, o = Lo(Cr, e), [i, a] = x.useState(!1), [s, l] = x.useState(!1);
  return k2(() => a(!0)), x.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ b(Yn, { asChild: !0, children: /* @__PURE__ */ b(No, { ...r, children: i && /* @__PURE__ */ $(Ce, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, T2 = "ToastTitle", gm = x.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t;
    return /* @__PURE__ */ b(q.div, { ...r, ref: e });
  }
);
gm.displayName = T2;
var I2 = "ToastDescription", bm = x.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t;
    return /* @__PURE__ */ b(q.div, { ...r, ref: e });
  }
);
bm.displayName = I2;
var ym = "ToastAction", M2 = x.forwardRef(
  (t, e) => {
    const { altText: n, ...r } = t;
    return n.trim() ? /* @__PURE__ */ b(xm, { altText: n, asChild: !0, children: /* @__PURE__ */ b(js, { ...r, ref: e }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${ym}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
M2.displayName = ym;
var wm = "ToastClose", js = x.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t, o = P2(wm, n);
    return /* @__PURE__ */ b(xm, { asChild: !0, children: /* @__PURE__ */ b(
      q.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: U(t.onClick, o.onClose)
      }
    ) });
  }
);
js.displayName = wm;
var xm = x.forwardRef((t, e) => {
  const { __scopeToast: n, altText: r, ...o } = t;
  return /* @__PURE__ */ b(
    q.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: e
    }
  );
});
function Sm(t) {
  const e = [];
  return Array.from(t.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && e.push(r.textContent), _2(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const a = r.dataset.radixToastAnnounceAlt;
          a && e.push(a);
        } else
          e.push(...Sm(r));
    }
  }), e;
}
function Rr(t, e, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(t, { bubbles: !0, cancelable: !0, detail: n });
  e && o.addEventListener(t, e, { once: !0 }), r ? Il(o, i) : o.dispatchEvent(i);
}
var xl = (t, e, n = 0) => {
  const r = Math.abs(t.x), o = Math.abs(t.y), i = r > o;
  return e === "left" || e === "right" ? i && r > n : !i && o > n;
};
function k2(t = () => {
}) {
  const e = at(t);
  De(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(e)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [e]);
}
function _2(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function D2(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function mi(t) {
  const e = document.activeElement;
  return t.some((n) => n === e ? !0 : (n.focus(), document.activeElement !== e));
}
var R2 = fm, A2 = hm, F2 = vm, L2 = gm, W2 = bm, $2 = js;
const Ln = {
  intent: {
    positive: "positive",
    negative: "negative"
  },
  toastType: {
    fancy: "fancy",
    simple: "simple"
  }
}, V2 = Yt("p-sm pointer-events-auto relative flex w-full items-center justify-between border", {
  variants: {
    intent: {
      ...Ln.intent
    },
    toastType: {
      ...Ln.toastType,
      simple: "rounded-sm",
      fancy: "border-grayscale-x-light data-[state=closed]:animate-slideOutToast data-[state=open]:animate-slideInToast rounded-md bg-white shadow-lg"
    }
  },
  compoundVariants: [{
    intent: "positive",
    toastType: "simple",
    className: "border-positive-x-light bg-positive-xx-light"
  }, {
    intent: "negative",
    toastType: "simple",
    className: "border-negative-x-light bg-negative-xx-light"
  }],
  defaultVariants: {
    intent: "positive",
    toastType: "fancy"
  }
}), B2 = Yt("size-md", {
  variants: {
    intent: {
      ...Ln.intent
    },
    toastType: {
      ...Ln.toastType,
      fancy: "text-grayscale-x-dark",
      simple: "text-grayscale-dark"
    }
  },
  defaultVariants: {
    intent: "positive",
    toastType: "fancy"
  }
}), z2 = Yt("", {
  variants: {
    intent: {
      ...Ln.intent,
      positive: "text-positive-dark",
      negative: "text-negative"
    },
    toastType: {
      ...Ln.toastType
    }
  },
  defaultVariants: {
    intent: "positive",
    toastType: "fancy"
  }
}), H2 = {
  positive: "🤙",
  negative: "👎"
}, Y2 = (t) => {
  const e = ee(44);
  let n, r, o, i, a, s;
  e[0] !== t ? ({
    className: n,
    intent: i,
    toastType: a,
    title: s,
    description: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = r, e[3] = o, e[4] = i, e[5] = a, e[6] = s) : (n = e[1], r = e[2], o = e[3], i = e[4], a = e[5], s = e[6]);
  const l = i === void 0 ? "positive" : i, c = a === void 0 ? "fancy" : a;
  let d;
  e[7] !== n || e[8] !== l || e[9] !== c ? (d = H(V2({
    intent: l,
    toastType: c
  }), n), e[7] = n, e[8] = l, e[9] = c, e[10] = d) : d = e[10];
  const u = c === "fancy" ? "gap-x-lg" : "gap-x-sm";
  let m;
  e[11] !== u ? (m = H("flex items-center", u), e[11] = u, e[12] = m) : m = e[12];
  let h;
  e[13] !== l || e[14] !== c ? (h = c === "fancy" ? /* @__PURE__ */ b(ve, { step: "1", children: /* @__PURE__ */ b(bC, { symbol: H2[l] }) }) : null, e[13] = l, e[14] = c, e[15] = h) : h = e[15];
  let v;
  e[16] !== l || e[17] !== c ? (v = z2({
    intent: l,
    toastType: c
  }), e[16] = l, e[17] = c, e[18] = v) : v = e[18];
  let f;
  e[19] !== v || e[20] !== s ? (f = /* @__PURE__ */ b(L2, { asChild: !0, children: /* @__PURE__ */ b(ve, { className: v, weight: "semibold", children: s }) }), e[19] = v, e[20] = s, e[21] = f) : f = e[21];
  let p;
  e[22] !== r || e[23] !== c ? (p = r && c === "fancy" ? /* @__PURE__ */ b(W2, { asChild: !0, children: /* @__PURE__ */ b(ve, { className: "text-grayscale-dark", weight: "normal", children: r }) }) : null, e[22] = r, e[23] = c, e[24] = p) : p = e[24];
  let g;
  e[25] !== f || e[26] !== p ? (g = /* @__PURE__ */ $("div", { children: [
    f,
    p
  ] }), e[25] = f, e[26] = p, e[27] = g) : g = e[27];
  let y;
  e[28] !== g || e[29] !== h ? (y = /* @__PURE__ */ $("div", { className: "gap-x-sm flex items-center", children: [
    h,
    g
  ] }), e[28] = g, e[29] = h, e[30] = y) : y = e[30];
  let w;
  e[31] !== l || e[32] !== c ? (w = B2({
    intent: l,
    toastType: c
  }), e[31] = l, e[32] = c, e[33] = w) : w = e[33];
  let C;
  e[34] !== w ? (C = /* @__PURE__ */ b($2, { children: /* @__PURE__ */ b(Wn, { className: w }) }), e[34] = w, e[35] = C) : C = e[35];
  let S;
  e[36] !== y || e[37] !== C || e[38] !== m ? (S = /* @__PURE__ */ $("div", { className: m, children: [
    y,
    C
  ] }), e[36] = y, e[37] = C, e[38] = m, e[39] = S) : S = e[39];
  let P;
  return e[40] !== o || e[41] !== S || e[42] !== d ? (P = /* @__PURE__ */ b(F2, { className: d, ...o, children: S }), e[40] = o, e[41] = S, e[42] = d, e[43] = P) : P = e[43], P;
}, K2 = 1, U2 = 4e3;
let hi = 0;
function j2() {
  return hi = (hi + 1) % Number.MAX_SAFE_INTEGER, hi.toString();
}
const pi = /* @__PURE__ */ new Map(), Sl = (t) => {
  if (pi.has(t))
    return;
  const e = setTimeout(() => {
    pi.delete(t), tr({
      type: "REMOVE_TOAST",
      toastId: t
    });
  }, U2);
  pi.set(t, e);
}, G2 = (t, e) => {
  switch (e.type) {
    case "ADD_TOAST":
      return {
        ...t,
        toasts: [e.toast, ...t.toasts].slice(0, K2)
      };
    case "UPDATE_TOAST":
      return {
        ...t,
        toasts: t.toasts.map((n) => n.id === e.toast.id ? {
          ...n,
          ...e.toast
        } : n)
      };
    case "DISMISS_TOAST": {
      const {
        toastId: n
      } = e;
      return n ? Sl(n) : t.toasts.forEach((r) => {
        Sl(r.id);
      }), {
        ...t,
        toasts: t.toasts.map((r) => r.id === n || n === void 0 ? {
          ...r,
          open: !1
        } : r)
      };
    }
    case "REMOVE_TOAST":
      return e.toastId === void 0 ? {
        ...t,
        toasts: []
      } : {
        ...t,
        toasts: t.toasts.filter((n) => n.id !== e.toastId)
      };
  }
}, Vr = [];
let Br = {
  toasts: []
};
function tr(t) {
  Br = G2(Br, t), Vr.forEach((e) => {
    e(Br);
  });
}
function q2({
  ...t
}) {
  const e = j2(), n = (o) => tr({
    type: "UPDATE_TOAST",
    toast: {
      ...o,
      id: e
    }
  }), r = () => tr({
    type: "DISMISS_TOAST",
    toastId: e
  });
  return tr({
    type: "ADD_TOAST",
    toast: {
      ...t,
      id: e,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: e,
    dismiss: r,
    update: n
  };
}
function X2() {
  const t = ee(5), [e, n] = le(Br);
  let r;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (r = () => (Vr.push(n), () => {
    const a = Vr.indexOf(n);
    a > -1 && Vr.splice(a, 1);
  }), t[0] = r) : r = t[0];
  let o;
  t[1] !== e ? (o = [e], t[1] = e, t[2] = o) : o = t[2], fe(r, o);
  let i;
  return t[3] !== e ? (i = {
    ...e,
    toast: q2,
    dismiss: Z2
  }, t[3] = e, t[4] = i) : i = t[4], i;
}
function Z2(t) {
  return tr({
    type: "DISMISS_TOAST",
    toastId: t
  });
}
function YP() {
  const t = ee(5), {
    toasts: e
  } = X2();
  let n;
  t[0] !== e ? (n = e.map(J2), t[0] = e, t[1] = n) : n = t[1];
  let r;
  t[2] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ b(A2, { className: "gap-2xs pt-md fixed top-0 left-1/2 z-100 flex max-h-screen -translate-x-1/2 flex-col" }), t[2] = r) : r = t[2];
  let o;
  return t[3] !== n ? (o = /* @__PURE__ */ $(R2, { duration: 4e3, children: [
    n,
    r
  ] }), t[3] = n, t[4] = o) : o = t[4], o;
}
function J2(t) {
  const {
    id: e,
    ...n
  } = t;
  return /* @__PURE__ */ b(Y2, { ...n }, e);
}
const ht = "animate-pulse bg-grayscale-x-light", Q2 = {
  "-2": "h-xs",
  "-1": "h-sm",
  0: "h-sm",
  1: "h-md",
  2: "h-md",
  3: "h-lg",
  4: "h-lg",
  5: "h-xl"
}, Cl = [/* @__PURE__ */ b(Ce, { children: /* @__PURE__ */ b("div", { className: H("h-xs col-span-3 rounded-full", ht) }) }), /* @__PURE__ */ $(Ce, { children: [
  /* @__PURE__ */ b("div", { className: H("h-xs col-span-2 rounded-full", ht) }),
  /* @__PURE__ */ b("div", { className: H("h-xs col-span-1 rounded-full", ht) })
] }), /* @__PURE__ */ $(Ce, { children: [
  /* @__PURE__ */ b("div", { className: H("h-xs col-span-1 rounded-full", ht) }),
  /* @__PURE__ */ b("div", { className: H("h-xs col-span-2 rounded-full", ht) })
] }), /* @__PURE__ */ $(Ce, { children: [
  /* @__PURE__ */ b("div", { className: H("h-xs col-span-1 rounded-full", ht) }),
  /* @__PURE__ */ b("div", { className: H("h-xs col-span-1 rounded-full", ht) }),
  /* @__PURE__ */ b("div", { className: H("h-xs col-span-1 rounded-full", ht) })
] })], KP = (t) => {
  const e = ee(20), {
    type: n,
    step: r,
    numberOfLines: o,
    ready: i,
    className: a,
    childrenWrapperClassName: s,
    noChildrenWrapper: l,
    children: c
  } = t, d = n === void 0 ? "circle" : n, u = r === void 0 ? "0" : r, m = o === void 0 ? 3 : o, h = i === void 0 ? !1 : i, v = l === void 0 ? !1 : l;
  if (h) {
    if (v)
      return c;
    {
      let y;
      e[0] !== s ? (y = H("animate-in fade-in", s), e[0] = s, e[1] = y) : y = e[1];
      let w;
      return e[2] !== c || e[3] !== y ? (w = /* @__PURE__ */ b("div", { className: y, children: c }), e[2] = c, e[3] = y, e[4] = w) : w = e[4], w;
    }
  }
  if (d === "line") {
    const y = Q2[u];
    let w;
    e[5] !== a || e[6] !== y ? (w = H("rounded-full", ht, y, a), e[5] = a, e[6] = y, e[7] = w) : w = e[7];
    let C;
    return e[8] !== w ? (C = /* @__PURE__ */ b("div", { className: w }), e[8] = w, e[9] = C) : C = e[9], C;
  }
  if (d === "paragraph") {
    let y;
    return e[10] !== m ? (y = /* @__PURE__ */ b("div", { className: "gap-sm grid grid-cols-3", children: [...Array(m)].map(eP) }), e[10] = m, e[11] = y) : y = e[11], y;
  }
  if (d === "circle") {
    const y = a || "size-2xl";
    let w;
    e[12] !== y ? (w = H("rounded-full", ht, y), e[12] = y, e[13] = w) : w = e[13];
    let C;
    return e[14] !== w ? (C = /* @__PURE__ */ b("div", { className: w }), e[14] = w, e[15] = C) : C = e[15], C;
  }
  const f = a || "h-3xl";
  let p;
  e[16] !== f ? (p = H("rounded-lg", ht, f), e[16] = f, e[17] = p) : p = e[17];
  let g;
  return e[18] !== p ? (g = /* @__PURE__ */ b("div", { className: p }), e[18] = p, e[19] = g) : g = e[19], g;
};
function eP(t, e) {
  return /* @__PURE__ */ b(oo, { children: Cl[Math.floor(Math.random() * Cl.length)] }, e);
}
export {
  lP as Accordion,
  cP as Banner,
  RP as Body,
  dP as Breadcrumb,
  $t as Button,
  Yw as Calendar,
  fP as Card,
  AP as Cell,
  hP as Checkbox,
  go as ClosePopover,
  FP as ColumnHeaderCell,
  p0 as Combobox,
  pP as DateField,
  bP as Dialog,
  wP as Dropdown,
  bC as Emoji,
  xP as GooglePlacesField,
  LP as Header,
  yn as Label,
  SP as Link,
  PP as Menu,
  nE as NumberField,
  NP as PasswordIndications,
  gs as Popover,
  Bc as PopoverAnchor,
  OP as RadialProgressBar,
  Rf as Radio,
  NE as RadioGroup,
  WP as Row,
  MP as Slider,
  kP as Stepper,
  DP as Switch,
  $P as Table,
  BP as Tabs,
  zP as Tag,
  h2 as TextField,
  YP as Toaster,
  QC as Tooltip,
  EP as TooltipProvider,
  ve as Typography,
  KP as UIPlaceholder,
  X2 as useToast,
  GP as util
};
